import React from 'react'
import sheepmain from "../images/products/sheephamper/sheepmain.jpeg"
import sheep1 from "../images/products/sheephamper/sheep1.jpeg"
import sheep2 from "../images/products/sheephamper/sheep2.jpeg"
import sheep3 from "../images/products/sheephamper/sheep3.jpeg"
import sheep4 from "../images/products/sheephamper/sheep4.jpeg"
import sheep5 from "../images/products/sheephamper/sheep5.jpeg"
import sheep6 from "../images/products/sheephamper/sheep6.jpeg"
import sheep7 from "../images/products/sheephamper/sheep7.jpeg"
import sheep8 from "../images/products/sheephamper/sheep8.png"
import elephantmain from "../images/products/elephanthamper/elephantmain.jpeg"
import elephant1 from "../images/products/elephanthamper/elephant1.jpeg"
import elephant2 from "../images/products/elephanthamper/elephant2.jpeg"
import elephant3 from "../images/products/elephanthamper/elephant3.jpeg"
import elephant4 from "../images/products/elephanthamper/elephant4.jpeg"
import elephant5 from "../images/products/elephanthamper/elephant5.jpeg"
import elephant6 from "../images/products/elephanthamper/elephant6.jpeg"
import elephant7 from "../images/products/elephanthamper/elephant7.jpeg"
import elephant8 from "../images/products/elephanthamper/elephant8.jpeg"
import elephant9 from "../images/products/elephanthamper/elephant9.jpeg"
import elephant10 from "../images/products/elephanthamper/elephant10.jpeg"
import greyhat from "../images/products/greyhat.jpeg"
import mustardhat from "../images/products/mustardhat.jpeg"
import navyhat from "../images/products/navyhat.jpeg"
import pinkhat from "../images/products/pinkhat.jpeg"
import sagehat from "../images/products/sagehat.jpeg"
import steelhat from "../images/products/steelhat.jpeg"
import whitehat from "../images/products/whitehat.jpeg"
import bluehat from "../images/products/bluehat.jpeg"
import coffeehat from "../images/products/coffeehat.jpeg"
import whitegreyhat from "../images/products/whitegreyhat.jpeg"
import rosehat from "../images/products/rosehat.jpeg"
import cosyelephantmain from "../images/products/cosyelephant/cosyelephantmain.png"
import cosyelephant1 from "../images/products/cosyelephant/cosyelephant1.png"
import cosyelephant2 from "../images/products/cosyelephant/cosyelephant2.png"
import cosyelephant3 from "../images/products/cosyelephant/cosyelephant3.png"
import milestonesmain from "../images/products/milestones/milestonesmain.png"
import milestone1 from "../images/products/milestones/milestone1.png"
import milestone2 from "../images/products/milestones/milestone2.png"
import milestone3 from "../images/products/milestones/milestone3.png"
import bunnycloud from "../images/products/bunnycloud.jpeg"
import unicorn from "../images/products/unicorn.jpeg"
import penguin from "../images/products/penguin.png"
import lion from "../images/products/lion.png"
import sheep from "../images/products/sheep.jpeg"
import whitecellular from "../images/products/whitecellular.png"
import cosyzebramain from "../images/products/cosyzebra/cosyzebramain.png"
import cosyzebra1 from "../images/products/cosyzebra/cosyzebra1.png"
import cosyzebra2 from "../images/products/cosyzebra/cosyzebra2.png"
import zebra from "../images/products/zebra.jpeg"
import lemonanimalmain from "../images/products/lemonanimal/lemonanimalmain.png"
import lemonwaffle from "../images/products/lemonwaffle.jpeg"
import lemonanimal1 from "../images/products/lemonanimal/lemonanimal1.png"
import lemonanimal2 from "../images/products/lemonanimal/lemonanimal2.png"
import lemonanimal3 from "../images/products/lemonanimal/lemonanimal3.png"
import lemonanimal4 from "../images/products/lemonanimal/lemonanimal4.png"
import lemonanimal5 from "../images/products/lemonanimal/lemonanimal5.png"
import recycledcomforters from "../images/products/recycledcomforters.png"
import greyelephant from "../images/products/greyelephant.png"
import floralbathmain from "../images/products/floralbath/floralbathmain.png"
import floralbath1 from "../images/products/floralbath/floralbath1.png"
import floralbath2 from "../images/products/floralbath/floralbath2.png"
import comb from "../images/products/comb.jpeg"
import comforters from "../images/products/comforters.png"
import cosycolourmain from "../images/products/cosycolour/cosycolourmain.png"
import cosycolour1 from "../images/products/cosycolour/cosycolour1.png"
import cosycolour2 from "../images/products/cosycolour/cosycolour2.png"
import cosycolour3 from "../images/products/cosycolour/cosycolour3.png"
import cosycolour4 from "../images/products/cosycolour/cosycolour4.png"
import cosycolour5 from "../images/products/cosycolour/cosycolour5.png"
import cosycolour6 from "../images/products/cosycolour/cosycolour6.png"
import cosycolour7 from "../images/products/cosycolour/cosycolour7.png"
import whiteelephant from "../images/products/whiteelephant.png"
import greybunnymain from "../images/products/greybunny/greybunnymain.png"
import greybunny1 from "../images/products/greybunny/greybunny1.png"
import greybunny2 from "../images/products/greybunny/greybunny2.png"
import greybunny3 from "../images/products/greybunny/greybunny3.png"
import greybunny4 from "../images/products/greybunny/greybunny4.png"
import greybunny5 from "../images/products/greybunny/greybunny5.png"
import greybunny6 from "../images/products/greybunny/greybunny6.png"
import greycellular from "../images/products/greycellular.png"
import bluebooties from "../images/products/bluebooties.png"
import navybooties from "../images/products/navybooties.png"
import bluewhalemain from "../images/products/bluewhale/bluewhalemain.png"
import bluewhale1 from "../images/products/bluewhale/bluewhale1.png"
import bluewhale2 from "../images/products/bluewhale/bluewhale2.png"
import bluewhale3 from "../images/products/bluewhale/bluewhale3.png"
import bluewhale4 from "../images/products/bluewhale/bluewhale4.png"
import bluewhale5 from "../images/products/bluewhale/bluewhale5.png"
import bluewhale6 from "../images/products/bluewhale/bluewhale6.png"
import whitebooties from "../images/products/whitebooties.jpeg"
import greybooties from "../images/products/greybooties.png"
import pinkbooties from "../images/products/pinkbooties.png"
import pinkfloralemain from "../images/products/pinkfloral/pinkfloralmain.png"
import pinkfloral1 from "../images/products/pinkfloral/pinkfloral1.png"
import pinkfloral2 from "../images/products/pinkfloral/pinkfloral2.png"
import pinkfloral3 from "../images/products/pinkfloral/pinkfloral3.png"
import pinkfloral4 from "../images/products/pinkfloral/pinkfloral4.png"
import pinkfloral5 from "../images/products/pinkfloral/pinkfloral5.png"
import pinkfloral6 from "../images/products/pinkfloral/pinkfloral6.png"
import pinkcellular from "../images/products/pinkcellular.png"
import frames from "../images/products/frames.png"
import pinkfairymain from "../images/products/pinkfairy/pinkfairymain.png"
import pinkfairy1 from "../images/products/pinkfairy/pinkfairy1.png"
import pinkfairy2 from "../images/products/pinkfairy/pinkfairy2.png"
import pinkfairy3 from "../images/products/pinkfairy/pinkfairy3.png"
import pinkfairy4 from "../images/products/pinkfairy/pinkfairy4.png"
import pinkfairy5 from "../images/products/pinkfairy/pinkfairy5.png"
import pinkfairy6 from "../images/products/pinkfairy/pinkfairy6.png"
import rainbowteether from "../images/products/rainbowteether.png"
import organicrainbowmain from "../images/products/organicrainbow/organicrainbowmain.png"
import organicrainbow1 from "../images/products/organicrainbow/organicrainbow1.png"
import organicrainbow2 from "../images/products/organicrainbow/organicrainbow2.png"
import organicrainbow3 from "../images/products/organicrainbow/organicrainbow3.png"
import organicrainbow4 from "../images/products/organicrainbow/organicrainbow4.png"
import newmomentsmain from "../images/products/newmoments/newmomentsmain.png"
import newmoments1 from "../images/products/newmoments/newmoments1.png"
import milestonecards from "../images/products/milestonecards.png"
import greymuslin from "../images/products/greymuslin.jpeg"
import whitemuslin from "../images/products/whitemuslin.jpeg"
import bluemuslin from "../images/products/bluemuslin.jpeg"
import pinkmuslin from "../images/products/pinkmuslin.jpeg"
import giftwrap from "../images/products/giftwrap.png"
import organicdandelionmain from "../images/products/organicdandelion/organicdandelionmain.png"
import organicdandelion1 from "../images/products/organicdandelion/organicdandelion1.png"
import dandelionswaddle from "../images/products/dandelionswaddle.png"
import organicbibs from "../images/products/organicbibs.jpeg"
import organicteethers from "../images/products/organicteethers.png"
import organicgeometricmain from "../images/products/organicgeometric/organicgeometricmain.png"
import organicgeometric1 from "../images/products/organicgeometric/organicgeometric1.png"
import organicmint from "../images/products/organicmint.png"
import pinkbunnymain from "../images/products/pinkbunny/pinkbunnymain.png"
import pinkbunny1 from "../images/products/pinkbunny/pinkbunny1.png"
import pinkbunny2 from "../images/products/pinkbunny/pinkbunny2.png"
import pinkbunny3 from "../images/products/pinkbunny/pinkbunny3.png"
import pinkbunny4 from "../images/products/pinkbunny/pinkbunny4.png"
import pinkbunny from "../images/products/pinkbunny.png"
import waffles from "../images/products/waffles.jpeg"
import littleoneplaque from "../images/products/littleoneplaque.png"
import rainbowblanket from "../images/products/rainbowblanket.jpeg"
import hats1 from "../images/products/hats1.png"
import hats2 from "../images/products/hats2.jpeg"
import rainbowmain from "../images/products/rainbow/rainbowmain.png"
import rainbow1 from "../images/products/rainbow/rainbow1.png"
import baththermometer from "../images/products/baththermometer.jpeg"
import foamshapes from "../images/products/foamshapes.jpeg"
import bathbooks from "../images/products/bathbooks.jpeg"
import buildingcups1 from "../images/products/buildingcups1.jpeg"
import buildingcups2 from "../images/products/buildingcups2.jpeg"
import bathmirror from "../images/products/bathmirror.jpeg"
import floralbibmain from "../images/products/floralbib/floralbibmain.png"
import floralbib from "../images/products/floralbib.jpeg"
import floralheadband from "../images/products/floralheadband.png"
import plaques from "../images/products/plaques.png"
import wishstring from "../images/products/wishstring.jpeg"
import newbabymain from "../images/products/newbaby/newbabymain.png"
import newbaby1 from "../images/products/newbaby/newbaby1.png"
import babyonboard from "../images/products/babyonboard.png"
import milestonecardsmain from "../images/products/milestonecardsmain.jpeg"
import farmyardmain from "../images/products/farmyard/farmyardmain.png"
import farmyard1 from "../images/products/farmyard/farmyard1.png"
import farmyard2 from "../images/products/farmyard/farmyard2.png"
import farmyard3 from "../images/products/farmyard/farmyard3.png"
import zebrarecycledmain from "../images/products/zebrarecycled/zebrarecycledmain.png"
import zebrarecycled1 from "../images/products/zebrarecycled/zebrarecycled1.png"
import zebrablanket from "../images/products/zebrablanket.png"
import zebraonesie from "../images/products/zebraonesie.png"
import reczebras from "../images/products/reczebras.png"
import reczebracomforter from "../images/products/reczebracomforter.jpeg"
import reczebteething from "../images/products/reczebteething.png"
import reczebtoy from "../images/products/reczebtoy.png"
import reczebrattle from "../images/products/reczebrattle.png"
import dinosaurbathmain from "../images/products/dinosaurbath/dinosaurbathmain.png"
import dinosaurbath1 from "../images/products/dinosaurbath/dinosaurbath1.png"
import bluedressing from "../images/products/bluedressing.png"
import teddymain from "../images/products/teddy/teddymain.png"
import teddy1 from "../images/products/teddy/teddy1.png"
import teddy2 from "../images/products/teddy/teddy2.png"
import teddy3 from "../images/products/teddy/teddy3.png"
import teddy4 from "../images/products/teddy/teddy4.png"
import whitedribble from "../images/products/whitedribble.png"
import greydribble from "../images/products/greydribble.png"
import whitedressing from "../images/products/whitedressing.png"
import unicornmain from "../images/products/unicorn/unicornmain.png"
import unicorn1 from "../images/products/unicorn/unicorn1.png"
import unicorn2 from "../images/products/unicorn/unicorn2.png"
import unicorn3 from "../images/products/unicorn/unicorn3.png"
import teddybikemain from "../images/products/teddybike/teddybikemain.png"
import teddybike1 from "../images/products/teddybike/teddybike1.png"
import teddybike2 from "../images/products/teddybike/teddybike2.png"
import teddybike3 from "../images/products/teddybike/teddybike3.png"
import teddybike4 from "../images/products/teddybike/teddybike4.png"
import teddybike5 from "../images/products/teddybike/teddybike5.png"
import cuttlery from "../images/products/cuttlery.png"
import twinkleplaque from "../images/products/twinkleplaque.png"
import whitewaffle from "../images/products/whitewaffle.jpeg"
import nauticalmain from "../images/products/nautical/nauticalmain.png"
import nautical1 from "../images/products/nautical/nautical1.png"
import nautical2 from "../images/products/nautical/nautical2.png"
import bearvelourmain from "../images/products/bearvelour/bearvelourmain.png"
import bearvelour1 from "../images/products/bearvelour/bearvelour1.png"
import bearvelour2 from "../images/products/bearvelour/bearvelour2.png"
import pinkmummymemain from "../images/products/pinkmummyme/pinkmummymemain.png"
import pinkmummyme1 from "../images/products/pinkmummyme/pinkmummyme1.png"
import pinkmummyme2 from "../images/products/pinkmummyme/pinkmummyme2.png"
import pinkmummyme3 from "../images/products/pinkmummyme/pinkmummyme3.png"
import pinkmummyme4 from "../images/products/pinkmummyme/pinkmummyme4.png"
import pinkmummyme5 from "../images/products/pinkmummyme/pinkmummyme5.png"
import pinkmummyme6 from "../images/products/pinkmummyme/pinkmummyme6.png"
import giraffeanimalmain from "../images/products/giraffeanimal/giraffeanimalmain.png"
import giraffeanimal1 from "../images/products/giraffeanimal/giraffeanimal1.png"
import giraffeanimal2 from "../images/products/giraffeanimal/giraffeanimal2.png"
import giraffeanimal3 from "../images/products/giraffeanimal/giraffeanimal3.png"
import giraffeanimal4 from "../images/products/giraffeanimal/giraffeanimal4.png"
import giraffeanimal5 from "../images/products/giraffeanimal/giraffeanimal5.png"
import recycledall from "../images/products/recycledall.png"
import recycledtoys from "../images/products/recycledtoys.png"
import lionmain from "../images/products/lion/lionmain.png"
import lion1 from "../images/products/lion/lion1.png"
import lion2 from "../images/products/lion/lion2.png"
import leopardmain from "../images/products/leopard/leopardmain.png"
import leopard1 from "../images/products/leopard/leopard1.png"
import leopard2 from "../images/products/leopard/leopard2.png"
import leopard3 from "../images/products/leopard/leopard3.png"
import leopard4 from "../images/products/leopard/leopard4.png"
import leopard5 from "../images/products/leopard/leopard5.png"
import newmugmain from "../images/products/newmug/newmugmain.png"
import newmug1 from "../images/products/newmug/newmug1.png"
import welcomeplaque from "../images/products/welcomeplaque.jpeg"
import checkmain from "../images/products/check/checkmain.png"
import check1 from "../images/products/check/check1.png"
import check2 from "../images/products/check/check2.png"
import check3 from "../images/products/check/check3.png"
import check4 from "../images/products/check/check4.png"
import check5 from "../images/products/check/check5.png"
import check6 from "../images/products/check/check6.png"
import dinosaurmain from "../images/products/dinosaur/dinosaurmain.png"
import dinosaur1 from "../images/products/dinosaur/dinosaur1.png"
import dinosaur2 from "../images/products/dinosaur/dinosaur2.png"
import dinosaur3 from "../images/products/dinosaur/dinosaur3.png"
import dinosaur4 from "../images/products/dinosaur/dinosaur4.png"
import whitedinosaur from "../images/products/whitedinosaur.png"
import bluedinosaur from "../images/products/bluedinosaur.png"
import sheepblanket from "../images/products/sheepblanket.jpeg"
import letterboxbibmain from "../images/products/letterboxbib/letterboxbibmain.png"
import letterboxbib1 from "../images/products/letterboxbib/letterboxbib1.png"
import navybib from "../images/products/navybib.png"
import greybib from "../images/products/greybib.png"
import whitebib from "../images/products/whitebib.png"
import bluebib from "../images/products/bluebib.png"
import pinkbib from "../images/products/pinkbib.png"
import alltoowordy from "../images/products/toowordy/alltoowordy.jpeg"
import babyboybanner from '../images/products/toowordy/babyboybanner.jpeg'
import bluetiny from '../images/products/toowordy/bluetiny.jpeg'
import bluewelcomebanner from '../images/products/toowordy/bluewelcomebanner.jpeg'
import brandlittledude from '../images/products/toowordy/brandlittledude.jpeg'
import brandnewlittlelady from '../images/products/toowordy/brandnewlittlelady.jpeg'
import bundleofjoy from '../images/products/toowordy/bundleofjoy.jpeg'
import buninoven from '../images/products/toowordy/buninoven.jpeg'
import lovelyhappynews from '../images/products/toowordy/lovelyhappynews.jpeg'
import newchapter from '../images/products/toowordy/newchapter.jpeg'
import pinktiny from '../images/products/toowordy/pinktiny.jpeg'
import pinkwelcome from '../images/products/toowordy/pinkwelcome.jpeg'
import preciousdaughter from '../images/products/toowordy/preciousdaughter.jpeg'
import pinkhearttaggie from "../images/products/pinkhearttaggie.png"
import bluestartaggie from "../images/products/bluestartaggie.png"
import whitecartaggie from "../images/products/whitecartaggie.png"
import greystartaggie from "../images/products/greystartaggie.png"
import elephantcomforterrattle from "../images/products/elephantcomforterrattle.jpeg"
import recgiraffecomforter from "../images/products/recgiraffecomforter.jpeg"
import reclambcomforter from "../images/products/reclambcomforter.jpeg"
import whitestartaggie from "../images/products/whitestartaggie.png"
import knitrabbit from "../images/products/knitrabbit.jpeg"
import knitcat from "../images/products/knitcat.jpeg"
import allbibs from "../images/products/allbibs.jpeg"
import giraffecomforterrattle from "../images/products/giraffecomforterrattle.jpeg"
import dinosaurblanket from "../images/products/dinosaurblanket.jpeg"
import starblanket from "../images/products/starblanket.jpeg"
import bluestarblanket from "../images/products/bluestarblanket.jpeg"
import giraffeprintblanket from '../images/products/giraffeprintblanket.jpeg'
import allmuslins from '../images/products/allmuslins.jpeg'
import allbooties from '../images/products/allbooties.jpeg'
import newbabyletterboxmain from '../images/products/newbabyletterbox/newbabyletterboxmain.png'
import alltaggies from '../images/products/alltaggies.jpeg'
import taggieletterboxmain from '../images/products/taggieletterbox/taggieletterboxmain.png'
import bathset from '../images/products/bathset.jpeg'
import sheepbathmain from '../images/products/sheepbath/sheepbathmain.png'
import sheeptowel from '../images/products/sheeptowel.png'
import farmyardbathmain from '../images/products/farmyardbath/farmyardbathmain.png'
import greydressing from '../images/products/greydressing.png'
import pinkdressing from '../images/products/pinkdressing.png'
import bearbathmain from '../images/products/bearbath/bearbathmain.png'
import bearbath1 from '../images/products/bearbath/bearbath1.png'
import bearbath2 from '../images/products/bearbath/bearbath2.png'
import allcellular from '../images/products/allcellular.jpeg'
import bluecellular from '../images/products/bluecellular.jpeg'
import rosewaffle from '../images/products/rosewaffle.jpeg'
import coffeewaffle from '../images/products/coffeewaffle.jpeg'
import mustardwaffle from '../images/products/mustardwaffle.jpeg'
import bluewaffle from '../images/products/bluewaffle.jpeg'
import pinkwaffle from '../images/products/pinkwaffle.jpeg'
import greywaffle from '../images/products/greywaffle.jpeg'
import navyknittedblanket from '../images/products/navyknittedblanket.jpeg'
import elephantblanket from '../images/products/elephantblanket.png'
import allorganicblankets from '../images/products/allorganicblankets.jpeg'
import organicdandelion from '../images/products/organicdandelion.jpeg'
import organicorangegeometric from '../images/products/organicorangegeometric.jpeg'
import organicwhitegeometric from '../images/products/organicwhitegeometric.jpeg'
import sageknittedblanket from '../images/products/sageknittedblanket.jpeg'
import floralminkblanket from '../images/products/floralminkblanket.png'
import elephantwrap from '../images/products/elephantwrap.jpeg'
import owlwrap from '../images/products/owlwrap.jpeg'
import knotheadbandpk from '../images/products/knotheadbandpk.jpeg'
import knotheadbandwh from '../images/products/knotheadbandwh.jpeg'
import floralwrapandhead from '../images/products/floralwrapandhead.jpeg'
import mugs from '../images/products/mugs.jpeg'
import countdownboards from '../images/products/countdownboards.jpeg'
import bigbrotherboard from '../images/products/bigbrotherboard.png'
import placeholder from '../images/products/placeholder.png'
import bowbooties from '../images/products/bowbooties.jpeg'
import unicorncomfblanket from '../images/products/unicorncomfblanket/unicorncomfblanket.jpeg'
import unicorncomfblanket1 from '../images/products/unicorncomfblanket/unicorncomfblanket1.jpeg'
import unicorncomfblanket2 from '../images/products/unicorncomfblanket/unicorncomfblanket2.jpeg'
import elephantcomfblanket from '../images/products/elephcomfblanket/elephantcomfblanket.jpeg'
import elephantcomfblanket1 from '../images/products/elephcomfblanket/elephantcomfblanket1.jpeg'
import elephantcomfblanket2 from '../images/products/elephcomfblanket/elephantcomfblanket2.jpeg'
import allorganicbowteether from '../images/products/allorganicbowteether.png'
import allorganicrainbowteether from '../images/products/allorganicrainbowteether.jpeg'
import greyknitcardi from '../images/products/greyknitcardi.jpeg'
import navyknitcardi from '../images/products/navyknitcardi.jpeg'
import pinkcardifancy1 from '../images/products/pinkcardifancyknit/pinkcardifancy1.jpeg'
import pinkcardifancy2 from '../images/products/pinkcardifancyknit/pinkcardifancy2.jpeg'
import whiteknitcardi from '../images/products/whiteknitcardi.jpeg'
import bunnytoy from '../images/products/bunnytoy.jpeg'
import softcube from '../images/products/softcube.png'
import allrecrattle from '../images/products/allrecrattle.jpeg'
import allrecrings from '../images/products/allrecrings.jpeg'
import sheephoodedtowel from '../images/products/sheephoodedtowel.png'
import pinkbeartowel from '../images/products/pinkbeartowel.png'
import dinotowel from '../images/products/dinotowel.png'
import flowertowel from '../images/products/flowertowel.png'
import zebratowel from '../images/products/zebratowel.png'
import boyheartplaque from '../images/products/boyheartplaque.png'
import boykeepsakebox from '../images/products/boykeepsakebox.png'
import girlkeepsakebox from '../images/products/girlkeepsakebox.png'
import allstarmoneyboxes from '../images/products/allstarmoneyboxes.jpeg'
import boardbooks from '../images/products/boardbooks.png'
import mazecoasters from '../images/products/mazecoasters.png'
import vehiclejigsaw from '../images/products/vehiclejigsaw.png'
import woodenblocks from '../images/products/woodenblocks.png'
import rainbowspotmain from '../images/products/rainbowspot/rainbowspotmain.png'
import rainbowspot1 from '../images/products/rainbowspot/rainbowspot1.png'
import rainbowspot2 from '../images/products/rainbowspot/rainbowspot2.png'
import rainbowspot3 from '../images/products/rainbowspot/rainbowspot3.png'
import rainbowspot4 from '../images/products/rainbowspot/rainbowspot4.png'
import rainbowspot5 from '../images/products/rainbowspot/rainbowspot5.png'
import thpcwhiteelephantmummymain from '../images/products/thpcwhiteelephantmummy/thpcwhiteelephantmummymain.jpeg'
import thpcwhiteelephantmummy1 from '../images/products/thpcwhiteelephantmummy/thpcwhiteelephantmummy1.jpeg'
import thpcwhiteelephantmummy2 from '../images/products/thpcwhiteelephantmummy/thpcwhiteelephantmummy2.jpeg'
import fipcwhiteelephantmain from '../images/products/fipcwhiteelephant/fipcwhiteelephantmain.jpeg'
import fipcwhiteelephant1 from '../images/products/fipcwhiteelephant/fipcwhiteelephant1.jpeg'
import fipcwhiteelephant2 from '../images/products/fipcwhiteelephant/fipcwhiteelephant2.jpeg'
import fipcwhiteelephant3 from '../images/products/fipcwhiteelephant/fipcwhiteelephant3.jpeg'
import fipcwhiteelephant4 from '../images/products/fipcwhiteelephant/fipcwhiteelephant4.jpeg'
import fipcpurplefloralrabmain from '../images/products/fipcpurplefloralrab/fipcpurplefloralrabmain.jpeg'
import fipcpurplefloralrab1 from '../images/products/fipcpurplefloralrab/fipcpurplefloralrab1.jpeg'
import fipcpurplefloralrab2 from '../images/products/fipcpurplefloralrab/fipcpurplefloralrab2.jpeg'
import fipcpurplefloralrab3 from '../images/products/fipcpurplefloralrab/fipcpurplefloralrab3.jpeg'
import fipcpurplefloralrab4 from '../images/products/fipcpurplefloralrab/fipcpurplefloralrab4.jpeg'
import fipcwhitelambsmain from '../images/products/fipcwhitelambs/fipcwhitelambsmain.jpeg'
import fipcwhitelambs1 from '../images/products/fipcwhitelambs/fipcwhitelambs1.jpeg'
import fipcwhitelambs2 from '../images/products/fipcwhitelambs/fipcwhitelambs2.jpeg'
import fipcwhitelambs3 from '../images/products/fipcwhitelambs/fipcwhitelambs3.jpeg'
import fipcwhitelambs4 from '../images/products/fipcwhitelambs/fipcwhitelambs4.jpeg'
import fipctransportmain from '../images/products/fipctransport/fipctransportmain.jpeg'
import fipctransport1 from '../images/products/fipctransport/fipctransport1.jpeg'
import fipctransport2 from '../images/products/fipctransport/fipctransport2.jpeg'
import fipctransport3 from '../images/products/fipctransport/fipctransport3.jpeg'
import fipctransport4 from '../images/products/fipctransport/fipctransport4.jpeg'
import fipcsafarimain from '../images/products/fipcsafari/fipcsafarimain.jpeg'
import fipcsafari1 from '../images/products/fipcsafari/fipcsafari1.jpeg'
import fipcsafari2 from '../images/products/fipcsafari/fipcsafari2.jpeg'
import fipcsafari3 from '../images/products/fipcsafari/fipcsafari3.jpeg'
import fipcsafari4 from '../images/products/fipcsafari/fipcsafari4.jpeg'
import thpcdinosaurmain from '../images/products/thpcdinosaur/thpcdinosaurmain.jpeg'
import thpcdinosaur1 from '../images/products/thpcdinosaur/thpcdinosaur1.jpeg'
import thpcdinosaur2 from '../images/products/thpcdinosaur/thpcdinosaur2.jpeg'
import fipcnavyteddymain from '../images/products/fipcnavyteddy/fipcnavyteddymain.jpeg'
import fipcnavyteddy1 from '../images/products/fipcnavyteddy/fipcnavyteddy1.jpeg'
import fipcnavyteddy2 from '../images/products/fipcnavyteddy/fipcnavyteddy2.jpeg'
import fipcnavyteddy3 from '../images/products/fipcnavyteddy/fipcnavyteddy4.jpeg'
import fipcnavyteddy4 from '../images/products/fipcnavyteddy/fipcnavyteddy4.jpeg'
import fipclittledinosaurmain from '../images/products/fipclittledinosaur/fipclittledinosaurmain.jpeg'
import fipcbeepmain from '../images/products/fipcbeep/fipcbeepmain.jpeg'
import fipcbeep1 from '../images/products/fipcbeep/fipcbeep1.jpeg'
import fipcbeep2 from '../images/products/fipcbeep/fipcbeep2.jpeg'
import fipcbeep3 from '../images/products/fipcbeep/fipcbeep3.jpeg'
import fipcbeep4 from '../images/products/fipcbeep/fipcbeep4.jpeg'
import fipcbluewhalemain from '../images/products/fipcbluewhale/fipcbluewhalemain.jpeg'
import fipcbluewhale1 from '../images/products/fipcbluewhale/fipcbluewhale1.jpeg'
import fipcbluewhale2 from '../images/products/fipcbluewhale/fipcbluewhale2.jpeg'
import fipcbluewhale3 from '../images/products/fipcbluewhale/fipcbluewhale3.jpeg'
import fipcbluewhale4 from '../images/products/fipcbluewhale/fipcbluewhale4.jpeg'
import fipcbluepandamain from '../images/products/fipcbluepanda/fipcbluepandamain.jpeg'
import fipcbluepanda1 from '../images/products/fipcbluepanda/fipcbluepanda1.jpeg'
import fipcbluepanda2 from '../images/products/fipcbluepanda/fipcbluepanda2.jpeg'
import fipcbluepanda3 from '../images/products/fipcbluepanda/fipcbluepanda3.jpeg'
import fipcbluepanda4 from '../images/products/fipcbluepanda/fipcbluepanda4.jpeg'
import fipcahoywhalemain from '../images/products/fipcahoywhale/fipcahoywhalemain.jpeg'
import fipcahoywhale1 from '../images/products/fipcahoywhale/fipcahoywhale1.jpeg'
import fipcahoywhale2 from '../images/products/fipcahoywhale/fipcahoywhale2.jpeg'
import fipcahoywhale3 from '../images/products/fipcahoywhale/fipcahoywhale3.jpeg'
import fipcahoywhale4 from '../images/products/fipcahoywhale/fipcahoywhale4.jpeg'
import nipcbestfriendsmain from '../images/products/nipcbestfriends/nipcbestfriendsmain.jpeg'
import nipcbestfriends1 from '../images/products/nipcbestfriends/nipcbestfriends1.jpeg'
import nipcbestfriends2 from '../images/products/nipcbestfriends/nipcbestfriends2.jpeg'
import nipcbestfriends3 from '../images/products/nipcbestfriends/nipcbestfriends3.jpeg'
import fipcgreystarmain from '../images/products/fipcgreystar/fipcgreystarmain.jpeg'
import fipcgreystar1 from '../images/products/fipcgreystar/fipcgreystar1.jpeg'
import fipcgreystar2 from '../images/products/fipcgreystar/fipcgreystar2.jpeg'
import fipcgreystar3 from '../images/products/fipcgreystar/fipcgreystar3.jpeg'
import fipcgreystar4 from '../images/products/fipcgreystar/fipcgreystar4.jpeg'
import thpcbearmain from '../images/products/thpcbear/thpcbearmain.jpeg'
import thpcbear1 from '../images/products/thpcbear/thpcbear1.jpeg'
import thpcbear2 from '../images/products/thpcbear/thpcbear2.jpeg'
import thpcbear3 from '../images/products/thpcbear/thpcbear3.jpeg'
import thpcfarmmain from '../images/products/thpcfarm/thpcfarmmain.jpeg'
import thpcfarm1 from '../images/products/thpcfarm/thpcfarm1.jpeg'
import thpcfarm2 from '../images/products/thpcfarm/thpcfarm2.jpeg'
import fipcpinkfloralmain from '../images/products/fipcpinkfloral/fipcpinkfloralmain.jpeg'
import fipcpinkfloral1 from '../images/products/fipcpinkfloral/fipcpinkfloral1.jpeg'
import fipcpinkfloral2 from '../images/products/fipcpinkfloral/fipcpinkfloral2.jpeg'
import fipcpinkfloral3 from '../images/products/fipcpinkfloral/fipcpinkfloral3.jpeg'
import fipcpinkfloral4 from '../images/products/fipcpinkfloral/fipcpinkfloral4.jpeg'
import fipcpinkcloudmain from '../images/products/fipcpinkcloud/fipcpinkcloudmain.jpeg'
import fipcpinkcloud1 from '../images/products/fipcpinkcloud/fipcpinkcloud1.jpeg'
import fipcpinkcloud2 from '../images/products/fipcpinkcloud/fipcpinkcloud2.jpeg'
import fipcpinkcloud3 from '../images/products/fipcpinkcloud/fipcpinkcloud3.jpeg'
import fipcpinkcloud4 from '../images/products/fipcpinkcloud/fipcpinkcloud4.jpeg'
import fipcbluefloralmain from '..//images/products/fipcbluefloral/fipcbluefloralmain.jpeg'
import fipcbluefloral1 from '..//images/products/fipcbluefloral/fipcbluefloral1.jpeg'
import fipcbluefloral2 from '..//images/products/fipcbluefloral/fipcbluefloral2.jpeg'
import fipcbluefloral3 from '..//images/products/fipcbluefloral/fipcbluefloral3.jpeg'
import fipcbluefloral4 from '../images/products/fipcbluefloral/fipcbluefloral4.jpeg'
import fipcballmousemain from '../images/products/fipcballmouse/fipcballmousemain.jpeg'
import fipcballmouse1 from '../images/products/fipcballmouse/fipcballmouse1.jpeg'
import fipcballmouse2 from '../images/products/fipcballmouse/fipcballmouse2.jpeg'
import fipcballmouse3 from '../images/products/fipcballmouse/fipcballmouse3.jpeg'
import fipcballmouse4 from '../images/products/fipcballmouse/fipcballmouse4.jpeg'
import fipcbrownleopardmain from '../images/products/fipcbrownleopard/fipcbrownleopardmain.jpeg'
import fipcbrownleopard1 from '../images/products/fipcbrownleopard/fipcbrownleopard1.jpeg'
import fipcbrownleopard2 from '../images/products/fipcbrownleopard/fipcbrownleopard2.jpeg'
import fipcbrownleopard3 from '../images/products/fipcbrownleopard/fipcbrownleopard3.jpeg'
import fipcbrownleopard4 from '../images/products/fipcbrownleopard/fipcbrownleopard4.jpeg'
import fipclilacrainmain from '../images/products/fipclilacrain/fipclilacrainmain.jpeg'
import fipclilacrain1 from '../images/products/fipclilacrain/fipclilacrain1.jpeg'
import fipclilacrain2 from '../images/products/fipclilacrain/fipclilacrain2.jpeg'
import fipclilacrain3 from '../images/products/fipclilacrain/fipclilacrain3.jpeg'
import fipclilacrain4 from '../images/products/fipclilacrain/fipclilacrain4.jpeg'
import fipcrosebunnymain from '../images/products/fipcrosebunny/fipcrosebunnymain.jpeg'
import fipcrosebunny1 from '../images/products/fipcrosebunny/fipcrosebunny1.jpeg'
import fipcrosebunny2 from '../images/products/fipcrosebunny/fipcrosebunny2.jpeg'
import fipcrosebunny3 from '../images/products/fipcrosebunny/fipcrosebunny3.jpeg'
import fipcrosebunny4 from '../images/products/fipcrosebunny/fipcrosebunny4.jpeg'
import fipcpastelfloralmain from '../images/products/fipcpastelfloral/fipcpastelfloralmain.jpeg'
import fipcpastelfloral1 from '../images/products/fipcpastelfloral/fipcpastelfloral1.jpeg'
import fipcpastelfloral2 from '../images/products/fipcpastelfloral/fipcpastelfloral2.jpeg'
import fipcpastelfloral3 from '../images/products/fipcpastelfloral/fipcpastelfloral3.jpeg'
import fipcpastelfloral4 from '../images/products/fipcpastelfloral/fipcpastelfloral4.jpeg'
import fipcpinkblossommain from '../images/products/fipcpinkblossom/fipcpinkblossommain.jpeg'
import fipcpinkblossom1 from '../images/products/fipcpinkblossom/fipcpinkblossom1.jpeg'
import fipcpinkblossom2 from '../images/products/fipcpinkblossom/fipcpinkblossom2.jpeg'
import fipcpinkblossom3 from '../images/products/fipcpinkblossom/fipcpinkblossom3.jpeg'
import fipcpinkblossom4 from '../images/products/fipcpinkblossom/fipcpinkblossom4.jpeg'
import fipclemonbravemain from '../images/products/fipclemonbrave/fipclemonbravemain.jpeg'
import fipclemonbrave1 from '../images/products/fipclemonbrave/fipclemonbrave1.jpeg'
import fipclemonbrave2 from '../images/products/fipclemonbrave/fipclemonbrave2.jpeg'
import fipclemonbrave3 from '../images/products/fipclemonbrave/fipclemonbrave3.jpeg'
import fipclemonbrave4 from '../images/products/fipclemonbrave/fipclemonbrave4.jpeg'
import fipcbrownsafarimain from '../images/products/fipcbrownsafari/fipcbrownsafarimain.jpeg'
import fipcbrownsafari1 from '../images/products/fipcbrownsafari/fipcbrownsafari1.jpeg'
import fipcbrownsafari2 from '../images/products/fipcbrownsafari/fipcbrownsafari2.jpeg'
import fipcbrownsafari3 from '../images/products/fipcbrownsafari/fipcbrownsafari3.jpeg'
import fipcbrownsafari4 from '../images/products/fipcbrownsafari/fipcbrownsafari4.jpeg'
import fipcwhiteabcmain from '../images/products/fipcwhiteabc/fipcwhiteabcmain.jpeg'
import fipcwhiteabc1 from '../images/products/fipcwhiteabc/fipcwhiteabc1.jpeg'
import fipcwhiteabc2 from '../images/products/fipcwhiteabc/fipcwhiteabc2.jpeg'
import fipcwhiteabc3 from '../images/products/fipcwhiteabc/fipcwhiteabc3.jpeg'
import fipcwhiteabc4 from '../images/products/fipcwhiteabc/fipcwhiteabc4.jpeg'
import fipcspottygmain from '../images/products/fipcspottyg/fipcspottygmain.jpeg'
import fipcspottyg1 from '../images/products/fipcspottyg/fipcspottyg1.jpeg'
import fipcspottyg2 from '../images/products/fipcspottyg/fipcspottyg2.jpeg'
import fipcspottyg3 from '../images/products/fipcspottyg/fipcspottyg3.jpeg'
import fipcspottyg4 from '../images/products/fipcspottyg/fipcspottyg4.jpeg'
import fipcwhiterabbitmain from '../images/products/fipcwhiterabbit/fipcwhiterabbitmain.jpeg'
import fipcwhiterabbit1 from '../images/products/fipcwhiterabbit/fipcwhiterabbit1.jpeg'
import fipcwhiterabbit2 from '../images/products/fipcwhiterabbit/fipcwhiterabbit2.jpeg'
import fipcwhiterabbit3 from '../images/products/fipcwhiterabbit/fipcwhiterabbit3.jpeg'
import dumbellrattlesmain from '../images/products/dumbellrattles/dumbellrattlesmain.jpeg'
import dumbellrattles1 from '../images/products/dumbellrattles/dumbellrattles1.jpeg'
import dumbellrattles2 from '../images/products/dumbellrattles/dumbellrattles2.jpeg'
import waterteethermain from '../images/products/waterteethers/waterteethermain.jpeg'
import waterteether1 from '../images/products/waterteethers/waterteether1.jpeg'
import waterteether2 from '../images/products/waterteethers/waterteether2.jpeg'
import waterteether3 from '../images/products/waterteethers/waterteether3.jpeg'
import waterteether4 from '../images/products/waterteethers/waterteether4.jpeg'
import pinkmuslinsetmain from '../images/products/pinkmuslinset/pinkmuslinsetmain.jpeg'
import pinkmuslinrompermain from '../images/products/pinkmuslinromper/pinkmuslinrompermain.jpeg'
import bluemuslinrompermain from '../images/products/bluemuslinromper/bluemuslinrompermain.jpeg'
import bluemuslindungareesmain from '../images/products/bluemuslindungarees/bluemuslindungareesmain.jpeg'
import fourpcanimalmain from '../images/products/fourpcanimal/fourpcanimalmain.jpeg'
import fourpcdinosaurmain from '../images/products/fourpcdinosaur/fourpcdinosaurmain.jpeg'
import fourpcbunnymain from '../images/products/fourpcbunny/fourpcbunnymain.jpeg'
import fourpcrainbowmain from '../images/products/fourpcrainbow/fourpcrainbowmain.jpeg'
import checksetmain from '../images/products/checkset/checksetmain.jpeg'
import checkset1 from '../images/products/checkset/checkset1.jpeg'
import checkset2 from '../images/products/checkset/checkset2.jpeg'
import checkset3 from '../images/products/checkset/checkset3.jpeg'
import checkset4 from '../images/products/checkset/checkset4.jpeg'
import checkset5 from '../images/products/checkset/checkset5.jpeg'
import coralorganicmain from '../images/products/coralorganic/coralorganicmain.jpeg'
import fipcmintorganicmain from '../images/products/fipcmintorganic/fipcmintorganicmain.jpeg'
import fipcmintorganic2 from '../images/products/fipcmintorganic/fipcmintorganic2.jpeg'
import fipcmintorganic3 from '../images/products/fipcmintorganic/fipcmintorganic3.jpeg'
import lemondaydreamermain from '../images/products/lemondaydreamer/lemondaydreamermain.jpeg'
import pinkfloralbummain from '../images/products/pinkfloralbum/pinkfloralbummain.jpeg'
import pinkfloralbum1 from '../images/products/pinkfloralbum/pinkfloralbum1.jpeg'
import pinkfloralbum2 from '../images/products/pinkfloralbum/pinkfloralbum2.jpeg'
import pinkfloralbum3 from '../images/products/pinkfloralbum/pinkfloralbum3.jpeg'
import fourpcpinkfloralmain from '../images/products/fourpcpinkfloral/fourpcpinkfloralmain.jpeg'
import fourpcpinkfloral1 from '../images/products/fourpcpinkfloral/fourpcpinkfloral1.jpeg'
import fourpcpinkfloral2 from '../images/products/fourpcpinkfloral/fourpcpinkfloral2.jpeg'
import fourpcpinkfloral3 from '../images/products/fourpcpinkfloral/fourpcpinkfloral3.jpeg'
import organicmintmain from '../images/products/organicmint/organicmintmain.jpeg'
import organicbeigemain from '../images/products/organicbeige/organicbeigemain.jpeg'
import animaldeermain from '../images/products/animaldeer/animaldeermain.png'
import elephantmummymain from '../images/products/elephantmummy/elephantmummymain.png'
import elephantcloudmain from '../images/products/elephantcloud/elephantcloudmain.png'
import brownsafarimain from '../images/products/brownsafari/brownsafarimain.png'
import bisforbabymain from '../images/products/bisforbaby/bisforbabymain.png'
import bluemuslinmain from '../images/products/bluemuslin/bluemuslinmain.png'
import bluemuslinorganicmain from '../images/products/bluemuslinorganic/bluemuslinorganicmain.png'
import coralmuslinorganicmain from '../images/products/coralmuslinorganic/coralmuslinorganicmain.png'
import pastelfloralhamper from '../images/products/pastelfloral/pastelfloralhamper.jpeg'
import blossomfloralhamper from '../images/products/blossomfloral/blossomfloralhamper.jpeg'
import floralbunnyhamper from '../images/products/floralbunny/floralbunnyhamper.jpeg'
import ballerinamousehamper from '../images/products/ballerinamouse/ballerinamousehamper.jpeg'
import pinkcloudhamper from '../images/products/pinkcloud/pinkcloudhamper.jpeg'
import pinkstarvelourhamper from '../images/products/pinkstarvelour/pinkstarvelourhamper.jpeg'
import pinkstarveloursingle from '../images/products/pinkstarveloursingle.jpeg'
import fleecedinohamper from '../images/products/fleecedinohamper/fleecedinohamper.jpeg'
import bluesafarihamper from '../images/products/bluesafarihamper/bluesafarihamper.jpeg'
import aeroplanehamper from '../images/products/aeroplanehamper/aeroplanehamper.jpeg'
import diggerhamper from '../images/products/diggerhamper/diggerhamper.jpeg'
import beepbeephamper from '../images/products/beepbeephamper/beepbeephamper.jpeg'
import cosypgiraffemain from '../images/products/cosypinkgiraffe/cosypgiraffemain.jpeg'
import cosypgiraffe1 from '../images/products/cosypinkgiraffe/cosypgiraffe1.jpeg'
import cosybmonkeymain from '../images/products/cosybluemonkey/cosybmonkeymain.jpeg'
import cosybmonkey1 from '../images/products/cosybluemonkey/cosybmonkey1.jpeg'
import cosygsheepmain from '../images/products/cosygreysheep/cosygsheepmain.jpeg'
import cosygsheep1 from '../images/products/cosygreysheep/cosygsheep1.jpeg'
import cosyclambmain from '../images/products/cosycreamlamb/cosyclambmain.jpeg'
import cosyclamb1 from '../images/products/cosycreamlamb/cosyclamb1.jpeg'
import milestonemugmain from '../images/products/milestonemug/milestonemugmain.jpeg'
import milestonemug1 from '../images/products/milestonemug/milestonemug1.jpeg'
import babyaccmain from '../images/products/babyaccessories/babyaccmain.jpeg'
import babyacc1 from '../images/products/babyaccessories/babyacc1.jpeg'
import blueteddybathmain from '../images/products/blueteddybath/blueteddybathmain.jpeg'
import blueteddybath1 from '../images/products/blueteddybath/blueteddybath1.jpeg'
import balletbathmain from '../images/products/balletbath/balletbathmain.jpeg'
import ballettowel from '../images/products/balletbath/ballettowel.jpeg'
import thpcminthamper from '../images/products/fipcmintorganic/thpcminthamper.jpeg'
import thpcminthamper1 from '../images/products/fipcmintorganic/thpcminthamper1.jpeg'
import fipcmintorganic4 from '../images/products/fipcmintorganic/fipcmintorganic4.jpeg'
import fipcmintorgmain from '../images/products/fipcorgminthamper/fipcmintorgmain.jpeg'
import fipcmintorg2 from '../images/products/fipcorgminthamper/fipcmintorg2.jpeg'
import fipcmintorg3 from '../images/products/fipcorgminthamper/fipcmintorg3.jpeg'
import fipcmintorg4 from '../images/products/fipcorgminthamper/fipcmintorg4.jpeg'
import bearteether from '../images/products/bearteether.jpeg'
import woodenrattle from '../images/products/woodenrattle.jpeg'
import zoomuslin from '../images/products/zoomuslin.jpeg'
import pandamuslin from '../images/products/pandamuslin.jpeg'
import rattleorganicmain from '../images/products/rattleorganic/rattleorganicmain.jpeg'
import rattleorganic1 from '../images/products/rattleorganic/rattleorganic1.jpeg'
import teetherorganicmain from '../images/products/teetherorganic/teetherorganicmain.jpeg'
import teetherorganic1 from '../images/products/teetherorganic/teetherorganic1.jpeg'
import babyscan from '../images/products/babyscan.jpeg'
import babyscanmain from '../images/products/babyscanhamper/babyscanmain.jpeg'
import babyscan1 from '../images/products/babyscanhamper/babyscan1.jpeg'
import knittedheartmain from '../images/products/knittedhearthamper/knittedheartmain.jpeg'
import knittedheart1 from '../images/products/knittedhearthamper/knittedheart1.jpeg'
import knittedheart2 from '../images/products/knittedhearthamper/knittedheart2.jpeg'
import ecounicorncomforter from '../images/products/ecounicorncomforter.jpeg'
import ecounicorntoy from '../images/products/ecounicorntoy.jpeg'
import pinkunicornmain from '../images/products/pinkunicornhamper/pinkunicornmain.jpeg'
import pinkunicorn1 from '../images/products/pinkunicornhamper/pinkunicorn1.jpeg'
import pinkunicorn2 from '../images/products/pinkunicornhamper/pinkunicorn2.jpeg'
import pinkunicorn3 from '../images/products/pinkunicornhamper/pinkunicorn3.jpeg'
import pinkunicorn4 from '../images/products/pinkunicornhamper/pinkunicorn4.jpeg'
import pinkunicorn5 from '../images/products/pinkunicornhamper/pinkunicorn5.jpeg'
import thpcblueelephmain from '../images/products/thpcblueeleph/thpcblueelephmain.jpeg'
import thpcblueeleph1 from '../images/products/thpcblueeleph/thpcblueeleph1.jpeg'
import thpcblueeleph2 from '../images/products/thpcblueeleph/thpcblueeleph2.jpeg'
import thpcblueeleph3 from '../images/products/thpcblueeleph/thpcblueeleph3.jpeg'
import brownbearcomf from '../images/products/brownbearcomf.jpeg'
import pinkbearcomf from '../images/products/pinkbearcomf.jpeg'
import colourmomentsmain from '../images/products/colourmoments/colourmomentsmain.jpeg'
import colourmomentspink from '../images/products/colourmoments/colourmomentspink.jpeg'
import colourmomentsblue from '../images/products/colourmoments/colourmomentsblue.jpeg'
import greyelephteether from '../images/products/greyelephteether.jpeg'
import pinkbunnyteether from '../images/products/pinkbunnyteether.jpeg'
import organicanimalsmain from '../images/products/organicanimal/organicanimalsmain.jpeg'
import organicpanda from '../images/products/organicanimal/organicpanda.jpeg'
import organiczoo from '../images/products/organicanimal/organiczoo.jpeg'
import thpcsheepmain from '../images/products/thpcsheep/thpcsheepmain.jpeg'
import thpcsheephamper from '../images/products/thpcsheep/thpcsheephamper.jpeg'
import thpcsheep1 from '../images/products/thpcsheep/thpcsheep1.jpeg'
import thpcsheep2 from '../images/products/thpcsheep/thpcsheep2.jpeg'
import fipcunicornmain from '../images/products/fipcpinkunicorn/fipcunicornmain.jpeg'
import fipcunicorn1 from '../images/products/fipcpinkunicorn/fipcunicorn1.jpeg'
import fipcunicorn2 from '../images/products/fipcpinkunicorn/fipcunicorn2.jpeg'
import fipcunicorn3 from '../images/products/fipcpinkunicorn/fipcunicorn3.jpeg'
import cablemitts from '../images/products/cablemitts.jpeg'
import pegframe from '../images/products/pegframe.jpeg'
import recordbook from '../images/products/recordbook.jpeg'
import photoalbum from '../images/products/photoalbum.jpeg'
import photoalbuminside from '../images/products/photoalbuminside.jpeg'
import woodenstacker from '../images/products/woodenstacker.jpeg'
import sheepgown from '../images/products/sheepgown.jpeg'
import bunnygown from '../images/products/bunnygown.jpeg'
import giraffeprintcomforter from '../images/products/giraffeprintcomforter.png'
import rainbowgown from '../images/products/rainbowgown.png'
import fipcbiglovemain from '../images/products/fipcbiglove/fipcbiglovemain.jpeg'
import fipcbiglove1 from '../images/products/fipcbiglove/fipcbiglove1.jpeg'
import fipcbiglove2 from '../images/products/fipcbiglove/fipcbiglove2.jpeg'
import fipcbiglove3 from '../images/products/fipcbiglove/fipcbiglove3.jpeg'
import fipcbiglovehamp from '../images/products/fipcbiglove/fipcbiglovehamp.jpeg'
import fipcnavybear1 from '../images/products/fipcnavybear/fipcnavybear1.jpeg'
import fipcnavybear2 from '../images/products/fipcnavybear/fipcnavybear2.jpeg'
import fipclookup1 from '../images/products/fipclookup/fipclookup1.jpeg'
import fipcmintzebra from '../images/products/fipcmintzebra/fipcmintzebra.jpeg'
import fipcsafaribaby from '../images/products/fipcsafaribaby/fipcsafaribaby.jpeg'
import pinkdoubleknit from '../images/products/pinkdoubleknit.jpeg'
import brownknitted from '../images/products/brownknitted.jpeg'
import mintorganicsetmain from '../images/products/mintorganicset/mintorganicsetmain.jpeg'
import mintorganicset1 from '../images/products/mintorganicset/mintorganicset1.jpeg'
import navyknitbear from '../images/products/navyknitbear.jpeg'
import whiteknitbear from '../images/products/whiteknitbear.jpeg'
import roseknitbear from '../images/products/roseknitbear.jpeg'
import fipcsunshinerainbowsmain from '../images/products/fipcsunshinerainbow/fipcsunshinerainbowsmain.jpeg'
import fipcmusicalbearmain from '../images/products/fipcmusicalbear/fipcmusicalbearmain.jpeg'
import ecolambtoy from '../images/products/ecolambtoy.jpeg'
import ecozebratoy from '../images/products/ecozebratoy.jpeg'
import ecogiraffetoy from '../images/products/ecogiraffetoy.jpeg'
import fipclovebearmain from '../images/products/fipclovebear/fipclovebearmain.jpeg'
import fipclovetwirlbearmain from '../images/products/fipclovetwirlbear/fipclovetwirlbearmain.jpeg'
import fipcbluedinosaurmain from '../images/products/fipcbluedinosaur/fipcbluedinosaurmain.jpeg'
import knittedheart from '../images/products/knittedheart.jpeg'
import thpkleopardmuslin from '../images/products/thpkleopardmuslin.jpeg'
import thpkleafmuslin from '../images/products/thpkleafmuslin.jpeg'
import elephantorganicmuslin from '../images/products/elephantorganicmuslin.jpeg'
import flowerorganicmuslin from '../images/products/flowerorganicmuslin.jpeg'
import seaanimalsorganicmuslin from '../images/products/seaanimalsorganicmuslin.jpeg'
import spotorganicmuslin from '../images/products/spotorganicmuslin.jpeg'
import orangeleaforganicmuslin from '../images/products/orangeleaforganicmuslin.jpeg'
import leopardorganicmuslin from '../images/products/leopardorganicmuslin.jpeg'
import leaforganicmuslin from '../images/products/leaforganicmuslin.jpeg'
import swirlorganicmuslin from '../images/products/swirlorganicmuslin.jpeg'
import rosebowbooties from '../images/products/rosebowbooties.jpeg'
import greybowbooties from '../images/products/greybowbooties.jpeg'
import sagebooties from '../images/products/sagebooties.jpeg'
import beigebooties from '../images/products/beigebooties.jpeg'
import rosebooties from '../images/products/rosebooties.jpeg'
import rabbitblanketcomf from '../images/products/rabbitblanketcomf.jpeg'
import mummymug from '../images/products/mummymug.jpeg'
import daddymug from '../images/products/daddymug.jpeg'
import knotheadbands from '../images/products/knotheadbands.jpeg'
import redwaffle from '../images/products/redwaffle.jpeg'
import gingerbreadbooties from '../images/products/gingerbreadbooties.jpeg'
import reindeerblanket from '../images/products/reindeerblanket.jpeg'
import snowmanbooties from '../images/products/snowmanbooties.jpeg'
import xmasbibs from '../images/products/xmasbibs.jpeg'
import xmashatbooties from '../images/products/xmashatbooties.jpeg'
import xmasonesie from '../images/products/xmasonesie.jpeg'
import xmasjumper from '../images/products/xmasjumper.jpeg'
import xmaspyjamas from '../images/products/xmaspyjamas.jpeg'
import elfhatbooties from '../images/products/elfhatbooties.jpeg'
import knittedwhite from '../images/products/knittedwhite.jpeg'
import looksafari from '../images/products/looksafari.jpeg'
import knittedstarstripehamper from "../images/products/knittedstarstripehamper.jpeg"
import greystarstripe from "../images/products/greystarstripe.jpeg"
import blueknittedbear from "../images/products/blueknittedbear.jpeg"
import knittednavystripemain from "../images/products/knittednavystripe/knittednavystripemain.jpeg"
import knittednavystripe1 from "../images/products/knittednavystripe/knittednavystripe1.jpeg"
import bluedoubleknit from "../images/products/bluedoubleknit.jpeg"
import quiltedsheepmain from "../images/products/quiltedsheep/quiltedsheepmain.jpeg"
import quiltedsheep1 from "../images/products/quiltedsheep/quiltedsheep1.jpeg"
import elephantstarblanket from "../images/products/elephantstarblanket.jpeg"
import ballerinatowel from "../images/products/ballerinatowel.jpeg"
import bicyclebear from "../images/products/bicyclebear.jpeg"
import elephanthoodedtowel from "../images/products/elephanthoodedtowel.jpeg"
import fipcmusicalanimals from '../images/products/fipcmusicalanimals.jpeg'
import fipcbunnymeadow from '../images/products/fipcbunnymeadow.jpeg'
import fipcballerina from '../images/products/fipcballerina.jpeg'
import bunnyvelour from "../images/products/bunnyvelour.jpeg"
import heartstarvelour from "../images/products/heartstarvelour.jpeg"
import floralbootieheadband from "../images/products/floralbootieheadband.jpeg"
import fipcballoonanimal from "../images/products/fipcballoonanimal.jpeg"
import fipcbrightsafari from "../images/products/fipcbrightsafari.jpeg"
import fipcmonoanimal from "../images/products/fipcmonoanimal.jpeg"
import navybearhamper from "../images/products/navybearhamper.jpeg"
import allhats from '../images/products/allhats.jpeg'
import knittedstripehamper from '../images/products/knittedstripehamper.jpeg'
import fipcballoonanimalmain from '../images/products/fipcballoonanimal/fipcballoonanimalmain.jpeg'
import newwhiteelephanthamper from '../images/products/newwhiteelephanthamper.jpeg'
import elephantbathhamper from '../images/products/elephantbathhamper.jpeg'
import alloversheepbath from '../images/products/alloversheepbath.jpeg'
import rainbowbath from '../images/products/rainbowbath.jpeg'
import cosypinkbunny from '../images/products/cosypinkbunny.jpeg'
import bunnyballethamper from '../images/products/bunnyballethamper.jpeg'
import mintzebrahamper from '../images/products/mintzebrahamper.jpeg'
import organicblackswirl from '../images/products/organicblackswirl.jpeg'
import organicseacreatures from '../images/products/organicseacreatures.jpeg'
import organicpastelelephant from '../images/products/organicpastelelephant.jpeg'
import organicorgangeleaf from '../images/products/organicorgangeleaf.jpeg'
import organicorangespot from '../images/products/organicorangespot.jpeg'
import organicgreenleaf from '../images/products/organicgreenleaf.jpeg'
import organicpinkfloral from '../images/products/organicpinkfloral.jpeg'
import organicleopard from '../images/products/organicleopard.jpeg'
import organicleopardmultipk from '../images/products/organicleopardmultipk.jpeg'
import organicleafmulti from '../images/products/organicleafmulti.jpeg'
import organicspotmulti from '../images/products/organicspotmulti.jpeg'
import brightrainbowhamper from '../images/products/brightrainbowhamper.jpeg'
import pinkballethamper from '../images/products/pinkballethamper.jpeg'
import lionjumperset from '../images/products/lionjumperset.jpeg'
import pandajumperset from '../images/products/pandajumperset.jpeg'
import pandajumperhamper from '../images/products/pandajumperhamper.jpeg'
import lionjumperhamper from '../images/products/lionjumperhamper.jpeg'
import starelephanthamper from '../images/products/starelephanthamper.jpeg'
import fipcelephantstar from '../images/products/fipcelephantstar.jpeg'
import fipcwhiteteddy from '../images/products/fipcwhiteteddy.jpeg'
import fipcbluesafari from '../images/products/fipcbluesafari.jpeg'
import hoodedknittedheart from '../images/products/hoodedknittedheart.jpeg'
import whiteteddyhamper from '../images/products/whiteteddyhamper.jpeg'
import bluesafarimain from '../images/products/bluesafari/bluesafarimain.jpeg'
import bluesafari1 from '../images/products/bluesafari/bluesafari1.jpeg'
import bluesafari2 from '../images/products/bluesafari/bluesafari2.jpeg'
import bluesafari3 from '../images/products/bluesafari/bluesafari3.jpeg'
import elephantstarhamper from '../images/products/elephantstarhamper.jpeg'
import bluestripehampermain from '../images/products/bluestripehamper/bluestripehampermain.jpeg'
import bluestripehamper from '../images/products/bluestripehamper/bluestripehamper.jpeg'
import allcomforters1 from '../images/products/allcomforters1.jpeg'
import knittedstripehamper1 from '../images/products/knittedstripehamper1.jpeg'
import knittedblueteddymain from '../images/products/knittedblueteddy/knittedblueteddymain.jpeg'
import knittedblueteddy1 from '../images/products/knittedblueteddy/knittedblueteddy1.jpeg'
import pinkcardihamper from '../images/products/pinkcardihamper.jpeg'
import sheepjoghamper from '../images/products/sheepjoghamper.jpeg'
import littlecosybear from '../images/products/littlecosy/littlecosybear.jpeg'
import littlecosypenguin from '../images/products/littlecosy/littlecosypenguin.jpeg'
import littlecosyelephant from '../images/products/littlecosy/littlecosyelephant.jpeg'
import aopzebratowel from '../images/products/aopzebratowel.jpeg'
import aopsafaritowel from '../images/products/aopsafaritowel.jpeg'
import velourteddymain from '../images/products/velourteddy/velourteddymain.jpeg'
import velourteddy1 from '../images/products/velourteddy/velourteddy1.jpeg'
import firstxmashamper from '../images/products/firstxmashamper.jpeg'
import xmasbowhamper from '../images/products/xmasbowhamper.jpeg'
import aopzebrabathmain from '../images/products/aopzebrabath/aopzebrabathmain.jpeg'
import aopzebrabath1 from '../images/products/aopzebrabath/aopzebrabath1.jpeg'
import aopsafaribathmain from '../images/products/aopsafaribath/aopsafaribathmain.jpeg'
import aopsafaribath1 from '../images/products/aopsafaribath/aopsafaribath1.jpeg'
import musicalanimalhamper from '../images/products/musicalanimalhamper.jpeg'
import brownbearsuitcase from '../images/products/brownbearsuitcase.jpeg'
import suitcases from '../images/products/suitcases.jpeg'
import cosysheepsuitcase from '../images/products/cosysheepsuitcase.jpeg'
import greycosysheepsuitcase from '../images/products/greycosysheepsuitcase.jpeg'
import monkeysuitcase from '../images/products/monkeysuitcase.jpeg'
import lambsuitcase from '../images/products/lambsuitcase.jpeg'
import pinkbearsuitcase from '../images/products/pinkbearsuitcase.jpeg'
import penguinsuitcase from '../images/products/penguinsuitcase.jpeg'
import sheepsuitcase from '../images/products/sheepsuitcase.jpeg'
import lionsuitcase from '../images/products/lionsuitcase.jpeg'
import unicornsuitcase from '../images/products/unicornsuitcase.jpeg'
import smallbrownbearsuitcase from '../images/products/smallbrownbearsuitcase.jpeg'
import whiteelephantsuitcase from '../images/products/whiteelephantsuitcase.jpeg'
import bluebunnysuitcase from '../images/products/bluebunnysuitcase.jpeg'
import bluebunny from '../images/products/bluebunny.jpeg'
import greyfloralbunny from '../images/products/greyfloralbunny.jpeg'
import pinkfloralbunny from '../images/products/pinkfloralbunny.jpeg'
import pinkbunnycomf from '../images/products/pinkbunnycomf.jpeg'
import whitebunny from '../images/products/whitebunny.jpeg'
import whitebunnysuitcase from '../images/products/whitebunnysuitcase.jpeg'
import giraffesuitcase from '../images/products/giraffesuitcase.jpeg'
import whitedinosaursuitcase from '../images/products/whitedinosaursuitcase.jpeg'
import beigecosysuitcase from '../images/products/beigecosysuitcase.jpeg'
import whitecosysuitcase from '../images/products/whitecosysuitcase.jpeg'
import knittedbowhamper from '../images/products/knittedbowhamper.jpeg'
import knittedbowset from '../images/products/knittedbowset.jpeg'
import threepcblueknitted from '../images/products/threepcblueknitted.jpeg'
import threepcgreyknitted from '../images/products/threepcgreyknitted.jpeg'
import navycablestripe from '../images/products/navycablestripe.jpeg'
import navydoubleknit from '../images/products/navydoubleknit.jpeg'
import woodenbrush from '../images/products/woodenbrush.jpeg'
import quiltedrosebunny from '../images/products/quiltedrosebunny.jpeg'
import mintcuddles from '../images/products/mintcuddles.jpeg'
import safarijacketset from '../images/products/safarijacketset.jpeg'
import cosypenguin from '../images/products/cosypenguin.jpeg'
import woodlandgown from '../images/products/woodlandgown.jpeg'
import quiltedgreybunny from '../images/products/quiltedgreybunny.jpeg'
import knittedgreystripe from '../images/products/knittedgreystripe.jpeg'
import velourzebra from '../images/products/velourzebra.jpeg'
import zebraonesiehamper from '../images/products/zebraonesiehamper.jpeg'
import fipcrainbowsafari from '../images/products/fipcrainbowsafari.jpeg'
import fipcwhitegiraffe from '../images/products/fipcwhitegiraffe.jpeg'
import whitegiraffehamper from '../images/products/whitegiraffehamper.jpeg'
import whitegiraffehamper2 from '../images/products/whitegiraffehamper2.jpeg'
import rainbowsafarihamper2 from '../images/products/rainbowsafarihamper2.jpeg'
import rainbowsafarihamper from '../images/products/rainbowsafarihamper.jpeg'
import cosygiraffesage from '../images/products/cosygiraffe/cosygiraffesage.jpeg'
import cosygiraffesteel from '../images/products/cosygiraffe/cosygiraffesteel.jpeg'
import cosygiraffegrey from '../images/products/cosygiraffe/cosygiraffegrey.jpeg'
import cosygiraffemustard from '../images/products/cosygiraffe/cosygiraffemustard.jpeg'
import cosygiraffepink from '../images/products/cosygiraffe/cosygiraffepink.jpeg'
import cosygiraffewhite from '../images/products/cosygiraffe/cosygiraffewhite.jpeg'
import cosygiraffeblue from '../images/products/cosygiraffe/cosygiraffeblue.jpeg'
import cosygiraffewhitestripe from '../images/products/cosygiraffe/cosygiraffewhitestripe.jpeg'
import littlebutloudhamper from '../images/products/littlebutloudhamper.jpeg'
import knittedwrap1 from '../images/products/knittedwrap1.jpeg'
import knittedwrap2 from '../images/products/knittedwrap2.jpeg'
import bluevelourbunny from '../images/products/bluevelourbunny.jpeg'
import bluevelourfox from '../images/products/bluevelourfox.jpeg'
import bluevelourwhale from '../images/products/bluevelourwhale.jpeg'
import pinkvelourballet from '../images/products/pinkvelourballet.jpeg'
import pinkvelourfrill from '../images/products/pinkvelourfrill.jpeg'
import fipcwhitesheep from '../images/products/fipcwhitesheep.jpeg'
import fipcwhitesheephamper from '../images/products/fipcwhitesheephamper.jpeg'
import twopackfloralonesies from '../images/products/lemonfloral/twopackfloralonesies.jpeg'
import boldfloralonesie from '../images/products/lemonfloral/boldfloralonesie.jpeg'
import ditsyfloralonesie from '../images/products/lemonfloral/ditsyfloralonesie.jpeg'
import threepackfloralbib from '../images/products/lemonfloral/threepackfloralbib.jpeg'
import lemonfloralhamper from '../images/products/lemonfloral/lemonfloralhamper.jpeg'
import starduckonesie from '../images/products/starduckonesie.jpeg'
import greyvelourbunnyhamper from '../images/products/greyvelourbunnyhamper.jpeg'
import greyvelourbunnyonesie from '../images/products/greyvelourbunnyonesie.jpeg'
import chickhamper from '../images/products/chickhamper.jpeg'
import lemonchickonesie from '../images/products/lemonchickonesie.jpeg'
import lemonchickonesie2 from '../images/products/lemonchickonesie2.jpeg'
import lemonchickonesie3 from '../images/products/lemonchickonesie3.jpeg'
import lemonchickonesie4 from '../images/products/lemonchickonesie4.jpeg'
import duckhamper from '../images/products/duckhamper.jpeg'
import ballerinahamper from '../images/products/ballerinahamper.jpeg'
import bluetropicalromper from '../images/products/bluetropicalromper.jpeg'
import peachtropicalromper from '../images/products/peachtropicalromper.jpeg'
import bluebunnycomf from '../images/products/bluebunnycomf.jpeg'
import sageplaysuit from '../images/products/sageplaysuit.jpeg'
import floralplaysuit from '../images/products/floralplaysuit.jpeg'
import brightgiraffecomforter from '../images/products/brightgiraffecomforter.jpeg'
import velourfrillhamper from '../images/products/velourfrillhamper.jpeg'
import fipccartoongiraffehamper from '../images/products/fipccartoongiraffe/fipccartoongiraffehamper.jpeg'
import fipccartoongiraffe from '../images/products/fipccartoongiraffe/fipccartoongiraffe.jpeg'
import fipccartoongiraffeprint from '../images/products/fipccartoongiraffe/fipccartoongiraffeprint.jpeg'
import newbrownbearcomf from '../images/products/newbrownbearcomf.jpeg'
import brightteddyhamper from '../images/products/brightteddy/brightteddyhamper.jpeg'
import fipcbrightteddy from '../images/products/brightteddy/fipcbrightteddy.jpeg'
import brightteddyprint from '../images/products/brightteddy/brightteddyprint.jpeg'
import neutraldinosaurhamper from '../images/products/neutraldinosaur/neutraldinosaurhamper.jpeg'
import fipcneutraldinosaur from '../images/products/neutraldinosaur/fipcneutraldinosaur.jpeg'
import neutraldinosaurprint from '../images/products/neutraldinosaur/neutraldinosaurprint.jpeg'
import sagedoublebcardi from '../images/products/cardigans/sagedoublebcardi.jpeg'
import greydoublebcardi from '../images/products/cardigans/greydoublebcardi.jpeg'
import allcardis from '../images/products/cardigans/allcardis.jpeg'
import pinkcardi from '../images/products/cardigans/pinkcardi.jpeg'
import pinkteddyjacket from '../images/products/jackets/pinkteddyjacket.jpeg'
import brownteddyjacket from '../images/products/jackets/brownteddyjacket.jpeg'
import quiltedelephant from '../images/products/quiltedelephant.jpeg'
import fipclambmain from '../images/products/fipclamb/fipclambmain.jpeg'
import fipclamb from '../images/products/fipclamb/fipclamb.jpeg'
import lambcomf from '../images/products/lambcomf.jpeg'
import ecomonkeytoy from '../images/products/ecomonkeytoy.jpeg'
import ecoducktoy from '../images/products/ecoducktoy.jpeg'
import ecokoalatoy from '../images/products/ecokoalatoy.jpeg'
import ecoelephanttoy from '../images/products/ecoelephanttoy.jpeg'
import fipcneutralhelloworldmain from '../images/products/fipcneutralhelloworld/fipcneutralhelloworldmain.jpeg'
import fipcneutralhelloworld from '../images/products/fipcneutralhelloworld/fipcneutralhelloworld.jpeg'
import babyannouncevest from '../images/products/personalisedvests/babyannouncevest.jpeg'
import babyannouncevestmain from '../images/products/personalisedvests/babyannouncevestmain.jpeg'
import amazingdaddyvest from '../images/products/personalisedvests/amazingdaddyvest.jpeg'
import daddycuddlesvest from '../images/products/personalisedvests/daddycuddlesvest.jpeg'
import daddyfootballvest from '../images/products/personalisedvests/daddyfootballvest.jpeg'
import fatherdaynamevest from '../images/products/personalisedvests/fatherdaynamevest.jpeg'
import fathersdayvest from '../images/products/personalisedvests/fathersdayvest.jpeg'
import vestcolours from '../images/products/personalisedvests/vestcolours.jpeg'
import fathersdaybeer from '../images/products/personalisedvests/fathersdaybeer.jpeg'
import firstfathersdayvest from '../images/products/personalisedvests/firstfathersdayvest.jpeg'
import myfirstfathersdayvest from '../images/products/personalisedvests/myfirstfathersdayvest.jpeg'
import newtothecrewvest from '../images/products/personalisedvests/newtothecrewvest.jpeg'
import arrivingvest from '../images/products/personalisedvests/arrivingvest.jpeg'
import comingsoondiscmain from '../images/products/personalisedacc/comingsoondiscmain.jpeg'
import comingsoondisc from '../images/products/personalisedacc/comingsoondisc.jpeg'
import helloworlddiscmain from '../images/products/personalisedacc/helloworlddiscmain.jpeg'
import helloworlddisc from '../images/products/personalisedacc/helloworlddisc.jpeg'
import fullnamedisc from '../images/products/personalisedacc/fullnamedisc.jpeg'
import comingsoonvest from '../images/products/personalisedvests/comingsoonvest.jpeg'
import comingsoonvestcsdisc from '../images/products/personalisedvests/comingsoonvestcsdisc.jpeg'
import comingsoonvesthwdisc from '../images/products/personalisedvests/comingsoonvesthwdisc.jpeg'
import rainbowbabyvest from '../images/products/personalisedvests/rainbowbabyvest.jpeg'
import rainbowbabycsvest from '../images/products/personalisedvests/rainbowbabycsvest.jpeg'
import rainbowbabyhwvest from '../images/products/personalisedvests/rainbowbabyhwvest.jpeg'


export const deliveryCharges = [
  {name: "Express (First Class - Signed For)", cost: 5.99, multipier: 0},
  {name: "Second Class (Signed For)", cost: 3.99, multipier: 0}
];

export const Store = [
  {
    id: "baby-announce-vest",
    description:
    <>Baby Announcements are a really special time for both the parent(s) to be and for everyone close to them finding out the new. Let us help make this first moment special with our personalised baby vest revealing the news. 
      <br /><br />We can put any variation of Baby Name & Due Date - our most common design is in the main image "Baby Smith Due March 2025" but make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals", "best-sellers"],
    name: "Baby Announcement Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: babyannouncevestmain,
    productImages: [
      babyannouncevestmain, babyannouncevest
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      }
    ]
  },
  {
    id: "baby-fatherday-vest",
    description:
    <>Make those first moments special with a personalised baby vest this Father's Day. This vest features a super cute design saying "Happy 1st Father's Day".
      <br /><br />We can add in the baby name to personalise this for you - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "First Father's Day Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: fatherdaynamevest,
    productImages: [
      fatherdaynamevest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "baby-daddycuddles-vest",
    description:
    <>Make those first moments special with a personalised baby vest this Father's Day. This vest features a super cute design saying "My Daddy gives the best cuddles!".
      <br /><br />We can add in the baby name to personalise this for you or change the name "Daddy" to any option you wish - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "Father's Day Cuddles Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: daddycuddlesvest,
    productImages: [
      daddycuddlesvest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "baby-daddyfootball-vest",
    description:
    <>Make those first moments special with a personalised baby vest this Father's Day. This vest features a super cute design saying "I love my Dad more than he loves football".
      <br /><br />We can add in the baby name to personalise this for you or change the name "Dad" or "Football" to any option you wish - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "Father's Day Love Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: daddyfootballvest,
    productImages: [
      daddyfootballvest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "baby-daddybeer-vest",
    description:
    <>Make those first moments special with a personalised baby vest this Father's Day. This vest features a super cute design saying "Our First Father's Day Together".
      <br /><br />We can add in the baby name to personalise this for you - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "Father's Day Drinks Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: fathersdaybeer,
    productImages: [
      fathersdaybeer, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "baby-daddyamazing-vest",
    description:
    <>Make those first moments special with a personalised baby vest this Father's Day. This vest features a super cute design saying "Daddy, You're Amazing!".
      <br /><br />We can add in the baby name to personalise this for you, we can also change the name "Daddy" for any option you wish - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "Father's Day Amazing Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: amazingdaddyvest,
    productImages: [
      amazingdaddyvest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "baby-firstday-vest",
    description:
    <>Make those first moments special with a personalised baby vest this Father's Day. This vest features a super cute design saying "Happy First Father's Day".
      <br /><br />We can add in the baby name to personalise this for you - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "First Father's Day Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: firstfathersdayvest,
    productImages: [
      firstfathersdayvest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "baby-firstfathers-vest",
    description:
    <>Make those first moments special with a personalised baby vest this Father's Day. This vest features a super cute design saying "My First Father's Day".
      <br /><br />We can add in the baby name to personalise this for you - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "Father's Day Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: myfirstfathersdayvest,
    productImages: [
      myfirstfathersdayvest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  }, 
  {
    id: "baby-newtocrew-vest",
    description:
    <>Make those first moments special with a personalised baby vest to announce a new baby or as a gift for a new arrival into the world. This vest features a super cute design saying "New to the crew".
      <br /><br />We can add in the baby name to personalise this for you ie "Baby Smith, New to the crew" - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "New to Crew Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: newtothecrewvest,
    productImages: [
      newtothecrewvest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "coming-soon-vest",
    description:
    <>Make those first moments special with this personalised vest, perfect to announce a new arrival expected into the world. This vest features a super cute design saying "Coming Soon".
      <br /><br />We can add in the baby name to personalise this for you ie "Baby Smith Arriving 2025", and we can change the year to 2026 too - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "Coming Soon Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: comingsoonvest,
    productImages: [
      comingsoonvest, comingsoonvestcsdisc, comingsoonvesthwdisc, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "baby-arriving-vest",
    description:
    <>Make those first moments special with this personalised vest, perfect to announce a new arrival expected into the world. This vest features a super cute design saying "Arriving 2025".
      <br /><br />We can add in the baby name to personalise this for you ie "Baby Smith Arriving 2025", and we can change the year to 2026 too - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "Arriving Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: arrivingvest,
    productImages: [
      arrivingvest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },  
  {
    id: "rainbow-vest",
    description:
    <>Make those first moments special with this personalised vest, perfect to announce a new rainbow baby arrival expected into the world. This vest features a super cute design with the words "After every storm comes a rainbow".
      <br /><br />We can add in the baby name to personalise this for you ie "Baby Smith Arriving 2025", and we can change the year to 2026 too - make sure to message us when you place the order to confirm your wording choice.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 & 6-9 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-clothing", "new-arrivals"],
    name: "Rainbow Baby Vest",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: rainbowbabyvest,
    productImages: [
      rainbowbabyvest, rainbowbabyhwvest, rainbowbabycsvest, vestcolours
    ],
    variants: [
      {
        title: 'Vest Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Vest Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },
      {
        title: 'Font Colour',
        options: [
          {
            name: 'Rainbow Colours'
          },
          {
            name: 'Black'
          },
          {
            name: 'Black Glitter'
          },
          {
            name: 'Silver Glitter'
          },
          {
            name: 'Pink Glitter'
          },
          {
            name: 'Royal Blue Glitter'
          },
          {
            name: 'Blue Glitter'
          },
          {
            name: 'Red Glitter'
          }
        ]
      },   
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  
  {
    id: "hello-world-disc",
    description:
    <>Make those first moments special with this personalised disc, perfect to announce your new arrival that has just arrived into the world.
      <br /><br />The disc will have the words "Hello World" on.  Why not add in another disc, or even a personalised baby vest, to announce baby's name to add and even more personalised touch.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed! Please also be aware that these items are for decoration only and should only be utilised under adult supervision.
      <br /><br />
      <ul>
        <li>Materials: Wood </li>
        <li>Size: 10cm x 10cm</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-accessories", "new-arrivals"],
    name: "Hello World Disc",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 4.99,
    img: helloworlddiscmain,
    productImages: [
      helloworlddiscmain, helloworlddisc, comingsoonvesthwdisc, fullnamedisc
    ],
  },
  {
    id: "coming-soon-disc",
    description:
    <>Make those first moments special with this personalised disc, perfect to announce your expected new arrival.
      <br /><br />The disc will have the words "Coming Soon" on.  Add in Baby's surname to make it even more special. Or, why not add a personalised baby vest, to announce baby's name to make that announcement extra special.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed! Please also be aware that these items are for decoration only and should only be utilised under adult supervision.
      <br /><br />
      <ul>
        <li>Materials: Wood </li>
        <li>Size: 10cm x 10cm</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-accessories", "new-arrivals"],
    name: "Coming Soon Disc",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 4.99,
    img: comingsoondiscmain,
    productImages: [
      comingsoondiscmain, comingsoondisc, comingsoonvesthwdisc, 
    ],
    variants: [
          {
            title: 'Optional Personalised Name',
            options: [
              {
                name: 'Yes Please'
              },
              {
                name: 'No Thanks'
              }
        ]
      }
    ]
  },
  {
    id: "full-name-disc",
    description:
    <>Make those first moments special with this personalised disc, perfect to announce your new arrivals name.
      <br /><br /> Why not add in one of our "Hello World" discs, or even a personalised baby vest, to add and even more personalised touch.
      <br /><br /> Add baby's name in our gift message box on checkout or email us with your name.
      <br /><br />As our personalised items are made to order, please check your choices and spellings as we cannot change an item once the design has been printed! Please also be aware that these items are for decoration only and should only be utilised under adult supervision.
      <br /><br />
      <ul>
        <li>Materials: Wood </li>
        <li>Size: 10cm x 10cm</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["personalised-accessories", "new-arrivals"],
    name: "Full Name Disc",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 4.99,
    img: fullnamedisc,
    productImages: [
    fullnamedisc, helloworlddisc
    ],
  },      
  {
  id: "neutral-hello-hamper",
  description:
  <>A new take on our bestselling gift sets, this lovely hamper has a safari theme and features subtle neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
  <br /><br />Gift Hamper includes:
  <br /><br /><ul>
    <li>Supersoft Wafffle Fleece Blanket</li>
    <li>White Safari Animal Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
    <li>White "Hello World" Vest (100% Cotton)</li>
    <li>White "Welcome To The World" Bib (100% Cotton)</li>
    <li>White Sarafi Animal Hat & Scratch Mittens</li>
    <li>Crochet Booties (100% Acrylic)</li></ul>
      <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
      <br /><br />5 * Star Rated on Etsy - check out our shop for reviews & more.
</>,
  categories: ["Unisex", "new-arrivals"],
  name: "Neutral Safari Hamper Gift Set",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 27.99,
  img: fipcneutralhelloworldmain,
  productImages: [
    fipcneutralhelloworldmain, fipcneutralhelloworld, mustardwaffle, whitewaffle, allbooties, recgiraffecomforter, ecogiraffetoy, allrecrings, allrecrattle, greyelephant, whiteelephant, alltoowordy
  ],
  variants: [
    {
      title: 'Clothing Size',
      options: [
        {
          name: 'Newborn <2 available>'
        },
        {
          name: '0-3 months <4 available>'
        },
        {
          name: '3-6 months <1 availalbe>'
        }
      ]
    },
    {
      title: 'Bootie Colour',
      options: [
        {
          name: 'White Booties'
        },
        {
          name: 'Grey Booties'
        },
        {
          name: 'Blue Booties'
        },
        {
          name: 'Pink Booties'
        },
        {
          name: 'Navy Booties'
        }
      ]
    },
    {
      title: 'Blanket Colour',
      options: [
        {
          name: 'Mustard Waffle Fleece'
        },
        {
          name: 'White Waffle Fleece'
        }
      ]
    },
    {
      title: 'Optional Comforter',
      options: [
        {
          name: 'No Thanks'
        },
        {
          name: 'White Elephant',
          increment: 6.0
        },
        {
          name: 'Grey Elephant',
          increment: 6.0
        },
        {
          name: 'Tan Giraffe',
          increment: 6.0
        },
        {
          name: 'Tan Giraffe Toy',
          increment: 7.0
        },
        {
          name: 'Tan Giraffe Teething Rattle',
          increment: 6.0
        },
        {
          name: 'Tan Giraffe Stick Rattle',
          increment: 5.0
        }
      ]
    },
    {
      title: 'Additional Giftcard',
      options: [
        {
          name: 'No Thanks'
        },
        {
          name: 'Pink Twinkle Toes',
          increment: 3.50
        },
        {
          name: 'Blue Twinkle Toes',
          increment: 3.50
        },
        // {
        //   name: 'Precious Daughter',
        //   increment: 3.50
        // },
        {
          name: 'Baby Boy Banner',
          increment: 3.50
        },
        {
          name: 'Little Lady',
          increment: 3.50
        },
        {
          name: 'Little Dude',
          increment: 3.50
        },
        {
          name: 'Lovely Happy News',
          increment: 3.50
        },
        {
          name: 'Bundle Of Joy',
          increment: 3.50
        },
        {
          name: 'Welcome Baby Boy',
          increment: 3.50
        },
        {
          name: 'Welcome Baby Girl',
          increment: 3.50
        },
        {
          name: 'New Chapter',
          increment: 3.50
        },
        {
          name: 'Bun In The Oven',
          increment: 3.50
        }
      ]
    },      
  ]
},
    {
    id: "5pc-hello-safari",
    description:
    <>This onesie set makes a great gift containing all the essentials for new baby. 
    <br /><br />The set contains a safari print onesie, "Hello World" vest and "Welcome To The World" bib and safari print mitts and hat. Giraffes are always really popular for us!
    <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
        <br />
      </ul>
      </>,
    categories: ["onesie-sets", "new-arrivals"],
    name: "Neutral Safari 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcneutralhelloworld,
    productImages: [
      fipcneutralhelloworld, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          {
            name: '0-3 Months <2 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },
  {
    id: "5pc-white-lamb",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a lamb print onesie, stripey vest, embroidered lamb bib, lamb mitts and hat.
      <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
        <br />
        <br /><br />
      </ul>
      </>,
    categories: ["onesie-sets", "new-arrivals"],
    name: "Lamb 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipclamb,
    productImages: [
      fipclamb, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          {
            name: '0-3 Months <2 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },
  {
    id: "5pc-bright-teddy",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a teddy bear print onesie, spotty vest and teddy bib, mitts and hat. We love the hints of orange and yellows throughout the print.
      <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 & 3-6 Months</li>
        <br />
        <br />
      </ul>
      </>,
    categories: ["onesie-sets", "new-arrivals"],
    name: "Teddy 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcbrightteddy,
    productImages: [
      fipcbrightteddy, brightteddyprint
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },
  // {
  //   id: "neutral-dinosaur-hamper",
  //   description:
  //   <>A lovley neutral gift sets, this hamper has a dinosaur theme and features subtle neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>Cellular Or Waffle Fleece Blanket(100% Cotton)</li>
  //     <li>White Dinosaur Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
  //     <li>White Spotty Vest (100% Cotton)</li>
  //     <li>White Dinosar Hat & Scratch Mittens</li>
  //     <li>White Dinosar Bib</li>
  //     <li>Crochet Booties (100% Acrylic)</li></ul>
  //   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br />Sizes Newborn &  0-3 Months - Sold Out
  // </>,
  //   categories: ["Unisex", "new-arrivals"],
  //   name: "Dinosaur Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: neutraldinosaurhamper,
  //   productImages: [
  //      neutraldinosaurhamper, fipcneutraldinosaur, neutraldinosaurprint, whitecellular, whitewaffle, coffeewaffle, allbooties, whitedinosaur, greyelephant, whiteelephant
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn <2 available>'
  //         // },
  //         // {
  //         //   name: '0-3 months <3 available>'
  //         // },
  //         {
  //           name: '3-6 months <1 available>'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'White Cellular'
  //         },
  //         {
  //           name: 'Coffee Waffle Fleece'
  //         },
  //         {
  //           name: 'White Waffle Fleece'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         // {
  //         //   name: 'White Dinosaur',
  //         //   increment: 6.0
  //         // },
  //         {
  //           name: 'White Elephant',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 6.0
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },      
  // ]
  // },
  // {
  //   id: "5pc-neutral-dinosaur",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a dinosaur print onesie, spotty vest and dinosaur bib, mitts and hat. Brown neutral tones are really popular for us at the moment.
  //     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3 & 3-6 Months</li>
  //       <br />Sizes Newborn & 0-3 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets", "new-arrivals"],
  //   name: "Dinosaur 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcneutraldinosaur,
  //   productImages: [
  //     fipcneutraldinosaur, neutraldinosaurprint
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn <2 available>'
  //         // },
  //         // {
  //         //   name: '0-3 Months <3 available>'
  //         // },
  //         {
  //           name: '3-6 Months <1 available>'
  //         }
  //       ]
  //     }
  //   ]
  // },  
  {
    id: "embroidered-lamb-hamper",
    description:
    <>A lovley neutral gift set, this hamper has a lamb theme and features subtle neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to. Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Cellular Or Waffle Fleece Blanket (100% Cotton)</li>
      <li>White Lamb Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
      <li>White Stripey Vest (100% Cotton)</li>
      <li>White Lamb Scratch Mittens & Hat</li>
      <li>White Embroidered Lamb Bib</li>
      <li>Crochet Booties (100% Acrylic)</li></ul>
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below.
        <br /><br />5 * Star rated on Etsy, check out out shop for reviews & more!
  </>,
    categories: ["Unisex", "new-arrivals"],
    name: "Lamb Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: fipclambmain,
    productImages: [
       fipclambmain, fipclamb, whitecellular, whitewaffle, allbooties, reclambcomforter, greyelephant, whiteelephant, alltoowordy
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          {
            name: '0-3 months <2 available>'
          },
          {
            name: '3-6 months <1 availalbe>'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'White Cellular'
          },
          {
            name: 'Grey Cellular'
          },
          {
            name: 'White Waffle Fleece'
          },
          {
            name: 'Grey Waffle Fleece'
          }
        ]
      },
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Cream Lamb',
            increment: 6.0
          },
          {
            name: 'White Elephant',
            increment: 6.0
          },
          {
            name: 'Grey Elephant',
            increment: 6.0
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },      
  ]
  },   
  {
    id: "bright-teddy-hamper",
    description:
    <>A lovley neutral gift set, this hamper has a teddy bear theme and features subtle neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to. Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Cellular Or Waffle Fleece Blanket (100% Cotton)</li>
      <li>White Teddy Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
      <li>White Spotty Vest (100% Cotton)</li>
      <li>White Teddy Hat & Scratch Mittens</li>
      <li>White Teddy Bib</li>
      <li>Crochet Booties (100% Acrylic)</li></ul>
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below.
        <br />
        <br />5 * Star rated on Etsy, check out our store for reviews & more!
  </>,
    categories: ["Unisex", "new-arrivals"],
    name: "Teddy Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: brightteddyhamper,
    productImages: [
       brightteddyhamper, fipcbrightteddy, brightteddyprint, whitecellular, whitewaffle, allbooties, newbrownbearcomf, greyelephant, whiteelephant, alltoowordy
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          {
            name: '0-3 months <1 available>'
          },
          {
            name: '3-6 months <1 availalbe>'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'White Cellular'
          },
          {
            name: 'White Waffle Fleece'
          }
        ]
      },
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Brown Bear',
            increment: 6.0
          },
          {
            name: 'White Elephant',
            increment: 6.0
          },
          {
            name: 'Grey Elephant',
            increment: 6.0
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },      
  ]
  },     
// {
//   id: "rainbow-safari-hamper",
//   description:
//   <>One of our popular gift sets, this lovely hamper has a rainbow & safari theme and features subtle neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
//   <br /><br />Gift Hamper includes:
//   <br /><br /><ul>
//     <li>Cellular Blanket(100% Cotton)</li>
//     <li>White Safari Animal Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
//     <li>White Rainbow Vest (100% Cotton)</li>
//     <li>White Sarafi Animal Bib, Hat & Scratch Mittens</li>
//     <li>Crochet Booties (100% Acrylic)</li></ul>
//   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
//       <br />
//       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
//       <br />Sizes Newborn & 3-6 Months - Sold Out
// </>,
//   categories: ["Unisex", "new-arrivals"],
//   name: "Rainbow Sarafi Hamper Gift Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 27.99,
//   img: rainbowsafarihamper2,
//   productImages: [
//     rainbowsafarihamper2, rainbowsafarihamper, fipcrainbowsafari, whitecellular, whitewaffle, coffeewaffle, allbooties, greyelephant, whiteelephant, recgiraffecomforter, recycledtoys, allrecrings, allrecrattle, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery, boyheartplaque
//   ],
//   variants: [
//     {
//       title: 'Clothing Size',
//       options: [
//         // {
//         //   name: 'Newborn <1 available>'
//         // },
//         {
//           name: '0-3 months <5 available>'
//         },
//         // {
//         //   name: '3-6 months <1 availalbe>'
//         // }
//       ]
//     },
//     {
//       title: 'Bootie Colour',
//       options: [
//         {
//           name: 'Grey Booties'
//         },
//         {
//           name: 'White Booties'
//         },
//         {
//           name: 'Blue Booties'
//         },
//         {
//           name: 'Pink Booties'
//         },
//         {
//           name: 'Navy Booties'
//         }
//       ]
//     },
//     {
//       title: 'Blanket Colour',
//       options: [
//         {
//           name: 'White Cellular'
//         },
//         {
//           name: 'Coffee Waffle Fleece'
//         },
//         {
//           name: 'White Waffle Fleece'
//         }
//       ]
//     },
//     {
//       title: 'Optional Comforter',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'White Elephant',
//           increment: 6.0
//         },
//         {
//           name: 'Grey Elephant',
//           increment: 6.0
//         },
//         {
//           name: 'Tan Giraffe',
//           increment: 6.0
//         },
//         {
//           name: 'Tan Giraffe Toy',
//           increment: 7.0
//         },
//         {
//           name: 'Tan Giraffe Teething Rattle',
//           increment: 6.0
//         },
//         {
//           name: 'Tan Giraffe Stick Rattle',
//           increment: 5.0
//         }
//       ]
//     },
//     {
//       title: 'Wishstring Bracelet',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'From Bump',
//           increment: 3.99
//         },
//         {
//           name: 'For Daddy',
//           increment: 3.99
//         },
//         // {
//         //   name: 'For New Mum',
//         //   increment: 3.99
//         // },
//         {
//           name: 'Mums Buttons',
//           increment: 3.99
//         }
//       ]
//     },
//     {
//       title: 'Additional Giftcard',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'Pink Twinkle Toes',
//           increment: 3.50
//         },
//         {
//           name: 'Blue Twinkle Toes',
//           increment: 3.50
//         },
//         // {
//         //   name: 'Precious Daughter',
//         //   increment: 3.50
//         // },
//         {
//           name: 'Baby Boy Banner',
//           increment: 3.50
//         },
//         {
//           name: 'Little Lady',
//           increment: 3.50
//         },
//         {
//           name: 'Little Dude',
//           increment: 3.50
//         },
//         {
//           name: 'Lovely Happy News',
//           increment: 3.50
//         },
//         {
//           name: 'Bundle Of Joy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Boy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Girl',
//           increment: 3.50
//         },
//         {
//           name: 'New Chapter',
//           increment: 3.50
//         },
//         {
//           name: 'Bun In The Oven',
//           increment: 3.50
//         }
//       ]
//     },      
//     {
//       title: 'Additional Items',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'White Elephant Frame',
//           increment: 4.99
//         },
//         {
//           name: 'Grey Bunny Frame',
//           increment: 4.99
//         },
//         {
//           name: 'Grey Elephant Plaque',
//           increment: 4.99
//         },
//         {
//           name: 'White Bunny Plaque',
//           increment: 4.99
//         },
//         {
//           name: 'My First Cutlery Set',
//           increment: 2.99
//         },
//         {
//           name: 'Milestone Moment Cards',
//           increment: 2.99
//         },
//         {
//           name: 'Welcome To The World Heart',
//           increment: 2.99
//         },
//         {
//           name: 'Mummy Mug',
//           increment: 5.99
//         },
//         {
//           name: 'Daddy Mug',
//           increment: 5.99
//         },
//         {
//           name: 'Baby Boy Hanging Heart Plaque',
//           increment: 5.99
//         }    
//   ]
// },
//   ]
// },
  //   {
  //   id: "5pc-rainbow-safari",
  //   description:
  //   <>This onesie set makes a great gift containing all the essentials for new baby. 
  //   <br /><br />The set contains a safari print onesie, rainbow vest and safari print bib, mitts and hat. Giraffes are always really popular for us!
  //   <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br /> Sizes Newborn & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets", "new-arrivals"],
  //   name: "Rainbow Safari 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcrainbowsafari,
  //   productImages: [
  //     fipcrainbowsafari, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn <1 available>'
  //         // },
  //         {
  //           name: '0-3 Months <5 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months <1 available>'
  //         // }
  //       ]
  //     }
  //   ]
  // },
// {
//   id: "5pc-white-giraffe",
//   description:
//     <>This onesie set makes a great gift containing all the essentials for new baby. 
//     <br /><br />The set contains a giraffe print onesie, star vest and giraffe bib, mitts and hat. Giraffes are always really popular for us!
//     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
//     <br /><br />
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: Newborn, 0-3 & 3-6 Months</li>
//       <br />
//       <br />Sizes 0-3 & 3-6 Months - Sold Out
//     </ul>
//     </>,
//   categories: ["onesie-sets", "new-arrivals", "best-sellers"],
//   name: "Giraffe 5pc Onesie Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 12.99,
//   img: fipcwhitegiraffe,
//   productImages: [
//     fipcwhitegiraffe, 
//   ],
//   variants: [
//     {
//       title: 'Onesie Size',
//       options: [
//         {
//           name: 'Newborn <2 available>'
//         },
//         // {
//         //   name: '0-3 Months <3 available>'
//         // },
//         // {
//         //   name: '3-6 Months <4 available>'
//         // }
//       ]
//     }
//   ]
// },  
// {
//   id: "white-giraffe-hamper",
//   description:
//   <>One of our most popular gift sets, this lovely hamper has a giraffe theme and features subtle neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
//   <br /><br />Gift Hamper includes:
//   <br /><br /><ul>
//     <li>Cellular Blanket(100% Cotton)</li>
//     <li>White Giraffe Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
//     <li>White Star Vest (100% Cotton)</li>
//     <li>White Giraffe Hat & Scratch Mittens</li>
//     <li>White 'Dream Big Little One' Giraffe Bib</li>
//     <li>Crochet Booties (100% Acrylic)</li></ul>
//   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
//       <br />
//       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
//       <br />
//       <br />Sizes 0-3 & 3-6 Months - Sold Out
// </>,
//   categories: ["Unisex", "new-arrivals", "best-sellers"],
//   name: "Giraffe Hamper Gift Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 27.99,
//   img: whitegiraffehamper,
//   productImages: [
//      whitegiraffehamper, whitegiraffehamper2, fipcwhitegiraffe, whitecellular, whitewaffle, coffeewaffle, allbooties, greyelephant, whiteelephant, recgiraffecomforter, recycledtoys, allrecrings, allrecrattle, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery, boyheartplaque
//   ],
//   variants: [
//     {
//       title: 'Clothing Size',
//       options: [
//         {
//           name: 'Newborn <2 available>'
//         },
//         // {
//         //   name: '0-3 months <3 available>'
//         // },
//         // {
//         //   name: '3-6 months <4 availalbe>'
//         // }
//       ]
//     },
//     {
//       title: 'Bootie Colour',
//       options: [
//         {
//           name: 'Grey Booties'
//         },
//         {
//           name: 'White Booties'
//         },
//         {
//           name: 'Blue Booties'
//         },
//         {
//           name: 'Pink Booties'
//         },
//         {
//           name: 'Navy Booties'
//         }
//       ]
//     },
//     {
//       title: 'Blanket Colour',
//       options: [
//         {
//           name: 'White Cellular'
//         },
//         {
//           name: 'Coffee Waffle Fleece'
//         },
//         {
//           name: 'White Waffle Fleece'
//         }
//       ]
//     },
//     {
//       title: 'Optional Comforter',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'White Elephant',
//           increment: 6.0
//         },
//         {
//           name: 'Grey Elephant',
//           increment: 6.0
//         },
//         {
//           name: 'Tan Giraffe',
//           increment: 6.0
//         },
//         {
//           name: 'Tan Giraffe Toy',
//           increment: 7.0
//         },
//         {
//           name: 'Tan Giraffe Teething Rattle',
//           increment: 6.0
//         },
//         {
//           name: 'Tan Giraffe Stick Rattle',
//           increment: 5.0
//         }
//       ]
//     },
//     {
//       title: 'Additional Giftcard',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'Pink Twinkle Toes',
//           increment: 3.50
//         },
//         {
//           name: 'Blue Twinkle Toes',
//           increment: 3.50
//         },
//         // {
//         //   name: 'Precious Daughter',
//         //   increment: 3.50
//         // },
//         {
//           name: 'Baby Boy Banner',
//           increment: 3.50
//         },
//         {
//           name: 'Little Lady',
//           increment: 3.50
//         },
//         {
//           name: 'Little Dude',
//           increment: 3.50
//         },
//         {
//           name: 'Lovely Happy News',
//           increment: 3.50
//         },
//         {
//           name: 'Bundle Of Joy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Boy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Girl',
//           increment: 3.50
//         },
//         {
//           name: 'New Chapter',
//           increment: 3.50
//         },
//         {
//           name: 'Bun In The Oven',
//           increment: 3.50
//         }
//       ]
//     },      
// ]
// },
{
  id: "lemon-chick-hamper",
  description:
  <>Start the new season right with this chick themed hamper. A great selection of essentials for any new arrival. Ideal for a baby shower, or for a new parent and baby. 
  <br /><br />Gift Hamper includes:
  <br /><br /><ul>
    <li>Choice of Blanket (100% Cotton)</li>
    <li>Chick Embroidered Onesie (100% Cotton, Sizes: 0-3 or 3-6 Months)</li>
    <li>Lemon Vest with embroidered Chick</li>
    <li>Lemon Bib with embroidered Chicks</li>
    <li>Lemon Jacket with Embroidered Chick (100% Cotton)</li>
    <li>Lemon Jogging Bottoms (100% Cotton)</li>
    <li>Lemon Hat and Lemon Scratch Mitts (100% Cotton)</li>
    <li>Crochet Booties (100% Acrylic)</li></ul>
  <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
      <br />
      <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
</>,
  categories: ["unisex", "spring-summer"],
  name: "Lemon Chick Hamper",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 28.99,
  img: chickhamper,
  productImages: [
    chickhamper, lemonchickonesie, lemonchickonesie2, lemonchickonesie3, lemonchickonesie4, whitecellular, whitewaffle, lemonwaffle, allbooties, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery
  ],
  variants: [
    {
      title: 'Clothing Size',
      options: [
        {
          name: '0-3 months <3 available>'
        },
        {
          name: '3-6 months <3 availalbe>'
        }
      ]
    },
    {
      title: 'Bootie Colour',
      options: [
        {
          name: 'White Booties'
        },
        {
          name: 'Grey Booties'
        },
        {
          name: 'Blue Booties'
        },
        {
          name: 'Pink Booties'
        },
        {
          name: 'Navy Booties'
        }
      ]
    },
    {
      title: 'Blanket Choice',
      options: [
        {
          name: 'White Cellular'
        },
        {
          name: 'Lemon Waffle Fleece'
        },
        {
          name: 'White Waffle Fleece'
        }
      ]
    },
    {
      title: 'Wishstring Bracelet',
      options: [
        {
          name: 'No Thanks'
        },
        {
          name: 'From Bump',
          increment: 3.99
        },
        {
          name: 'For Daddy',
          increment: 3.99
        },
        // {
        //   name: 'For New Mum',
        //   increment: 3.99
        // },
        {
          name: 'Mums Buttons',
          increment: 3.99
        }
      ]
    },
    {
      title: 'Additional Giftcard',
      options: [
        {
          name: 'No Thanks'
        },
        {
          name: 'Pink Twinkle Toes',
          increment: 3.50
        },
        {
          name: 'Blue Twinkle Toes',
          increment: 3.50
        },
        // {
        //   name: 'Precious Daughter',
        //   increment: 3.50
        // },
        {
          name: 'Baby Boy Banner',
          increment: 3.50
        },
        {
          name: 'Little Lady',
          increment: 3.50
        },
        {
          name: 'Little Dude',
          increment: 3.50
        },
        {
          name: 'Lovely Happy News',
          increment: 3.50
        },
        {
          name: 'Bundle Of Joy',
          increment: 3.50
        },
        {
          name: 'Welcome Baby Boy',
          increment: 3.50
        },
        {
          name: 'Welcome Baby Girl',
          increment: 3.50
        },
        {
          name: 'New Chapter',
          increment: 3.50
        },
        {
          name: 'Bun In The Oven',
          increment: 3.50
        }
      ]
    },      
    {
      title: 'Additional Items',
      options: [
        {
          name: 'No Thanks'
        },
        {
          name: 'White Elephant Frame',
          increment: 4.99
        },
        {
          name: 'Grey Bunny Frame',
          increment: 4.99
        },
        {
          name: 'Grey Elephant Plaque',
          increment: 4.99
        },
        {
          name: 'White Bunny Plaque',
          increment: 4.99
        },
        {
          name: 'My First Cutlery Set',
          increment: 2.99
        },
        {
          name: 'Milestone Moment Cards',
          increment: 2.99
        },
        {
          name: 'Welcome To The World Heart',
          increment: 2.99
        },
        {
          name: 'Mummy Mug',
          increment: 5.99
        },
        {
          name: 'Daddy Mug',
          increment: 5.99
        }    
  ]
},
]
},
{
  id: "duck-hamper",
  description:
  <>Start the new season right with this duck themed hamper. A great selection of essentials for any new arrival. Ideal for a baby shower, or for a new parent and baby. 
  <br /><br />Gift Hamper includes:
  <br /><br /><ul>  
    <li>Choice of Blanket (100% Cotton)</li>
    <li>Duck embroidered Onesie (100% Cotton, Sizes: 0-3, 3-6, 6-9 Months)</li>
    <li>Crochet Booties (100% Acrylic)</li></ul>
      <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
      <br />
      <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
</>,
  categories: ["unisex", "spring-summer"],
  name: "Duck Hamper",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 23.99,
  img: duckhamper,
  productImages: [
    duckhamper, starduckonesie, starblanket, sheepblanket, giraffeprintblanket, whitecellular, whitewaffle, lemonwaffle, allbooties, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery
  ],
  variants: [
    {
      title: 'Clothing Size',
      options: [
        {
          name: '0-3 months <1 available>'
        },
        {
          name: '3-6 months <1 availalbe>'
        },
        {
          name: '6-9 months <1 available>'
        }
      ]
    },
    {
      title: 'Bootie Colour',
      options: [
        {
          name: 'White Booties'
        },
        {
          name: 'Grey Booties'
        },
        {
          name: 'Blue Booties'
        },
        {
          name: 'Pink Booties'
        },
        {
          name: 'Navy Booties'
        }
      ]
    },
    {
      title: 'Blanket Choice',
      options: [
        {
          name: 'Star Blanket'
        },
        {
          name: 'Sheep Blanket'
        },
        {
          name: 'Giraffe Blanket'
        },
        {
          name: 'White Cellular'
        },
        {
          name: 'Lemon Waffle Fleece'
        },
        {
          name: 'White Waffle Fleece'
        }
      ]
    },
    {
      title: 'Wishstring Bracelet',
      options: [
        {
          name: 'No Thanks'
        },
        {
          name: 'From Bump',
          increment: 3.99
        },
        {
          name: 'For Daddy',
          increment: 3.99
        },
        // {
        //   name: 'For New Mum',
        //   increment: 3.99
        // },
        {
          name: 'Mums Buttons',
          increment: 3.99
        }
      ]
    },
    {
      title: 'Additional Giftcard',
      options: [
        {
          name: 'No Thanks'
        },
        {
          name: 'Pink Twinkle Toes',
          increment: 3.50
        },
        {
          name: 'Blue Twinkle Toes',
          increment: 3.50
        },
        // {
        //   name: 'Precious Daughter',
        //   increment: 3.50
        // },
        {
          name: 'Baby Boy Banner',
          increment: 3.50
        },
        {
          name: 'Little Lady',
          increment: 3.50
        },
        {
          name: 'Little Dude',
          increment: 3.50
        },
        {
          name: 'Lovely Happy News',
          increment: 3.50
        },
        {
          name: 'Bundle Of Joy',
          increment: 3.50
        },
        {
          name: 'Welcome Baby Boy',
          increment: 3.50
        },
        {
          name: 'Welcome Baby Girl',
          increment: 3.50
        },
        {
          name: 'New Chapter',
          increment: 3.50
        },
        {
          name: 'Bun In The Oven',
          increment: 3.50
        }
      ]
    },      
    {
      title: 'Additional Items',
      options: [
        {
          name: 'No Thanks'
        },
        {
          name: 'White Elephant Frame',
          increment: 4.99
        },
        {
          name: 'Grey Bunny Frame',
          increment: 4.99
        },
        {
          name: 'Grey Elephant Plaque',
          increment: 4.99
        },
        {
          name: 'White Bunny Plaque',
          increment: 4.99
        },
        {
          name: 'My First Cutlery Set',
          increment: 2.99
        },
        {
          name: 'Milestone Moment Cards',
          increment: 2.99
        },
        {
          name: 'Welcome To The World Heart',
          increment: 2.99
        },
        {
          name: 'Mummy Mug',
          increment: 5.99
        },
        {
          name: 'Daddy Mug',
          increment: 5.99
        }    
  ]
},
]
},
// {
//   id: "balerina-hamper",
//   description:
//   <>A perfect gift for a new twinkle toes with this ballerina themed hamper. A great selection of essentials for any new arrival. Ideal for a baby shower, or for a new parent and baby. 
//   <br /><br />Gift Hamper includes:
//   <br /><br /><ul>
//     <li>Choice of Blanket (100% Cotton)</li>
//     <li>Ballerina Embroidered Velour Onesie (80% Cotton, 20% Polyester Sizes: 0-3 or 3-6 Months)</li>
//     <li>Two Floral Bibs and Matching Headband</li>
//     </ul>
//   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
//       <br />
//       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
// </>,
//   categories: ["new-arrivals", "girls", "spring-summer"],
//   name: "Ballerina Hamper",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 27.99,
//   img: ballerinahamper,
//   productImages: [
//     ballerinahamper, allcellular, whitewaffle, pinkwaffle, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery
//   ],
//   variants: [
//     {
//       title: 'Clothing Size',
//       options: [
//         {
//           name: '0-3 months <3 available>'
//         },
//         {
//           name: '3-6 months <3 availalbe>'
//         }
//       ]
//     },
//     {
//       title: 'Blanket Choice',
//       options: [
//         {
//           name: 'White Cellular'
//         },
//         {
//           name: 'Pink Cellular'
//         },
//         {
//           name: 'White Waffle Fleece'
//         },
//         {
//           name: 'Pink Waffle Fleece'
//         }
//       ]
//     },

//     {
//       title: 'Wishstring Bracelet',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'From Bump',
//           increment: 3.99
//         },
//         {
//           name: 'For Daddy',
//           increment: 3.99
//         },
//         // {
//         //   name: 'For New Mum',
//         //   increment: 3.99
//         // },
//         {
//           name: 'Mums Buttons',
//           increment: 3.99
//         }
//       ]
//     },
//     {
//       title: 'Additional Giftcard',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'Pink Twinkle Toes',
//           increment: 3.50
//         },
//         {
//           name: 'Blue Twinkle Toes',
//           increment: 3.50
//         },
//         // {
//         //   name: 'Precious Daughter',
//         //   increment: 3.50
//         // },
//         {
//           name: 'Baby Boy Banner',
//           increment: 3.50
//         },
//         {
//           name: 'Little Lady',
//           increment: 3.50
//         },
//         {
//           name: 'Little Dude',
//           increment: 3.50
//         },
//         {
//           name: 'Lovely Happy News',
//           increment: 3.50
//         },
//         {
//           name: 'Bundle Of Joy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Boy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Girl',
//           increment: 3.50
//         },
//         {
//           name: 'New Chapter',
//           increment: 3.50
//         },
//         {
//           name: 'Bun In The Oven',
//           increment: 3.50
//         }
//       ]
//     },      
//     {
//       title: 'Additional Items',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'White Elephant Frame',
//           increment: 4.99
//         },
//         {
//           name: 'Grey Bunny Frame',
//           increment: 4.99
//         },
//         {
//           name: 'Grey Elephant Plaque',
//           increment: 4.99
//         },
//         {
//           name: 'White Bunny Plaque',
//           increment: 4.99
//         },
//         {
//           name: 'My First Cutlery Set',
//           increment: 2.99
//         },
//         {
//           name: 'Milestone Moment Cards',
//           increment: 2.99
//         },
//         {
//           name: 'Welcome To The World Heart',
//           increment: 2.99
//         },
//         {
//           name: 'Mummy Mug',
//           increment: 5.99
//         },
//         {
//           name: 'Daddy Mug',
//           increment: 5.99
//         }    
//   ]
// },
// ]
// },
{
  id: "2pk-floral-onesies",
  description:
    <>This adorable set contains two floral onesies, one with a bold larger print floral design and one with a smaller ditsy floral design.
    <br /><br />Matching Bibs Available
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Sizes: 0-3 or 3-6 Months</li>
      <br />Size 3-6 Months - Sold Out
    </ul>
    </>,
  categories: ["onesie-sets", "spring-summer"],
  name: "2pk Lemon Floral Onesie",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 12.99,
  img: twopackfloralonesies,
  productImages: [
    twopackfloralonesies, boldfloralonesie, ditsyfloralonesie
  ],
  variants: [
    {
      title: 'Onesie Size',
      options: [
        {
          name: '0-3 Months <5 available>'
        },
        // {
        //   name: '3-6 Months <3 available>'
        // }
      ]
    }
  ]
}, 
{
  id: "3pk-floral-bibs",
  description:
  <>This adorable set contains three floral bibs, can you ever have enough bibs?! One with a bold larger print floral design, one with a smaller ditsy floral design and a plain lemon one.
  <br /> <br />Matching Onesies Available
  <br /><br />
  <ul>
    <li>Materials: Bibs - Front: 100% Cotton, Back: 76% Cotton, 24% Polyester</li>
    <li>One Size</li></ul></>,
  categories: ["baby-accessories", "spring-summer"],
  name: "3pk Lemon Floral Bibs",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 8.99,
  img: threepackfloralbib,
  productImages: [
    threepackfloralbib
  ],
},
{
  id: "grey-doublebreast-cardigan",
  description:
    <>This lovely baby cardigan is perfect to keep baby warm out on their walks in the pram. With cute ears on the hood and wooden buttons to one side. We love the "homegrown" wording for all those cute little ones.
    <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
    <br /><br />Also Available in Sage & Pink
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6 or 6-12 Months</li>
    <br />
      </ul></>,
  categories: ["winter-warmers", "clothing"],
  name: "Grey Knitted Cardigan",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 14.99,
  img: greydoublebcardi,
  productImages: [
    greydoublebcardi
  ],
  variants: [
    {
      title: 'Cardigan Size',
      options: [
        {
          name: '0-3 Months <1 available>'
        },
        {
          name: '3-6 Months <1 available>'
        },
        {
          name: '6-12 Months <1 available>'
        }
      ]
    },
  ]
},
{
  id: "pink-button-cardigan",
  description:
    <>This lovely baby cardigan is perfect to keep baby warm out on their walks in the pram. With cute ears on the hood and wooden buttons to one side. We love the "homegrown" wording for all those cute little ones.
    <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
    <br /><br />Similar available in Grey & Sage
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6 or 6-12 Months</li>
    <br />Sizes 3-6 & 6-12 Months - Sold Out
      </ul></>,
  categories: ["winter-warmers", "clothing"],
  name: "Pink Knitted Cardigan",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 14.99,
  img: pinkcardi,
  productImages: [
    pinkcardi
  ],
  variants: [
    {
      title: 'Cardigan Size',
      options: [
        {
          name: '0-3 Months <1 available>'
        },
        // {
        //   name: '3-6 Months <1 available>'
        // },
        // {
        //   name: '6-12 Months <1 available>'
        // }
      ]
    },
  ]
},
{
  id: "sage-doublebreast-cardigan",
  description:
    <>This lovely baby cardigan is perfect to keep baby warm out on their walks in the pram. With cute ears on the hood and wooden buttons to one side. We love the "homegrown" wording for all those little ones.
    <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
    <br /><br />Also available in grey & pink
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6 or 6-12 Months</li>
    <br />Sizes 0-3 & 3-6 Months - Sold Out
      </ul></>,
  categories: ["winter-warmers", "clothing"],
  name: "Sage Knitted Cardigan",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 14.99,
  img: sagedoublebcardi,
  productImages: [
    sagedoublebcardi, allcardis
  ],
  variants: [
    {
      title: 'Cardigan Size',
      options: [
        // {
        //   name: '0-3 Months <1 available>'
        // },
        // {
        //   name: '3-6 Months <1 available>'
        // },
        {
          name: '6-12 Months <1 available>'
        }
      ]
    },
  ]
}, 
{
  id: "brown-teddy-jacket",
  description:
    <>This lovely baby jacket is perfect to keep baby warm out on their walks in the pram. With cute ears on the hood, we love the "B is for Bear wording", and it comes with the CUTEST little bear attached to the Zip.
    <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6, 6-12 or 12-18 Months</li>
    <br /> Size 0-3 Months - Sold Out
      </ul></>,
  categories: ["winter-warmers", "clothing"],
  name: "Brown Teddy Jacket",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 14.99,
  img: brownteddyjacket,
  productImages: [
    brownteddyjacket
  ],
  variants: [
    {
      title: 'Jacket Size',
      options: [
        // {
        //   name: '0-3 Months <1 available>'
        // },
        {
          name: '3-6 Months <1 available>'
        },
        {
          name: '6-12 Months <1 available>'
        },
        {
          name: '12-18 Months <1 available>'
        }
      ]
    },
  ]
},
{
  id: "pink-teddy-jacket",
  description:
    <>This lovely baby jacket is perfect to keep baby warm out on their walks in the pram. We love the "Always Dreaming" wording on the pocket.
    <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6, 6-12 or 12-18 Months</li>
    <br />
      </ul></>,
  categories: ["winter-warmers", "clothing"],
  name: "Pink Teddy Jacket",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 14.99,
  img: pinkteddyjacket,
  productImages: [
    pinkteddyjacket
  ],
  variants: [
    {
      title: 'Jacket Size',
      options: [
        {
          name: '0-3 Months <1 available>'
        },
        {
          name: '3-6 Months <1 available>'
        },
        {
          name: '6-12 Months <1 available>'
        },
        {
          name: '12-18 Months <1 available>'
        }
      ]
    },
  ]
}, 
{
  id: "knitted-wrap-set",
  description:
    <>This gorgeous clothing set makes a great gift for a little person, with soft knitted material to keep them cosy. This set contains a knitted jumper with bobble detail all over, a cute side wrap button up, and matching pants.
    <br/><br/> With plenty of other matching options available, why not make a nice themed hamper?
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Sizes : 0-3, 3-6 or 6-9 Months</li>
      <br />
      </ul></>,
  categories: ["clothing", "new-arrivals", "winter-warmers"],
  name: "Pink Knitted Bobble Set",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 12.99,
  img: knittedwrap1,
  productImages: [
    knittedwrap1, knittedwrap2
  ],
  variants: [
    {
      title: 'Size',
      options: [
        {
          name: '0-3 Months <1 available>'
        },
        {
          name: '3-6 Months <1 available>'
        },
        {
          name: '6-9 Months <1 available>'
        }
      ]
    },
  ]
},
{
  id: "quilted-elephant-set",
  description:
    <>This grey and white quilted 2pc set has a lovely embroidered elephant design. This super cute quilted jumper and pants comes with a stripe trim around the cuffs & waist. This set would be perfect with our elephant blanket and elephant comforter. 
    <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. Matching elephant options available.
    <br />
    <br />Also available in bunny & sheep designs.
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6 or 6-9 Months</li>
      <br />Size 0-3 Months - Sold Out
      </ul></>,
  categories: ["clothing", "winter-warmers", "new-arrivals"],
  name: "2pc Quilted Elephant Set",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 12.99,
  img: quiltedelephant,
  productImages: [
    quiltedelephant
  ],
  variants: [
    {
      title: 'Size',
      options: [
        // {
        //   name: '0-3 Months <1 available>'
        // },
        {
          name: '3-6 Months <1 available>'
        },
        {
          name: '6-9 Months <1 available>'
        }
      ]
    },
  ]
},    
{
  id: "quilted-bunny-set",
  description:
    <>This grey and white quilted 2pc set has a lovely embroidered rabbit design. This super cute quilted jumper and pants comes with a stripe trim around the cuffs & waist.
    <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit.
    <br /><br />Also available in sheep & elephant designs.
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6 or 6-9 Months</li>
      <br />Size 0-3 & 3-6 Months - Sold Out
      </ul></>,
  categories: ["clothing", "winter-warmers", "new-arrivals"],
  name: "2pc Quilted Bunny Set",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 12.99,
  img: quiltedgreybunny,
  productImages: [
    quiltedgreybunny
  ],
  variants: [
    {
      title: 'Size',
      options: [
        // {
        //   name: '0-3 Months'
        // },
        // {
        //   name: '3-6 Months <1 available>'
        // },
        {
          name: '6-9 Months <1 available>'
        }
      ]
    },
  ]
},  
// {
//   id: "quilted-sheep-set",
//   description:
//     <>This grey and white quilted 2pc set has a lovely embroidered sheep design. This super cute quilted jumper and pants comes with a stripe trim around the cuffs & waist. This set would be perfect with our sheep blanket and sheep comforter. 
//     <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. Matching sheep options available.
//     <br /><br />
//     <br /><br />Also available in bunny & elephant designs.
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: 0-3, 3-6 or 6-9 Months</li>
//       <br />Size 3-6 Months - Sold Out
//       </ul></>,
//   categories: ["clothing", "winter-warmers"],
//   name: "2pc Quilted Sheep Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 12.99,
//   img: quiltedsheepmain,
//   productImages: [
//     quiltedsheepmain, quiltedsheep1
//   ],
//   variants: [
//     {
//       title: 'Size',
//       options: [
//         {
//           name: '0-3 Months <1 available>'
//         },
//         // {
//         //   name: '3-6 Months'
//         // },
//         {
//           name: '6-9 Months <2 available>'
//         }
//       ]
//     },
//   ]
// },
// {
//   id: "velour-frill-hamper",
//   description:
//   <>Start the new season right with this floral & frill themed hamper. A great selection of essentials for any new arrival. Ideal for a baby shower, or for a new parent and baby. 
//   <br /><br />Gift Hamper includes:
//   <br /><br /><ul>
//     <li>Choice of Blanket (100% Cotton)</li>
//     <li>Pink Frill Panel Velour Onesie (80% Cotton, 20% Polyester Sizes: 0-3, 3-6 or 6-9 Months)</li>
//     <li>Two Floral Bibs and Matching Headband</li>
//     <li>Pink Muslin Square (75cm x 75cm)</li>
//     <li>Crochet Booties</li>    
//     </ul>
//   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
//       <br />
//       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
// </>,
//   categories: ["new-arrivals", "girls", "spring-summer"],
//   name: "Floral & Frill Hamper",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 28.99,
//   img: velourfrillhamper,
//   productImages: [
//     velourfrillhamper, pinkvelourfrill, allcellular, whitewaffle, pinkwaffle, allbooties, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery
//   ],
//   variants: [
//     {
//       title: 'Clothing Size',
//       options: [
//         {
//           name: '0-3 months <1 available>'
//         },
//         {
//           name: '3-6 months <1 availalbe>'
//         },
//         {
//           name: '6-9 months <1 availalbe>'
//         }
//       ]
//     },
//     {
//       title: 'Bootie Choice',
//       options: [
//         {
//           name: 'White Booties'
//         },
//         {
//           name: 'Pink Booties'
//         },
//         {
//           name: 'Rose Booties'
//         }
//       ]
//     },
//     {
//       title: 'Blanket Choice',
//       options: [
//         {
//           name: 'White Cellular'
//         },
//         {
//           name: 'Pink Cellular'
//         },
//         {
//           name: 'White Waffle Fleece'
//         },
//         {
//           name: 'Pink Waffle Fleece'
//         }
//       ]
//     },

//     {
//       title: 'Wishstring Bracelet',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'From Bump',
//           increment: 3.99
//         },
//         {
//           name: 'For Daddy',
//           increment: 3.99
//         },
//         // {
//         //   name: 'For New Mum',
//         //   increment: 3.99
//         // },
//         {
//           name: 'Mums Buttons',
//           increment: 3.99
//         }
//       ]
//     },
//     {
//       title: 'Additional Giftcard',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'Pink Twinkle Toes',
//           increment: 3.50
//         },
//         {
//           name: 'Blue Twinkle Toes',
//           increment: 3.50
//         },
//         // {
//         //   name: 'Precious Daughter',
//         //   increment: 3.50
//         // },
//         {
//           name: 'Baby Boy Banner',
//           increment: 3.50
//         },
//         {
//           name: 'Little Lady',
//           increment: 3.50
//         },
//         {
//           name: 'Little Dude',
//           increment: 3.50
//         },
//         {
//           name: 'Lovely Happy News',
//           increment: 3.50
//         },
//         {
//           name: 'Bundle Of Joy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Boy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Girl',
//           increment: 3.50
//         },
//         {
//           name: 'New Chapter',
//           increment: 3.50
//         },
//         {
//           name: 'Bun In The Oven',
//           increment: 3.50
//         }
//       ]
//     },      
//     {
//       title: 'Additional Items',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'White Elephant Frame',
//           increment: 4.99
//         },
//         {
//           name: 'Grey Bunny Frame',
//           increment: 4.99
//         },
//         {
//           name: 'Grey Elephant Plaque',
//           increment: 4.99
//         },
//         {
//           name: 'White Bunny Plaque',
//           increment: 4.99
//         },
//         {
//           name: 'My First Cutlery Set',
//           increment: 2.99
//         },
//         {
//           name: 'Milestone Moment Cards',
//           increment: 2.99
//         },
//         {
//           name: 'Welcome To The World Heart',
//           increment: 2.99
//         },
//         {
//           name: 'Mummy Mug',
//           increment: 5.99
//         },
//         {
//           name: 'Daddy Mug',
//           increment: 5.99
//         }    
//   ]
// },
// ]
// },
{
  id: "grey-velour-bunny",
  description:
    <>Keep them cosy all year round with our cute & cosy velour onesies. This adorable bunny velour onesie features a bow and bunny detail throughout, with adorable white fleece foot bootie detail.
    <br/><br/>Team up with our other blankets, booties & comforters to make a great hamper!
    <br /><br />
    <ul>
      <li>Materials: 80% Cotton, 20% Polyester</li>
      <li>Size: 0-3 or 3-6 Months</li>
      <br />Size 3-6 Months Sold Out
      <br />
    </ul>
    </>,
  categories: ["onesie-sets", "clothing", "new-arrivals", "spring-summer"],
  name: "Bunny Velour Onesie",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 9.99,
  img: greyvelourbunnyonesie,
  productImages: [
    greyvelourbunnyonesie, 
  ],
  variants: [
    {
      title: 'Onesie Size',
      options: [
        {
          name: '0-3 Months <1 available>'
        },
        // {
        //   name: '3-6 Months <1 available>'
        // }
      ]
    }
  ]
},  
// {
//   id: "white-sheep-hamper",
//   description:
//   <>A lovely neutral gift set, this hamper has a sheep theme and features neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
//   <br /><br />Gift Hamper includes:
//   <br /><br /><ul>
//     <li>Supersoft Waffle Fleece or Cellular Blanket</li>
//     <li>White Embroidered Sheep Onesie (100% Cotton, Sizes: Newborn, 0-3 or 3-6 Months)</li>
//     <li>White Embroidered Sheep Vest (100% Cotton)</li>
//     <li>White Sheep Bib & Hat</li>
//     <li>White Scratch Mitts</li>
//     <li>2pk Washcloths</li>
//     <li>Crochet Booties (100% Acrylic)</li></ul>
//   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
//       <br />
//       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
//       <br /><br />
// </>,
//   categories: ["Unisex", "new-arrivals"],
//   name: "Sheep Hamper Gift Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 27.99,
//   img: fipcwhitesheephamper,
//   productImages: [
//     fipcwhitesheephamper, fipcwhitesheep, whitewaffle, greywaffle, greycellular, whitecellular, allbooties, sheep, wishstring, alltoowordy
//   ],
//   variants: [
//     {
//       title: 'Clothing Size',
//       options: [
//         // {
//         //   name: 'Newborn'
//         // },
//         {
//           name: '0-3 months <3 available>'
//         },
//         // {
//         //   name: '3-6 months'
//         // }
//       ]
//     },
//     {
//       title: 'Blanket Choice',
//       options: [
//         {
//           name: 'Grey Waffle Fleece'
//         },
//         {
//           name: 'White Waffle Fleece'
//         },
//         {
//           name: 'Grey Cellular'
//         },
//         {
//           name: 'White Cellular'
//         }
//       ]
//     },
//     {
//       title: 'Bootie Colour',
//       options: [
//         {
//           name: 'Grey'
//         },
//         {
//           name: 'White'
//         },
//         {
//           name: 'Coffee'
//         },          
//         {
//           name: 'Blue'
//         },
//         {
//           name: 'Pink'
//         },
//         {
//           name: 'Navy'
//         },    
//         {
//           name: 'Rose'
//         }            
//       ]
//     },            
//     {
//       title: 'Optional Comforter',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'White Sheep',
//           increment: 6.00
//         }
//       ]
//     },
//     {
//       title: 'Wishstring Bracelet',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'From Bump',
//           increment: 3.99
//         },
//         {
//           name: 'For Daddy',
//           increment: 3.99
//         },
//         {
//           name: 'Congrats',
//           increment: 3.99
//         },
//         {
//           name: 'Coming Baby Shower',
//           increment: 3.99
//         },
//         {
//           name: 'Wonderful Mummy',
//           increment: 3.99
//         },
//         // {
//         //   name: 'For New Mum',
//         //   increment: 3.99
//         // },
//         {
//           name: 'Mums Buttons',
//           increment: 3.99
//         }
//       ]
//     },
//     {
//       title: 'Additional Giftcard',
//       options: [
//         {
//           name: 'No Thanks'
//         },
//         {
//           name: 'Pink Twinkle Toes',
//           increment: 3.50
//         },
//         {
//           name: 'Blue Twinkle Toes',
//           increment: 3.50
//         },
//         // {
//         //   name: 'Precious Daughter',
//         //   increment: 3.50
//         // },
//         {
//           name: 'Baby Boy Banner',
//           increment: 3.50
//         },
//         {
//           name: 'Little Lady',
//           increment: 3.50
//         },
//         {
//           name: 'Little Dude',
//           increment: 3.50
//         },
//         {
//           name: 'Lovely Happy News',
//           increment: 3.50
//         },
//         {
//           name: 'Bundle Of Joy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Boy',
//           increment: 3.50
//         },
//         {
//           name: 'Welcome Baby Girl',
//           increment: 3.50
//         },
//         {
//           name: 'New Chapter',
//           increment: 3.50
//         },
//         {
//           name: 'Bun In The Oven',
//           increment: 3.50
//         }
//       ]
//     },
//   ]
// }, 
  {
    id: "little-loud-hamper",
    description:
    <>ROAAARRR!! This dinosaur theme hamper is packed full of essentials for any new baby. 'Little But Loud' printed on the Bib is fitting for any baby. Why not add in a dinosaur comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Cellular or Fleece Blanket(100% Cotton)</li>
      <li>White & Blue Dinosaur Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
      <li>White & Blue Star Vest (100% Cotton)</li>
      <li>White & Blue Dinosaur Hat & Scratch Mittens</li>
      <li>White 'Little But Loud' Dinosaur Bib</li>
      <li>Crochet Booties (100% Acrylic)</li></ul>
          <br />Size 0-3 Months - Sold Out
    <br /><br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  </>,
    categories: ["Male", "new-arrivals"],
    name: "Dinosaur Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: littlebutloudhamper,
    productImages: [
       littlebutloudhamper, fipclittledinosaurmain, whitecellular, whitewaffle, bluecellular, bluewaffle, allbooties, whitedinosaur, bluedinosaur, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery, boyheartplaque
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn <2 available>'
          },
          // {
          //   name: '0-3 months <2 available>'
          // },
          {
            name: '3-6 months <2 available>'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'White Cellular'
          },
          {
            name: 'Blue Cellular'
          },
          {
            name: 'White Waffle Fleece'
          },
          {
            name: 'Blue Waffle Fleece'
          }
        ]
      },
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Dinosaur',
            increment: 6.0
          },
          {
            name: 'Blue Dinosaur',
            increment: 6.0
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },      
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          }    
    ]
  },  
    ]
  },  
  // {
  //   id: "medium-pink-bear-suitcase",
  //   description:
  //   <>Our bestselling suitcase hamper, this super cute bear set is adorable. The rose tones throughout are sweet, and it comes with a super cute keepsake suitcase included also. Perfect to keep little ones tucked up warm anytime of the year. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a medium gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Pink Bear Comforter (100% Polyester, 30cmx30cm</li>
  //   <li>30 pc Milestone Cards to Record Those Special Moments</li>
  //   <li>Rose Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>Rose Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Medium Gifting Suitcase (Size: 25 x 17.5 x 8.5cm)</li></>,    
  //   categories: ["suitcases", "best-sellers", "new-arrivals"],
  //   name: "Medium Pink Bear Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 21.99,
  //   img: pinkbearsuitcase,
  //   productImages: [
  //     pinkbearsuitcase, pinkbearcomf, milestonecardsmain, rosehat, rosebooties, suitcases
  //   ],
  // },
  // {
  //   id: "3pc-bright-safari",
  //   description:
  //     <>This adorable safari themed onesie set contains essentials that every new mum needs. 
  //     <br /><br />Each set contains a onesie, bib and hat and can be bought as a set, or teamed up with our other essential blankets, booties & comforters to make a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3 or 3-6 Months</li>
  //       <br />
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets","best-sellers"],
  //   name: "Bright Safari Animals 3pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcbrightsafari,
  //   productImages: [
  //     fipcbrightsafari,
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <2 available>'
  //         },
  //         {
  //           name: '0-3 Months <4 available>'
  //         },
  //         {
  //           name: '3-6 Months <2 available>'
  //         }
  //       ]
  //     }
  //   ]
  // },  
  //  {
  //    id: "grey-elephant-hamper",
  //    description:
  //      <>Our bestselling cosy elephant hamper gift, perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly. You can choose your own colours adding your own personal touch!
  //        <br /><br />Gift Hamper includes:
  //        <br /><br /><ul>
  //          <li>Elephant Comforter (100% Polyester)</li>
  //          <li>Grey Supersoft Sheep Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //          <li>Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
  //          <li>Crochet Booties (100% Acrylic)</li>
  //        </ul>
  //        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //        <br />
  //        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //        <br />
  //      </>,
  //    categories: ["cosy-hampers", "best-sellers", "Unisex"], 
  //    showOnHomepage: true,
  //    name: "Elephant Hamper Gift Set",
  //    review: "productize virtual markets",
  //    deliveryCharge: deliveryCharges,
  //    price: 24.99,
  //    img: elephantmain,
  //    productImages: [
  //      elephantmain, elephant1, elephant2, elephant3, elephant4, elephant5, elephant6, elephant7, elephant8, elephant9, elephant10, greyelephant, sheepblanket, greyhat, whitehat, whitegreyhat, rosehat, navyhat, mustardhat, steelhat, pinkhat, sagehat, bluehat, coffeehat, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //    ],
  //    variants: [
  //      {
  //        title: 'Hat & Mittens Colour',
  //        options: [
  //          {
  //            name: 'Grey Hat & Mittens'
  //          },
  //          {
  //            name: 'White Hat & Mittens'
  //          },
  //          {
  //            name: 'White & Grey Hat & Mittens'
  //          },
  //          {
  //            name: 'Blue Hat & Mittens'
  //          },
  //          {
  //            name: 'Pink Hat & Mittens'
  //          },
  //          {
  //            name: 'Navy Hat & Mittens'
  //          },
          // {
          //   name: 'Mustard Hat & Mittens'
          // },
  //          {
  //            name: 'Sage Hat & Mittens'
  //          },
  //          {
  //            name: 'Steel Hat & Mittens'
  //          },
  //          {
  //            name: 'Rose Hat & Mittens'
  //          },
  //          {
  //            name: 'Coffee Hat & Mittens'
  //          }
  //        ]
  //      },
  //      {
  //        title: 'Bootie Colour',
  //        options: [
  //          {
  //            name: 'Grey Booties'
  //          },
  //          {
  //            name: 'White Booties'
  //          },
  //          {
  //            name: 'Blue Booties'
  //          },
  //          {
  //            name: 'Pink Booties'
  //          },
  //          {
  //            name: 'Navy Booties'
  //          },
  //          {
  //            name: 'Coffee Booties'
  //          },
  //          {
  //            name: 'Rose Booties'
  //          },
  //          {
  //            name: 'Sage Booties'
  //          }
  //        ]
  //      },
  //      {
  //        title: 'Wishstring Bracelet',
  //        options: [
  //          {
  //            name: 'No Thanks'
  //          },
  //          {
  //            name: 'From Bump',
  //            increment: 3.99
  //          },
  //          {
  //            name: 'For Daddy',
  //            increment: 3.99
  //          },
  //          {
  //            name: 'Congrats',
  //            increment: 3.99
  //          },
  //          {
  //            name: 'Coming Baby Shower',
  //            increment: 3.99
  //          },
  //          {
  //            name: 'Wonderful Mummy',
  //            increment: 3.99
  //          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
  //          {
  //            name: 'Mums Buttons',
  //            increment: 3.99
  //          }
  //        ]
  //      },
  //      {
  //        title: 'Additional Giftcard',
  //        options: [
  //          {
  //            name: 'No Thanks'
  //          },
  //          {
  //            name: 'Pink Twinkle Toes',
  //            increment: 3.50
  //          },
  //          {
  //            name: 'Blue Twinkle Toes',
  //            increment: 3.50
  //          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
  //          {
  //            name: 'Baby Boy Banner',
  //           increment: 3.50
  //          },
  //          {
  //            name: 'Little Lady',
  //            increment: 3.50
  //          },
  //          {
  //            name: 'Little Dude',
  //            increment: 3.50
  //          },
  //          {
  //            name: 'Lovely Happy News',
  //            increment: 3.50
  //          },
  //          {
  //            name: 'Bundle Of Joy',
  //            increment: 3.50
  //          },
  //          {
  //            name: 'Welcome Baby Boy',
  //            increment: 3.50
  //          },
  //          {
  //            name: 'Welcome Baby Girl',
  //            increment: 3.50
  //          },
  //          {
  //            name: 'New Chapter',
  //            increment: 3.50
  //          },
  //          {
  //            name: 'Bun In The Oven',
  //            increment: 3.50
  //          }
  //        ]
  //      },
  //      {
  //        title: 'Additional Items',
  //        options: [
  //          {
  //            name: 'No Thanks'
  //          },
  //          {
  //            name: 'White Elephant Frame',
  //            increment: 4.99
  //          },
  //          {
  //            name: 'Grey Bunny Frame',
  //            increment: 4.99
  //          },
  //          {
  //            name: 'Grey Elephant Plaque',
  //            increment: 4.99
  //          },
  //          {
  //            name: 'White Bunny Plaque',
  //            increment: 4.99
  //          },
  //          {
  //            name: 'My First Cutlery Set',
  //            increment: 2.99
  //          },
  //          {
  //            name: 'Milestone Moment Cards',
  //            increment: 2.99
  //          },
  //          {
  //            name: 'Welcome To The World Heart',
  //            increment: 2.99
  //          },
          // {
          //   name: 'Unicorn Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Mermaid Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Car Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Dinosaur Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Pink Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'Yellow Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'White Geo Organic Teether',
          //   increment: 5.99
          // },
  //          {
  //            name: 'Orange Geo Organic Teether',
  //            increment: 5.99
  //          },
  //          {
  //            name: 'Dandelion Organic Teether',
  //            increment: 5.99
  //          },
          // {
          //   name: 'Pink Rainbow Teether',
          //   increment: 7.99
          // },
  //          {
  //            name: 'Brown Rainbow Teether',
  //            increment: 7.99
  //          },
  //          {
  //            name: 'Burgundy Rainbow Teether',
  //            increment: 7.99
  //          },
  //          {
  //            name: 'Mummy Mug',
  //            increment: 5.99
  //          },
  //          {
  //            name: 'Daddy Mug',
  //            increment: 5.99
  //          },
  //          {
  //            name: 'Big Sister Countdown Plaque',
  //            increment: 5.99
  //          },
  //          {
  //            name: 'Big Brother Countdown Plaque',
  //            increment: 5.99
  //          },
  //          {
  //            name: 'Pink Elephant Keepsake Box',
  //            increment: 11.99
  //          },
          // {
          //   name: 'Blue Elephant Keepsake Box',
          //   increment: 11.99
          // },
  //          {
  //            name: 'Baby Boy Hanging Heart Plaque',
  //            increment: 5.99
  //          },
  //          {
  //            name: 'Everyday I Love You Moneybox',
  //            increment: 14.99
  //          },
  //          {
  //            name: 'Little Love Moneybox',
  //            increment: 14.99
  //          },
  //          {
  //            name: 'Twinkle Twinkle Moneybox',
  //            increment: 14.99
  //          },
  //          {
  //            name: 'Smallest Heart Moneybox',
  //            increment: 14.99
  //          },
  //          {
  //            name: 'Pink Soft Rattle Cube',
  //            increment: 7.99
  //          },
  //          {
  //            name: 'Blue Soft Rattle Cube',
  //            increment: 7.99
  //          },
  //          {
  //            name: 'Maze Learning Toy',
  //            increment: 5.99
  //          },
          // {
          //   name: 'Wooden Shape Sorter',
          //   increment: 12.99
          // },
  //          {
  //            name: 'Vehicles Puzzle',
  //            increment: 5.99
  //          }    
  //       ]
  //     },
  //    ]
  //  },  
  // {
  //   id: "large-sage-cosy-sheep-suitcase",
  //   description: 
  //     <>Our bestselling cosy elephant hamper gift but with a super cute keepsake suitcase included also. Perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly! Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //     <br /><br />Comes presented in a large gifting suitcase, ready to go and includes:
  //     <br />
  //     <li>Grey Elephant Comforter (100% Polyester, 36x36cm)</li>
  //     <li>Supersoft Sheep Blanket (100% Polyester, 75cmx90cm)</li>
  //     <li>Sage Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //     <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //     <li>Large Gifting Suitcase (Size: 30 x 20.5 x 9cm)</li></>,
  //   categories: ["suitcases", "best-sellers", "new-arrivals"],
  //   name: "Large Sage Cosy Sheep Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 28.99,
  //   img: cosysheepsuitcase,
  //   productImages: [
  //     cosysheepsuitcase, sheepblanket, greyelephant, sagehat, whitebooties, suitcases
  //   ],
  // },
  // {
  //   id: "small-giraffe-suitcase",
  //   description:
  //   <>A small version of our bestselling suitcase hampers, with a cute giraffe theme. Giraffes are super popular for us! Each gift contains a toy, booties and a keepsake heart to welcome the new arrival. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a small gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Grey Giraffe Comforter (100% Polyester, 30cmx30cm)</li>
  //   <li>Welcome to the World Plaque (Materials: 100% Wood Size: 14cmx13cm)</li>
  //   <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Small Gifting Suitcase (Size : 20 x 14.5 x 8cm)</li></>,    
  //   categories: ["suitcases", "best-sellers", "new-arrivals"],
  //   name: "Small Giraffe Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 16.99,
  //   img: giraffesuitcase,
  //   productImages: [
  //     giraffesuitcase, giraffeprintcomforter, welcomeplaque, whitebooties, suitcases
  //   ],
  // },
  // {
  //   id: "medium-penguin-suitcase",
  //   description:
  //   <>A variation on our bestselling suitcase hamper, we just love this penguin gift set, with mustard tones throughout. Perfect to keep little ones tucked up warm anytime of the year. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a medium gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Penguin Comforter (100% Polyester, 30cmx30cm)</li>
  //   <li>30 pc Milestone Cards to Record Those Special Moments</li>
  //   <li>Mustard Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Medium Gifting Suitcase (Size: 25 x 17.5 x 8.5cm)</li></>,    
  //   categories: ["suitcases"],
  //   name: "Medium Penguin Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 21.99,
  //   img: penguinsuitcase,
  //   productImages: [
  //     penguinsuitcase, penguin, milestonecardsmain, mustardhat, whitebooties, suitcases
  //   ],
  // },
  // {
  //   id: "large-brown-bear-suitcase",
  //   description:
  //   <>A variation on our bestselling cosy hamper, and with a super cute keepsake suitcase included also. Perfect to keep little ones tucked up warm anytime of the year. We just love this bear comforter. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a large gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Brown Bear Comforter (100% Polyester, 30x30cm)</li>
  //   <li>Coffee Supersoft Blanket (100% Polyester Waffle Fleece, 75cmx100cm</li>
  //   <li>White Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>Coffee Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Large Gifting Suitcase (Size: 30 x 20.5 x 9cm)</li></>,
  //   categories: ["suitcases"],
  //   name: "Large Brown Bear Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 28.99,
  //   img: brownbearsuitcase,
  //   productImages: [
  //     brownbearsuitcase, brownbearcomf, coffeewaffle, whitehat, beigebooties, suitcases
  //   ],
  // },
  // {
  //   id: "small-brown-bear-suitcase",
  //   description:
  //   <>A small version of our bestselling suitcase hampers, with a cute bear theme. Each gift contains a toy, booties and a keepsake heart to welcome the new arrival. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a small gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Brown Bear Comforter (100% Polyester, 30cmx30cm)</li>
  //   <li>Welcome to the World Plaque (Materials: 100% Wood Size: 14cmx13cm)</li>
  //   <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Small Gifting Suitcase (Size : 20 x 14.5 x 8cm)</li></>,    
  //   categories: ["suitcases"],
  //   name: "Small Brown Bear Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 16.99,
  //   img: smallbrownbearsuitcase,
  //   productImages: [
  //     smallbrownbearsuitcase, brownbearcomf, welcomeplaque, beigebooties, suitcases
  //   ],
  // },
  // {
  //   id: "large-grey-cosy-sheep-suitcase",
  //   description:
  //   <>Our bestselling cosy elephant hamper gift but with a super cute keepsake suitcase included also. Perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly! Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a large gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Grey Elephant Comforter (100% Polyester, 36x36cm)</li>
  //   <li>Supersoft Sheep Blanket (100% Polyester, 75cmx90cm)</li>
  //   <li>Grey Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>Grey Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Large Gifting Suitcase (Size: 30 x 20.5 x 9cm)</li></>,
  //   categories: ["suitcases"],
  //   name: "Large Grey Cosy Sheep Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 28.99,
  //   img: greycosysheepsuitcase,
  //   productImages: [
  //     greycosysheepsuitcase, sheepblanket, greyelephant, greyhat, greybooties, suitcases
  //   ],
  // },
  {
    id: "blue-velour-bunny",
    description:
      <>Keep them cosy all year round with our cute & cosy velour onesies. This adorable bunny velour onesie features three emboidered bunnies across the front and has a cute peterpan collar.
      <br/><br/>Team up with our other blankets, booties & comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3 or 3-6 Months</li>
        <br />
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "new-arrivals", "spring-summer"],
    name: "Bunny Velour Onesie",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: bluevelourbunny,
    productImages: [
      bluevelourbunny, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <3 available>'
          },
          {
            name: '3-6 Months <2 available>'
          }
        ]
      }
    ]
  },     
  {
    id: "zebra-onesie",
    description:
      <>Keep them cosy in the cooler months with our cute & cosy onesies. This adorable white onesie with a Zebra print throughout, we just love the embroidered Zebras along the front.
      <br/><br/>Team up with our Blankets, Booties & Comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "new-arrivals"],
    name: "Zebra Onesie",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: velourzebra,
    productImages: [
      velourzebra, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-9 Months <1 available>'
          }
        ]
      }
    ]
  },  
  // {
  //   id: "medium-lion-suitcase",
  //   description:
  //   <>A variation on our bestselling suitcase hamper, a super cute lion gift set with mustard tones throughout. Perfect to keep little ones tucked up warm anytime of the year. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a medium gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Lion Comforter (100% Polyester, 30cmx30cm)</li>
  //   <li>30 pc Milestone Cards to Record Those Special Moments</li>
  //   <li>Mustard Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Medium Gifting Suitcase (Size: 25 x 17.5 x 8.5cm)</li></>,    
  //   categories: ["suitcases", "best-sellers", "new-arrivals"],
  //   name: "Medium Lion Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 21.99,
  //   img: lionsuitcase,
  //   productImages: [
  //     lionsuitcase, lion, milestonecardsmain, mustardhat, whitebooties, suitcases
  //   ],
  // },
  {
    id: "small-dinosaur-suitcase",
    description:
    <>A small version of our bestselling suitcase hampers, with a cute dinosaur theme. Each gift contains a toy, booties and a keepsake heart to welcome the new arrival. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
    <br /><br />Comes presented in a small gifting suitcase, ready to go and includes:
    <br />
    <li>White Dinosaur Comforter (100% Polyester, 30cmx30cm)</li>
    <li>Welcome to the World Plaque (Materials: 100% Wood Size: 14cmx13cm)</li>
    <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
    <li>Small Gifting Suitcase (Size : 20 x 14.5 x 8cm)</li></>,    
    categories: ["suitcases"],                                                       
    name: "Small White Dinosaur Suitcase",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 16.99,
    img: whitedinosaursuitcase,
    productImages: [
      whitedinosaursuitcase, whitedinosaur, welcomeplaque, whitebooties, suitcases
    ],
  },
  // {
  //   id: "large-white-cosy-sheep-suitcase",
  //   description:
  //   <>Our bestselling cosy elephant hamper gift but with a super cute keepsake suitcase included also. Perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly! Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a large gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Grey Elephant Comforter (100% Polyester, 36x36cm)</li>
  //   <li>Supersoft Sheep Blanket (100% Polyester, 75cmx90cm)</li>
  //   <li>White Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>White Crochet Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Large Gifting Suitcase (Size: 30 x 20.5 x 9cm)</li></>,
  //   categories: ["suitcases"],
  //   name: "Large White Cosy Sheep Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 28.99,
  //   img: whitecosysuitcase,
  //   productImages: [
  //     whitecosysuitcase, sheepblanket, greyelephant, whitehat, whitebooties, suitcases
  //   ],
  // },
  {
    id: "small-white-elephant-suitcase",
    description:
    <>A small version of our bestselling suitcase hampers, with a cute elephant theme. Each gift contains a toy, booties and a keepsake heart to welcome the new arrival. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
    <br /><br />Comes presented in a small gifting suitcase, ready to go and includes:
    <br />
    <li>White Elephant Comforter (100% Polyester, 30cmx30cm)</li>
    <li>Welcome to the World Plaque (Materials: 100% Wood Size: 14cmx13cm)</li>
    <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
    <li>Small Gifting Suitcase (Size : 20 x 14.5 x 8cm)</li></>,    
    categories: ["suitcases"],
    name: "Small White Elephant Suitcase",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 16.99,
    img: whiteelephantsuitcase,
    productImages: [
      whiteelephantsuitcase, whiteelephant, welcomeplaque, whitebooties, suitcases
    ],
  },
  // {
  //   id: "medium-sheep-suitcase",
  //   description:
  //   <>A variation on our bestselling suitcase hamper, a super cute sheep gift set with white tones throughout. This sheep comforter is really soft! Perfect to keep little ones tucked up warm anytime of the year. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a medium gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Sheep Comforter (100% Polyester, 30cmx30cm)</li>
  //   <li>30 pc Milestone Cards to Record Those Special Moments</li>
  //   <li>White Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Medium Gifting Suitcase (Size: 25 x 17.5 x 8.5cm)</li></>,    
  //   categories: ["suitcases"],
  //   name: "Medium Sheep Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 21.99,
  //   img: sheepsuitcase,
  //   productImages: [
  //     sheepsuitcase, sheep, milestonecardsmain, whitehat, whitebooties, suitcases
  //   ],
  // },
  // {
  //   id: "small-blue-bunny-suitcase",
  //   description:
  //   <>A small version of our bestselling suitcase hampers, with a cute bunny theme. Each gift contains a toy, booties and a keepsake heart to welcome the new arrival. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a small gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Blue Bunny Comforter (100% Polyester, 30cmx30cm)</li>
  //   <li>Welcome to the World Plaque (Materials: 100% Wood Size: 14cmx13cm)</li>
  //   <li>Blue Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Small Gifting Suitcase (Size : 20 x 14.5 x 8cm)</li></>,    
  //   categories: ["suitcases", "best-sellers", "new-arrivals"],
  //   name: "Small Blue Bunny Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 16.99,
  //   img: bluebunnysuitcase,
  //   productImages: [
  //     bluebunnysuitcase, bluebunny, welcomeplaque, bluebooties, suitcases
  //   ],
  // },
  {
    id: "large-monkey-suitcase",
    description:
    <>A variation on our bestselling cosy hamper, and with a super cute keepsake suitcase included also. Perfect to keep little ones tucked up warm anytime of the year. We just love this bear comforter. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
    <br /><br />Comes presented in a large gifting suitcase, ready to go and includes:
    <br />
    <li>Blue Monkey Comforter (100% Polyester, 30x30cm)</li>
    <li>Blue Blanket with Stars and Moon Design (100% Polyester, 75cmx90cm)</li>
    <li>White Hat and Mittens (100% Acrylic, 0-12 Months)</li>
    <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
    <li>Large Gifting Suitcase (Size: 30 x 20.5 x 9cm)</li></>,    
    categories: ["suitcases"],
    name: "Large Monkey Suitcase",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 28.99,
    img: monkeysuitcase,
    productImages: [
      monkeysuitcase, cosybmonkey1, whitehat, whitebooties, suitcases
    ],
  },
  // {
  //   id: "large-beige-cosy-sheep-suitcase",
  //   description:
  //   <>Our bestselling cosy elephant hamper gift but with a super cute keepsake suitcase included also. Perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly! Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a large gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Grey Elephant Comforter (100% Polyester, 36x36cm)</li>
  //   <li>Supersoft Sheep Blanket (100% Polyester, 75cmx90cm)</li>
  //   <li>Coffee Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>Coffee Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Large Gifting Suitcase (Size: 30 x 20.5 x 9cm)</li></>,
  //   categories: ["suitcases"],
  //   name: "Large Coffee Cosy Sheep Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 28.99,
  //   img: beigecosysuitcase,
  //   productImages: [
  //     beigecosysuitcase, sheepblanket, greyelephant, coffeehat, beigebooties, suitcases
  //   ],
  // },
  // {
  //   id: "large-lamb-suitcase",
  //   description:
  //   <>A variation on our bestselling cosy hamper, and with a super cute keepsake suitcase included also. Perfect to keep little ones tucked up warm anytime of the year. We just love this bear comforter. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a large gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Cream Lamb Comforter (100% Polyester, 30x30cm)</li>
  //   <li>Cream Blanket with Grey Clouds Design (100% Polyester, 75cmx90cm)</li>
  //   <li>Grey Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>Grey Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Large Gifting Suitcase (Size: 30 x 20.5 x 9cm)</li></>,    
  //   categories: ["suitcases"],
  //   name: "Large Lamb Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 28.99,
  //   img: lambsuitcase,
  //   productImages: [
  //     lambsuitcase, cosyclamb1, greyhat, greybooties, suitcases
  //   ],
  // },
  {
    id: "small-white-bunny-suitcase",
    description:
    <>A small version of our bestselling suitcase hampers, with a cute bunny theme. Each gift contains a toy, booties and a keepsake heart to welcome the new arrival. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
    <br /><br />Comes presented in a small gifting suitcase, ready to go and includes:
    <br />
    <li>Grey Bunny Comforter (100% Polyester, 30cmx30cm)</li>
    <li>Welcome to the World Plaque (Materials: 100% Wood Size: 14cmx13cm)</li>
    <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
    <li>Small Gifting Suitcase (Size : 20 x 14.5 x 8cm)</li></>,    
    categories: ["suitcases"],
    name: "Small White Bunny Suitcase",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 16.99,
    img: whitebunnysuitcase,
    productImages: [
      whitebunnysuitcase, whitebunny, welcomeplaque, whitebooties, suitcases
    ],
  },
  // {
  //   id: "medium-unicorn-suitcase",
  //   description:
  //   <>A variation on our bestselling suitcase hamper, unicorns are always really popular for us and this feautres a rattle in the unicorns head, and pink tones throughout. Perfect to keep little ones tucked up warm anytime of the year. Ideal gift for a baby shower, or new parents to be. The suitcase is perfect to be kept and store baby keepsakes for years to come.
  //   <br /><br />Comes presented in a medium gifting suitcase, ready to go and includes:
  //   <br />
  //   <li>Unicorn Rattle Comforter (100% Polyester, 30cmx30cm)</li>
  //   <li>30 pc Milestone Cards to Record Those Special Moments</li>
  //   <li>Pink Hat and Mittens (100% Acrylic, 0-12 Months)</li>
  //   <li>White Knitted Booties (100% Acrylic, one size: 0-6 Months)</li>
  //   <li>Medium Gifting Suitcase (Size: 25 x 17.5 x 8.5cm)</li></>,    
  //   categories: ["suitcases"],
  //   name: "Medium Unicorn Suitcase",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 21.99,
  //   img: unicornsuitcase,
  //   productImages: [
  //     unicornsuitcase, unicorn, milestonecardsmain, pinkhat, pinkbooties, suitcases
  //   ],
  // },
  {
    id: "knitted-bow-hamper",
    description:
      <>This hamper features a cute design featuring a rose bow knitted set. A lovely gift set to welcome a new twinkle toes! This hamper allows you to build your own colour scheme on the accessories and add in additional extra touches too. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Cellular Blanket (100% Cotton)</li>
        <li>Rose Knited Bow Jumper & Pant Set (100% Cotton, Sizes 0-3, 3-6 or 6-9 months)</li>
        <li>Choice Of Crochet Booties</li>
        <li>Optional Comforter</li>
        </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
        <br />
        </>,
    categories: ["Female", "new-arrivals"],
    name: "Rose Bow Hamper Gift Set",
    deliveryCharge: deliveryCharges,
    price: 26.99,
    img: knittedbowhamper,
    productImages: [
      knittedbowhamper, knittedbowset, allcellular, allbooties, pinkfloralbunny, frames, plaques, welcomeplaque, wishstring, alltoowordy, mugs, milestonecards
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
      {
        title: 'Blanket Choice',
        options: [
          {
            name: 'Pink Cellular'
          },
          {
            name: 'White Cellular'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          },
          {
            name: 'Rose Booties'
          }
        ]
      },
      {
        title: 'Additional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Floral Bunny',
            increment: 6.00
          },
          {
            name: 'Pink Bear',
            increment: 6.00
          }
        ]
      },      
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },          
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          }    
    ]
  },
    ]
  },
  {
    id: "pink-ballet",
    description:
      <>This hamper features a cute design featuring a gorgeous ballerina theme, with a pink colour throughout. A lovely gift set to welcome a new twinkle toes! This hamper is packed full of essentials for a new arrival and we've lots of ways for you to add your own personal touch to all the little details. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Cellular or Fleece Blanket (100% Cotton)</li>
        <li>Pink Star Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
        <li>Pink & White Stripe Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
        <li>White Ballerina Bib </li>
        <li>Pink Star Hat & Scratch Mitts </li>
        <li>Choice Of Crochet Booties</li>
        </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
        <br /> Size 0-3 Months - Sold Out
        </>,
    categories: ["Female"],
    name: "Ballerina Hamper Gift Set",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: pinkballethamper,
    productImages: [
      pinkballethamper, fipcballerina, pinkwaffle, whitewaffle, whitecellular, pinkcellular, allbooties, frames, plaques, welcomeplaque, wishstring, alltoowordy, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, countdownboards, allstarmoneyboxes, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn <1 Available>'
          },
          // {
          //   name: '0-3 months'
          // },
          {
            name: '3-6 months <1 Available>'
          }
        ]
      },
      {
        title: 'Blanket Choice',
        options: [
          {
            name: 'Pink Cellular'
          },
          {
            name: 'White Cellular'
          },
          {
            name: 'Pink Waffle Fleece'
          },
          {
            name: 'White Waffle Fleece'
          }          
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          },
          {
            name: 'Rose Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          // {
          //   name: 'White Bunny Plaque',
          //   increment: 4.99
          // },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },          
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          // {
          //   name: 'Pink Elephant Keepsake Box',
          //   increment: 11.99
          // },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          }    
    ]
  },
    ]
  },
  {
    id: "pink-velour-teddy",
    description:
      <>This hamper feautres lovely items for any new arrival, with a pink colour & teddy theme throughout. This hamper is packed full of essentials for a new arrival and we've lots of ways for you to add your own personal touch to all the little details. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Cellular or Fleece Blanket (100% Cotton)</li>
        <li>Pink Velour Teddy Onesie (80% Cotton, 20% Polyester : Sizes 0-3, 3-6 or 6-9 months)</li>
        <li>Choice Of Crochet Booties</li>
        </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
        <br /> Size: 0-3 Months - Sold Out
        <br />
        </>,
    categories: ["Female", "new-arrivals", "best-seller"],
    name: "Teddy Hamper Gift Set",
    deliveryCharge: deliveryCharges,
    price: 23.99,
    img: velourteddymain,
    productImages: [
      velourteddymain, velourteddy1, pinkwaffle, whitewaffle, whitecellular, pinkcellular, allbooties, pinkbearcomf, brownbearcomf, frames, plaques, welcomeplaque, wishstring, alltoowordy, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, countdownboards, allstarmoneyboxes, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          // {
          //   name: '0-3 months <1 available>'
          // },
          {
            name: '3-6 months <1 available>'
          },
          {
            name: '6-9 months <1 available>'
          }
        ]
      },
      {
        title: 'Blanket Choice',
        options: [
          {
            name: 'Pink Cellular'
          },
          {
            name: 'White Cellular'
          },
          {
            name: 'Pink Waffle Fleece'
          },
          {
            name: 'White Waffle Fleece'
          }          
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          },
          {
            name: 'Rose Booties'
          }
        ]
      },
      {
        title: 'Additional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Bear',
            increment: 6.00
          },
          // {
          //   name: 'Brown Bear',
          //   increment: 6.00
          // }
        ]
      },      
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },          
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          }    
    ]
  },
    ]
  },  
  {
    id: "blue-safari-animal-hamper",
    description:
      <>This hamper is packed full of essentials for the new arrival and features a cute animal design. We just love the safari animal print on the ligher blues for baby. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
        <br />
        <li>Blue Animal Design Onesie (100% Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
        <li>White & Blue Spotty Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
        <li>Blue Animal Design Hat & Scratch Mittens</li>
        <li>Blue 'I Love You' Animal Design Bib</li>
        <li>Choice Of Crochet Booties</li>
        <li>Optional Supersoft Waffle Fleece Blanket</li>
        <li>Optional Comforter</li>
        <li>Optional Hat & Mittens</li>
          </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br /><br />Sizes Newborn & 3-6 Months - Sold Out
          </>,
    categories: ["Male", "new-arrivals"],
    name: "Blue Safari Hamper Gift Set",
    deliveryCharge: deliveryCharges,
    price: 18.99,
    img: bluesafarimain,
    productImages: [
      bluesafarimain, bluesafari1, bluesafari2, bluesafari3, whitewaffle, bluewaffle, allbooties, giraffeprintcomforter, greyelephant, whiteelephant, allhats, frames, plaques, wishstring, alltoowordy, welcomeplaque, milestonecards
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          // {
          //   name: 'Newborn <1 available>'
          // },
          {
            name: '0-3 Months <2 available>'
          },
          // {
          //   name: '3-6 months <1 available>'
          // },
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Blanket',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey',
            increment: 6.00
          },
          {
            name: 'White',
            increment: 6.00
          },
          {
            name: 'Blue',
            increment: 6.00
          }
        ]
      },
      {
        title: 'Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Giraffe',
            increment: 6.00
          },
          {
            name: 'White Elephant',
            increment: 6.00
          },
          {
            name: 'Grey Elephant',
            increment: 6.00
          }
        ]
      },
      {
        title: 'Hat & Mittens',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White',
            increment: 5.00
          },
          {
            name: 'Blue',
            increment: 5.00
          },
          {
            name: 'Grey',
            increment: 5.00
          }
        ]
      },      
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },          
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },          
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }          
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          }    
    ]
  },
    ]
  },  
  // {
  //   id: "musical-animal-hamper",
  //   description:
  //     <>This hamper is packed full of essentials for the new arrival and features a lovley muscial animal design. We just love the safari animal print, and navy always proves popular for baby. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Blue & Red Animal Design Onesie (100% Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
  //       <li>Blue & Red Star Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Blue Animal Design Hat & Scratch Mittens</li>
  //       <li>Blue Musical Animal Design Bib</li>
  //       <li>30pc Milestone Moment Cards</li>        
  //       <li>Choice Of Crochet Booties</li>
  //       <li>Optional Supersoft Waffle Fleece Blanket</li>
  //       <li>Optional Comforter</li>
  //         </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br /><br />Sizes Newborn & 3-6 Months - Sold Out
  //         </>,
  //   categories: ["Male", "bestsellers"],
  //   name: "Musical Animal Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 22.99,
  //   img: musicalanimalhamper,
  //   productImages: [
  //     musicalanimalhamper, whitewaffle, bluewaffle, coffeewaffle, allbooties, milestonecards, lion, giraffeprintcomforter, frames, plaques, wishstring, alltoowordy, welcomeplaque 
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn <1 available>'
  //         // },
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 months <1 available>'
  //         // },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Coffee',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Blue',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Lion',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Grey Giraffe',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 6.00
  //         }
  //       ]
  //     },      
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },          
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },          
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }          
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         }    
  //   ]
  // },
  //   ]
  // },   
  {
    id: "Dinosaur-Bath",
    description:
      <>Help keep baby cosy after bathtime with this lovely dinosaur hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin.
      <br /><br /> Add in a comforter of your choice also to help baby cuddle up and settle off to sleep!
        <br /><br />Gift Hamper includes:<ul>
          <br />
        <li>White Hooded Bath Towel with Blue & Red Dinosaur Print</li>
        <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
        <li>Choice of comforter (Materials Differ)</li></ul>
        <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun        
        </>,
    categories: ["bath-time-hampers","Male"],
    name: "Dinosaur Bathtime Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: dinosaurbathmain,
    productImages: [
      dinosaurbathmain, dinosaurbath1, greydressing, whitedressing, bluedressing, bluedinosaur, whitedinosaur, sheep, greyelephant, lion, unicorn, whiteelephant, bunnycloud, recgiraffecomforter, reczebracomforter, comb, alltoowordy
    ],
    variants: [
      {
        title: 'Comforter',
        options: [
          {
            name: 'Blue Dinosaur'
          },
          {
            name: 'White Dinosaur'
          },
          {
            name: 'Grey Bunny'
          },
          // {
          //   name: 'Pink Bunny'
          // },
          {
            name: 'White Sheep'
          },
          {
            name: 'Grey Penguin'
          },
          {
            name: 'White Elephant'
          },
          {
            name: 'Grey Elephant'
          },
          {
            name: 'White Unicorn'
          },
          {
            name: 'Cream Lion'
          },
          {
            name: 'Tan Giraffe'
          },
          {
            name: 'Grey Zebra'
          },

        ]
      },
      {
        title: 'Dressing Gown Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White',
          },
          {
            name: 'Blue',
          },
        ]
      },
      {
        title: 'Optional Extras',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Brush & Comb Set',
            increment: 2.00
          },
          // {
          //   name: 'Bath Mirror',
          //   increment: 2.50
          // },
          // {
          //   name: 'Bath Thermometer',
          //   increment: 2.50
          // },
          // {
          //   name: 'ABC Foam Letters',
          //   increment: 6.00
          // },
          // {
          //   name: 'Bath Books',
          //   increment: 2.00
          // },
          // {
          //   name: '9 Pack Stacking Cups',
          //   increment: 6.00
          // }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },  
  // {
  //   id: "white-sheep",
  //   description:
  //   <>A really popular gift set, this lovely gift has a sheep theme throughout. The lovely 3pc clothing set matches back perfectly with some of our other sheep design items. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>White Sheep Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
  //     <li>White Sheep Vest (100% Cotton)</li>
  //     <li>White Sheep Bib</li>
  //     <li>Crochet Booties (100% Acrylic)</li></ul>
  //   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br />Size 3-6 Months - Sold Out
  // </>,
  //   categories: ["Unisex", "best-sellers"],
  //   name: "Sheep Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 18.99,
  //   img: thpcsheephamper,
  //   productImages: [
  //      thpcsheephamper, thpcsheepmain, sheep, sheepblanket, greywaffle, whitewaffle, allcellular, allbooties, wishstring, alltoowordy, mugs, cuttlery, milestonecardsmain
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 available>'
  //         },
  //         {
  //           name: '0-3 months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 months <1 available>'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Choice',
  //       options: [
  //         {
  //           name: 'No Thanks'           
  //         },          
  //         // {
  //         //   name: 'Supersoft Sheep Grey Fleece',
  //         //   increment : 6.99          
  //         // },
  //         {
  //           name: 'White Waffle Fleece',
  //           increment : 5.99            
  //         },
  //         {
  //           name: 'Grey Waffle Fleece',
  //           increment : 5.99    
  //         },    
  //         {
  //           name: 'White Cellular',
  //           increment : 5.99   
  //         },
  //         {
  //           name: 'Grey Cellular',
  //           increment : 5.99     
  //         }                     
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Sheep',
  //           increment: 6.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Mummy & Daddy Mugs',
  //           increment: 10.00
  //         }
  //   ]
  // },
  //   ]
  // },   
//   {
//     id: "knitted-coffee",
//     description:
//     <>Part of our Winter Warmers Collection, this gift set is cute & cosy! This set contains lots of neutral items to keep baby wrapped up warm. Features a two piece knitted set with a brown & cream stripe design. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
//     <br /><br />Gift Hamper includes:
//     <br /><br /><ul>
//       <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
//       <li>Stripe Two Piece Knitted Set (50% Cotton, 50% Acrylic Sizes: 0-3, 3-6, 6-12 Months)</li>
//       <li>Pom Pom Hat & Matching Mittens (100% Cotton)</li>
// </ul>
//     <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
//         <br />
//         <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
//         <br /><br />Size 3-6 Months - Sold out
//   </>,
//     categories: ["Unisex"],
//     name: "Knitted Stripe Gift Set",
//     review: "productize virtual markets",
//     deliveryCharge: deliveryCharges,
//     price: 28.99,
//     img: knittedstripehamper,
//     productImages: [
//       knittedstripehamper, knittedstripehamper1, brownknitted, coffeewaffle, whitewaffle, mustardwaffle, hats2, allbooties, greyelephant, whiteelephant, brownbearcomf, pinkbearcomf, giraffeprintcomforter, bluedinosaur, whitedinosaur, sheep, wishstring, alltoowordy
//     ],
//     variants: [
//       {
//         title: 'Clothing Size',
//         options: [
//           {
//             name: '0-3 months <1 available>'
//           },
//           // {
//           //   name: '3-6 months'
//           // },
//           {
//             name: '6-12 months <1 available>'
//           }
//         ]
//       },
//       {
//         title: 'Blanket Colour',
//         options: [
//           {
//             name: 'Coffee'
//           },
//           {
//             name: 'White'
//           },
//           {
//             name: 'Mustard'
//           }
//         ]
//       },
//       {
//         title: 'Hat & Mitten Colour',
//         options: [
//           {
//             name: 'White'
//           },
//           {
//             name: 'Grey'
//           },
//           {
//             name: 'White & Grey Stripe'
//           },
//           {
//             name: 'Blue'
//           },          
//           {
//             name: 'Pink'
//           },          
//           {
//             name: 'Sage'
//           },
//           {
//             name: 'Mustard'
//           },
//           {
//             name: 'Coffee'
//           },          
//           {
//             name: 'Rose'
//           }          
//         ]
//       },
//       {
//         title: 'Optional Booties',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'White Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Grey Booties',
//             increment : 2.00
//           },          
//           {
//             name: 'Blue Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Pink Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Navy Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Coffee Booties',
//             increment : 2.00
//           },        
//           {
//             name: 'Rose Booties',
//             increment : 2.00
//           }            
//         ]
//       },            
//       {
//         title: 'Optional Comforter',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'Brown Bear',
//             increment: 7.99
//           },
//           {
//             name: 'Pink Bear',
//             increment: 7.99
//           },
//           {
//             name: 'White Sheep',
//             increment: 7.99
//           },
//           {
//             name: 'Grey Penguin',
//             increment: 7.99
//           },          
//           {
//             name: 'White Elephant',
//             increment: 7.99
//           },          
//           {
//             name: 'Grey Dinosaur',
//             increment: 7.99
//           },          
//           {
//             name: 'Grey Giraffe',
//             increment: 7.99
//           }
//         ]
//       },
//       {
//         title: 'Wishstring Bracelet',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'From Bump',
//             increment: 3.99
//           },
//           {
//             name: 'For Daddy',
//             increment: 3.99
//           },
//           {
//             name: 'Congrats',
//             increment: 3.99
//           },
//           {
//             name: 'Coming Baby Shower',
//             increment: 3.99
//           },
//           {
//             name: 'Wonderful Mummy',
//             increment: 3.99
//           },
//           // {
//           //   name: 'For New Mum',
//           //   increment: 3.99
//           // },
//           {
//             name: 'Mums Buttons',
//             increment: 3.99
//           }
//         ]
//       },
//       {
//         title: 'Additional Giftcard',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'Pink Twinkle Toes',
//             increment: 3.50
//           },
//           {
//             name: 'Blue Twinkle Toes',
//             increment: 3.50
//           },
//           {
//             name: 'Precious Daughter',
//             increment: 3.50
//           },
//           // {
//           //   name: 'Baby Boy Banner',
//           //   increment: 3.50
//           // },
//           {
//             name: 'Little Lady',
//             increment: 3.50
//           },
//           {
//             name: 'Little Dude',
//             increment: 3.50
//           },
//           {
//             name: 'Lovely Happy News',
//             increment: 3.50
//           },
//           {
//             name: 'Bundle Of Joy',
//             increment: 3.50
//           },
//           {
//             name: 'Welcome Baby Boy',
//             increment: 3.50
//           },
//           {
//             name: 'Welcome Baby Girl',
//             increment: 3.50
//           },
//           {
//             name: 'New Chapter',
//             increment: 3.50
//           },
//           {
//             name: 'Bun In The Oven',
//             increment: 3.50
//           }
//         ]
//       },
//     ]
//   },      
  // {
  //   id: "neautral-bear",
  //   description:
  //   <>A really popular gift set, this lovely gift has a sheep theme throughout. The lovely 3pc clothing set matches back perfectly with some of our other sheep design items. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>White Sheep Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
  //     <li>White Sheep Vest (100% Cotton)</li>
  //     <li>White Sheep Bib</li>
  //     <li>Crochet Booties (100% Acrylic)</li></ul>
  //   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Size 3-6 Months - Sold Out
  // </>,
  //   categories: ["Unisex", "best-sellers"],
  //   name: "Sheep Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 18.99,
  //   img: thpcsheephamper,
  //   productImages: [
  //      thpcsheephamper, thpcsheepmain, sheep, sheepblanket, greywaffle, whitewaffle, allcellular, allbooties, wishstring, alltoowordy, mugs, cuttlery, milestonecardsmain
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 months'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Choice',
  //       options: [
  //         {
  //           name: 'No Thanks'           
  //         },          
  //         {
  //           name: 'Supersoft Sheep Grey Fleece',
  //           increment : 6.99          
  //         },
  //         {
  //           name: 'White Waffle Fleece',
  //           increment : 5.99            
  //         },
  //         {
  //           name: 'Grey Waffle Fleece',
  //           increment : 5.99    
  //         },    
  //         {
  //           name: 'White Cellular',
  //           increment : 5.99   
  //         },
  //         {
  //           name: 'Grey Cellular',
  //           increment : 5.99     
  //         }                     
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Sheep',
  //           increment: 6.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Baby Boy Banner',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Mummy & Daddy Mugs',
  //           increment: 10.00
  //         }
  //   ]
  // },
  //   ]
  // }, 
  {
    id: "zebra-printed-bath",
    description:
      <>Help keep baby cosy after bathtime with this lovely white & grey zebra bath hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin. And what baby doesn't look cute and snuggled in a hooded towel after a bedtime bath. 
      <br/>Our adorable Eco zebra toys are perfect to baby to snuggle into and we've a great selection of toys to add in to help make bathtime more fun. 
        <br /><br />Gift Hamper includes:<ul>
          <br />
        <li>White Hooded Bath Towel with Zebra Design (100% Cotton) </li>
        <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
        <li>Zebra Comforter or Toy (100% Recylced Fabrics)</li></ul>
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
      <br /><br />5 * Star Rated on Etsy - check out our shop for reviews & more.
        </>,
    categories: ["bath-time-hampers", "Unisex"],
    name: "Zebra Bathtime Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 29.99,
    img: aopzebrabathmain,
    productImages: [
      aopzebrabathmain, aopzebrabath1, aopzebratowel, greydressing, whitedressing, pinkdressing, bluedressing, reczebracomforter, ecozebratoy, comb, alltoowordy
    ],
    variants: [
      {
        title: 'Dressing Gown Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White',
          },
          {
            name: 'Pink',
          },
          {
            name: 'Blue',
          }
        ]
      },
      {
        title: 'Zebra Choice',
        options: [
          {
            name: 'Comforter'
          },
          {
            name: 'Beanie Toy',
          }
        ]
      },      
      {
        title: 'Optional Extras',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Brush & Comb Set',
            increment: 2.00
          }
      //     {
      //       name: 'Bath Mirror',
      //       increment: 2.50
      //     },
      //     {
      //       name: 'Bath Thermometer',
      //       increment: 2.50
      //     },
      //     {
      //       name: 'ABC Foam Letters',
      //       increment: 6.00
      //     },
      //     {
      //       name: 'Bath Books',
      //       increment: 2.00
      //     },
      //     {
      //       name: '9 Pack Stacking Cups',
      // //       increment: 6.00
      //     }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },
  {
    id: "safari-printed-bath",
    description:
      <>Help keep baby cosy after bathtime with this lovely subtly coloured bath hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin. And what baby doesnt look cute and snuggled in a hooded towel after a bedtime bath. 
      <br/>Our adorable Eco Giraffe toys are perfect to baby to snuggle into and we've a great selection of toys to add in to help make bathtime more fun. 
        <br /><br />Gift Hamper includes:<ul>
          <br />
        <li>White Hooded Bath Towel with Safari Design (100% Cotton) </li>
        <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
        <li>Giraffe Comforter or Toy (100% Recylced Fabrics)</li></ul>
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
      <br /><br />5 * Star Rated on Etsy - check out our shop for reviews & more.
        </>,
    categories: ["bath-time-hampers", "Unisex"],
    name: "Safari Bathtime Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 29.99,
    img: aopsafaribathmain,
    productImages: [
      aopsafaribathmain, aopsafaribath1, aopsafaritowel, greydressing, whitedressing, pinkdressing, bluedressing, reczebracomforter, ecozebratoy, comb, alltoowordy
    ],
    variants: [
      {
        title: 'Dressing Gown Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White',
          },
          {
            name: 'Pink',
          },
          {
            name: 'Blue',
          }
        ]
      },
      {
        title: 'Giraffe Choice',
        options: [
          {
            name: 'Comforter'
          },
          {
            name: 'Beanie Toy',
          }
        ]
      },      
      {
        title: 'Optional Extras',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Brush & Comb Set',
            increment: 2.00
          }
          // {
          //   name: 'Bath Mirror',
          //   increment: 2.50
          // },
          // {
          //   name: 'Bath Thermometer',
          //   increment: 2.50
          // },
          // {
          //   name: 'ABC Foam Letters',
          //   increment: 6.00
          // },
          // {
          //   name: 'Bath Books',
          //   increment: 2.00
          // },
          // {
          //   name: '9 Pack Stacking Cups',
          //   increment: 6.00
          // }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },        
  // {
  //   id: "sheep-bath",
  //   description:
  //     <>Help keep baby cosy after bathtime with this lovely white sheep bath hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin. 
  //     <br/>Our adorable sheep comforter is perfect to baby to snuggle into and we've a great selection of toys to add in to help make bathtime more fun. 
  //       <br /><br />Gift Hamper includes:<ul>
  //         <br />
  //       <li>White Hooded Bath Towel with Sheep Embroidery (100% Cotton) </li>
  //       <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
  //       <li>White Sheep Comforter (100% Polyester)</li></ul>
  //       <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun        
  //       </>,
  //   categories: ["bath-time-hampers", "best-sellers", "Unisex"],
  //   name: "Sheep Bathtime Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: sheepbathmain,
  //   productImages: [
  //     sheepbathmain, sheeptowel, greydressing, whitedressing, pinkdressing, bluedressing, sheep, comb, bathset, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Dressing Gown Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White',
  //         },
  //         {
  //           name: 'Pink',
  //         },
  //         {
  //           name: 'Blue',
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Extras',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Brush & Comb Set',
  //           increment: 2.00
  //         },
  //         {
  //           name: 'Bath Mirror',
  //           increment: 2.50
  //         },
  //         {
  //           name: 'Bath Thermometer',
  //           increment: 2.50
  //         },
  //         {
  //           name: 'ABC Foam Letters',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Bath Books',
  //           increment: 2.00
  //         },
  //         {
  //           name: '9 Pack Stacking Cups',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "Floral-Bath",
  //   description:
  //     <>Help keep baby cosy after bathtime with this lovely floral hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin. 
  //     <br /><br />Add in a comforter of your choice also to help baby cuddle up and settle off to sleep!
  //       <br />
  //       <br />Gift Hamper includes:<ul>
  //         <br />
  //       <li>White Hooded Bath Towel with Floral Print</li>
  //       <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
  //       <li>Choice of comforter (Materials Differ)</li></ul>
  //       <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun
  //       </>,
  //   categories: ["bath-time-hampers", "Female"],
  //   name: "Floral Bathtime Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: floralbathmain,
  //   productImages: [
  //     floralbathmain, floralbath1, floralbath2, greydressing, whitedressing, pinkdressing, sheep, greyelephant, lion, unicorn, whiteelephant, bluedinosaur, whitedinosaur, bunnycloud, recgiraffecomforter, reczebracomforter, comb, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Comforter',
  //       options: [
  //         {
  //           name: 'Grey Bunny'
  //         },
  //         // {
  //         //   name: 'Pink Bunny'
  //         // },
  //         {
  //           name: 'White Sheep'
  //         },
  //         {
  //           name: 'Grey Penguin'
  //         },
  //         {
  //           name: 'White Elephant'
  //         },
  //         {
  //           name: 'Grey Elephant'
  //         },
  //         {
  //           name: 'White Unicorn'
  //         },
  //         {
  //           name: 'Blue Dinosaur'
  //         },
  //         {
  //           name: 'White Dinosaur'
  //         },
  //         {
  //           name: 'Cream Lion'
  //         },
  //         {
  //           name: 'Tan Giraffe'
  //         },
  //         {
  //           name: 'Grey Zebra'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Dressing Gown Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White',
  //         },
  //         {
  //           name: 'Pink',
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Optional Extras',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Brush & Comb Set',
  //           increment: 2.00
  //         },
  //         // {
  //         //   name: 'Bath Mirror',
  //         //   increment: 2.50
  //         // },
  //         // {
  //         //   name: 'Bath Thermometer',
  //         //   increment: 2.50
  //         // },
  //         // {
  //         //   name: 'ABC Foam Letters',
  //         //   increment: 6.00
  //         // },
  //         // {
  //         //   name: 'Bath Books',
  //         //   increment: 2.00
  //         // },
  //         // {
  //         //   name: '9 Pack Stacking Cups',
  //         //   increment: 6.00
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },  
  // {
  //   id: "sheep-jog-hamper",
  //   description:
  //     <>This super cute sheep themed set is perfect for those tiny toes. White & grey tones throughout this makes a great gift for surpise gender babies, or those who prefer a neatural tone. We just love the fluffy sheep design on the jumper. The supersoft blanket is super snuggly too. You can choose your own colours of add on accessories adding your own personal touch!
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Grey Jumper With Fluffy Sheep Detail (100% Cotton, Sizes 0-3, 3-6 or 6-9 Months)</li>
  //         <li>Grey Supersoft Sheep Blanket (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Optional Sheep Comforter (100% Polyester)</li>
  //         <li>Optional Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br /><br />Size 3-6 Months - Sold Out, Sheep Comforter - Sold Out
  //       <br />
  //     </>,
  //   categories: ["new-arrivals", "Unisex"], 
  //   showOnHomepage: true,
  //   name: "Sheep Quilted Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 21.99,
  //   img: sheepjoghamper,
  //   productImages: [
  //     sheepjoghamper, quiltedsheepmain, sheepblanket, sheep, greyhat, whitegreyhat, allhats, frames, plaques, wishstring, alltoowordy, welcomeplaque
  //  ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         {
  //           name: '6-9 Months <2 available>'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Hat & Mittens',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Grey Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'White Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Blue Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Pink Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Navy Hat & Mittens',
  //           increment: 6.00
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens',
  //         //   increment: 6.00
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Steel Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Rose Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         // {
  //         //   name: 'Sheep',
  //         //   increment: 6.00
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         }    
  //      ]
  //    },
  //   ]
  // },  
  // {
  //   id: "star-elephant-hamper",
  //   description:
  //     <>This super cute elephant & star themed set is perfect for those tiny toes. White & grey tones throughout this makes a great gift for surpise gender babies, or those who prefer a neatural tone. We just love the elephant embroidery & star details throughout. The supersoft blanket is super snuggly. You can choose your own colours adding your own personal touch!
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Elephant Onesie With Embroidery Detail (100% Cotton, Sizes 0-3, 3-6 or 6-9 Months)</li>
  //         <li>Grey Supersoft Elephant Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br />Size 0-3 & 3-6 Months - Sold Out
  //     </>,
  //   categories: ["Unisex"], 
  //   showOnHomepage: true,
  //   name: "Star & Elephant Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 26.99,
  //   img: starelephanthamper,
  //   productImages: [
  //     starelephanthamper, elephantstarblanket, greyelephant, whiteelephant, greyhat, whitehat, whitegreyhat, rosehat, navyhat, mustardhat, steelhat, pinkhat, sagehat, bluehat, coffeehat, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, boyheartplaque, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         {
  //           name: '6-9 Months <1 available>'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Rose Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // },
  {
    id: "zebra-onesie-hamper",
    description:
      <>This super cute Zebra themed set is perfect for those tiny toes. White & grey tones throughout this makes a great gift for surpise gender babies, or those who prefer a neatural tone. We just love the zebra print throughout. You can choose your own Zebra accessory, hat and mittens colour adding your own personal touch.
        <br /><br />Gift Hamper includes:
        <br /><br /><ul>
          <li>Zebra Print Onesie (100% Cotton, Sizes 0-3, 3-6 or 6-9 Months)</li>
          <li>Choice of Eco Zebra item (Toy, Comforter, Teething Ring, Rattle Stick)  (100% Recycled Plastic Fabrics)</li>
          <li>Optional Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
        </ul>
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br /><br />5 * Star Rated on Etsy - check out our shop for reviews & more.
      </>,
    categories: ["new-arrivals", "Unisex"], 
    showOnHomepage: true,
    name: "Zebra Onesie Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 19.99,
    img: zebraonesiehamper,
    productImages: [
      zebraonesiehamper, velourzebra, ecozebratoy, reczebracomforter, allrecrings, allrecrattle, greyhat, whitegreyhat, allhats, alltoowordy
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-9 Months <1 available>'
          }
        ]
      },
      {
        title: 'Zebra Option',
        options: [
          {
            name: 'Zebra Toy'
          },
          {
            name: 'Zebra Comforter',
          },
          {
            name: 'Zebra Teething Ring', 
          },
          {
            name: 'Zebra Rattle'
          }
        ]
      },
{
        title: 'Hat & Mittens Colour',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Hat & Mittens',
            increment: 6.00
          },
          {
            name: 'White Hat & Mittens',
            increment: 6.00
          },
          {
            name: 'White & Grey Hat & Mittens',
            increment: 6.00
          },
          {
            name: 'Blue Hat & Mittens',
            increment: 6.00
          },
          {
            name: 'Pink Hat & Mittens',
            increment: 6.00
          },
          {
            name: 'Navy Hat & Mittens',
            increment: 6.00
          },
          // {
          //   name: 'Mustard Hat & Mittens'
          // },
          {
            name: 'Sage Hat & Mittens',
            increment: 6.00
          },
          {
            name: 'Steel Hat & Mittens',
            increment: 6.00
          },
          {
            name: 'Rose Hat & Mittens',
            increment: 6.00
          },
          {
            name: 'Coffee Hat & Mittens',
            increment: 6.00
          }
        ]
      },      
      // {
      //   title: 'Wishstring Bracelet',
      //   options: [
      //     {
      //       name: 'No Thanks'
      //     },
      //     {
      //       name: 'From Bump',
      //       increment: 3.99
      //     },
      //     {
      //       name: 'For Daddy',
      //       increment: 3.99
      //     },
      //     {
      //       name: 'Congrats',
      //       increment: 3.99
      //     },
      //     {
      //       name: 'Coming Baby Shower',
      //       increment: 3.99
      //     },
      //     {
      //       name: 'Wonderful Mummy',
      //       increment: 3.99
      //     },
      //     // {
      //     //   name: 'For New Mum',
      //     //   increment: 3.99
      //     // },
      //     {
      //       name: 'Mums Buttons',
      //       increment: 3.99
      //     }
      //   ]
      // },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    //   {
    //     title: 'Additional Items',
    //     options: [
    //       {
    //         name: 'No Thanks'
    //       },
    //       {
    //         name: 'White Elephant Frame',
    //         increment: 4.99
    //       },
    //       {
    //         name: 'Grey Elephant Plaque',
    //         increment: 4.99
    //       },
    //       {
    //         name: 'My First Cutlery Set',
    //         increment: 2.99
    //       },
    //       {
    //         name: 'Milestone Moment Cards',
    //         increment: 2.99
    //       },
    //       {
    //         name: 'Welcome To The World Heart',
    //         increment: 2.99
    //       },
    //       {
    //         name: 'Orange Geo Organic Teether',
    //         increment: 5.99
    //       },
    //       {
    //         name: 'Dandelion Organic Teether',
    //         increment: 5.99
    //       },
    //       {
    //         name: 'Brown Rainbow Teether',
    //         increment: 7.99
    //       },
    //       {
    //         name: 'Burgundy Rainbow Teether',
    //         increment: 7.99
    //       },
    //       {
    //         name: 'Mummy Mug',
    //         increment: 5.99
    //       },
    //       {
    //         name: 'Daddy Mug',
    //         increment: 5.99
    //       },
    //       {
    //         name: 'Baby Boy Hanging Heart Plaque',
    //         increment: 5.99
    //       }    
    //    ]
    //  },
    ]
  },
  // {
  //   id: "christmas-pj-hamper",
  //   description:
  //     <>Celebrate their first christmas with this adorable gift set. Red christmas design throughout, with "my 1st christmas" pjs, perfect for Christmas Eve bedtime. The supersoft blanket is super snuggly. You can choose your own colours adding your own personal touch!
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>"My 1st Christmas" Pjs (100% Cotton, Sizes First Size, 0-3, 3-6, 6-9 or 9-12 Months)</li>
  //         <li>Red or White Waffle Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Optional Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
  //         <li>Optional Christmas Novelty Accessory</li>
  //       </ul>
  //       <br />
  //     </>,
  //   categories: ["new-arrivals", "Unisex", "christmas"], 
  //   showOnHomepage: true,
  //   name: "1st Christmas Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 18.99,
  //   img: firstxmashamper,
  //   productImages: [
  //     firstxmashamper, xmaspyjamas, redwaffle, whitewaffle, whitehat, mustardhat, coffeehat, greyhat, whitegreyhat, xmashatbooties, xmasbibs, whitegreyhat, rosehat, navyhat, mustardhat, steelhat, pinkhat, sagehat, bluehat, coffeehat, snowmanbooties, gingerbreadbooties, elfhatbooties
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'First Size'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-9 Months'
  //         },
  //         {
  //           name: '9-12 Months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Red'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Grey Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'White Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Mustard Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Sage Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Steel Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Novelty Accessory',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Snowman Booties',
  //           increment: 4.50
  //         },
  //         {
  //           name: 'Gingerbread Booties',
  //           increment: 4.50
  //         },
  //         {
  //           name: '2 Pack Bibs',
  //           increment: 5.50
  //         },
  //         {
  //           name: 'Santa Hat & Booties',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Elf Hat & Booties',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //   ]
  // }, 
  {
    id: "christmas-hat-booties",
    description:
      <>Look at this Chrismtas Hat with the words 'Little Christmas Wishes' and matching red booties! How gorgeous will any little one look in this?  Perfect for those special Christmas pictures!
      <br /><br /> Why not match with other items from our Christmas range, clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Cotton</li>
        <li>One Size, 0-6 Months</li></ul></>,
    categories: ["christmas"],
    name: "Christmas Hat and Booties",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: xmashatbooties,
    productImages: [
      xmashatbooties
    ],
  },  
  // {
  //   id: "christmas-bow-hamper",
  //   description:
  //     <>Celebrate their first christmas with this adorable gift set. Feautring this super cute onesie with a bow design and a "best present ever" tag detail, perfect for Christmas bedtimes or first Christmas outfits. The supersoft blanket is super snuggly. You can choose your own colours adding your own personal touch!
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>White Spotty Christmas Bow Onesie (100% Cotton, Sizes First Size, 0-3, 3-6, 6-9 or 9-12 Months)</li>
  //         <li>Red or White Waffle Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Optional Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
  //         <li>Optional Christmas Novelty Accessory</li>
  //       </ul>
  //       <br />
  //     </>,
  //   categories: ["new-arrivals", "Unisex", "christmas"], 
  //   showOnHomepage: true,
  //   name: "Christmas Bow Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 18.99,
  //   img: xmasbowhamper,
  //   productImages: [
  //     xmasbowhamper, xmasonesie, redwaffle, whitewaffle, whitehat, mustardhat, coffeehat, greyhat, whitegreyhat, xmashatbooties, xmasbibs, whitegreyhat, rosehat, navyhat, mustardhat, steelhat, pinkhat, sagehat, bluehat, coffeehat, snowmanbooties, gingerbreadbooties, elfhatbooties
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'First Size'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-9 Months'
  //         },
  //         {
  //           name: '9-12 Months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Red'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Grey Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'White Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Mustard Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Sage Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Steel Hat & Mittens',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Novelty Accessory',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Snowman Booties',
  //           increment: 4.50
  //         },
  //         {
  //           name: 'Gingerbread Booties',
  //           increment: 4.50
  //         },
  //         {
  //           name: '2 Pack Bibs',
  //           increment: 5.50
  //         },
  //         {
  //           name: 'Santa Hat & Booties',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Elf Hat & Booties',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //   ]
  // },    
  // {
  //   id: "white-bear-hamper",
  //   description:
  //   <>A lovely neutral gift set, this hamper has a bear theme and features neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
  //     <li>White Teddy & Cloud Print Onesie (100% Cotton, Sizes: Newborn, 0-3 or 3-6 Months)</li>
  //     <li>White Teddy & Cloud Print Vest (100% Cotton)</li>
  //     <li>White Teddy & Cloud Print Bib</li>
  //     <li>White Teddy & Cloud Print Hat & Mitts</li>
  //     <li>Crochet Booties (100% Acrylic)</li></ul>
  //   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />Brown Bear Comforter - Sold Out
  // </>,
  //   categories: ["Unisex"],
  //   name: "Neutral Teddy Bear Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 28.99,
  //   img: whiteteddyhamper,
  //   productImages: [
  //     whiteteddyhamper, fipcwhiteteddy, coffeewaffle, whitewaffle, mustardwaffle, pinkwaffle, bluewaffle, hats2, allbooties, brownbearcomf, pinkbearcomf, wishstring, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 available>'
  //         },
  //         {
  //           name: '0-3 months <2 available>'
  //         },
  //         {
  //           name: '3-6 months <1 available>'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Coffee'
  //         },
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //         {
  //           name: 'Mustard'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Coffee'
  //         },          
  //         {
  //           name: 'Blue'
  //         },
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'Navy'
  //         },    
  //         {
  //           name: 'Rose'
  //         }            
  //       ]
  //     },            
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         // {
  //         //   name: 'Brown Bear',
  //         //   increment: 6.00
  //         // },
  //         {
  //           name: 'Pink Bear',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },  
  {
    id: "mint-zebra-unisex",
    description:
    <>A lovely neutral gift set, this hamper has a zebra theme and features white & mint tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
      <li>Mint Zebra Print Onesie (100% Cotton, Sizes: 0-3, 3-6 or 6-9 Months)</li>
      <li>White Scribble Print Vest (100% Cotton)</li>
      <li>Mint Zebra Design Bib</li>
      <li>Mint Zebra Print Hat & Scratch Mitts</li>
      <li>Crochet Booties (100% Acrylic)</li></ul>
    <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  </>,
    categories: ["Unisex", "Male"],
    name: "Mint Zebra Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: mintzebrahamper,
    productImages: [
      mintzebrahamper, fipcmintzebra, greywaffle, whitewaffle, allbooties, reczebracomforter, ecozebratoy, allrecrattle, allrecrings, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 months'
          },
          {
            name: '6-9 months'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Sage Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Rose Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White'
          }
        ]
      },
      {
        title: 'Optional Comforter/Toy',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Zebra Comforter',
            increment: 7.00
          },
          {
            name: 'Zebra Toy',
            increment: 7.00
          },
          {
            name: 'Zebra Ring Rattle',
            increment: 5.00
          },
          {
            name: 'Zebra Stick Rattle',
            increment: 5.00
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'Heart Welcome Baby Plaque',
            increment: 2.99
          },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          }
       ]
     },
    ]
  },     
  {
    id: "white-elephant-star-hamper",
    description:
    <>A lovely neutral gift set, this hamper has an elephant theme and features neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to. Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
      <li>White Elephant Print Onesie (100% Cotton, Sizes: Newborn, 0-3 or 3-6 Months)</li>
      <li>White Stripe Vest (100% Cotton)</li>
      <li>White Elephant & Star Print Bib</li>
      <li>White Elephant Print Hat & Mitts</li>
      <li>Crochet Booties </li></ul>
      <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
      <br /><br />5 * Star Rated on Etsy - check out our shop for reviews & more.
      <br /><br />Size 3-6 Months - Sold Out
  </>,
    categories: ["Unisex", "best-sellers"],
    name: "Elephant Star Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: elephantstarhamper,
    productImages: [
      elephantstarhamper, fipcelephantstar, whitewaffle, greywaffle, pinkwaffle, bluewaffle, allbooties, greyelephant, whiteelephant, alltoowordy
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          {
            name: '0-3 months <2 available>'
          },
          // {
          //   name: '3-6 months <2 available>'
          // }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Pink'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White'
          },
          {
            name: 'Coffee'
          },          
          {
            name: 'Blue'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Navy'
          },    
          {
            name: 'Rose'
          }            
        ]
      },            
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Elephant',
            increment: 6.00
          },
          {
            name: 'White Elephant',
            increment: 6.00
          }
        ]
      },
      // {
      //   title: 'Wishstring Bracelet',
      //   options: [
      //     {
      //       name: 'No Thanks'
      //     },
      //     {
      //       name: 'From Bump',
      //       increment: 3.99
      //     },
      //     {
      //       name: 'For Daddy',
      //       increment: 3.99
      //     },
      //     {
      //       name: 'Congrats',
      //       increment: 3.99
      //     },
      //     {
      //       name: 'Coming Baby Shower',
      //       increment: 3.99
      //     },
      //     {
      //       name: 'Wonderful Mummy',
      //       increment: 3.99
      //     },
      //     // {
      //     //   name: 'For New Mum',
      //     //   increment: 3.99
      //     // },
      //     {
      //       name: 'Mums Buttons',
      //       increment: 3.99
      //     }
      //   ]
      // },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },  
  // {
  //   id: "Elephant-Bath",
  //   description:
  //     <>Help keep baby cosy after bathtime with this lovely neautral bath hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin. 
  //     <br/>Our bestselling elephant comforter is perfect to baby to snuggle into and we've a great selection of toys to add in to help make bathtime more fun. 
  //       <br /><br />Gift Hamper includes:<ul>
  //         <br />
  //       <li>Grey & White Hooded Bath Towel with Elephant Design (100% Cotton) </li>
  //       <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
  //       <li>Choice of Elephant Comforter (100% Polyester)</li></ul>
  //       <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun        
  //       </>,
  //   categories: ["bath-time-hampers", "Unisex"],
  //   name: "Elephant Bathtime Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: elephantbathhamper,
  //   productImages: [
  //     elephantbathhamper, elephanthoodedtowel, greydressing, whitedressing, pinkdressing, bluedressing, greyelephant, whiteelephant, comb, bathset, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Dressing Gown Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White',
  //         },
  //         {
  //           name: 'Pink',
  //         },
  //         {
  //           name: 'Blue',
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Comforter Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White',
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Extras',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Brush & Comb Set',
  //           increment: 2.00
  //         },
  //         {
  //           name: 'Bath Mirror',
  //           increment: 2.50
  //         },
  //         {
  //           name: 'Bath Thermometer',
  //           increment: 2.50
  //         },
  //         {
  //           name: 'ABC Foam Letters',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Bath Books',
  //           increment: 2.00
  //         },
  //         {
  //           name: '9 Pack Stacking Cups',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Baby Boy Banner',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  {
    id: "rainbow-bath",
    description:
      <>Help keep baby cosy after bathtime with this lovely neautral bath hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin and features a lovely elephant & rainbow design with pastel tones. 
      <br/>Our bestselling elephant comforter is perfect to baby to snuggle into and we've a great selection of toys to add in to help make bathtime more fun. 
        <br /><br />Gift Hamper includes:<ul>
          <br />
        <li>Supersoft Fleece Hooded Robe with Rainbow Elephant Design (100% Polyester, Sizes 0-6 or 6-12 Months)</li>
        <li>White Elephant Comforter (100% Polyester)</li>
        <li>Choice of Wooden Accessory</li></ul>
        <br />We've also added an option for you to add in any of our hooded towles & bathtime toys and accessories to help baby have fun        
        <br /><br />
        </>,
    categories: ["bath-time-hampers", "Unisex"],
    name: "Rainbow Bathtime Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 25.99,
    img: rainbowbath,
    productImages: [
      rainbowbath, rainbowgown, whiteelephant, elephanthoodedtowel, sheephoodedtowel, frames, plaques, welcomeplaque, comb, bathset, alltoowordy
    ],
    variants: [
      {
        title: 'Dressing Gown Size',
        options: [
          {
            name: '0-6 Months <1 available>'
          },
          {
            name: '6-12 Months <1 available',
          }
        ]
      },
      {
        title: 'Wooden Accessory',
        options: [
          {
            name: 'Elephant Plaque'
          },
          {
            name: 'Elephant Frame'
          },
          {
            name: 'Welcome Heart Plaque'
          }
        ]
      },
      {
        title: 'Optional Bath Towel',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Elephant Towel',
            increment: 8.00
          },
          // {
          //   name: 'Sheep Towel',
          //   increment: 8.00
          // }
        ]
      },            
      {
        title: 'Optional Extras',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Brush & Comb Set',
            increment: 2.00
          },
          {
            name: 'Bath Mirror',
            increment: 2.50
          },
          {
            name: 'Bath Thermometer',
            increment: 2.50
          },
          {
            name: 'ABC Foam Letters',
            increment: 6.00
          },
          {
            name: 'Bath Books',
            increment: 2.00
          },
          {
            name: '9 Pack Stacking Cups',
            increment: 6.00
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Precious Daughter',
            increment: 3.50
          },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },  
  // {
  //   id: "sheep-print-bath",
  //   description:
  //     <>Help keep baby cosy after bathtime with this lovely white sheep bath hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin. 
  //     <br/>Our adorable sheep comforter is perfect to baby to snuggle into and we've a great selection of toys to add in to help make bathtime more fun. 
  //       <br /><br />Gift Hamper includes:<ul>
  //         <br />
  //       <li>White Hooded Bath Towel with Sheep Embroidery (100% Cotton) </li>
  //       <li>Supersoft Fleece Hooded Robe with Sheep Print Design (100% Polyester, Sizes 0-6 or 6-12 Months)</li>
  //       <li>White Sheep Comforter (100% Polyester)</li></ul>
  //       <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun        
  //       </>,
  //   categories: ["bath-time-hampers", "new-arrivals", "Unisex"],
  //   name: "Sheep Bathtime Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: alloversheepbath,
  //   productImages: [
  //     alloversheepbath, sheeptowel, sheepgown, sheep, comb, bathset, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Dressing Gown Size',
  //       options: [
  //         {
  //           name: '0-6 Months'
  //         },
  //         {
  //           name: '6-12 Months',
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Extras',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Brush & Comb Set',
  //           increment: 2.00
  //         },
  //         {
  //           name: 'Bath Mirror',
  //           increment: 2.50
  //         },
  //         {
  //           name: 'Bath Thermometer',
  //           increment: 2.50
  //         },
  //         {
  //           name: 'ABC Foam Letters',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Bath Books',
  //           increment: 2.00
  //         },
  //         {
  //           name: '9 Pack Stacking Cups',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },  
  // {
  //   id: "Farmyard-Bath",
  //   description:
  //     <>Treat baby after bathtime to this super cute hamper. Contains a supersoft fleece dressing gown and a lovely farmyard clothing set to get baby ready bed all snuggly and clean. 
  //     <br /><br />Add in your choice of comforter to help comfort baby and give them something to cuddle into.
  //       <br /><br />Gift Hamper includes:<ul>
  //         <br />
  //       <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
  //       <li>3pc Farmyard Animal Clothing Set (Sizes 0-3, 3-6 or 6-9 Months, 100% Cotton)</li></ul>
  //       <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun!        
  //       <br />Sizes 0-3 & 6-9 Months - Sold Out
  //       </>,
  //   categories: ["bath-time-hampers", "Unisex"],
  //   showOnHomepage: true,
  //   name: "Farmyard Bathtime Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 22.99,
  //   img: farmyardbathmain,
  //   productImages: [
  //     farmyardbathmain, farmyard1, farmyard2, farmyard3, greydressing, whitedressing, pinkdressing, bluedressing, sheep, greyelephant, lion, unicorn, whiteelephant, bluedinosaur, whitedinosaur, bunnycloud, recgiraffecomforter, reczebracomforter, comb, bathset, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Dressing Gown Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White',
  //         },
  //         {
  //           name: 'Pink',
  //         },
  //         {
  //           name: 'Blue',
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: '0-3 Months <1 available>'
  //         // },
  //         {
  //           name: '3-6 Months <1 available>'
  //         },
  //         // {
  //         //   name: '6-9 Months <1 available>'
  //         // },
  //       ]
  //     },
  //     {
  //       title: 'Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Grey Bunny',
  //           increment: 7.00
  //         },
  //         // {
  //         //   name: 'Pink Bunny',
  //         //   increment: 7.00
  //         // },
  //         {
  //           name: 'White Sheep',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Grey Penguin',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'White Unicorn',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Cream Lion',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Tan Giraffe',
  //           increment: 8.00
  //         },
  //         {
  //           name: 'Grey Zebra',
  //           increment: 8.00
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Optional Extras',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Brush & Comb Set',
  //           increment: 2.00
  //         },
  //         {
  //           name: 'Bath Mirror',
  //           increment: 2.50
  //         },
  //         {
  //           name: 'Bath Thermometer',
  //           increment: 2.50
  //         },
  //         {
  //           name: 'ABC Foam Letters',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Bath Books',
  //           increment: 2.00
  //         },
  //         {
  //           name: '9 Pack Stacking Cups',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  {
    id: "Bear-Bath",
    description:
      <>Treat baby after bathtime to this super cute hamper. Contains a supersoft fleece dressing gown and a lovely bear clothing set to get baby ready bed all snuggly and clean.
      <br /><br />Add in your choice of comforter to help comfort baby and give them something to cuddle into.
        <br /><br />Gift Hamper includes:<ul>
          <br />
        <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
        <li>3pc Bear Clothing Set (Sizes 0-3, 3-6 or 6-9 Months, 100% Cotton)</li></ul>
        <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun!        
        </>,
    categories: ["bath-time-hampers"],
    showOnHomepage: true,
    name: "Bear Bathtime Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 22.99,
    img: bearbathmain,
    productImages: [
      bearbathmain, bearbath1, bearbath2, greydressing, whitedressing, pinkdressing, bluedressing, sheep, greyelephant, lion, unicorn, whiteelephant, bluedinosaur, whitedinosaur, bunnycloud, recgiraffecomforter, reczebracomforter, comb, bathset, alltoowordy
    ],
    variants: [
      {
        title: 'Dressing Gown Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White',
          },
          {
            name: 'Pink',
          },
          {
            name: 'Blue',
          }
        ]
      },
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          },
        ]
      },
      {
        title: 'Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Bunny',
            increment: 7.00
          },
          // {
          //   name: 'Pink Bunny',
          //   increment: 7.00
          // },
          {
            name: 'White Sheep',
            increment: 7.00
          },
          {
            name: 'Grey Penguin',
            increment: 7.00
          },
          {
            name: 'White Elephant',
            increment: 7.00
          },
          {
            name: 'Grey Elephant',
            increment: 7.00
          },
          {
            name: 'White Unicorn',
            increment: 7.00
          },
          {
            name: 'Cream Lion',
            increment: 7.00
          },
          {
            name: 'Tan Giraffe',
            increment: 8.00
          },
          {
            name: 'Grey Zebra',
            increment: 8.00
          },
        ]
      },
      {
        title: 'Optional Extras',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Brush & Comb Set',
            increment: 2.00
          },
          {
            name: 'Bath Mirror',
            increment: 2.50
          },
          {
            name: 'Bath Thermometer',
            increment: 2.50
          },
          {
            name: 'ABC Foam Letters',
            increment: 6.00
          },
          {
            name: 'Bath Books',
            increment: 2.00
          },
          {
            name: '9 Pack Stacking Cups',
            increment: 6.00
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },
  {
    id: "Blue-Teddy-Bath",
    description:
      <>Help keep baby cosy after bathtime with this lovely teddy hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin.
      <br /><br /> Add in a comforter of your choice also to help baby cuddle up and settle off to sleep!
        <br /><br />Gift Hamper includes:<ul>
          <br />
        <li>Blue Hooded Bath Towel With Teddy Embroidery</li>
        <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
        <li>Choice of comforter (Materials Differ)</li></ul>
        <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun.        
        <br />
        <br />Why not add in one of our giftcards to help get everything in the one place, we can write your gift message in for you and send the gift straight to the recipient!
        </>,
    categories: ["bath-time-hampers"],
    showOnHomepage: true,
    name: "Teddy Bathtime Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: blueteddybathmain,
    productImages: [
      blueteddybathmain, bicyclebear, greydressing, whitedressing, bluedressing, sheep, greyelephant, lion, unicorn, whiteelephant, bluedinosaur, whitedinosaur, bunnycloud, recgiraffecomforter, reczebracomforter, comb, bathset, alltoowordy
    ],
    variants: [
      {
        title: 'Comforter',
        options: [
          // {
          //   name: 'Grey Bunny'
          // },
          // {
          //   name: 'Pink Bunny'
          // },
          // {
          //   name: 'White Sheep'
          // },
          {
            name: 'Grey Penguin'
          },
          {
            name: 'White Elephant'
          },
          {
            name: 'Grey Elephant'
          },
          {
            name: 'White Unicorn'
          },
          {
            name: 'White Dinosaur'
          },
          {
            name: 'Blue Dinosaur'
          },
          {
            name: 'Cream Lion'
          },
          // {
          //   name: 'Tan Giraffe'
          // },
          {
            name: 'Grey Zebra'
          },

        ]
      },
      {
        title: 'Dressing Gown Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White',
          },
          {
            name: 'Blue',
          },
        ]
      },
      {
        title: 'Optional Extras',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Brush & Comb Set',
            increment: 1.99
          },
          {
            name: 'Bath Mirror',
            increment: 2.50
          },
          {
            name: 'Bath Thermometer',
            increment: 2.50
          },
          {
            name: 'ABC Foam Letters',
            increment: 5.99
          },
          {
            name: 'Bath Books',
            increment: 1.99
          },
          {
            name: '9 Pack Stacking Cups',
            increment: 5.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },      
    ]
  },
  {
    id: "Ballerina-Bath",
    description:
      <>Help keep twinkle toes cosy after bathtime with this lovely ballerina hamper. The Supersoft dressing gown with cute ears on the hood is gentle on baby's skin.
      <br /><br /> Add in a comforter of your choice also to help baby cuddle up and settle off to sleep!
        <br /><br />Gift Hamper includes:<ul>
          <br />
        <li>Pink Hooded Bath Towel With Ballerina Embroidery</li>
        <li>Supersoft Fleece Hooded Robe with Elephant Embroidery (100% Polyester, One Size 0-6 Months)</li>
        <li>Choice of comforter (Materials Differ)</li></ul>
        <br />We've also added an option for you to add in any of our bathtime toys and accessories to help baby have fun.        
        <br />
        <br />Why not add in one of our giftcards to help get everything in the one place, we can write your gift message in for you and send the gift straight to the recipient!
        </>,
    categories: ["bath-time-hampers"],
    showOnHomepage: true,
    name: "Ballerina Bathtime Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: balletbathmain,
    productImages: [
      balletbathmain, ballerinatowel, greydressing, whitedressing, pinkdressing, sheep, greyelephant, lion, unicorn, whiteelephant, bluedinosaur, whitedinosaur, bunnycloud, recgiraffecomforter, reczebracomforter, comb, bathset, alltoowordy
    ],
    variants: [
      {
        title: 'Comforter',
        options: [
          // {
          //   name: 'Grey Bunny'
          // },
          // {
          //   name: 'Pink Bunny'
          // },
          // {
          //   name: 'White Sheep'
          // },
          {
            name: 'Grey Penguin'
          },
          {
            name: 'White Elephant'
          },
          {
            name: 'Grey Elephant'
          },
          {
            name: 'White Unicorn'
          },
          {
            name: 'White Dinosaur'
          },
          {
            name: 'Blue Dinosaur'
          },
          {
            name: 'Cream Lion'
          },
          // {
          //   name: 'Tan Giraffe'
          // },
          {
            name: 'Grey Zebra'
          },
        ]
      },
      {
        title: 'Dressing Gown Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White',
          },
          {
            name: 'Pink',
          },
        ]
      },
      {
        title: 'Optional Extras',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Brush & Comb Set',
            increment: 1.99
          },
          {
            name: 'Bath Mirror',
            increment: 2.50
          },
          {
            name: 'Bath Thermometer',
            increment: 2.50
          },
          {
            name: 'ABC Foam Letters',
            increment: 5.99
          },
          {
            name: 'Bath Books',
            increment: 1.99
          },
          {
            name: '9 Pack Stacking Cups',
            increment: 5.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },      
    ]
  },  
  // {
  //   id: "cosy-browngiraffe-hamper",
  //   description:
  //     <>The newnest addition to the cosy hamper collection is this neautral giraffe gift set, perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is adorable! You can choose your own colours adding your own personal touch!
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Giraffe Comforter (100% Recycled Materials)</li>
  //         <li>Cream Giraffe Supersoft Fleece Blanket (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
  //         <li>Crochet Booties (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //     </>,
  //   categories: ["cosy-hampers", "Unisex", "new-arrivals"], 
  //   showOnHomepage: true,
  //   name: "Giraffe Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: newwhiteelephanthamper,
  //   productImages: [
  //     newwhiteelephanthamper, whiteelephant, elephantstarblanket, greyhat, whitehat, whitegreyhat, rosehat, navyhat, mustardhat, steelhat, pinkhat, sagehat, bluehat, coffeehat, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Rose Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         }    
  //      ]
  //    },
  //   ]
  // },   
  {
    id: "white-elephantprint-hamper",
    description:
      <>Our bestselling cosy elephant hamper gift, perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly. You can choose your own colours adding your own personal touch!
        <br /><br />Gift Hamper includes:
        <br /><br /><ul>
          <li>Elephant Comforter (100% Polyester)</li>
          <li>Grey Supersoft Elephant Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
          <li>Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
          <li>Crochet Booties (100% Acrylic)</li>
        </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
      </>,
    categories: ["cosy-hampers", "Unisex", "best-sellers"], 
    showOnHomepage: true,
    name: "Elephant Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: newwhiteelephanthamper,
    productImages: [
      newwhiteelephanthamper, whiteelephant, elephantstarblanket, greyhat, whitehat, whitegreyhat, rosehat, navyhat, mustardhat, steelhat, pinkhat, sagehat, bluehat, coffeehat, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Hat & Mittens Colour',
        options: [
          {
            name: 'Grey Hat & Mittens'
          },
          {
            name: 'White Hat & Mittens'
          },
          {
            name: 'White & Grey Hat & Mittens'
          },
          {
            name: 'Blue Hat & Mittens'
          },
          {
            name: 'Pink Hat & Mittens'
          },
          {
            name: 'Navy Hat & Mittens'
          },
          // {
          //   name: 'Mustard Hat & Mittens'
          // },
          {
            name: 'Sage Hat & Mittens'
          },
          {
            name: 'Steel Hat & Mittens'
          },
          {
            name: 'Rose Hat & Mittens'
          },
          {
            name: 'Coffee Hat & Mittens'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Rose Booties'
          },
          {
            name: 'Sage Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          // {
          //   name: 'Unicorn Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Mermaid Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Car Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Dinosaur Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Pink Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'Yellow Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'White Geo Organic Teether',
          //   increment: 5.99
          // },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          // {
          //   name: 'Pink Rainbow Teether',
          //   increment: 7.99
          // },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          // {
          //   name: 'Blue Elephant Keepsake Box',
          //   increment: 11.99
          // },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          // {
          //   name: 'Wooden Shape Sorter',
          //   increment: 12.99
          // },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
       ]
     },
    ]
  },  
  // {
  //   id: "cosy-penguin-hamper",
  //   description:
  //     <>One of our bestselling cosy hamper gifts, perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly. You can choose your own colours adding your own personal touch!
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Penguin Comforter (100% Polyester)</li>
  //         <li>Grey Supersoft Star Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
  //         <li>Crochet Booties (100% Acrylic)</li>
  //         <br />Mustard Hat & Mittens - Sold Out
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //     </>,
  //   categories: ["cosy-hampers", "best-sellers", "Unisex"], 
  //   showOnHomepage: true,
  //   name: "Penguin Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: cosypenguin,
  //   productImages: [
  //     cosypenguin, penguin, starblanket, allhats , frames, plaques, wishstring, alltoowordy, welcomeplaque, mugs, milestonecards, cuttlery, boyheartplaque
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Rose Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // }, 
  {
    id: "cosy-giraffe-hamper",
    description:
      <>A version of our bestselling cosy elephant hamper gift, perfect to keep little ones tucked up warm anytime of the year. The blanket and comforter have matching super soft giraffe print design. You can choose your own colours adding your own personal touch!
        <br /><br />Gift Hamper includes:
        <br /><br /><ul>
          <li>Giraffe Comforter (100% Polyester)</li>
          <li>Grey Supersoft Giraffe Print Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
          <li>Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
          <li>Crochet Booties (100% Acrylic)</li>
        </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
      </>,
    categories: ["cosy-hampers", "best-sellers", "Unisex"], 
    showOnHomepage: true,
    name: "Giraffe Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: cosygiraffesage,
    productImages: [
      cosygiraffesage, cosygiraffesteel, cosygiraffewhite, cosygiraffemustard, cosygiraffeblue, cosygiraffewhitestripe, cosygiraffegrey, cosygiraffepink, giraffeprintcomforter, giraffeprintblanket, whitegreyhat, allhats, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, cuttlery, boyheartplaque
    ],
    variants: [
      {
        title: 'Hat & Mittens Colour',
        options: [
          {
            name: 'Grey Hat & Mittens'
          },
          {
            name: 'White Hat & Mittens'
          },
          {
            name: 'White & Grey Hat & Mittens'
          },
          {
            name: 'Blue Hat & Mittens'
          },
          {
            name: 'Pink Hat & Mittens'
          },
          {
            name: 'Navy Hat & Mittens'
          },
          // {
          //   name: 'Mustard Hat & Mittens'
          // },
          {
            name: 'Sage Hat & Mittens'
          },
          {
            name: 'Steel Hat & Mittens'
          },
          {
            name: 'Rose Hat & Mittens'
          },
          {
            name: 'Coffee Hat & Mittens'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Rose Booties'
          },
          {
            name: 'Sage Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          // {
          //   name: 'White Bunny Plaque',
          //   increment: 4.99
          // },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          }    
       ]
     },
    ]
  },   
  {
    id: "panda-jumper-hamper",
    description:
    <>This lovely set is packed full of items to keep baby cosy & cute! The set features a panda & spotty design and comes with hat & mittens, perfect to keep little ones tucked up warm. You can choose your own colour of matching accessories, adding your own personal touch! 
    <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
        <br /><br />Gift Hamper includes:
        <br /><br /><ul>
          <li>Sage Quilted Panda Jumper (Material : CVC 60/40 Quilted 220gsm) </li>
          <li>Spotty Panda Pants (100% Cotton)</li>
          <li>Spotty Socks (100% Polyester)</li>
          <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
        </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
      </>,
    categories: ["Female"],
    name: "Spotty Panda Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 22.99,
    img: pandajumperhamper,
    productImages: [
      pandajumperhamper, pandajumperset, greyhat, whitehat, whitegreyhat, bluehat, pinkhat, navyhat, sagehat, steelhat, mustardhat, coffeehat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, countdownboards, allstarmoneyboxes, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-12 Months'
          }
        ]
      },
      {
        title: 'Hat & Mittens Colour',
        options: [
          {
            name: 'Grey Hat & Mittens'
          },
          {
            name: 'White Hat & Mittens'
          },
          {
            name: 'White & Grey Hat & Mittens'
          },
          {
            name: 'Blue Hat & Mittens'
          },
          {
            name: 'Pink Hat & Mittens'
          },
          {
            name: 'Navy Hat & Mittens'
          },
          // {
          //   name: 'Mustard Hat & Mittens'
          // },
          {
            name: 'Sage Hat & Mittens'
          },
          {
            name: 'Steel Hat & Mittens'
          },
          {
            name: 'Coffee Hat & Mittens'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          // {
          //   name: 'Unicorn Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Mermaid Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Car Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Dinosaur Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Pink Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'Yellow Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'White Geo Organic Teether',
          //   increment: 5.99
          // },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          // {
          //   name: 'Pink Rainbow Teether',
          //   increment: 7.99
          // },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          // {
          //   name: 'Blue Elephant Keepsake Box',
          //   increment: 11.99
          // },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          // {
          //   name: 'Wooden Shape Sorter',
          //   increment: 12.99
          // },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
       ]
     },
    ]
  }, 
  // {
  //   id: "lion-jumper-hamper",
  //   description:
  //   <>This lovely set is packed full of items to keep baby cosy & cute! The set features an earthy lion design and comes with hat & mittens, perfect to keep little ones tucked up warm. You can choose your own colour of matching accessories, adding your own personal touch! 
  //   <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Dark Quilted Lion Jumper (CVC 60/40 Quilted 220gsm) </li>
  //         <li>Lion Print Pants (100% Cotton)</li>
  //         <li>Stripey Socks (100% Polyester)</li>
  //         <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Size 3-6, 6-12 Months - Sold Out 
  //     </>,
  //   categories: ["Male"],
  //   name: "Lion Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 22.99,
  //   img: lionjumperhamper,
  //   productImages: [
  //     lionjumperhamper, lionjumperset, greyhat, whitehat, whitegreyhat, bluehat, pinkhat, navyhat, sagehat, steelhat, mustardhat, coffeehat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, countdownboards, allstarmoneyboxes, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         // {
  //         //   name: '6-12 Months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // },   
  // {
  //   id: "cosy-pink-giraffe",
  //   description:
  //   <>This lovely addition to our cosy hamper collection features a heart design and a super cute giraffe comforter, perfect to keep little ones tucked up warm anytime of the year. You can choose your own colour of matching accessories, adding your own personal touch! 
  //   <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Pink Heart Giraffe Comforter (100% Polyester) </li>
  //         <li>Pink Heart Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
  //         <li>Crochet Booties (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //     </>,
  //   categories: ["cosy-hampers", "Female"],
  //   name: "Cosy Giraffe Heart Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: cosypgiraffemain,
  //   productImages: [
  //     cosypgiraffemain, cosypgiraffe1, greyhat, whitehat, whitegreyhat, bluehat, pinkhat, navyhat, sagehat, steelhat, mustardhat, coffeehat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // },   
  // {
  //   id: "sheep-hamper",
  //   description:
  //   <>Our bestselling cosy hamper gift, perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly and this sheep comforter is so fluffly, the new arrivals will love to keep him close by. You can choose your own colour adding your own personal touch and these hampers make perfect baby shower or new parent gifts.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Fluffy Sheep Comforter</li>
  //       <li>Grey Supersoft Sheep Blanket (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //       <li>Pom Pom Hat & Matching Mittens, lots of colours to choose from (100% Acrylic)</li>
  //       <li>Choice of Crochet Booties</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["cosy-hampers", "best-sellers", "Unisex"],
  //   name: "Sheep Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: sheepmain,
  //   productImages: [
  //     sheepmain, sheep1, sheep2, sheep3, sheep4, sheep5, whitegreyhat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },         
  //   ]
  // },
  {
    id: "big-love-unisex",
    description:
    <>A lovely neutral gift set, this hamper has a forest animal theme, with the words 'Big Love' featured. All in our very popular grey & white neutral tones. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
      <li>White Animal Print Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
      <li>White Star Vest (100% Cotton)</li>
      <li>White Animal Print Hat</li>
      <li>White 'Big Love' Bib</li>
      <li>White Animal Print Mittens</li>
      <li>Crochet Booties (100% Acrylic)</li></ul>
    <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  </>,
    categories: ["Unisex"],
    name: "Big Love Animal Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: fipcbiglovehamp,
    productImages: [
       fipcbiglovehamp, fipcbiglovemain, greywaffle, whitewaffle, coffeewaffle, mustardwaffle, allbooties, greyelephant, whiteelephant, bunnycloud, brownbearcomf, pinkbearcomf, giraffeprintcomforter, reczebracomforter, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn <2 Available>'
          },
          // {
          //   name: '0-3 months'
          // },
          {
            name: '3-6 months <1 Available>'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Coffee'
          },          
          {
            name: 'Mustard'
          },          
          {
            name: 'Rose'
          },          
          {
            name: 'Lemon'
          }          
        ]
      },
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant',
            increment: 7.99
          },
          {
            name: 'Grey Elephant',
            increment: 7.99
          },
          // {
          //   name: 'Grey Bunny',
          //   increment: 7.99
          // },
          {
            name: 'Grey Giraffe',
            increment: 7.99
          },
          // {
          //   name: 'Brown Bear',
          //   increment: 7.99
          // },          
          {
            name: 'Pink Bear',
            increment: 7.99
          },          
          {
            name: 'Grey Zebra',
            increment: 8.99
          }
        ]
      },
      {
        title: 'TooWordy Gift Card',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Tiny Toes',
            increment: 3.50
          },
          {
            name: 'Blue Tiny Toes',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },          
          {
            name: 'Bun in Oven',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Lovely News',
            increment: 3.50
          },
          {
            name: 'Blue Welcome World',
            increment: 3.50
          },          
          {
            name: 'Pink Welcome World',
            increment: 3.50
          }          
        ]
      },      
    ]
  },  
//   {
//     id: "knitted-grey-stars",
//     description:
//     <>Part of our Winter Warmers Collection, this gift set is cute & cosy! This set contains lof of neautral items to keep baby wrapped up warm. Features a two piece knitted set with a grey star & stripe design. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
//     <br /><br />Gift Hamper includes:
//     <br /><br /><ul>
//       <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
//       <li>Star & Stripe Two Piece Knitted Set (50% Cotton, 50% Acrylic Sizes: 0-3, 3-6, 6-12 Months)</li>
//       <li>Pom Pom Hat & Matching Mittens (100% Cotton)</li>
// </ul>
//     <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
//         <br />
//         <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
//         <br />
//         <br />Sizes 0-3 & 3-6 Months - Sold Out
//   </>,
//     categories: ["Unisex"],
//     name: "Knitted Star & Stripe Gift Set",
//     review: "productize virtual markets",
//     deliveryCharge: deliveryCharges,
//     price: 28.99,
//     img: knittedstarstripehamper,
//     productImages: [
//       knittedstarstripehamper, greystarstripe, whitewaffle, greywaffle, bluewaffle, pinkwaffle, hats2, allbooties, greyelephant, whiteelephant, bunnycloud, giraffeprintcomforter, bluedinosaur, whitedinosaur, wishstring, alltoowordy
//     ],
//     variants: [
//       {
//         title: 'Clothing Size',
//         options: [
//           // {
//           //   name: '0-3 months'
//           // },
//           // {
//           //   name: '3-6 months'
//           // },
//           {
//             name: '6-12 months <1 available>'
//           }
//         ]
//       },
//       {
//         title: 'Blanket Colour',
//         options: [
//           {
//             name: 'Grey'
//           },
//           {
//             name: 'White'
//           },
//           {
//             name: 'Blue'
//           },
//           {
//             name: 'Pink'
//           }
//         ]
//       },
//       {
//         title: 'Hat & Mitten Colour',
//         options: [
//           {
//             name: 'White'
//           },
//           {
//             name: 'Grey'
//           },
//           {
//             name: 'White & Grey Stripe'
//           },
//           {
//             name: 'Blue'
//           },          
//           {
//             name: 'Pink'
//           },          
//           {
//             name: 'Sage'
//           },
//           {
//             name: 'Mustard'
//           },
//           {
//             name: 'Coffee'
//           },          
//           {
//             name: 'Rose'
//           }          
//         ]
//       },
//       {
//         title: 'Optional Booties',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'White Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Grey Booties',
//             increment : 2.00
//           },          
//           {
//             name: 'Blue Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Pink Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Navy Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Coffee Booties',
//             increment : 2.00
//           },        
//           {
//             name: 'Rose Booties',
//             increment : 2.00
//           }            
//         ]
//       },            
//       {
//         title: 'Optional Comforter',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'White Elephant',
//             increment: 6.99
//           },
//           {
//             name: 'Grey Elephant',
//             increment: 6.99
//           },
//           {
//             name: 'Grey Bunny',
//             increment: 6.99
//           },
//           {
//             name: 'Grey Penguin',
//             increment: 6.99
//           },          
//           {
//             name: 'White Dinosaur',
//             increment: 6.99
//           },          
//           {
//             name: 'Blue Dinosaur',
//             increment: 6.99
//           },          
//           {
//             name: 'Grey Giraffe',
//             increment: 6.99
//           }
//         ]
//       },
//       {
//         title: 'Wishstring Bracelet',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'From Bump',
//             increment: 3.99
//           },
//           {
//             name: 'For Daddy',
//             increment: 3.99
//           },
//           {
//             name: 'Congrats',
//             increment: 3.99
//           },
//           {
//             name: 'Coming Baby Shower',
//             increment: 3.99
//           },
//           {
//             name: 'Wonderful Mummy',
//             increment: 3.99
//           },
//           // {
//           //   name: 'For New Mum',
//           //   increment: 3.99
//           // },
//           {
//             name: 'Mums Buttons',
//             increment: 3.99
//           }
//         ]
//       },
//       {
//         title: 'Additional Giftcard',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'Pink Twinkle Toes',
//             increment: 3.50
//           },
//           {
//             name: 'Blue Twinkle Toes',
//             increment: 3.50
//           },
//           {
//             name: 'Precious Daughter',
//             increment: 3.50
//           },
//           // {
//           //   name: 'Baby Boy Banner',
//           //   increment: 3.50
//           // },
//           {
//             name: 'Little Lady',
//             increment: 3.50
//           },
//           {
//             name: 'Little Dude',
//             increment: 3.50
//           },
//           {
//             name: 'Lovely Happy News',
//             increment: 3.50
//           },
//           {
//             name: 'Bundle Of Joy',
//             increment: 3.50
//           },
//           {
//             name: 'Welcome Baby Boy',
//             increment: 3.50
//           },
//           {
//             name: 'Welcome Baby Girl',
//             increment: 3.50
//           },
//           {
//             name: 'New Chapter',
//             increment: 3.50
//           },
//           {
//             name: 'Bun In The Oven',
//             increment: 3.50
//           }
//         ]
//       },
//     ]
//   },   
  {
    id: "hot-air-balloon-unisex",
    description:
    <>A lovely neutral gift sets, this hamper has a bunny & bear theme and features subtle white & grey tones throughout. A sweet hot air balloon design on the Bib. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
      <li>White Animal Print Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
      <li>White Bear Vest (100% Cotton)</li>
      <li>White Animal Print Hat</li>
      <li>White Hot Air Balloon Bib</li>
      <li>White Animal Print Mittens</li>
      <li>Crochet Booties (100% Acrylic)</li></ul>
    <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  </>,
    categories: ["Unisex"],
    name: "Animal Balloon Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: fipcballoonanimalmain,
    productImages: [
      fipcballoonanimalmain, fipcballoonanimal, greywaffle, whitewaffle, pinkwaffle, bluewaffle, allbooties, greyelephant, whiteelephant, bunnycloud, brownbearcomf, giraffeprintcomforter, reczebracomforter, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters 
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn <1 Available>'
          },
          {
            name: '0-3 months <1 Available>'
          },
          {
            name: '3-6 months <1 Available>'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Sage Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Rose Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Pink'
          }
        ]
      },
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant',
            increment: 6.99
          },
          {
            name: 'Grey Elephant',
            increment: 6.99
          },
          {
            name: 'Grey Bunny',
            increment: 6.99
          },
          {
            name: 'Grey Giraffe',
            increment: 6.99
          },
          // {
          //   name: 'Brown Bear',
          //   increment: 6.99
          // },
          {
            name: 'Grey Zebra',
            increment: 7.99
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          // {
          //   name: 'Unicorn Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Mermaid Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Car Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Dinosaur Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Pink Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'Yellow Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'White Geo Organic Teether',
          //   increment: 5.99
          // },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          // {
          //   name: 'Pink Rainbow Teether',
          //   increment: 7.99
          // },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          // {
          //   name: 'Blue Elephant Keepsake Box',
          //   increment: 11.99
          // },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          // {
          //   name: 'Wooden Shape Sorter',
          //   increment: 12.99
          // },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
       ]
     },
    ]
  }, 
  {
    id: "bunny-jumper-set",
    description:
      <>This clothing set makes a great gift for a little person, containing a fun outfit and accessories. This set contains a jumper, jog pants and matching socks, all with a cute bunny & floral theme. 
      <br/><br/> With plenty of other matching options available, why not make a nice themed hamper? Rose is a really popular colour choice for us at the moment.
      <br /><br />
      <ul>
        <li>Materials: Top: CVC 60/40 Quilted 220gsm; Pant: 100% cotton Interlock 180gsm; Socks: 100% polyeste</li>
        <li>Sizes: 0-3, 3-6 or 6-12 Months</li></ul></>,
    categories: ["clothing"],
    name: "3pc Bunny Jumper Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 11.99,
    img: quiltedrosebunny,
    productImages: [
      quiltedrosebunny,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          // {
          //   name: '0-3 Months'
          // },
          // {
          //   name: '3-6 Months'
          // },
          {
            name: '6-12 Months <1 available>'
          }
        ]
      },
    ]
  },      
  {
    id: "grey-knitted-stripe-set",
    description:
      <>This knitted 2pc set is perfect for keeping baby cosy. This set contains a knitted cardigan with cute ear details on the hood & grey stripe design on the front, and matching pants. 
      <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 or 6-12 Months</li>
        <br />Size 0-3 & 6-12 Months - Sold Out
        <br />
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Knitted Stripe Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: knittedgreystripe,
    productImages: [
      knittedgreystripe,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          // {
          //   name: '0-3 Months <1 available>'
          // },
          {
            name: '3-6 Months <1 available>'
          },
          // {
          //   name: '6-12 Months <1 available>'
          // }
        ]
      },
    ]
  },   
  {
    id: "knitted-bow-set",
    description:
      <>This clothing set makes a great gift for a little person, knitted material to keep them cosy. This set contains a knitted jumper with bow detail on the front and matching pants.
      <br/><br/> With plenty of other matching options available, why not make a nice themed hamper?
      <br /><br />
      <ul>c
        <li>Materials: 100% Cotton</li>
        <li>Sizes : 0-3, 3-6 or 6-9 Months</li>
        <br /> 
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Knitted Bow Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: knittedbowset,
    productImages: [
      knittedbowset,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-9 Months'
          }
        ]
      },
    ]
  },
  {
    id: "knitted-blue-set",
    description:
      <>This knitted 4pc set with hat and mittens included is perfect for keeping baby cosy.
      <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li></ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Blue Knitted Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: threepcblueknitted,
    productImages: [
      threepcblueknitted,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      },
    ]
  },
  {
    id: "knitted-grey-set",
    description:
      <>This knitted 4pc set with hat and mittens included is perfect for keeping baby cosy.
      <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li>
        <br />Size 0-3 Months - Sold Out
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Grey Knitted Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: threepcgreyknitted,
    productImages: [
      threepcgreyknitted,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          // {
          //   name: '0-3 Months'
          // },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      },
    ]
  },           
  // {
  //   id: "lion-jumper-set",
  //   description:
  //     <>This clothing set makes a great gift for a little person, containing a fun outfit and accessories. This set contains a jumper, jog pants and matching socks, all with a cute lion theme. 
  //     <br/><br/> With plenty of other matchung options available, why not make a nice themed hamper?
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Top: CVC 60/40 Quilted 220gsm; Pant: 100% cotton Interlock 180gsm; Socks: 100% polyeste</li>
  //       <li>Size:0-3, 3-6 or 6-12 Months</li>
  //       <br /> Size 3-6, 6-12 Months - Sold Out
  //       </ul></>,
  //   categories: ["clothing"],
  //   name: "3pc Lion Jumper Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 11.99,
  //   img: lionjumperset,
  //   productImages: [
  //     lionjumperset,
  //   ],
  //   variants: [
  //     {
  //       title: 'Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         // {
  //         //   name: '6-12 Months'
  //         // }
  //       ]
  //     },
  //   ]
  // }, 
  // {
  //   id: "blue-grey-cardigan",
  //   description:
  //     <>This lovely baby cardigan and pant set is perfect to keep baby warm out on their walks in the pram. With cute ears on the hood and bear shaped brown buttons on the front.
  //     <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
  //     <br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3, 3-6, 6-12 Months</li></ul></>,
  //   categories: ["winter-warmers", "clothing", "new-arrivals"],
  //   name: "Stripe Cardigan & Pant Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: bluedoubleknit,
  //   productImages: [
  //     bluedoubleknit
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-12 Months'
  //         }
  //       ]
  //     },
  //   ]
  // },   
  {
    id: "3pc-koala-cuddles",
    description:
      <>This 3pc set makes a great gift containing all a super cute outfit for baby. 
      <br /><br />The set contains a long sleeve vest with a koala design saying "cuddles please", mint star pants and a mint star hat to match.
      <br /><br />Neutral mint tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Tiny Baby, Newborn, 0-3 & 3-6 Months</li>
        <br />
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "new-arrivals"],
    name: "Koala Star 3pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: mintcuddles,
    productImages: [
      mintcuddles, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Tiny Baby <1 available>'
          },
          {
            name: 'Newborn <3 available>'
          },
          {
            name: '0-3 Months <3 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },   
  {
    id: "panda-jumper-set",
    description:
      <>This clothing set makes a great gift for a little person, containing a fun outfit and accessories. This set contains a jumper, jog pants and matching socks, all with a cute panda & spot theme. 
      <br/><br/> With plenty of other matching options available, why not make a nice themed hamper?
      <br /><br />
      <ul>
        <li>Materials: Top: CVC 60/40 Quilted 220gsm; Pant: 100% cotton Interlock 180gsm; Socks: 100% polyeste</li>
        <li>Size:0-3, 3-6 or 6-12 Months</li></ul></>,
    categories: ["clothing"],
    name: "3pc Panda Jumper Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 11.99,
    img: pandajumperset,
    productImages: [
      pandajumperset,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-12 Months'
          }
        ]
      },
    ]
  },   
  // {  
  //   id: "brown-knitted-jumper-trousers",
  //   description:
  //     <>A cute knitted brown jumper and trousers featuring a solid stripe design.  Perfect for those cosy days.   
  //     <br /><br />Team up with one of our cosy blankets or hat & mitten sets for the perfect cosy outfit!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton Knit</li>
  //       <li>Size: 0-3, 3-6, 6-12 Months</li>
  //       <br />Size 3-6 Months - Sold Out
  //       </ul></>,
  //   categories: ["clothing", "winter-warmers", "new-arrivals"],
  //   name: "Brown Knitted Jumper & Trousers",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: brownknitted,
  //   productImages: [
  //     brownknitted,
  //   ],
  //   variants: [
  //     {
  //       title: 'Size',
  //       options: [
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         {
  //           name: '6-12 Months <1 available>'
  //         }
  //       ]
  //     }
  //   ]
  // },   
  {
    id: "velour-bunny",
    description:
      <>Keep them cosy in the cooler months with our cute & cosy velour onesies. This adorable pink velour onesie, features three emboidered bunnies across the front and has a cute lace effect collar.
      <br/><br/>Team up with our other blankets, booties & comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
        <br />Size 3-6 Months - Sold Out
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "spring-summer"],
    name: "Bunny Velour Onesie",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: bunnyvelour,
    productImages: [
      bunnyvelour, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          // {
          //   name: '3-6 Months'
          // },
          {
            name: '6-9 Months <1 available>'
          }
        ]
      }
    ]
  },    
  {  
    id: "navy-cable-jumper-trousers",
    description:
      <>A cute knitted navy cable jumper and trousers featuring a stripe design on the trousers. We love the brown button details. Perfect for those cosy days inside, or wintery walks out and about.   
      <br /><br />Team up with one of our cosy blankets or hat & mitten sets for the perfect cosy outfit!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton Knit</li>
        <li>Size: 0-3, 3-6, 6-12 Months</li>
        <br />
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Navy Cable Jumper & Trousers",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: navycablestripe,
    productImages: [
      navycablestripe,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-12 Months <1 available>'
          }
        ]
      }
    ]
  },     
  {
    id: "hooded-knitted-heart-set",
    description:
      <>This knitted 2pc set is perfect for keeping baby cosy. This set contains a knitted cardigan with cute ear details on the hood & heart design on the front, and matching pants. 
      <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6 or 6-12 Months</li>
        <br />Size 0-3 Months - Sold Out
        <br />
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Knitted Heart Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: hoodedknittedheart,
    productImages: [
      hoodedknittedheart,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          // {
          //   name: '0-3 Months <1 available>'
          // },
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-12 Months <1 available>'
          }
        ]
      },
    ]
  },  
  {
    id: "pink-button-cardi-hamper",
    description:
    <>Part of our Winter Warmers Collection, this gift set is cute & cosy! This set has a pink theme with the perfect items to keep baby wrapped up warm. Features a cosy pink cardigan with wooden effect teddy buttons. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
      <li>Pink Knitted Cardigan (100% Cotton, Sizes: 0-3, 3-6, 6-12 Months)</li>
      <li>Optional Comforter (Various Materials)</li>
      <li>Optional Pom Pom Hat & Matching Mittens (100% Cotton)</li>
</ul>
      <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
      <br />
      <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
      <br /><br />Sizes 0-3 & 6-12 Months - Sold Out
  </>,
    categories: ["Female", "winter-warmers"],
    name: "Knitted Cardigan Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 22.99,
    img: pinkcardihamper,
    productImages: [
      pinkcardihamper, pinkdoubleknit, whitewaffle, greywaffle, pinkwaffle, rosewaffle, hats2, allbooties, allcomforters1, wishstring, alltoowordy
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          // {
          //   name: '0-3 months <1 available>'
          // },
          {
            name: '3-6 months <1 available>'
          },
          // {
          //   name: '6-12 months <1 available>'
          // }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Rose'
          }
        ]
      },
      {
        title: 'Optional Hat & Mitten',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White',
            increment: 6.00
          },
          {
            name: 'Grey',
            increment: 6.00
          },
          {
            name: 'White & Grey Stripe',
            increment: 6.00
          },
          {
            name: 'Pink',
            increment: 6.00
          },          
          {
            name: 'Coffee',
            increment: 6.00
          },          
          {
            name: 'Sage',
            increment: 6.00
          },
          {
            name: 'Rose',
            increment: 6.00
          }
        ]
      },
      {
        title: 'Optional Booties',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Booties',
            increment : 2.00
          },
          {
            name: 'Grey Booties',
            increment : 2.00
          },          
          {
            name: 'Pink Booties',
            increment : 2.00
          },
          {
            name: 'Rose Booties',
            increment : 2.00
          },
          {
            name: 'Coffee Booties',
            increment : 2.00
          }           
        ]
      },            
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant',
            increment: 6.00
          },
          {
            name: 'Grey Elephant',
            increment: 6.00
          },
          // {
          //   name: 'Grey Bunny',
          //   increment: 6.99
          // },
          {
            name: 'Grey Penguin',
            increment: 6.00
          },          
          // {
          //   name: 'White Dinosaur',
          //   increment: 6.99
          // },          
          {
            name: 'Blue Dinosaur',
            increment: 6.00
          },          
          {
            name: 'Grey Giraffe',
            increment: 6.00
          },
          {
            name: 'Brown Bear',
            increment: 6.00
          },
          {
            name: 'Pink Bear',
            increment: 6.00
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },
{
  id: "navy-stripe-cardigan",
  description:
    <>This lovely baby cardigan is perfect to keep baby warm out on their walks in the pram. With cute ears on the hood and bear shaped brown buttons on the front.
    <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6, 6-12 Months</li>
    <br /> Sizes 3-6 & 6-12 Months - Sold Out
      </ul></>,
  categories: ["winter-warmers", "clothing"],
  name: "Navy Double Knit Cardigan",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 14.99,
  img: navydoubleknit,
  productImages: [
    navydoubleknit
  ],
  variants: [
    {
      title: 'Cardigan Size',
      options: [
        {
          name: '0-3 Months <1 available>'
        },
        // {
        //   name: '3-6 Months'
        // },
        // {
        //   name: '6-12 Months <1 available>'
        // }
      ]
    },
  ]
},  
{
  id: "safari-jacket-set",
  description:
    <>This Bluey Grey 2pc set has a lovely safari design. This set also contains a hooded jacket with griaffe embroidery and super cute ear design, with matching pants with an animal design throughout.
    <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. 
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Sizes : 0-3, 3-6 or 6-9 Months</li>
      <br /> 
      </ul></>,
  categories: ["clothing"],
  name: "Safari Jacket & Pant Set",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 14.99,
  img: safarijacketset,
  productImages: [
    safarijacketset,
  ],
  variants: [
    {
      title: 'Size',
      options: [
                {
          name: '0-3 Months <1 available>'
        },
        {
          name: '3-6 Months <1 available'
        },
        {
          name: '6-9 Months <1 available'
        }
      ]
    },
  ]
}, 
  {
    id: "knitted-bear-set",
    description:
      <>This knitted Blue 4pc set has a lovely bear design on the front. This cute set also contains a hat and gloves and is perfect for keeping baby cosy.
      <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li>
        <br /> Sizes Newborn & 3-6 Months - Sold Out
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Blue Knitted Bear Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: blueknittedbear,
    productImages: [
      blueknittedbear,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          // {
          //   name: 'Newborn <1 available>'
          // },
          {
            name: '0-3 Months <1 available>'
          },
          // {
          //   name: '3-6 Months'
          // }
        ]
      },
    ]
  }, 
  // {  
  //   id: "navy-stripe-two-piece",
  //   description:
  //     <>A cute knitted navy top and trousers set. This 2pc set has a lovely cable design on the top.  The buttons on the top and bottoms, sets of this outfit perfectly. An essential for those cosy days.   
  //     <br /><br />We love the navy pocket detail on the trousers! Team up with one of our cosy blankets or hat & mitten sets for the perfect cosy outfit!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton Knit</li>
  //       <li>Size: 0-3, 3-6, 6-12 Months</li>
  //       <br /> Size 6-12 Months - Sold Out
  //       </ul></>,
  //   categories: ["clothing","new-arrivals", "winter-warmers"],
  //   name: "Knitted Navy striped Trousers and Top",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: knittednavystripemain,
  //   productImages: [
  //     knittednavystripemain, knittednavystripe1
  //   ],
  //   variants: [
  //     {
  //       title: 'Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         // {
  //         //   name: '6-12 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // }, 
  // {  
  //   id: "grey-star-two-piece",
  //   description:
  //     <>A cute knitted grey top and trousers featuring a star and stripe design.  Perfect for those cosy days.   
  //     <br /><br />Team up with one of our cosy blankets or hat & mitten sets for the perfect cosy outfit!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 50% Cotton Knit, 50% Acrylic</li>
  //       <li>Size: 0-3, 3-6, 6-12 Months</li>
  //       <br /><br /> Sizes 0-3 & 3-6 Months - Sold Out
  //       </ul></>,
  //   categories: ["clothing"],
  //   name: "Grey Star and Striped Trousers and Top",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: greystarstripe,
  //   productImages: [
  //     greystarstripe,
  //   ],
  //   variants: [
  //     {
  //       title: 'Size',
  //       options: [
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         {
  //           name: '6-12 Months <1 available>'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "cosy-pink-bunny",
  //   description:
  //   <>This lovely addition to our cosy hamper collection features a floral design and a super cute bunny comforter, perfect to keep little ones tucked up warm anytime of the year. You can choose your own colour of matching accessories, adding your own personal touch! 
  //   <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Pink Floral Bunny Comforter (100% Polyester) </li>
  //         <li>Pink Floral Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
  //         <li>Crochet Booties (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //     </>,
  //   categories: ["cosy-hampers", "Female"],
  //   name: "Cosy Bunny Heart Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: cosypinkbunny,
  //   productImages: [
  //     cosypinkbunny, rabbitblanketcomf, greyhat, whitehat, whitegreyhat, bluehat, pinkhat, navyhat, sagehat, steelhat, mustardhat, coffeehat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // },    
  {
    id: "cosy-blue-monkey",
    description:
    <>This lovely addition to our cosy hamper collection features a moon and stars design and a cheeky monkey comforter, perfect to keep little ones tucked up warm anytime of the year. You can choose your own colour of matching accessories, adding your own personal touch! 
    <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
        <br /><br />Gift Hamper includes:
        <br /><br /><ul>
          <li>Blue Moon & Stars Monkey Comforter (100% Polyester) </li>
          <li>Blue Moon & Stars Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
          <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
          <li>Crochet Booties (100% Acrylic)</li>
        </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
      </>,
    categories: ["cosy-hampers", "Male", "winter-warmers"],
    name: "Cosy Monkey Clouds Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: cosybmonkeymain,
    productImages: [
      cosybmonkeymain, cosybmonkey1, greyhat, whitehat, whitegreyhat, bluehat, pinkhat, navyhat, sagehat, steelhat, mustardhat, coffeehat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Hat & Mittens Colour',
        options: [
          {
            name: 'Grey Hat & Mittens'
          },
          {
            name: 'White Hat & Mittens'
          },
          {
            name: 'White & Grey Hat & Mittens'
          },
          {
            name: 'Blue Hat & Mittens'
          },
          {
            name: 'Pink Hat & Mittens'
          },
          {
            name: 'Navy Hat & Mittens'
          },
          // {
          //   name: 'Mustard Hat & Mittens'
          // },
          {
            name: 'Sage Hat & Mittens'
          },
          {
            name: 'Steel Hat & Mittens'
          },
          {
            name: 'Coffee Hat & Mittens'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Rose Booties'
          },
          {
            name: 'Sage Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          // {
          //   name: 'Unicorn Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Mermaid Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Car Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Dinosaur Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Pink Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'Yellow Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'White Geo Organic Teether',
          //   increment: 5.99
          // },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          // {
          //   name: 'Pink Rainbow Teether',
          //   increment: 7.99
          // },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          // {
          //   name: 'Blue Elephant Keepsake Box',
          //   increment: 11.99
          // },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          // {
          //   name: 'Wooden Shape Sorter',
          //   increment: 12.99
          // },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
       ]
     },
    ]
  },  
  // {
  //   id: "cosy_elephant_hamper",
  //   description:
  //     <>Our bestselling cosy elephant hamper gift with a twist, perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket is super snuggly.  You can choose your own colour adding your own personal touch!
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>White & Grey Elephant Comforter (100% Polyester) </li>
  //         <li>Grey Supersoft Elephant Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
  //         <li>Crochet Booties (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //     </>,
  //   categories: ["cosy-hampers"],
  //   name: "Cosy Elephant Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: cosyelephantmain,
  //   productImages: [
  //     cosyelephantmain, cosyelephant1, cosyelephant2, cosyelephant3, sheep4, sheep5, whitegreyhat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         {
  //           name: 'Mustard Hat & Mittens'
  //         },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // },
  // {
  //   id: "cosy-grey-sheep",
  //   description:
  //   <>This lovely addition to our cosy hamper collection features a star design and a lovely sheep comforter, perfect to keep little ones tucked up warm anytime of the year. You can choose your own colour of matching accessories, adding your own personal touch! 
  //   <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Grey Star Sheep Comforter (100% Polyester) </li>
  //         <li>Grey Star Sheep Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
  //         <li>Crochet Booties (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //     </>,
  //   categories: ["cosy-hampers", "Unisex", "winter-warmers"],
  //   name: "Cosy Star Sheep Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: cosygsheepmain,
  //   productImages: [
  //     cosygsheepmain, cosygsheep1, greyhat, whitehat, whitegreyhat, bluehat, pinkhat, navyhat, sagehat, steelhat, mustardhat, coffeehat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // },  
  {
    id: "bunny-ballet",
    description:
      <>This hamper features a cute design featuring a bunny ballerina theme, with a pink colour throughout. Bunny designs are always super popular for us! This hamper is packed full of essentials for a new arrival and we've lots of ways for you to add your own personal touch to all the little details. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Cellular or Fleece Blanket (100% Cotton)</li>
        <li>Pink Bunny Ballerina Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
        <li>Pink Bunny Ballerina Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
        <li>Pink Bunny Ballerina Hat, Bib & Scratch Mitts </li>
        <li>Choice Of Crochet Booties</li>
        </ul>
        <br /> Size Newborn - Sold Out
        <br /><br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
        </>,
    categories: ["Female"],
    name: "Bunny Ballerina Hamper Gift Set",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: bunnyballethamper,
    productImages: [
      bunnyballethamper, fipclovetwirlbearmain, pinkwaffle, whitewaffle, whitecellular, pinkcellular, allbooties, frames, plaques, welcomeplaque, wishstring, alltoowordy, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, countdownboards, allstarmoneyboxes, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          // {
          //   name: 'Newborn'
          // },
          {
            name: '0-3 months <1 Available>'
          },
          {
            name: '3-6 months <1 Available>'
          }
        ]
      },
      {
        title: 'Blanket Choice',
        options: [
          {
            name: 'Pink Cellular'
          },
          {
            name: 'White Cellular'
          },
          {
            name: 'Pink Waffle Fleece'
          },
          {
            name: 'White Waffle Fleece'
          }          
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          },
          {
            name: 'Rose Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          // {
          //   name: 'White Bunny Plaque',
          //   increment: 4.99
          // },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },          
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          // {
          //   name: 'Pink Elephant Keepsake Box',
          //   increment: 11.99
          // },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          }    
    ]
  },
    ]
  },
  {
    id: "little-cosy-hamper",
    description:
      <>A mini version of our bestselling cosy hamper gift, perfect to give you a fully customisable option. Either keep it simple or add in a super snuggly blanket too! You can choose your own choice of comforters & colours adding your own personal touch!
        <br /><br />Gift Hamper includes:
        <br /><br /><ul>
          <li>Choice Of Comforter (Various Materials)</li>
          <li>Pom Pom Hat and Matching Mittens (100% Acrylic)</li>
          <li>Optional Crochet Booties (100% Acrylic)</li>
          <li>Optional Blanket (Various Materials)</li>
        </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
      </>,
    categories: ["cosy-hampers", "Unisex"], 
    showOnHomepage: true,
    name: "Little Cosy Hamper Gift",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 17.99,
    img: littlecosypenguin,
    productImages: [
      littlecosypenguin, littlecosybear, littlecosyelephant, allcomforters1, allhats, hats2, sheepblanket, dinosaurblanket, elephantstarblanket, giraffeprintblanket, rainbowblanket, zebrablanket, greywaffle, whitewaffle, mustardwaffle, coffeewaffle, rosewaffle, wishstring, alltoowordy
    ],
    variants: [
      {
        title: 'Comforter Choice',
        options: [
          {
            name: 'Penguin'
          },
          {
            name: 'White Elephant'
          },
          {
            name: 'Grey Elephant'
          },
          {
            name: 'Brown Bear'
          },
          {
            name: 'Pink Bear'
          },
          // {
          //   name: 'Blue Dinosaur'
          // },
          {
            name: 'White Dinosaur'
          },
          {
            name: 'Giraffe'
          },
          // {
          //   name: 'Unicorn'
          // },
          {
            name: 'Sheep'
          },
          {
            name: 'Lion'
          },
          // {
          //   name: 'Grey Bunny'
          // }
        ]
      },
      {
        title: 'Hat & Mittens Colour',
        options: [
          {
            name: 'Grey Hat & Mittens'
          },
          {
            name: 'White Hat & Mittens'
          },
          {
            name: 'White & Grey Hat & Mittens'
          },
          {
            name: 'Blue Hat & Mittens'
          },
          {
            name: 'Pink Hat & Mittens'
          },
          {
            name: 'Navy Hat & Mittens'
          },
          // {
          //   name: 'Mustard Hat & Mittens'
          // },
          {
            name: 'Sage Hat & Mittens'
          },
          {
            name: 'Steel Hat & Mittens'
          },
          {
            name: 'Rose Hat & Mittens'
          },
          {
            name: 'Coffee Hat & Mittens'
          }
        ]
      },
      {
        title: 'Optional Bootie',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Booties',
            increment: 2.00
          },
          {
            name: 'White Booties',
            increment: 2.00
          },
          {
            name: 'Blue Booties',
            increment: 2.00
          },
          {
            name: 'Pink Booties',
            increment: 2.00
          },
          {
            name: 'Navy Booties',
            increment: 2.00
          },
          {
            name: 'Coffee Booties',
            increment: 2.00
          },
          {
            name: 'Rose Booties',
            increment: 2.00
          },
          {
            name: 'Sage Booties',
            increment: 2.00
          }
        ]
      },
      {
        title: 'Optional Blanket',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Sheep Blanket',
            increment: 6.00
          },
          {
            name: 'Rainbow Blanket',
            increment: 6.00
          },
          {
            name: 'Giraffe Print Blanket',
            increment: 6.00
          },
          {
            name: 'Zebra Blanket',
            increment: 6.00
          },
          {
            name: 'Dinosaur Blanket',
            increment: 6.00
          },
          {
            name: 'Grey Waffle Blanket',
            increment: 5.00
          },
          {
            name: 'Rose Waffle Blanket',
            increment: 5.00
          },
          {
            name: 'Mustard Waffle Blanket',
            increment: 5.00
          },
          {
            name: 'White Waffle Blanket',
            increment: 5.00
          },
          {
            name: 'Coffee Waffle Blanket',
            increment: 5.00
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },     
  // {
  //   id: "rainbow-sheep",
  //   description:
  //   <>Our bestselling cosy hamper gift, perfect to keep little ones tucked up warm anytime of the year. This hamper feautres a supersoft rainbow fleece blanket, and gives you the option to choose which comforter to add. You can choose your own colour adding your own personal touch and these hampers make perfect baby shower or new parent gifts.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Pink & White Rainbow Fleece Blanket</li>
  //       <li>Choice of Baby Comforter</li>
  //       <li>Pom Pom Hat & Matching Mittens, lots of colours to choose from (100% Acrylic)</li>
  //       <li>Choice of Crochet Booties</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["cosy-hampers", "Female"],
  //   showOnHomepage: true,
  //   name: "Rainbow Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: rainbowmain,
  //   productImages: [
  //     rainbowmain, rainbow1, rainbowblanket, whitegreyhat, hats1, hats2, allbooties, sheep, greyelephant, lion, unicorn, whiteelephant, bluedinosaur, whitedinosaur, pinkbunny, bunnycloud, recgiraffecomforter, reczebracomforter, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },      
  //   ]
  // },  
  {
    id: "cosy-colour",
    description:
      <>A simplier version of our cosy hamper, this lovely gift allows you to build your own and add as much or as little as you want. Our supersoft waffle blankets and matching accessories are perfect for keeping baby warm, and we've added lots of additional accessories options to allow you to personalise to your taste.
       <br /><br />Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes:<ul>
        <br />
        <li>Choice of Colour Supersoft Waffle Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
        <li>Pom Pom Hat & Matching Mittens, lots of colours to choose from</li>
        <li>Optional Comforter</li></ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />        
        </>,
    categories: ["cosy-hampers"],
    showOnHomepage: true,
    name: " Cosy Colour Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 16.99,
    img: cosycolourmain,
    productImages: [
      cosycolourmain, cosycolour1, cosycolour2, cosycolour3, cosycolour4, cosycolour5, cosycolour6, cosycolour7, bunnycloud, unicorn, penguin, sheep, lion, greyelephant, whiteelephant, recycledcomforters, comforters, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Blanket, Hat & Mittens Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Beige'
          },
          // {
          //   name: 'Mustard'
          // }
        ]
      },
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks',
          },
          {
            name: 'Penguin',
            increment: 7.00
          },
          {
            name: 'Lion',
            increment: 7.00
          },
          // {
          //   name: 'Zebra',
          //   increment: 7.99,
          // },
          {
            name: 'Grey Elephant',
            increment: 7.00
          },
          {
            name: 'White Elephant',
            increment: 7.00
          },
          // {
          //   name: 'Bunny',
          //   increment: 7.00
          // },
          // {
          //   name: 'Sheep',
          //   increment: 7.99
          // },
          {
            name: 'Unicorn',
            increment: 7.00
          },
          // {
          //   name: 'Recycled Giraffe',
          //   increment: 7.00
          // },
          {
            name: 'Recycled Zebra',
            increment: 7.00
          },
          {
            name: 'Recycled Cream Sheep',
            increment: 7.00
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          // {
          //   name: 'Unicorn Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Mermaid Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Car Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Dinosaur Water Teether',
          //   increment: 2.99
          // },
          // {
          //   name: 'Pink Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'Yellow Dumbell Rattle',
          //   increment: 2.99
          // },
          // {
          //   name: 'White Geo Organic Teether',
          //   increment: 5.99
          // },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          // {
          //   name: 'Pink Rainbow Teether',
          //   increment: 7.99
          // },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          // {
          //   name: 'Blue Elephant Keepsake Box',
          //   increment: 11.99
          // },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          // {
          //   name: 'Wooden Shape Sorter',
          //   increment: 12.99
          // },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
       ]
     },
    ]
  },
  {
    id: "lemon-floral-hamper",
    description:
    <>Start the new season right with this gorgeous lemon floral themed hamper. A great selection of essentials for any new arrival. Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Choice of Blanket (100% Cotton)</li>
      <li>Two Pack Floral Onesies (100% Cotton, Sizes: 0-3 or 3-6 Months)</li>
      <li>Three Pack Floral Bibs (2 x floral and one plain lemon) (100% Cotton)</li>
      <li>Crochet Booties (100% Acrylic)</li></ul>
    <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  </>,
    categories: ["new-arrivals", "girls", "spring-summer"],
    name: "Lemon Floral Hamper",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 28.99,
    img: lemonfloralhamper,
    productImages: [
      lemonfloralhamper, twopackfloralonesies, threepackfloralbib, whitecellular, whitewaffle, lemonwaffle, allbooties, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: '0-3 months <3 available>'
          },
          {
            name: '3-6 months <3 availalbe>'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White Booties'
          },
          {
            name: 'Grey Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Blanket Choice',
        options: [
          {
            name: 'White Cellular'
          },
          {
            name: 'Lemon Waffle Fleece'
          },
          {
            name: 'White Waffle Fleece'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },      
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          }    
    ]
  },
]
},  
  // {
  //   id: "cosy-Zebra-hamper",
  //   description:
  //   <>Our cosy hampers are always a winner and this cute little zebra one is really popular for us, perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket has a zebra applique design. You can choose your own colour of matching accessories, adding your own personal touch! 
  //   <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br /><li>Grey Zebra Comforter</li>
  //       <li>Grey Supersoft Zebra Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //       <li>Pom Pom Hat & Matching Mittens, lots of colours to choose from</li>
  //       <li>Choice of Crochet Booties</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["cosy-hampers"],
  //   name: "Cosy Zebra Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: cosyzebramain,
  //   productImages: [
  //     cosyzebramain, cosyzebra1, cosyzebra2, zebra, sheep4, sheep5, whitegreyhat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         {
  //           name: 'Mustard Hat & Mittens'
  //         },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },      
  //   ]
  // },
  // {
  //   id: "bright-rainbow",
  //   description:
  //     <>Rainbows have been really popular over the past couple of years and this hamper has a goregous rainbow blanket and lovely rainbow designs throughout. Packed full of essentials for the new arrival, this hamper makes a perfect gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes:<ul>
  //       <br />
  //        <li>White & Pink Rainbow Blanket (100% Polyester)</li>
  //        <li>Bright Rainbow Onesie (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
  //        <li>Bright Blue Cloud Vest (100% Cotton)</li> 
  //        <li>Pink Rainbow Bib</li>
  //        <li>Bright Rainbow Scratch Mitts & Hat</li>
  //       <li>Choice of Crochet Booties</li> </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br /><br />Sizes Newborn & 3-6 Months - Sold Out        
  //       </>,
  //   categories: ["Female",],
  //   name: "Bright Rainbow Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: brightrainbowhamper,
  //   productImages: [
  //     brightrainbowhamper, fipcsunshinerainbowsmain, rainbowblanket, allbooties, rainbowteether, welcomeplaque, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn <1 available>'
  //         // },
  //         {
  //           name: '0-3 months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks',
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Welcome Baby Plaque',
  //           increment: 3.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun in Oven',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },  
  // {
  //   id: "Unicorn_Hamper",
  //   description:
  //   <>Our cosy hampers are always a winner and we love the grey and white star detaisl in this unicorn version, perfect to keep little ones tucked up warm anytime of the year. The supersoft blanket has a zebra applique design. You can choose your own colour of matching accessories, adding your own personal touch! 
  //   <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Unicorn Comforter</li>
  //       <li>Star Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //       <li>Pom Pom Hat & Matching Mittens, lots of colours to choose from (100% Acrylic)</li>
  //       <li>Choice of Crochet Booties (100% Acrylic)</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["cosy-hampers", "Female"],
  //   name: "Unicorn Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: unicornmain,
  //   productImages: [
  //     unicornmain, unicorn1, unicorn2, unicorn3, hats1, hats2, whitegreyhat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },      
  //   ]
  // },
  // {
  //   id: "elephant-cloud-hamper",
  //   description:
  //   <>This lovely addition to our cost hamper collection features a moon & cloud design and an elephant comforter, perfect to keep little ones tucked up warm anytime of the year. You can choose your own colour of matching accessories, adding your own personal touch! 
  //   <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>White & Grey Elephant cloud Comforter (100% Polyester) </li>
  //         <li>White & Grey Cloud Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
  //         <li>Crochet Booties (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //     </>,
  //   categories: ["cosy-hampers", "Unisex", "winter-warmers"],
  //   name: "Cosy Elephant & Cloud Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: elephantcloudmain,
  //   productImages: [
  //     elephantcloudmain, elephantcomfblanket, greyhat, whitehat, whitegreyhat, bluehat, pinkhat, navyhat, sagehat, steelhat, mustardhat, coffeehat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // },
//   {
//     id: "blue-stripe-cardi-hamper",
//     description:
//     <>Part of our Winter Warmers Collection, this gift set is cute & cosy! This set has a blue theme with the perfect items to keep baby wrapped up warm. Features a two piece knitted set with a blue stripe design and wooden effect teddy buttons. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
//     <br /><br />Gift Hamper includes:
//     <br /><br /><ul>
//       <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
//       <li>Stripe Two Piece Knitted Set (50% Cotton, 50% Acrylic Sizes: 0-3, 3-6, 6-12 Months)</li>
//       <li>Optional Comforter (Various Materials)</li>
//       <li>Optional Pom Pom Hat & Matching Mittens (100% Cotton)</li>
// </ul>
//     <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
//         <br />
//         <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
//   </>,
//     categories: ["Male", "winter-warmers", "new-arrivals"],
//     name: "Blue Knitted Stripe Gift Set",
//     review: "productize virtual markets",
//     deliveryCharge: deliveryCharges,
//     price: 22.99,
//     img: bluestripehampermain,
//     productImages: [
//       bluestripehampermain, bluestripehamper, bluedoubleknit, whitewaffle, greywaffle, bluewaffle, coffeewaffle, hats2, allbooties, allcomforters1, wishstring, alltoowordy
//     ],
//     variants: [
//       {
//         title: 'Clothing Size',
//         options: [
//           {
//             name: '0-3 months'
//           },
//           {
//             name: '3-6 months'
//           },
//           {
//             name: '6-12 months'
//           }
//         ]
//       },
//       {
//         title: 'Blanket Colour',
//         options: [
//           {
//             name: 'Grey'
//           },
//           {
//             name: 'White'
//           },
//           {
//             name: 'Blue'
//           },
//           {
//             name: 'Coffee'
//           }
//         ]
//       },
//       {
//         title: 'Optional Hat & Mitten',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'White',
//             increment: 6.00
//           },
//           {
//             name: 'Grey',
//             increment: 6.00
//           },
//           {
//             name: 'White & Grey Stripe',
//             increment: 6.00
//           },
//           {
//             name: 'Blue',
//             increment: 6.00
//           },          
//           {
//             name: 'Coffee',
//             increment: 6.00
//           },          
//           {
//             name: 'Sage',
//             increment: 6.00
//           },
//           {
//             name: 'Mustard',
//             increment: 6.00
//           }
//         ]
//       },
//       {
//         title: 'Optional Booties',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'White Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Grey Booties',
//             increment : 2.00
//           },          
//           {
//             name: 'Blue Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Navy Booties',
//             increment : 2.00
//           },
//           {
//             name: 'Coffee Booties',
//             increment : 2.00
//           }           
//         ]
//       },            
//       {
//         title: 'Optional Comforter',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'White Elephant',
//             increment: 6.99
//           },
//           {
//             name: 'Grey Elephant',
//             increment: 6.99
//           },
//           {
//             name: 'Grey Bunny',
//             increment: 6.99
//           },
//           {
//             name: 'Grey Penguin',
//             increment: 6.99
//           },          
//           {
//             name: 'White Dinosaur',
//             increment: 6.99
//           },          
//           {
//             name: 'Blue Dinosaur',
//             increment: 6.99
//           },          
//           {
//             name: 'Grey Giraffe',
//             increment: 6.99
//           },
//           {
//             name: 'Brown Bear',
//             increment: 6.99
//           },
//           {
//             name: 'Pink Bear',
//             increment: 6.99
//           }
//         ]
//       },
//       {
//         title: 'Wishstring Bracelet',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'From Bump',
//             increment: 3.99
//           },
//           {
//             name: 'For Daddy',
//             increment: 3.99
//           },
//           {
//             name: 'Congrats',
//             increment: 3.99
//           },
//           {
//             name: 'Coming Baby Shower',
//             increment: 3.99
//           },
//           {
//             name: 'Wonderful Mummy',
//             increment: 3.99
//           },
//           // {
//           //   name: 'For New Mum',
//           //   increment: 3.99
//           // },
//           {
//             name: 'Mums Buttons',
//             increment: 3.99
//           }
//         ]
//       },
//       {
//         title: 'Additional Giftcard',
//         options: [
//           {
//             name: 'No Thanks'
//           },
//           {
//             name: 'Pink Twinkle Toes',
//             increment: 3.50
//           },
//           {
//             name: 'Blue Twinkle Toes',
//             increment: 3.50
//           },
//           {
//             name: 'Precious Daughter',
//             increment: 3.50
//           },
//           {
//             name: 'Baby Boy Banner',
//             increment: 3.50
//           },
//           {
//             name: 'Little Lady',
//             increment: 3.50
//           },
//           {
//             name: 'Little Dude',
//             increment: 3.50
//           },
//           {
//             name: 'Lovely Happy News',
//             increment: 3.50
//           },
//           {
//             name: 'Bundle Of Joy',
//             increment: 3.50
//           },
//           {
//             name: 'Welcome Baby Boy',
//             increment: 3.50
//           },
//           {
//             name: 'Welcome Baby Girl',
//             increment: 3.50
//           },
//           {
//             name: 'New Chapter',
//             increment: 3.50
//           },
//           {
//             name: 'Bun In The Oven',
//             increment: 3.50
//           }
//         ]
//       },
//     ]
//   },       
  // {
  //   id: "cosy-cream-lamb",
  //   description:
  //   <>This lovely addition to our cosy hamper collection features a spotty lamb comforter, perfect to keep little ones tucked up warm anytime of the year. You can choose your own colour of matching accessories, adding your own personal touch! 
  //   <br /><br />An ideal gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Gift Hamper includes:
  //       <br /><br /><ul>
  //         <li>Cream Cloud Design Lamb Comforter (100% Polyester) </li>
  //         <li>Cream Cloud Design Fleece Blanket  (100% Polyester Fleece, Size 90cm x 75cm)</li>
  //         <li>Pom Pom Hat & Matching Mittens (100% Acrylic)</li>
  //         <li>Crochet Booties (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //     </>,
  //   categories: ["cosy-hampers", "best-sellers", "Unisex"],
  //   name: "Cosy Spotty Lamb Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: cosyclambmain,
  //   productImages: [
  //     cosyclambmain, cosyclamb1, greyhat, whitehat, whitegreyhat, bluehat, pinkhat, navyhat, sagehat, steelhat, mustardhat, coffeehat, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //         {
  //           name: 'Coffee Booties'
  //         },
  //         {
  //           name: 'Rose Booties'
  //         },
  //         {
  //           name: 'Sage Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Congrats',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Coming Baby Shower',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Wonderful Mummy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         // {
  //         //   name: 'Blue Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //      ]
  //    },
  //   ]
  // },    
  {
    id: "letterbox-Bib-Hamper",
    description:
      <>Small, but packed full of treats for new parents & baby. Whether baby has arrived or you're treating an expectant parent, you can adapt to suit. The bib & booties are practical but cute, mix and match your own colours!
        <br /><br />Gift Hamper includes:<ul>
          <li>Dribble Bib (100% Cotton)</li>
          <li>Crochet Booties (100% Acrylic)</li>
          <li>Grey Elephant or White Bunny Plaque (Wooden) </li>
          <li>Wishstrings Bracelet</li>
        </ul>
        <br />This item comes presented in a brown postal box.  It also comes with a handwritten gift note, if you wish, just make sure to add your note below. This note can be upgraded to a gorgeous TooWordy giftcard for an additional £3.50. We make each hamper after you order, and pride ourselves on individually packing each order with the love it deserves.
      </>,
    categories: ["letterbox-gifts"],
    showOnHomepage: true,
    name: "Dribble Bib Letterbox Gift",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: letterboxbibmain,
    productImages: [
      letterboxbibmain, letterboxbib1, allbibs, allbooties, plaques, welcomeplaque, wishstring, alltoowordy,
    ],
    variants: [
      {
        title: 'Bib Colour',
        options: [
          {
            name: 'Navy'
          },
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Pink'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Navy Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Grey Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          }
        ]
      },
      {
          title: 'Wishstring',
          options: [
            // {
            //   name: 'A Little Wish For a New Mum'
            // },
            {
              name: 'Mums are like Buttons,'
            },
            {
              name: 'With Love From The Bump'
            },
            {
              name: 'A Little Wish For My Daddy'
            },
            // {
            //   name: 'Thanks For Coming To My Baby Shower'
            // }
          ]
        },
        {
        title: 'Plaque',
        options: [
          {
            name: 'Grey Elephant Plaque'
          },
          {
            name: 'White Bunny Plaque'
          },
          {
            name: 'Welcome to the World Plaque'
          },
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Tiny Toes',
            increment: 3.50
          },
          {
            name: 'Blue Tiny Toes',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun in Oven',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Lovely News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }
        ]
      },
    ]
  },
  {
    id: "newbaby-letterbox-hamper",
    description:
      <>A perfect little gift to mark the accouncement or arrival of a new baby. A lovely "Welcome to the world" plaque to hang in a nursery or to use in newborn photos. Also included, a pack of 30 cards to help record all the little milestones as baby grows, from monthly age milestones to recorded 'first steps', 'first smiles' and all those special moments.
        <br /><br />Gift Hamper includes:<ul>
          <li>TooWordy Giftcard (choice of designs)</li>
          <li>30pc Milestone Moment Cards (made from card)</li>
          <li>White Wooden 'Welcome To The World' Hanging Plaque (100% wood)</li>
        </ul>
        <br />This item comes presented in a brown postal box.  It also comes with a handwritten gift note, just make sure to add your note below.  We make each hamper after you order, and pride ourselves on individually packing each order with the love it deserves.
      </>,
    categories: ["letterbox-gifts"],
    showOnHomepage: true,
    name: "New Baby Letterbox Gift",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: newbabyletterboxmain,
    productImages: [
      newbabyletterboxmain, milestonecards, welcomeplaque, alltoowordy,
    ],
    variants: [
      {
        title: 'Giftcard Choice',
        options: [
          {
            name: 'Pink Tiny Toes',
          },
          {
            name: 'Blue Tiny Toes',
          },
          {
            name: 'New Chapter',
          },
          {
            name: 'Bun in Oven',
          },
          {
            name: 'Bundle Of Joy',
          },
          // {
          //   name: 'Precious Daughter',
          // },
          {
            name: 'Little Dude',
          },
          {
            name: 'Little Lady',
          },
          {
            name: 'Baby Boy Banner',
          },
          {
            name: 'Lovely News',
          },
          {
            name: 'Weclome Baby Boy',
          },
          {
            name: 'Welcome Baby Girl',
          }
        ]
      },
    ]
  },
  {
    id: "announcement-letterbox-hamper",
    description:
      <>A perfect little gift to mark the accouncement of a new baby or for a baby new reveal. A lovely "We can't wait to meet you" baby scan photo frame , the perfect size to showcase a first baby scan. Also contains our gorgeous bear teether and some booties for baby.
        <br /><br />Gift Hamper includes:<ul>
          <br />
          <li>White Wooden Scan Photo Frame</li>
          <li>Wood & Silicone Bear Teether (European Std Beech Wood, BPS & BPA Free)</li>
          <li>Choice of Crochet Booties</li>
        </ul>
        <br />This item comes presented in a brown postal box.  It also comes with a handwritten gift note, just make sure to add your note below.  We make each hamper after you order, and pride ourselves on individually packing each order with the love it deserves.
      </>,
    categories: ["letterbox-gifts"],
    showOnHomepage: true,
    name: "Baby Announcement Letterbox Gift",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 19.99,
    img: babyscanmain,
    productImages: [
      babyscanmain, babyscan1, babyscan, bearteether, allbooties, wishstring, alltoowordy
    ],
    variants: [
      {
        title: 'Teether Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
        ]
      },      
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },  
  {
    id: "taggie-comforter-hamper",
    description:
      <>Small, but packed full of treats for new parents & baby.This gift features our taggie comforter, a great sensory & developmental gift for baby to help them explore textures, colours and snuggle into. Teamed up with some super cute booties and an optional bracelet, plaque or pack of milestone moment cards.
        <br /><br />Gift Hamper includes:<ul>
          <li>Taggie Comforter (100% Polyester, Size 35x35cm)</li>
          <li>Crochet Booties (100% Acrylic)</li>
        </ul>
        <br />This item comes presented in a brown postal box.  It also comes with a handwritten gift note, if you wish, just make sure to add your note below. This note can be upgraded to a gorgeous TooWordy giftcard for an additional £3.50. We make each hamper after you order, and pride ourselves on individually packing each order with the love it deserves.
      </>,
    categories: ["letterbox-gifts"],
    showOnHomepage: true,
    name: "Taggie Comforter Letterbox Gift",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: taggieletterboxmain,
    productImages: [
      taggieletterboxmain, alltaggies, allbooties, welcomeplaque, plaques, milestonecards, wishstring, alltoowordy,
    ],
    variants: [
      {
        title: 'Taggie',
        options: [
          {
            name: 'Grey Star'
          },
          {
            name: 'Navy Star'
          },
          {
            name: 'Pink Hearts'
          },
          {
            name: 'Blue Vehicles'
          },
          {
            name: 'White & Blue Star'
          },
          {
            name: 'White & Pink Star'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Navy Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Grey Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          }
        ]
      },
      {
          title: 'Wishstring',
          options: [
            {
              name: 'No Thanks'
            },
            // {
            //   name: 'A Little Wish For a New Mum',
            //   increment: 3.99
            // },
            {
              name: 'Mums are like Buttons,',
              increment: 3.99
            },
            {
              name: 'With Love From The Bump',
              increment: 3.99
            },
            {
              name: 'A Little Wish For My Daddy',
              increment: 3.99
            },
            // {
            //   name: 'Thanks For Coming To My Baby Shower'
            // }
          ]
        },
        {
        title: 'Extra Gift',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.00
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.00
          },
          {
            name: 'Welcome to the World Plaque',
            increment: 3.00
          },
          {
            name: 'Milestone Cards',
            increment: 3.00
          },
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Tiny Toes',
            increment: 3.50
          },
          {
            name: 'Blue Tiny Toes',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun in Oven',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Lovely News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }
        ]
      },
    ]
  },
  // {
  //   id: "Milestone-Hamper",
  //   description:
  //     <>There are so many little (and some big!) milestones that baby hits over their first few years, so we've put together a great hamper with the tools to help record these to remember for years to come. 
  //     <br /><br />Our milestone blanket lets you grab a picture of baby over time so you can track how they look as they grow, your only challenge will be to keep them still long enough to get the picture. Our milestone cards contain some prompts to help record some of the bigger moments like first steps, first teeth, first Christmas and everything else that happens! 
  //     <br /><br />Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Milestone Moments Blanket</li>
  //       <li>30 Pack Milestone Cards</li>
  //       <li>Choice of Crochet Booties</li>
  //       <li>Choice of Baby Comforter</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["new-parent-hampers"],
  //   name: "Milestones Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 26.99,

  //   img: milestonesmain,
  //   productImages: [
  //     milestonesmain, milestone1, milestone2, milestone3, bunnycloud, unicorn, penguin, sheep, lion, sheep6, sheep7, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Comforter Choice',
  //       options: [
  //         {
  //           name: 'Grey Bunny'
  //         },
  //         // {
  //         //   name: 'Grey Penguin'
  //         // },
  //         {
  //           name: 'White Sheep'
  //         },
  //         {
  //           name: 'White Unicorn (head rattles)'
  //         },
  //         {
  //           name: 'White Elephant'
  //         },
  //         {
  //           name: 'White Lion'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },      
  //   ]
  // },
  // {
  //   id: "Milestone-Newmug",
  //   description:
  //     <>This hamper has been put together to celebrate both the parents and the new arrival together. Help get the new parents prepared with some lovely mugs to mark the new roles they are about to adapt into! Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Choice of Combination Of Mummy & Daddy Mugs</li>
  //       <li>30 Pack Milestone Cards</li>
  //       <li>Choice of Crochet Booties</li>
  //       <li>Choice of Baby Comforter</li></ul>
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br /> 
  //         </>,
  //   categories: ["new-parent-hampers"],
  //   name: "Milestones Hamper & Mugs Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,

  //   img: newmugmain,
  //   productImages: [
  //     newmugmain, newmug1, milestonecards, bunnycloud, unicorn, penguin, sheep, lion, allbooties, plaques, frames, welcomeplaque, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Mug Choice',
  //       options: [
  //         {
  //           name: 'Mummy Mug'
  //         },
  //         {
  //           name: 'Daddy Mug'
  //         },
  //         {
  //           name: 'Mummy & Daddy Mugs',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Mummy & Mummy Mugs',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Daddy & Daddy Mugs',
  //           increment: 4.99
  //         }
  //       ]
  //     },      
  //     {
  //       title: 'Comforter Choice',
  //       options: [
  //         {
  //           name: 'Grey Bunny'
  //         },
  //         // {
  //         //   name: 'Grey Penguin'
  //         // },
  //         {
  //           name: 'White Sheep'
  //         },
  //         {
  //           name: 'White Unicorn (head rattles)'
  //         },
  //         {
  //           name: 'White Elephant'
  //         },
  //         {
  //           name: 'Grey Elephant'
  //         },
  //         {
  //           name: 'Cream Lion'
  //         },
  //         {
  //           name: 'Pink Bunny'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Welcome Plaque',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Elephant Frame',
  //           increment: 4.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },      
  //   ]
  // },
  {
    id: "Milestone-Mug",
    description:
      <>This hamper has been put together to celebrate both the parents and the new arrival together. Help get the new parents prepared with some lovely mugs to mark the new roles they are about to adapt into! Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
        <br />
        <li>Choice of Combination Of Mummy & Daddy Mugs</li>
        <li>30 Pack Milestone Cards</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Baby Comforter</li></ul>
        <br />We also have some great giftcards & additional items to add into the hamper available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br /> 
          </>,
    categories: ["new-parent-hampers", "best-sellers"],
    name: "New Parent Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 23.99,
    img: milestonemugmain,
    productImages: [
      milestonemugmain, milestonemug1, milestonecards, mugs, greyelephant, whiteelephant, newbrownbearcomf, penguin, sheep, lion, whitedinosaur, pinkbearcomf, allbooties, alltoowordy
    ],
    variants: [
      {
        title: 'Mug Choice',
        options: [
          {
            name: 'Mummy Mug'
          },
          {
            name: 'Daddy Mug'
          },
          {
            name: 'Mummy & Daddy Mugs',
            increment: 4.00
          },
          {
            name: 'Mummy & Mummy Mugs',
            increment: 4.00
          },
          {
            name: 'Daddy & Daddy Mugs',
            increment: 4.00
          }
        ]
      },      
      {
        title: 'Comforter Choice',
        options: [
          // {
          //   name: 'Grey Bunny'
          // },
          {
            name: 'Grey Penguin'
          },
          {
            name: 'White Sheep'
          },
          // {
          //   name: 'White Unicorn (head rattles)'
          // },
          {
            name: 'White Elephant'
          },
          {
            name: 'Grey Elephant'
          },
          // {
          //   name: 'Blue Dinosaur'
          // },
          {
            name: 'White Dinosaur'
          },
          {
            name: 'Brown Bear'
          },
          {
            name: 'Pink Bear'
          },
          {
            name: 'Cream Lion'
          },
          // {
          //   name: 'Pink Bunny'
          // }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Sage Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Rose Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },      
    ]
  },
  {
    id: "Milestone-Cube",
    description:
      <>This hamper has been put together to celebrate the new arrival. Help get the new parents prepared with some lovely gifts for baby, featuring our milestone momeny cards to help record the little moments over the first year, and a lovely play cube for lots of sensory playtime! Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
        <br />
        <li>Blue or Pink Sensory Play cube</li>
        <li>30 Pack Milestone Cards</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Baby Comforter</li></ul>
        <br />We also have some great giftcards & other gifts available to add in and help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br /> 
          </>,
    categories: ["new-parent-hampers"],
    name: "Baby Accessories Gift Hamper",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: babyaccmain,
    productImages: [
      babyaccmain, babyacc1, milestonecards, bunnycloud, unicorn, penguin, sheep, lion, bluedinosaur, whitedinosaur, brownbearcomf, pinkbearcomf, softcube, allbooties, plaques, frames, welcomeplaque, alltoowordy
    ],
    variants: [      
      {
        title: 'Comforter Choice',
        options: [
          // {
          //   name: 'Grey Bunny'
          // },
          {
            name: 'Grey Penguin'
          },
          // {
          //   name: 'White Sheep'
          // },
          {
            name: 'White Unicorn (head rattles)'
          },
          {
            name: 'White Elephant'
          },
          {
            name: 'Grey Elephant'
          },
          {
            name: 'Blue Dinosaur'
          },
          {
            name: 'White Dinosaur'
          },
          // {
          //   name: 'Brown Bear'
          // },
          {
            name: 'Pink Bear'
          },
          {
            name: 'Cream Lion'
          },
          // {
          //   name: 'Pink Bunny'
          // }
        ]
      },
      {
        title: 'Cube Colour',
        options: [
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      },      
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Sage Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Rose Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Additional Gift',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Welcome Plaque',
            increment: 3.0
          },
          {
            name: 'Bunny Plaque',
            increment: 3.0
          },
          {
            name: 'Elephant Plaque',
            increment: 3.0
          },
          {
            name: 'Bunny Frame',
            increment: 5.0
          },
          {
            name: 'Elephant Frame',
            increment: 5.0
          },
          {
            name: 'Milestone Cards',
            increment: 3.0
          },
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },      
    ]
  }, 
  // {
  //   id: "new-baby",
  //   description:
  //     <>This lovely little gift box contains some baby essentials to welcome new baby, or celebrate a new pregnancy announcement. Ideal for a baby shower, or for a new mum and baby.
  //      <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>30 pack Milestone Cards</li>
  //       <li>Grey Baby On Board Hanging Car Sign</li>
  //       <li>Choice of Crochet Booties</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["new-parent-hampers"],
  //   name: "New Baby Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: newbabymain,
  //   productImages: [
  //     newbabymain, newbaby1, milestonecards, babyonboard, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Milestone Moment Cards',
  //         //   increment: 2.99
  //         // },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },      
  //   ]
  // },
  {
    id: "little-moments",
    description:
      <>This little gift hamper is full of cuteness for the new arrival. Our Milestone Cards help the new parents record all the lovely little moments and achievements of the first year and are perfect as a new baby gift, choose from white, pink or blue cards. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
        <br />
        <li>30 Pack Milestone Cards</li>        
        <li>Choice of Muslin Square (100% Cotton)</li>
        <li>Choice of Baby Comforter</li>
        <li>Choice of Crochet Booties</li></ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />        
        </>,
    categories: ["new-parent-hampers"],
    name: "New Moments Hamper Gift Set",
    deliveryCharge: deliveryCharges,
    price: 17.99,
    img: newmomentsmain,
    productImages: [
      newmomentsmain, newmoments1, milestonecards, allmuslins, unicorn, sheep, penguin, whiteelephant, lion, greyelephant, bunnycloud, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Comforter Choice',
        options: [
          // {
          //   name: 'Grey Bunny'
          // },
          {
            name: 'Grey Penguin'
          },
          // {
          //   name: 'White Sheep'
          // },
          {
            name: 'White Unicorn'
          },
          {
            name: 'White Elephant'
          },
          {
            name: 'Cream Lion'
          },
          {
            name: 'Grey Elephant'
          }
        ]
      },
      {
        title: 'Muslin Square Colour',
        options: [
          {
            name: 'Pink'
          },
          {
            name: 'White'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Grey'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Sage Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Rose Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          // {
          //   name: 'White Bunny Plaque',
          //   increment: 4.99
          // },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          // {
            // name: 'Milestone Moment Cards',
          // increment: 2.99
          // },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          {
            name: 'Unicorn Water Teether',
            increment: 2.99
          },
          {
            name: 'Mermaid Water Teether',
            increment: 2.99
          },
          {
            name: 'Car Water Teether',
            increment: 2.99
          },
          {
            name: 'Dinosaur Water Teether',
            increment: 2.99
          },
          {
            name: 'Pink Dumbell Rattle',
            increment: 2.99
          },
          {
            name: 'Yellow Dumbell Rattle',
            increment: 2.99
          },
          {
            name: 'White Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          {
            name: 'Pink Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Blue Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          {
            name: 'Wooden Shape Sorter',
            increment: 12.99
          },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
    ]
  },
    ]
  },
  {
    id: "organic-pink-floral",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a pastel floral muslin blanket, and a choice of wooden accessory. All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Pastel Floral Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Wooden Accessory (some items have an additional cost)</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "Female"],
    showOnHomepage: true,
    name: "Floral Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: organicpinkfloral,
    productImages: [
      organicpinkfloral, flowerorganicmuslin, allbooties, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Navy'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Beige'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Sage'
          }
        ]
      },
      {
        title: 'Wooden Accessory',
        options: [
          {
            name: 'Elephant Frame',
          },
          {
            name: 'Bunny Frame',
          },
          {
            name: 'Elephant Plaque',
          },
          // {
          //   name: 'Bunny Plaque',
          // },
          {
            name: 'Wooden Heart Plaque',
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 5.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 5.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 3.00
          }
        ]
      },      
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },   
  // {
  //   id: "Floral-Bib-Hamper",
  //   description:
  //     <>Treat the new parents & baby together in this gorgeous gift hamper packed full of little gifts to celebrate the new arrival. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>2pk Pink Floral Bibs With Pom Pom Trim</li>
  //       <li>Pink Floral Headband</li>
  //       <li>Pink Cellular Blanket (100% Cotton, Size 70cm x 90cm)</li>
  //       <li>Elephant or Bunny Baby Plaque / Photo Frame</li>
  //       <li>Choice of Wishstring Bracelet</li>
  //       <li>Choice of Crochet Booties (100% Acrylic)</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       </>,
  //   categories: ["Female"],
  //   name: "Baby Girl Floral Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: floralbibmain,
  //   productImages: [
  //     floralbibmain, floralbib, floralheadband, pinkcellular, pinkmuslin, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Frame or Plaque',
  //       options: [
  //         {
  //            name: 'Grey Elephant Plaque'
  //          },
  //          {
  //            name: 'White Bunny Plaque'
  //          },
  //         {
  //           name: 'White Elephant Frame'
  //         },
  //         {
  //           name: 'Grey Bunny Frame'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Option',
  //       options: [
  //         {
  //           name: 'From Bump'
  //         },
  //         {
  //           name: 'For Daddy'
  //         },
  //         // {
  //         //   name: 'For New Mum'
  //         // },
  //         {
  //           name: 'Mums Buttons'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "pink-floral",
  //   description:
  //     <>This lovley hamper features a pink floral print adding a bit of a traditional feel. Packed full of lots of items perfect for a new baby. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Pink or White Cellular Blanket (100% Cotton, Size 75cm x 90cm)</li>
  //       <li>Pink Floral Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Floral Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Floral Hat</li>
  //       <li>Pink Floral Bib</li>
  //       <li>Pink Floral Mitts</li>
  //       <li>Choice Crochet Booties</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes Newborn & 3-6 Months - Sold Out
  //       </>,
  //   categories: ["sale"],
  //   name: "Pink Floral Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   was: 27.99,
  //   img: pinkfloralemain,
  //   productImages: [
  //     pinkfloralemain, pinkfloral1, pinkfloral2, pinkfloral3, pinkfloral4, pinkfloral5, pinkfloral6, whitecellular, pinkcellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 months'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //           {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "pastel-floral",
  //   description:
  //     <>This hamper features a lovely floral design with pastel colours throughout. A hamper packed full of essential items for new baby. Ideal for a baby shower, or for a parent mum and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //         <br />
  //       <li>Pink or White Cellular Blanket (100% Cotton)</li>
  //       <li>Pink Floral Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Floral Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Floral Hat</li>
  //       <li>Pink Floral Bib</li>
  //       <li>Pink Floral Mitts</li>
  //       <li>Choice Crochet Booties</li>
  //       </ul>
  //       <br />Sizes 0-3 & 3-6 Months - Sold Out
  //       <br /><br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       </>,
  //   categories: ["Female"],
  //   name: "Pastel Floral Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: pastelfloralhamper,
  //   productImages: [
  //     pastelfloralhamper, fipcpastelfloral1, fipcpastelfloral2, fipcpastelfloral3, fipcpastelfloral4, whitecellular, pinkcellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 Available>'
  //         },
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //         {
  //           title: 'Wishstring Bracelet',
  //           options: [
  //             {
  //               name: 'No Thanks'
  //             },
  //             {
  //               name: 'From Bump',
  //               increment: 3.99
  //             },
  //             {
  //               name: 'For Daddy',
  //               increment: 3.99
  //             },
  //             // {
  //             //   name: 'For New Mum',
  //             //   increment: 3.99
  //             // },
  //             {
  //               name: 'Mums Buttons',
  //               increment: 3.99
  //             }
  //           ]
  //         },
  //         {
  //           title: 'Additional Giftcard',
  //           options: [
  //             {
  //               name: 'No Thanks'
  //             },
  //             {
  //               name: 'Pink Twinkle Toes',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Blue Twinkle Toes',
  //               increment: 3.50
  //             },
  //             // {
  //             //   name: 'Precious Daughter',
  //             //   increment: 3.50
  //             // },
  //             {
  //               name: 'Baby Boy Banner',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Little Lady',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Little Dude',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Lovely Happy News',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Bundle Of Joy',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'New Chapter',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Bun In The Oven',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Welcome Baby Boy',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Welcome Baby Girl',
  //               increment: 3.50
  //             }
  //           ]
  //         },
  //         {
  //           title: 'Additional Items',
  //           options: [
  //             {
  //               name: 'No Thanks'
  //             },
  //             {
  //               name: 'White Elephant Frame',
  //               increment: 4.99
  //             },
  //             {
  //               name: 'Grey Bunny Frame',
  //               increment: 4.99
  //             },
  //             {
  //               name: 'Grey Elephant Plaque',
  //               increment: 4.99
  //             },
  //             // {
  //             //   name: 'White Bunny Plaque',
  //             //   increment: 4.99
  //             // },
  //             {
  //               name: 'My First Cutlery Set',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Milestone Moment Cards',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Welcome To The World Heart',
  //               increment: 2.99
  //             },
  //             // {
  //             //   name: 'Unicorn Water Teether',
  //             //   increment: 2.99
  //             // },
  //             // {
  //             //   name: 'Mermaid Water Teether',
  //             //   increment: 2.99
  //             // },
  //             // {
  //             //   name: 'Car Water Teether',
  //             //   increment: 2.99
  //             // },
  //             // {
  //             //   name: 'Dinosaur Water Teether',
  //             //   increment: 2.99
  //             // },
  //             // {
  //             //   name: 'Pink Dumbell Rattle',
  //             //   increment: 2.99
  //             // },
  //             // {
  //             //   name: 'Yellow Dumbell Rattle',
  //             //   increment: 2.99
  //             // },
  //             // {
  //             //   name: 'White Geo Organic Teether',
  //             //   increment: 5.99
  //             // },
  //             {
  //               name: 'Orange Geo Organic Teether',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Dandelion Organic Teether',
  //               increment: 5.99
  //             },
  //             // {
  //             //   name: 'Pink Rainbow Teether',
  //             //   increment: 7.99
  //             // },
  //             {
  //               name: 'Brown Rainbow Teether',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Burgundy Rainbow Teether',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Mummy Mug',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Daddy Mug',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Big Sister Countdown Plaque',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Big Brother Countdown Plaque',
  //               increment: 5.99
  //             },
  //             // {
  //             //   name: 'Pink Elephant Keepsake Box',
  //             //   increment: 11.99
  //             // },
  //             {
  //               name: 'Blue Elephant Keepsake Box',
  //               increment: 11.99
  //             },
  //             {
  //               name: 'Baby Boy Hanging Heart Plaque',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Everyday I Love You Moneybox',
  //               increment: 14.99
  //             },
  //             {
  //               name: 'Little Love Moneybox',
  //               increment: 14.99
  //             },
  //             {
  //               name: 'Twinkle Twinkle Moneybox',
  //               increment: 14.99
  //             },
  //             {
  //               name: 'Smallest Heart Moneybox',
  //               increment: 14.99
  //             },
  //             {
  //               name: 'Pink Soft Rattle Cube',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Blue Soft Rattle Cube',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Maze Learning Toy',
  //               increment: 5.99
  //             },
  //             // {
  //             //   name: 'Wooden Shape Sorter',
  //             //   increment: 12.99
  //             // },
  //             {
  //               name: 'Vehicles Puzzle',
  //               increment: 5.99
  //             }    
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "mouse-ballerina",
  //   description:
  //     <>Treat little twinkle toes with all the essentials they need in this cute floral hamper. Features a lovely ballerina mouse character design throughout. Our clothing hampers are super popular and allow you to choose your own colours of accessories and gifts to personalise with. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :
  //       <br /><br />
  //       <ul>
  //       <li>Pink or White Cellular Blanket (100% Cotton)</li>
  //       <li>Pink Ballerina Mouse Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Floral Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Ballerina Mouse Hat</li>
  //       <li>Pink Ballerina Mouse Bib</li>
  //       <li>Pink Ballerina Mouse Mitts</li>
  //       <li>Choice Crochet Booties</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       </>,
  //   categories: ["Female"],
  //   name: "Floral Ballerina Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: ballerinamousehamper,
  //   productImages: [
  //     ballerinamousehamper, fipcballmouse1, fipcballmouse2, fipcballmouse3, fipcballmouse4, whitecellular, pinkcellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },          
  //         {
  //           title: 'Wishstring Bracelet',
  //           options: [
  //             {
  //               name: 'No Thanks'
  //             },
  //             {
  //               name: 'From Bump',
  //               increment: 3.99
  //             },
  //             {
  //               name: 'For Daddy',
  //               increment: 3.99
  //             },
  //             // {
  //             //   name: 'For New Mum',
  //             //   increment: 3.99
  //             // },
  //             {
  //               name: 'Mums Buttons',
  //               increment: 3.99
  //             }
  //           ]
  //         },
  //         {
  //           title: 'Additional Giftcard',
  //           options: [
  //             {
  //               name: 'No Thanks'
  //             },
  //             {
  //               name: 'Pink Twinkle Toes',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Blue Twinkle Toes',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Precious Daughter',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Baby Boy Banner',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Little Lady',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Little Dude',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Lovely Happy News',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'New Chapter',
  //               increment: 3.50
  //             },
  //             {
  //               name: 'Bun In The Oven',
  //               increment: 3.50
  //             }
  //           ]
  //         },
  //         {
  //           title: 'Additional Items',
  //           options: [
  //             {
  //               name: 'No Thanks'
  //             },
  //             {
  //               name: 'White Elephant Frame',
  //               increment: 4.99
  //             },
  //             {
  //               name: 'Grey Bunny Frame',
  //               increment: 4.99
  //             },
  //             {
  //               name: 'Grey Elephant Plaque',
  //               increment: 4.99
  //             },
  //             // {
  //             //   name: 'White Bunny Plaque',
  //             //   increment: 4.99
  //             // },
  //             {
  //               name: 'My First Cutlery Set',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Milestone Moment Cards',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Welcome To The World Heart',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Unicorn Water Teether',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Mermaid Water Teether',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Car Water Teether',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Dinosaur Water Teether',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Pink Dumbell Rattle',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'Yellow Dumbell Rattle',
  //               increment: 2.99
  //             },
  //             {
  //               name: 'White Geo Organic Teether',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Orange Geo Organic Teether',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Dandelion Organic Teether',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Pink Rainbow Teether',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Brown Rainbow Teether',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Burgundy Rainbow Teether',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Mummy Mug',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Daddy Mug',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Big Sister Countdown Plaque',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Big Brother Countdown Plaque',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Pink Elephant Keepsake Box',
  //               increment: 11.99
  //             },
  //             {
  //               name: 'Blue Elephant Keepsake Box',
  //               increment: 11.99
  //             },
  //             {
  //               name: 'Baby Boy Hanging Heart Plaque',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Everyday I Love You Moneybox',
  //               increment: 14.99
  //             },
  //             {
  //               name: 'Little Love Moneybox',
  //               increment: 14.99
  //             },
  //             {
  //               name: 'Twinkle Twinkle Moneybox',
  //               increment: 14.99
  //             },
  //             {
  //               name: 'Smallest Heart Moneybox',
  //               increment: 14.99
  //             },
  //             {
  //               name: 'Pink Soft Rattle Cube',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Blue Soft Rattle Cube',
  //               increment: 7.99
  //             },
  //             {
  //               name: 'Maze Learning Toy',
  //               increment: 5.99
  //             },
  //             {
  //               name: 'Wooden Shape Sorter',
  //               increment: 12.99
  //             },
  //             {
  //               name: 'Vehicles Puzzle',
  //               increment: 5.99
  //             }    
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "5pc-purple-floral-rabbit",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a floral print onesie, spotty vest, floral bunny bib, floral mitts and a florak print hat.
  //     <br /><br />Purple tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br />Size 0-3 & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["sale"],
  //   name: "Purple Floral Rabbit 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 5.00,
  //   was: 12.99,
  //   img: fipcpurplefloralrabmain,
  //   productImages: [
  //     fipcpurplefloralrabmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 available>'
  //         },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months <1 available>'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-blue-panda",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a panda print onesie, stripe vest, panda bib, stripey mitts and a panda print hat.
  //     <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3, 3-6, 6-9 Months</li>
  //       <br />Size 0-3 & 3-6 Months - Sold Out  
  //     </ul>
  //     </>,
  //   categories: ["sale"],
  //   name: "Blue Panda 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 5.00,
  //   was: 12.99,
  //   img: fipcbluepandamain,
  //   productImages: [
  //     fipcbluepandamain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <3 available>'
  //         },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },      
  // {
  //   id: "mint-organic-onesie-set",
  //   description:
  //     <>Part of our Eco Conscious Range, this gorgeous set is made from 100% organic cotton. Its mint colourings and spotty design make this onesie, vest, bib, hat & mitten set a perfect gift for baby. 
  //     <br/><br/> Team up with our organic cotton blankets & Eco comforter, toy and rattles for a gorgeous hamper.   
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Organic Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br /> Size Newborn & 3-6 Months - Sold Out
  //       </ul></>,
  //   categories: ["sale"],
  //   name: "Mint Organic 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price : 5.00,
  //   was : 14.99,
  //   img: fipcmintorganicmain,
  //   productImages: [
  //     fipcmintorganicmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     },
  //   ]
  // },   
  {
    id: "knitted-rose-bear-comforter",
    description:
      <>Super cute cable knitted bear comforter. Also available in White and Navy. 
      <br /><br />
      <ul>
        <li>100% Acrylic Knit</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["sale"],
    name: "Rose Knitted Bear Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.00,
    was: 7.99,
    img: roseknitbear,
    productImages: [
      roseknitbear
    ],
  },
  {
    id: "knitted-white-bear-comforter",
    description:
      <>Super cute cable knitted bear comforter. Also available in Pink and Navy. 
      <br /><br />
      <ul>
        <li>100% Acrylic Knit</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["sale"],
    name: "White Knitted Bear Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.00,
    was: 7.99,
    img: whiteknitbear,
    productImages: [
      whiteknitbear
    ],
  },
  {
    id: "knitted-navy-bear-comforter",
    description:
      <>Super cute cable knitted bear comforter. Also available in Pink and White.
      <br /><br />
      <ul>
        <li>100% Acrylic Knit</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["sale"],
    name: "Navy Knitted Bear Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.00,
    was: 7.99,
    img: navyknitbear,
    productImages: [
      navyknitbear
    ],
  },   
  {
    id: "mint-organic-clothing-set",
    description:
      <>Part of our Eco Conscious Range, this gorgeous set is made from 100% organic cotton. Its mint colourings and stripe design make this t-shirt, legging and bib set a perfect gift for baby. Check out the bib too, it's reversible!
      <br/><br/> Team up with our organic cotton blankets & wooden teethers for a lovely gift set.   
      <br /><br />
      <ul>
        <li>Materials: 100% Organic Cotton</li>
        <li>Size: 0-3, 3-6, 6-12 or 12-18 Months</li>
        <br /> Size 0-3 & 3-6 Months - Sold Out
        </ul></>,
    categories: ["sale"],
    name: "Mint Organic Cotton Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.00,
    was: 14.99,
    img: mintorganicsetmain,
    productImages: [
      mintorganicsetmain, mintorganicset1
    ],
    variants: [
      {
        title: 'Size',
        options: [
          // {
          //   name: '0-3 Months'
          // },
          // {
          //   name: '3-6 Months'
          // },
          {
            name: '6-12 Months <1 available>'
          },
          {
            name: '12-18 Months <1 available>'
          }
        ]
      },
    ]
  },  
  {
    id: "star-moneybox",
    description:
    <>These lovely items make a great keepsake gift for a new arrival. The moneybox has a slot and removable base to collect and remove babys first pennies. 
    <br/>These also comes with a matching plaque that would look great in any nursery. Available in 4 designs with a new baby quote.
    <br /><br />Quote "Sometimes the smallest thing can take up the most room in your heart".
    <br />Quote "Twinle Twinkle little star do you know how loved you are?"
    <br />Quote "A little love makes a huge difference."
    <br />Quote "Every Day I Love You"
    <br /><br />
    <ul>
      <li>Materials: Ceramic Material </li>
      <li>Approx Size: 5cmx5cm</li></ul></>,
    categories: ["sale"],
    name: "Star Moneybox & Plaque",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price : 5.00,
    was : 14.99,
    img: allstarmoneyboxes,
    productImages: [
      allstarmoneyboxes
    ],
    variants: [
      {
        title: 'Design',
        options: [
          {
            name: 'Sometimes The Smallest Thing'
          },
          {
            name: 'Twinkle Twinkle'
          },
          {
            name: 'A little Love'
          },
          {
            name: 'Every Day'
          }
        ]
      }
    ]
  },  
  {
    id: "coral-organic-clothing-set",
    description:
      <>Part of our Eco Conscious Range, this gorgeous set is made from 100% organic cotton. Its coral colourings and rainbow design make this smock top and legging set a perfect gift for baby. 
      <br/><br/> Team up with our organic cotton blankets & wooden rainbow teethers for a lovely gift set.  
      <br /><br />
      <ul>
        <li>Materials: 100% Organic Cotton</li>
        <li>Size: 0-3, 3-6, 6-12 or 12-18 Months</li>
        <br /> Sizes 0-3, 3-6 & 6-12 Months - Sold Out
        </ul></>,
    categories: ["sale"],
    name: "Coral Organic Cotton Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.00,
    was: 14.99,
    img: coralorganicmain,
    productImages: [
      coralorganicmain,
    ],
    variants: [
      { 
        title: 'Size',
        options: [
          // {
          //   name: '0-3 Months'
          // },
          // {
          //   name: '3-6 Months'
          // },
          // {
          //   name: '6-12 Months <1 available>'
          // },
          {
            name: '12-18 Months <1 available>'
          }
        ]
      },
    ]
  },   
  // {
  //   id: "5pc-pink-clouds",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a star print onesie, star vest, balloon bib, star mitts and a star print hat. 
  //     <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3 Months</li>
  //       <li>Sold Out: Newborn, 3-6 Months </li>
  //     </ul>
  //     </>,
  //   categories: ["sale"],
  //   name: "Pink Clouds 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 5.00,
  //   was: 12.99,
  //   img: fipcpinkcloudmain,
  //   productImages: [
  //     fipcpinkcloudmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn Months'
  //         // },
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },     
  {
    id: "5pc-blue-cars",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a car print onesie, stripe vest, car bib, stripey mitts and a car print hat.
      <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
        <br /> Size 0-3 & 3-6 Months - Sold Out
      </ul>
      </>,
    categories: ["sale"],
    name: "Blue Cars 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.00,
    was: 12.99,
    img: fipcbeepmain,
    productImages: [
      fipcbeepmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          // {
          //   name: '0-3 Months <1 available>'
          // },
          // {
          //   name: '3-6 Months'
          // }
        ]
      }
    ]
  },  
  {
    id: "5pc-ahoy-whale",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a whale print onesie, stripe vest, whale bib, stripey mitts and a whale print hat.
      <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 & 3-6 Months</li>
        <br />Sizes 0-3 & 3-6 Months Sold Out
      </ul>
      </>,
    categories: ["sale" ],
    name: "Ahoy Blue Whale 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.00,
    was : 12.99,
    img: fipcahoywhalemain,
    productImages: [
      fipcahoywhalemain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          // {
          //   name: '0-3 Months'
          // },
          // {
          //   name: '3-6 Months'
          // }
        ]
      }
    ]
  },  
  // {
  //   id: "5pc-blue-safari",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a cute safari animal design.
  //     <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br />Sizes 0-3 & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["sale"],
  //   name: "Blue Safari 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 5.00,
  //   was: 12.99,
  //   img: fipcsafarimain,
  //   productImages: [
  //     fipcsafarimain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 available>'
  //         },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },  
  // {
  //   id: "5pc-blue-floral",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a lovely floral design.
  //     <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br />Size Newborn, 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["sale"],
  //   name: "Blue Floral 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 5.00,
  //   was : 12.99,
  //   img: fipcbluefloralmain,
  //   productImages: [
  //     fipcbluefloralmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },   
    // {
    //   id: "floral-bunny",
    //   description:
    //     <>This hamper features a gorgeous floral design with cute bunny details also, with a purple colour throughout. Bunny designs are always super popular for us! This hamper is packed full of essentials for a new arrival and we've lots of ways for you to add your own personal touch to all the little details. Ideal for a baby shower, or for a new parent and baby.
    //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
    //         <br />
    //       <li>Pink or White Cellular Blanket (100% Cotton)</li>
    //       <li>Pink Floral Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
    //       <li>Pink Floral Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
    //       <li>Pink Floral Hat</li>
    //       <li>Pink Floral Bunny Bib</li>
    //       <li>Pink Floral Mitts</li>
    //       <li>Choice Crochet Booties</li>
    //       </ul>
    //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
    //       <br />
    //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
    //       <br /><br />Size 0-3 & 3-6 Months - Sold Out
    //       </>,
    //   categories: ["Female", "sale"],
    //   name: "Floral Bunny Hamper Gift Set",
    //   deliveryCharge: deliveryCharges,
    //   price: 19.99,
    //   was: 27.99,
    //   img: floralbunnyhamper,
    //   productImages: [
    //     floralbunnyhamper, fipcpurplefloralrab1, fipcpurplefloralrab2, fipcpurplefloralrab3, fipcpurplefloralrab4, whitecellular, pinkcellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards,  allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
    //   ],
    //   variants: [
    //     {
    //       title: 'Clothing Size',
    //       options: [
    //         {
    //           name: 'Newborn <1 available>'
    //         },
    //         // {
    //         //   name: '0-3 months'
    //         // },
    //         // {
    //         //   name: '3-6 months <1 available>'
    //         // }
    //       ]
    //     },
    //     {
    //       title: 'Blanket Colour',
    //       options: [
    //         {
    //           name: 'Pink'
    //         },
    //         {
    //           name: 'White'
    //         }
    //       ]
    //     },
    //     {
    //       title: 'Bootie Colour',
    //       options: [
    //         {
    //           name: 'Grey Booties'
    //         },
    //         {
    //           name: 'White Booties'
    //         },
    //         {
    //           name: 'Blue Booties'
    //         },
    //         {
    //           name: 'Pink Booties'
    //         },
    //         {
    //           name: 'Navy Booties'
    //         }
    //       ]
    //     },
    //     {
    //       title: 'Wishstring Bracelet',
    //       options: [
    //         {
    //           name: 'No Thanks'
    //         },
    //         {
    //           name: 'From Bump',
    //           increment: 3.99
    //         },
    //         {
    //           name: 'For Daddy',
    //           increment: 3.99
    //         },
    //         // {
    //         //   name: 'For New Mum',
    //         //   increment: 3.99
    //         // },
    //         {
    //           name: 'Mums Buttons',
    //           increment: 3.99
    //         }
    //       ]
    //     },
    //     {
    //       title: 'Additional Giftcard',
    //       options: [
    //         {
    //           name: 'No Thanks'
    //         },
    //         {
    //           name: 'Pink Twinkle Toes',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'Blue Twinkle Toes',
    //           increment: 3.50
    //         },
    //         // {
    //         //   name: 'Precious Daughter',
    //         //   increment: 3.50
    //         // },
    //         {
    //           name: 'Baby Boy Banner',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'Little Lady',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'Little Dude',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'Lovely Happy News',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'Bundle Of Joy',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'New Chapter',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'Bun In The Oven',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'Welcome Baby Boy',
    //           increment: 3.50
    //         },
    //         {
    //           name: 'Welcome Baby Girl',
    //           increment: 3.50
    //         }
    //       ]
    //     },
    //     {
    //       title: 'Additional Items',
    //       options: [
    //         {
    //           name: 'No Thanks'
    //         },
    //         {
    //           name: 'White Elephant Frame',
    //           increment: 4.99
    //         },
    //         {
    //           name: 'Grey Bunny Frame',
    //           increment: 4.99
    //         },
    //         {
    //           name: 'Grey Elephant Plaque',
    //           increment: 4.99
    //         },
    //         {
    //           name: 'White Bunny Plaque',
    //           increment: 4.99
    //         },
    //         {
    //           name: 'My First Cutlery Set',
    //           increment: 2.99
    //         },
    //         {
    //           name: 'Milestone Moment Cards',
    //           increment: 2.99
    //         },
    //         {
    //           name: 'Welcome To The World Heart',
    //           increment: 2.99
    //         },
    //         {
    //           name: 'Unicorn Water Teether',
    //           increment: 2.99
    //         },
    //         {
    //           name: 'Mermaid Water Teether',
    //           increment: 2.99
    //         },
    //         {
    //           name: 'Car Water Teether',
    //           increment: 2.99
    //         },
    //         {
    //           name: 'Dinosaur Water Teether',
    //           increment: 2.99
    //         },
    //         {
    //           name: 'Pink Dumbell Rattle',
    //           increment: 2.99
    //         },
    //         {
    //           name: 'Yellow Dumbell Rattle',
    //           increment: 2.99
    //         },
    //         // {
    //         //   name: 'White Geo Organic Teether',
    //         //   increment: 5.99
    //         // },
    //         {
    //           name: 'Orange Geo Organic Teether',
    //           increment: 5.99
    //         },
    //         {
    //           name: 'Dandelion Organic Teether',
    //           increment: 5.99
    //         },
    //         // {
    //         //   name: 'Pink Rainbow Teether',
    //         //   increment: 7.99
    //         // },
    //         {
    //           name: 'Brown Rainbow Teether',
    //           increment: 7.99
    //         },
    //         {
    //           name: 'Burgundy Rainbow Teether',
    //           increment: 7.99
    //         },
    //         {
    //           name: 'Mummy Mug',
    //           increment: 5.99
    //         },
    //         {
    //           name: 'Daddy Mug',
    //           increment: 5.99
    //         },
    //         {
    //           name: 'Big Sister Countdown Plaque',
    //           increment: 5.99
    //         },
    //         {
    //           name: 'Big Brother Countdown Plaque',
    //           increment: 5.99
    //         },
    //         {
    //           name: 'Pink Elephant Keepsake Box',
    //           increment: 11.99
    //         },
    //         {
    //           name: 'Blue Elephant Keepsake Box',
    //           increment: 11.99
    //         },
    //         {
    //           name: 'Baby Boy Hanging Heart Plaque',
    //           increment: 5.99
    //         },
    //         {
    //           name: 'Everyday I Love You Moneybox',
    //           increment: 14.99
    //         },
    //         {
    //           name: 'Little Love Moneybox',
    //           increment: 14.99
    //         },
    //         {
    //           name: 'Twinkle Twinkle Moneybox',
    //           increment: 14.99
    //         },
    //         {
    //           name: 'Smallest Heart Moneybox',
    //           increment: 14.99
    //         },
    //         {
    //           name: 'Pink Soft Rattle Cube',
    //           increment: 7.99
    //         },
    //         {
    //           name: 'Blue Soft Rattle Cube',
    //           increment: 7.99
    //         },
    //         {
    //           name: 'Maze Learning Toy',
    //           increment: 5.99
    //         },
    //         // {
    //         //   name: 'Wooden Shape Sorter',
    //         //   increment: 12.99
    //         // },
    //         {
    //           name: 'Vehicles Puzzle',
    //           increment: 5.99
    //         }    
    //   ]
    // },
    //   ]
    // },    
  // {
  //   id: "pink-blossom",
  //   description:
  //     <>This lovely hamper features a pink floral design throughout. Packed full of essentials for new baby, and lots of options to customise this to add a personal touch to the gift. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //         <br />
  //       <li>Pink or White Cellular Blanket (100% Cotton)</li>
  //       <li>Pink Floral Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Floral Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Floral Hat</li>
  //       <li>Pink Floral Bib</li>
  //       <li>Pink Floral Mitts</li>
  //       <li>Choice Of Crochet Booties</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes Newborn & 0-3 Months - Sold Out 
  //       </>,

  //   categories: ["sale"],
  //   showOnHomepage: true,
  //   name: "Blossom Floral Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 18.99,
  //   was: 27.99,
  //   img: blossomfloralhamper,
  //   productImages: [
  //     blossomfloralhamper, fipcpinkblossom1, fipcpinkblossom2, fipcpinkblossom3, fipcpinkblossom4, whitecellular, pinkcellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         {
  //           name: '3-6 months <1 available>'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Weclome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },
  // {
  //   id: "pink-cloud",
  //   description:
  //     <>Help kit out baby with all the essentials they need in this cute star & cloud hamper. Features a lovely star design throughout. Our clothing hampers are super popular and allow you to choose your own colours of accessories and gifts to personalise with. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Pink or White Cellular Blanket (100% Cotton)</li>
  //       <li>Pink Star & Clouds Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Stripe Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Star & Clouds Hat</li>
  //       <li>Pink Hot Air Balloon Bib</li>
  //       <li>Pink Star & Clouds Mitts</li>
  //       <li>2pk Pink & White Washcloths</li>
  //       <li>Choice Crochet Booties</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes Newborn & 3-6 Months - Sold Out
  //       </>,
  //   categories: ["sale"],
  //   name: "Pink Cloud Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 16.99,
  //   was: 27.99,
  //   img: pinkcloudhamper,
  //   productImages: [
  //     pinkcloudhamper, fipcpinkcloud1, fipcpinkcloud2, fipcpinkcloud3, fipcpinkcloud4, whitecellular, pinkcellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards,  allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 months <3 available>'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For New Mum',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Weclome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },
  // {
  //   id: "pink-velour-star",
  //   description:
  //     <>This hamper features a cosy velour onesie adding a more traditional feel to it. Supersoft with gorgeous silver heart and star embroidery. It's also packed full of other treats that you can add in to make it a special gift for a new arrival. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Pink or White Cellular Blanket (100% Cotton)</li>
  //       <li>Pink Velour Star & Hearts Onesie (100% Cotton, Sizes  0-3, 3-6 or 6-9 months)</li>
  //       <li>Choice Of Crochet Booties</li>
  //       <li>Pink Muslin Square (100% Cotton Muslin, Size 71cm x 71cm)</li>
  //       <li>Choice Of Gift</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes 3-6 & 6-9 Months - Sold Out
  //       </>,
  //   categories: ["Female"],
  //   name: "Pink Star & Heart Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: pinkstarvelourhamper,
  //   productImages: [
  //     pinkstarvelourhamper, pinkstarveloursingle, whitecellular, pinkcellular, allbooties, pinkmuslin, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards,  allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 months'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // },
  //         // {
  //         //   name: '6-9 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Choice of Gift',
  //       options: [
  //         {
  //           name: 'White Elephant Frame'
  //         },
  //         {
  //           name: 'Grey Bunny Frame'
  //         },
  //         {
  //           name: 'Grey Elephant Plaque'
  //         },
  //         {
  //           name: 'White Bunny Plaque'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Baby Boy Banner',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Weclome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //       ]  
  //     },
  //   ]
  // },
  // {
  //   id: "pink-fairy",
  //   description:
  //     <>This hamper is packed full of essentials for the new arrival. Featuring a fairy design throughout with pink/purple colours, it also features a bit of sparkle. We've also added lots of options to help you customise this to make it the perfect gift. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Pink or White Cellular Blanket (100% Cotton, Size 75cm x 90cm)</li>
  //       <li>Pink Fairy Onesie (100% Cotton, Sizes 0-3 or 3-6 or 6-9 months)</li>
  //       <li>Pink Fairy Vest (100% Cotton, Sizes 0-3, 3-6 or 6-9 months)</li>
  //       <li>Pink Fairy Hat</li>
  //       <li>Pink Fairy Bib</li>
  //       <li>Pink Fairy Scratch Mittens</li>
  //       <li>Choice Of Crochet Booties</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Size 0-3 & 3-6 Months - Sold Out
  //         </>,
  //   categories: ["sale"],
  //   name: "Pink Fairy Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   was : 27.99,
  //   img: pinkfairymain,
  //   productImages: [
  //     pinkfairymain, pinkfairy1, pinkfairy2, pinkfairy3, pinkfairy4, pinkfairy5, pinkfairy6, whitecellular, pinkcellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         // {
  //         //   name: '3-6 months'
  //         // },
  //         {
  //           name: '6-9 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'White'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //       ]  
  //     },
  //   ]
  // },
  // {
  //   id: "pink-bunny",
  //   description:
  //     <>This cute hamper is packed full of essentials for the new arrival. Featuring a lovely bunny and floral design. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Pink Bunny Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Bunny Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Bunny Hat</li>
  //       <li>Pink Bunny Bib</li>
  //       <li>Pink Bunny Scratch Mittens</li>
  //       <li>Choice Of Crochet Booties</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["Female"],
  //   name: "Pink Bunny Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   img: pinkbunnymain,
  //   productImages: [
  //     pinkbunnymain, pinkbunny1, pinkbunny2, pinkbunny3, pinkbunny4, waffles, pinkbunny, littleoneplaque, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters 
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 months'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Supersoft Fleece Blanket colour',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'White',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'Blue',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'Coffee',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'Rose',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'Grey',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'Mustard',
  //           increment: 6.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Bunny Comforter',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Little One Plaque',
  //           increment: 3.0
  //         },
  //         {
  //           name: 'Bunny Comforter & Plaque',
  //           increment: 9.0
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //       ]  
  //     }
  //   ] 
  // },
  // {
  //   id: "pink-unicorn",
  //   description:
  //     <>This cute hamper is packed full of essentials for the new arrival. Featuring a lovely pink and gold unicorn design. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Pink Unicorn Onesie (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Unicorn Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Pink Unicorn Hat</li>
  //       <li>Pink Unicorn Bib</li>
  //       <li>Pink Unicorn Scratch Mittens</li>
  //       <li>Choice Of Crochet Booties</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["Female"],
  //   name: "Pink Unicorn Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   img: pinkunicornmain,
  //   productImages: [
  //     pinkunicornmain, pinkunicorn1, pinkunicorn2, pinkunicorn3, pinkunicorn4, pinkunicorn5, pinkcellular, whitecellular, allbooties, unicorn, ecounicorncomforter, ecounicorntoy, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters 
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Cellular Blanket Colour',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'White',
  //           increment: 6.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Unicorn Comforter',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Eco Unicorn Comforter',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Eco Unicorn Beanie Toy',
  //           increment: 7.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //       ]  
  //     }
  //   ] 
  // },  
  // {
  //   id: "lilac-rainbow",
  //   description:
  //     <>Rainbows have been really popular over the past couple of years and this hamper has a goregous rainbow blanket and lovely rainbow designs throughout. Packed full of essentials for the new arrival, this hamper makes a perfect gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes:<ul>
  //       <br />
  //        <li>White & Pink Rainbow Blanket (100% Polyester)</li>
  //        <li>Rainbow Onesie (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
  //        <li>White Polkadot Vest (100% Cotton)</li> 
  //        <li>Rainbow Hat</li>
  //        <li>White Rainbow Bib</li>
  //        <li>White Polkadot Mitts</li>
  //       <li>Choice of Crochet Booties</li> </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />Sizes 0-3 & 3-6 Months - Sold Out
  //       </>,
  //   categories: ["sale"],
  //   name: "Lilac Rainbow Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   was: 27.99,
  //   img: rainbowspotmain,
  //   productImages: [
  //     rainbowspotmain, rainbowspot1, rainbowspot2, rainbowspot3, rainbowspot4, rainbowspot5, rainbowblanket, allbooties, bunnycloud, pinkbearcomf, sheep, unicorn, zebra, lion, greyelephant, whiteelephant, recycledcomforters,
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 available>'
  //         },
  //         // {
  //         //   name: '0-3 months <2 available>'
  //         // },
  //         // {
  //         //   name: '3-6 months <1 available>'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Add comforter',
  //       options: [
  //         {
  //           name: 'No Thanks',
  //         },
  //         {
  //           name: 'Lion',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Zebra',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Grey Bunny',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Pink Bear',
  //           increment: 7.99
  //         },
  //         // {
  //         //   name: 'Pink Bunny',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Sheep',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Unicorn',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Recycled Giraffe',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Recycled Zebra',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Recycled Cream Sheep',
  //           increment: 8.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun in Oven',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },  
  // {
  //   id: "knitted-heart",
  //   description:
  //     <>These goregous knitted set is perfect for keep baby cute & cosy at the same time. Packed full of essentials for the new arrival, this hamper makes a perfect gift for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes:<ul>
  //       <br />
  //        <li>Pink Cellular Blanket (100% Cotton, size 75cm x 90cm)</li>
  //        <li>Pink Knitted Jumper With Heart Design (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //        <li>Pink Knitted Leggings (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li> 
  //        <li>Pink Knitted Hat & Mittens</li>
  //        <li>Pink Crochet Booties</li> </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes Newborn & 0-3 Months - Sold Out        
  //       </>,
  //   categories: ["Female"],
  //   name: "Knitted Heart Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: knittedheartmain,
  //   productImages: [
  //     knittedheartmain, knittedheart1, knittedheart2, pinkcellular, bowbooties, bunnycloud, pinkbearcomf , sheep, unicorn, zebra, lion, greyelephant, whiteelephant, recycledcomforters, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         {
  //           name: '3-6 months <1 available>'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Add comforter',
  //       options: [
  //         {
  //           name: 'No Thanks',
  //         },
  //         {
  //           name: 'Lion',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Zebra',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Grey Bunny',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Pink Bear',
  //           increment: 7.99
  //         },
  //         // {
  //         //   name: 'Pink Bunny',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Sheep',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Unicorn',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Recycled Giraffe',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Recycled Zebra',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Recycled Cream Sheep',
  //           increment: 8.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Baby Boy Banner',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },  
  // {
  //   id: "muslin-organic-girl",
  //   description:
  //   <>Our muslin hampers are perfect for the warmer months to keep baby cool but still looking cute! The musin fabric is super soft, and we've teamed it up with our oganic cotton accessories to make a great gift. Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper comes packed in a white box and includes:
  //   <br /><br /><ul>
  //     <li>Muslin Romper or Muslin Dungarees (100% Cotton, Sizes: 0-3, 3-6, 6-12 Months)</li>
  //     <li>Organic Pom Pom Bib</li>
  //     <li>Optional Additional Extras</li>
  //   </ul>
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  // </>,
  //   categories: ["Female"],
  //   showOnHomepage: true,
  //   name: "Muslin Clothing Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   img: coralmuslinorganicmain,
  //   productImages: [
  //      coralmuslinorganicmain, pinkmuslinsetmain, pinkmuslinrompermain, organicbibs, organicteethers, allorganicblankets, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         },
  //         {
  //           name: '6-12 months'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bib Design',
  //       options: [
  //         {
  //           name: 'White Geometric'
  //         },
  //         {
  //           name: 'Orange Geometric'
  //         },
  //         {
  //           name: 'Navy'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bow Teether',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Geometric',
  //           increment: 8.0
  //         },
  //         {
  //           name: 'Orange Geometric',
  //           increment: 8.0
  //         },
  //         {
  //           name: 'Dandelion Print',
  //           increment: 8.0
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Large Organic Blanket',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Geometric',
  //           increment: 11.0
  //         },
  //         {
  //           name: 'Orange Geometric',
  //           increment: 11.0
  //         },
  //         {
  //           name: 'Dandelion Print',
  //           increment: 11.0
  //         },
  //       ]
  //     },
  //     {
  //       title: 'TooWordy Gift Card',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun in Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely News',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "Giraffe-Animals",
  //   description:
  //     <>This gorgeous hamper feautres a spotty grey and lemon animal design and it packed full of essentials for a new arrival. We've also popped in lots of opportunities for you to add in additional gifts to personalise to your taste. Ideal for a baby shower, or for a new mum and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br /><li>Choice of Cellular Blanket</li>
  //       <li>White Animal Onesie (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
  //       <li>White Polkadot Vest (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
  //       <li>White Animal Hat</li>
  //       <li>White Animal Bibs</li>
  //       <li>Grey Polkadot Scratch Mittens</li>
  //       <li>Choice of Crochet Booties</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />     
  //       <br />Size 0-3 & 3-6 Months - Sold Out
  //       <br />           
  //       </>,
  //   categories: ["Unisex", "Male", "Female"],
  //   name: "Giraffe and Animals Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: giraffeanimalmain,
  //   productImages: [
  //     giraffeanimalmain, giraffeanimal1, giraffeanimal2, giraffeanimal3, giraffeanimal4, giraffeanimal5, recycledcomforters, recycledtoys, recycledall, allcellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 Available>'
  //         },
  //         //{
  //         //  name: '0-3 months'
  //         //},
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Cellular Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //         {
  //           name: 'Pink'
  //         }
  //       ]
  //     },      
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Toy',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Zebra Toy',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Giraffe Toy',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Lamb Toy',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Zebra Comforter',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Giraffe Comforter',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Lamb Comforter',
  //           increment: 7.00
  //         },
  //         {
  //           name: 'Zebra Ring Rattle',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Giraffe Ring Rattle',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Lamb Ring Rattle',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Zebra Stick Rattle',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Giraffe Stick Rattle',
  //           increment: 6.00
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'Unicorn Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Mermaid Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Car Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Dinosaur Water Teether',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Pink Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         // {
  //         //   name: 'Yellow Dumbell Rattle',
  //         //   increment: 2.99
  //         // },
  //         //{
  //         //  name: 'White Geo Organic Teether',
  //         //  increment: 5.99
  //         //},
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         //{
  //         //  name: 'Pink Rainbow Teether',
  //         //  increment: 7.99
  //         //},
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Elephant Keepsake Box',
  //         //   increment: 11.99
  //         // },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         //{
  //         //  name: 'Wooden Shape Sorter',
  //         //  increment: 12.99
  //         //},
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },      
  //   ]
  // },
  {
    id: "Grey-Bunny",
    description:
      <>Treat that little person with this cute gift box packed full of lots of essential items for a new baby. We love the bunny print & matching comforters featured here! We've also added in lots of options for you to add in additional gifts to personalise this to your taste for the new baby. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
        <br /><li>Grey Cellular Blanket (100% Cotton, Size 75cm x 90cm)</li>
        <li>White Bunny Onesie (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
        <li>White Star Vest (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
        <li>White Bunny Hat</li>
        <li>White Bunny Bib</li>
        <li>White Bunny Scratch Mittens</li>
        <li>Choice of Crochet Booties</li>
        <li>Optional Bunny comforter</li></ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br /><br />Grey Bunny Comforter - Sold Out
        </>,
    categories: ["Unisex"],
    name: "Grey Bunny Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: greybunnymain,
    productImages: [
      greybunnymain, greybunny1, greybunny2, greybunny3, greybunny4, greybunny5, greybunny6, greycellular, bunnycloud, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn'
          },
          {
            name: '0-3 months'
          },
          {
            name: '3-6 months'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Optional Bunny Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          // {
          //   name: 'Grey Bunny',
          //   increment: 7.99
          // },
          {
            name: 'Pink Bunny',
            increment: 6.00
          }          
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Precious Daughter',
            increment: 3.50
          },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          // {
          //   name: 'White Bunny Plaque',
          //   increment: 4.99
          // },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          {
            name: 'Unicorn Water Teether',
            increment: 2.99
          },
          {
            name: 'Mermaid Water Teether',
            increment: 2.99
          },
          {
            name: 'Car Water Teether',
            increment: 2.99
          },
          {
            name: 'Dinosaur Water Teether',
            increment: 2.99
          },
          {
            name: 'Pink Dumbell Rattle',
            increment: 2.99
          },
          {
            name: 'Yellow Dumbell Rattle',
            increment: 2.99
          },
          {
            name: 'White Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          {
            name: 'Pink Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Blue Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          {
            name: 'Wooden Shape Sorter',
            increment: 12.99
          },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
    ]
  },
    ]
  },
  {
    id: "Zebra-unisex",
    description:
      <>This "100% Cute" set makes a perfect gift for a new baby and features a lovely zebra theme throughout. Mix and Match the zebra items to personalise to your taste. Ideal for a baby shower, or for a new mum and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
        <br /><li>White Zebra Onesie (100% Cotton, Sizes 0-3, 3-6 or 6-9 months)</li>
        <li>Zebra Toy, Comforter, Teething Ring or Rattle (Made from 100% recycled materials but still super soft!)</li>
        <li>Grey Zebra Fleece Blanket</li></ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!        
        </>,
    categories: ["Unisex"],
    name: "Zebra Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: zebrarecycledmain,
    productImages: [
      zebrarecycledmain, zebrarecycled1, zebrablanket, zebraonesie, reczebras, reczebracomforter, reczebrattle, reczebteething, reczebtoy, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: '0-3 months'
          },
          {
            name: '3-6 months'
          },
          {
            name: '6-9 months'
          }
        ]
      },
      {
        title: 'Choice of Toy',
        options: [
          {
            name: 'Zebra Toy'
          },
          {
            name: 'Zebra Comforter'
          },
          {
            name: 'Zebra Teething Rattle'
          },
          {
            name: 'Zebra Stick Rattle'
          },
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          {
            name: 'Unicorn Water Teether',
            increment: 2.99
          },
          {
            name: 'Mermaid Water Teether',
            increment: 2.99
          },
          {
            name: 'Car Water Teether',
            increment: 2.99
          },
          {
            name: 'Dinosaur Water Teether',
            increment: 2.99
          },
          {
            name: 'Pink Dumbell Rattle',
            increment: 2.99
          },
          {
            name: 'Yellow Dumbell Rattle',
            increment: 2.99
          },
          //{
          //  name: 'White Geo Organic Teether',
          //  increment: 5.99
          //},
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          //{
          //  name: 'Pink Rainbow Teether',
          //  increment: 7.99
          //},
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Blue Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          //{
          //  name: 'Wooden Shape Sorter',
          //  increment: 12.99
          //},
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
    ]
  },      
    ]
  },
  // {
  //   id: "farmyard-unisex",
  //   description:
  //     <>This lovely farmyard themed gift contains lots of essential items for a new baby. Why not match with a farmyard animal comforter to give baby a special new friend to snuggle up to. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br /><li>White Farmyard Onesie (100% Cotton, Sizes 0-3, 3-6 or 6-9 months)</li>
  //       <li>White Farmyard Hat</li>
  //       <li>White Farmyard Bib</li>
  //       <li>Choice of Crochet Booties</li>
  //       <li>Optional Additional Comforter</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!        
  //       <br />Sizes 0-3 & 6-9 Months - Sold Out
  //       </>,
  //   categories: ["Unisex"],
  //   name: "Farmyard Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 15.99,
  //   img: farmyardmain,
  //   productImages: [
  //     farmyardmain, farmyard1, farmyard2, farmyard3, greyelephant, whiteelephant, bunnycloud, sheep, pinkbunny, unicorn, recycledcomforters, allbooties, wishstring, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         {
  //           name: '3-6 months <1 available>'
  //         },
  //         // {
  //         //   name: '6-9 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'White Sheep',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Grey Bunny',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Cream Lion',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Tan Giraffe',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Grey Zebra',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Cream Lamb',
  //           increment: 8.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },  
  //   ]
  // },
  // {
  //   id: "Lemon-Animal",
  //   description:
  //     <>This lovley lemon gift set makes a perfect gift for any new arrival. Safari animals are always really popular, and this combination teams up perfectly to give the new arrival lots of essential items and look cute at the same time! Why not add in an animal comforter also for new baby to snuggle up to, out lion is really popular with this gift set. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br /><li>Lemon Supersoft Waffle Fleece Blanket</li>
  //       <li>Lemon Animal Onesie (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
  //       <li>Lemon Polkadot Vest (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
  //       <li>Lemon Amimal Hat</li>
  //       <li>Lemon Animal Bib</li>
  //       <li>Lemon Polkadot Scratch Mittens</li>
  //       <li>Choice of Crochet Booties</li>
  //       <li>Add optional comforter for an additional cost</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!        
  //       </>,
  //   categories: ["Unisex"],
  //   name: "Lemon Animal Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: lemonanimalmain,
  //   productImages: [
  //     lemonanimalmain, lemonanimal1, lemonwaffle, lemonanimal2, lemonanimal3, lemonanimal4, lemonanimal5, allbooties, bunnycloud, sheep, unicorn, zebra, lion, greyelephant, recycledcomforters, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Add comforter',
  //       options: [
  //         {
  //           name: 'No Thanks',
  //         },
  //         {
  //           name: 'Lion',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Zebra',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Bunny',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Sheep',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Unicorn',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Recycled Giraffe',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Recycled Zebra',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Recycled Cream Sheep',
  //           increment: 8.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         //{
  //         //  name: 'White Geo Organic Teether',
  //         //  increment: 5.99
  //         //},
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         //{
  //         //  name: 'Pink Rainbow Teether',
  //         //  increment: 7.99
  //         //},
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         //{
  //         //  name: 'Wooden Shape Sorter',
  //         //  increment: 12.99
  //         //},
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },
  // {
  //   id: "animal-deer",
  //   description:
  //   <>Treat that little person with this lovely unisex gift box. Packed full of essential items for a new baby and features a lovely deer design throughout. Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>Supersoft Waffle Fleece Blanket (100% Polyester Waffle Fleece)</li>
  //     <li>White Deer Animal Onesie (100% Cotton, Sizes: Newborn, 0-3 or 3-6 Months)</li>
  //     <li>White Stripe Vest (100% Cotton, Sizes: Newborn, 0-3 or 3-6 Months</li>
  //     <li>White Deer Animal Hat</li>
  //     <li>White Deer Animal Bib</li>
  //     <li>White Deer Animal Scratch Mittens</li>
  //     <li>Choice of Crochet Booties (100% Acrylic)</li></ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  // </>,
  //   categories: ["Unisex"],
  //   name: "Animal Deer Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: animaldeermain,
  //   productImages: [
  //      animaldeermain, fipcwhitelambsmain, fipcwhitelambs1, fipcwhitelambs2, fipcwhitelambs3, fipcwhitelambs4, waffles, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Waffle Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'Rose'
  //         },
  //         {
  //           name: 'Coffee'
  //         },
  //         {
  //           name: 'Mustard'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },      
  //   ]
  // },
  {
    id: "elephant-mummy",
    description:
    <>This gorgous "I Love Mummy" set makes a perfect gift for a new arrival. Packed with essentials for baby, featuring our milestone cards to help record all those milestones over the first year. Add in a cuddly friend for baby to make this the perfect gift set. Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>White Elephant Onesie (100% Cotton, Sizes: 0-3, 3-6, 6-9 Months)</li>
      <li>White Elephant Hat</li>
      <li>White Mummy Elephant Bib</li>
      <li>30pc Milestone Moments Cards</li>
      <li>Choice of Crochet Booties (100% Acrylic)</li>
      <li>Optional Comforter</li>
    </ul>
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
        <br />Size 0-3 Months - Sold Out
  </>,
    categories: ["Unisex"],
    name: "Elephant Mummy Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 18.99,
    img: elephantmummymain,
    productImages: [
       elephantmummymain, thpcwhiteelephantmummy1, thpcwhiteelephantmummy2, milestonecards, allbooties, greyelephant, whiteelephant, bunnycloud, pinkbunny, bluedinosaur, whitedinosaur, sheep, lion, unicorn, alltoowordy
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          // {
          //   name: '0-3 months'
          // },
          {
            name: '3-6 months <1 available>'
          },
          {
            name: '6-9 months <2 available>'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant',
            increment: 6.0
          },
          {
            name: 'Grey Elephant',
            increment: 6.0
          },
          {
            name: 'Pink Bunny',
            increment: 6.0
          },
          {
            name: 'Grey Bunny',
            increment: 6.0
          },
          {
            name: 'Cream Lion',
            increment: 6.0
          },
          {
            name: 'Tan Giraffe',
            increment: 6.0
          },
          {
            name: 'Grey Zebra',
            increment: 6.0
          },
          {
            name: 'Cream Lamb',
            increment: 6.0
          },
        ]
      },
      {
        title: 'TooWordy Gift Card',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Tiny Toes',
            increment: 3.50
          },
          {
            name: 'Blue Tiny Toes',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun in Oven',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Lovely News',
            increment: 3.50
          }
        ]
      },
    ]
  },
  // {
  //   id: "brown-safari",
  //   description:
  //   <>One of our most popular gift sets, this lovely hamper has a safari animal theme and features subtle neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>Cellular Blanket(100% Cotton)</li>
  //     <li>White Safari Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
  //     <li>White Stripe Vest (100% Cotton)</li>
  //     <li>White Safari Hat</li>
  //     <li>White Safari Bib</li>
  //     <li>White Stripe Mittens</li>
  //     <li>Crochet Booties (100% Acrylic)</li></ul>
  //   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  // </>,
  //   categories: ["Unisex"],
  //   name: "Safari Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: brownsafarimain,
  //   productImages: [
  //      brownsafarimain, fipcbrownsafarimain, fipcbrownsafari1, fipcbrownsafari2, fipcbrownsafari3, fipcbrownsafari4, allcellular, allbooties, greyelephant, whiteelephant, lion, pinkbunny, bunnycloud, recycledcomforters, allrecrings, allrecrattle, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Cellular Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //         {
  //           name: 'Pink'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Pink Bunny',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Grey Bunny',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Cream Lion',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Grey Zebra',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Cream Lamb',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe Toy',
  //           increment: 7.0
  //         },
  //         {
  //           name: 'Tan Giraffe Teething Rattle',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe Stick Rattle',
  //           increment: 5.0
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },
  // {
  //   id: "look-at-stars-safari",
  //   description:
  //   <>One of our most popular gift sets, this lovely hamper has a safari animal theme and features subtle neutral tones throughout. 'Look Up At The Stars' wording features across the Bib. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>Cellular Blanket(100% Cotton)</li>
  //     <li>White Safari Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
  //     <li>White Zebra Vest (100% Cotton)</li>
  //     <li>White Safari Hat</li>
  //     <li>White 'Look Up To The Stars' Animal Bib</li>
  //     <li>White Stripe Mittens</li>
  //     <li>Crochet Booties (100% Acrylic)</li></ul>
  //   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br />Size Newborn, 0-3 Months - Sold Out
  // </>,
  //   categories: ["Unisex", "best-sellers"],
  //   showOnHomepage: true,
  //   name: "Safari Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: looksafari,
  //   productImages: [
  //     looksafari, fipclookup1, allcellular, allbooties, greyelephant, whiteelephant, bunnycloud, lion, recycledcomforters, allrecrings, allrecrattle, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         {
  //           name: '3-6 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Cellular Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //         {
  //           name: 'Pink'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Grey Bunny',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Cream Lion',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Tan Giraffe',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Grey Zebra',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Cream Lamb',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Tan Giraffe Toy',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Tan Giraffe Teething Rattle',
  //           increment: 8.99
  //         },
  //         {
  //           name: 'Tan Giraffe Stick Rattle',
  //           increment: 6.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'TooWordy Gift Card',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },          
  //         {
  //           name: 'Bun in Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Baby Boy Banner',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Lovely News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Welcome World',
  //           increment: 3.50
  //         },          
  //         {
  //           name: 'Pink Welcome World',
  //           increment: 3.50
  //         }          
  //       ]
  //     },      
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         //  },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },        
  // {
  //   id: "giraffe-abc-baby",
  //   description:
  //   <>One of our most popular gift sets, this lovely hamper has an ABC animal theme and features bright & orange tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby.
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>Cellular Blanket (100% Cotton)</li>
  //     <li>White Giraffe Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
  //     <li>White Polkadot Vest (100% Cotton)</li>
  //     <li>White Giraffe Hat</li>
  //     <li>White Giraffe Bib</li>
  //     <li>White Polkadot Mittens</li>
  //     <li>Crochet Booties (100% Acrylic)</li></ul>
  //   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  // </>,
  //   categories: ["Unisex"],
  //   name: "Giraffe 'abc' Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: bisforbabymain,
  //   productImages: [
  //      bisforbabymain, fipcwhiteabcmain, fipcwhiteabc1, fipcwhiteabc2, fipcwhiteabc3, fipcwhiteabc4, allcellular, allbooties, greyelephant, whiteelephant, lion, pinkbunny, bunnycloud, recycledcomforters, allrecrings, allrecrattle, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Cellular Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //         {
  //           name: 'Pink'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Pink Bunny',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Grey Bunny',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Cream Lion',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Grey Zebra',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Cream Lamb',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe Toy',
  //           increment: 7.0
  //         },
  //         {
  //           name: 'Tan Giraffe Teething Rattle',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe Stick Rattle',
  //           increment: 5.0
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // }, 
  {
    id: "Cosy-Check-hamper",
    description:
      <>Treat that little person with this lovely unisex gift box. Featuring a check design throughout. Ideal for a baby shower, or for a new mum and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :
        <br />
        <li>Coffee Supersoft Waffle Fleece Blanket</li>
        <li>Coffee Lightweight Padded Jacket (Sizes Newborn, 0-3, or 3-6months)</li>
        <li>Grey Printed Vest (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
        <li>Coffee Check Trousers</li>
        <li>Coffee Hat with Fleece Lining</li>
        <li>Coffee Check Scratch Mittens</li>
        <br />Sizes : Newborn, 0-3 or 3-6 Months
        <br />
        <br />Sizes Newborn & 3-6 Months - Sold Out
        </>,
    categories: ["Unisex"],
    name: "Cosy Check Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 27.99,
    img: checkmain,
    productImages: [
      checkmain, checksetmain, frames, plaques, welcomeplaque
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          // {
          //   name: 'Newborn'
          // },
          {
            name: '0-3 months <3 available>'
          },
          // {
          //   name: '3-6 months'
          // }
        ]
      },
      {
        title: 'Additional Gift',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Welcome Plaque',
            increment: 3.0
          },
          // {
          //   name: 'Bunny Plaque',
          //   increment: 3.0
          // },
          {
            name: 'Elephant Plaque',
            increment: 3.0
          },
          {
            name: 'Bunny Frame',
            increment: 5.0
          },
          {
            name: 'Elephant Frame',
            increment: 5.0
          },
          {
            name: 'Milestone Cards',
            increment: 3.0
          }
        ]
      },
    ]
  },  
  {
    id: "muslin-romper-dungarees",
    description:
    <>Our muslin hampers are perfect for the warmer months to keep baby cool but still looking cute! The musin fabric is super soft, and we've teamed it up with our oganic cotton accessories to make a great gift. Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Muslin Romper or Muslin Dungarees (100% Cotton, Sizes: 0-3, 3-6, 6-12 Months)</li>
      <li>Welcome to the World Plaque</li>
      <li>Optional Additional Comforter</li>
    </ul>
    <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
    <br /> 
        <br />Size 3-6 Months Dungarees - Sold Out
  </>,
    categories: ["Male"],
    name: "Muslin Clothing Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 16.99,
    img: bluemuslinmain,
    productImages: [
       bluemuslinmain, bluemuslinrompermain, bluemuslindungareesmain, knitcat, knitrabbit, bunnytoy, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: '0-3 months Romper'
          },
          {
            name: '0-3 months Dungarees'
          },          
          {
            name: '3-6 months Romper'
          },
          // {
          //   name: '3-6 months Dungarees'
          // },          
          {
            name: '6-12 months Romper'
          },
          {
            name: '6-12 months Dungarees'
          }          
        ]
      },
      {
        title: 'Additional Comforter or Toy',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Knitted Rabbit Comforter',
            increment: 8.0
          },
          {
            name: 'Knitted Cat Comforter',
            increment: 8.0
          },
          {
            name: 'Bunny Toy',
            increment: 11.0
          },
        ]
      },
      {
        title: 'TooWordy Gift Card',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Tiny Toes',
            increment: 3.50
          },
          {
            name: 'Blue Tiny Toes',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },          
          {
            name: 'Bun in Oven',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },          
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },          
          {
            name: 'Lovely News',
            increment: 3.50
          }
        ]
      },
    ]
  },
  // {
  //   id: "muslin-organic",
  //   description:
  //   <>Our muslin hampers are perfect for the warmer months to keep baby cool but still looking cute! The musin fabric is super soft, and we've teamed it up with our oganic cotton accessories to make a great gift. Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>Muslin Romper or Muslin Dungarees (100% Cotton, Sizes: 0-3, 3-6, 6-12 Months)</li>
  //     <li>Organic Pom Pom Bib</li></ul>
  //     <br/>Optional Additional Extras
  //     <ul>
  //       <br/>
  //       <li>Organic Bow Teether, Colour: White Geometric, Orange Geometric, Dandelion Print  (100% Organic Cotton)</li>
  //       <li>Organic Blanket Colour:White Geometric, Orange Geometric, Dandelion Print  (100% Organic Cotton, 120cmx120cm)</li>
  //     </ul>
  //     <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  // </>,
  //   categories: ["Male"],
  //   name: "Muslin Clothing Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   img: bluemuslinorganicmain,
  //   productImages: [
  //      bluemuslinorganicmain, bluemuslinrompermain, bluemuslindungareesmain, organicbibs, organicteethers, allorganicblankets, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         },
  //         {
  //           name: '6-12 months'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bib Design',
  //       options: [
  //         {
  //           name: 'White Geometric'
  //         },
  //         {
  //           name: 'Orange Geometric'
  //         },
  //         {
  //           name: 'Navy'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bow Teether',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Geometric',
  //           increment: 8.0
  //         },
  //         {
  //           name: 'Orange Geometric',
  //           increment: 8.0
  //         },
  //         {
  //           name: 'Dandelion Print',
  //           increment: 8.0
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Large Organic Blanket',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Geometric',
  //           increment: 11.0
  //         },
  //         {
  //           name: 'Orange Geometric',
  //           increment: 11.0
  //         },
  //         {
  //           name: 'Dandelion Print',
  //           increment: 11.0
  //         },
  //       ]
  //     },
  //     {
  //       title: 'TooWordy Gift Card',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Tiny Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun in Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely News',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "Dinosaur",
  //   description:
  //     <>RAWR! Dinosaurs are always popular for us, and this hamper makes a great gift for a new arrival or baby. Lovely pale blue tones throughout, and lots of opportunities to customise and add in extras to make this special. Why not try some milestone moment cards to help record the first year with a new baby, or our dinosaur comforters for baby to snuggle up to. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Blue Dinosaur Onesie (100% Cotton, Sizes 0-3, 3-6 or 6-9 months)</li>
  //       <li>Blue Onesie (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)</li>
  //       <li>Blue Dinosaur Hat</li>
  //       <li>Blue Dinosaur Bib</li>
  //       <li>Choice of Crochet Booties</li>
  //       <li>Optional Comforter & Extra Gifts</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       </>,
  //   categories: ["Male", "sale"],
  //   showOnHomepage: true,
  //   name: "Dinosaur Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   was: 34.99,
  //   img: dinosaurmain,
  //   productImages: [
  //     dinosaurmain, dinosaur1, dinosaur2, dinosaur3, dinosaur4, whitedinosaur, bluedinosaur, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 months'
  //         },
  //         {
  //           name: '6-9 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Aditional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Blue Dinosaur',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'White Dinosaur',
  //           increment: 6.0
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },      
  //   ]
  // },
  // {
  //   id: "boy-whale",
  //   description:
  //     <>Treat the new arrival with this lovely Whale themed hamper packed full of essential for the new arrival. The Aqua tone througout makes a great contract to the white accessories. We've also added in lots of options for you to customise this to your taste to make the gift extra special. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>White Cellular Blanket (100% Cotton, Size 75cm x 90cm)</li>
  //       <li>Blue Whale Onesie (100% Cotton, Sizes 0-3, 3-6 or 6-9 months)</li>
  //       <li>Blue Stripe Vest (100% Cotton, Sizes 0-3, 3-6 or 6-9 months)</li>
  //       <li>Blue Whale Hat</li>
  //       <li>Blue Whale Bib</li>
  //       <li>Blue Whale Mitts</li>
  //       <li>Choice Of Crochet Booties</li>
  //       </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />        
  //       </>,
  //   categories: ["Male"],
  //   showOnHomepage: true,
  //   name: "Blue Whale Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: bluewhalemain,
  //   productImages: [
  //     bluewhalemain, bluewhale1, bluewhale2, bluewhale3, bluewhale4, bluewhale5, bluewhale6, whitecellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 months'
  //         },
  //         {
  //           name: '6-9 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },      
  //   ]
  // },
  // {
  //   id: "teddy-bicycle",
  //   description:
  //     <>This hamper is packed full of essentials for the new arrival and features a cute teddy design. Navy is really popular at the moment as a change to ligher blues for baby. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Coffee Supersoft Waffle Fleece Blanket</li>
  //       <li>Navy Teddy Onesie (100% Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
  //       <li>Navy & Red Stripe Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Navy Teddy Hat</li>
  //       <li>Navy Teddy Bib</li>
  //       <li>Navy Teddy Scratch Mittens</li>
  //       <li>Choice Of Crochet Booties</li>
  //         </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br />Size 0-3 & 3-6 Months - Sold Out     
  //       <br />Brown Bear Comforter - Sold Out
  //       <br />              
  //         </>,
  //   categories: ["sale"],
  //   name: "Teddy Bicycle Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   was: 27.99,
  //   img: teddybikemain,
  //   productImages: [
  //     teddybikemain, teddybike1, teddybike2, teddybike3, teddybike4, teddybike5, coffeewaffle, allbooties, brownbearcomf, pinkbearcomf, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 Available>'
  //         },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 months'
  //         // },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         // {
  //         //   name: 'Brown Bear',
  //         //   increment: 6.00
  //         // },
  //         {
  //           name: 'Pink Bear',
  //           increment: 6.00
  //         }
  //       ]
  //     },      
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },          
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },          
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }          
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },
  // {
  //   id: "navy-teddy",
  //   description:
  //     <>This hamper is packed full of essentials for the new arrival and features a cute teddy design. Navy is really popular at the moment as a change to ligher blues for baby. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Coffee Supersoft Waffle Fleece Blanket</li>
  //       <li>Navy Teddy Onesie (100% Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
  //       <li>Navy Striped Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>Navy Teddy Hat</li>
  //       <li>Navy Teddy Bib</li>
  //       <li>Navy Teddy Scratch Mittens</li>
  //       <li>Choice Of Crochet Booties</li>
  //         </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br /> 
  //       <br /> Size Newborn & 3-6 Months - Sold Out      Brown Bear Comforter - Sold Out        
  //         </>,
  //   categories: ["Male"],
  //   showOnHomepage: true,
  //   name: "Navy Teddy Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: navybearhamper,
  //   productImages: [
  //     navybearhamper, fipcnavybear1, coffeewaffle, allbooties, brownbearcomf, pinkbearcomf, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months <2 available>'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         // {
  //         //   name: 'Brown Bear',
  //         //   increment: 6.00
  //         // },
  //         {
  //           name: 'Pink Bear',
  //           increment: 6.00
  //         }
  //       ]
  //     },      
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },          
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },          
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }          
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },
  // {
  //   id: "blue-aeroplane",
  //   description:
  //     <>This hamper is packed full of essentials for the new arrival and features a cute aeroplane design. We've also added in lots of opportunities to add in additional gifts to customise this and make extra special. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>White or Blue Cellular Blanket (100% Cotton, Size 75cm x 90cm)</li>
  //       <li>White & Blue Aeroplane Onesie (100% Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
  //       <li>White Star Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
  //       <li>White & Blue Aeroplane Hat</li>
  //       <li>White & Blue Aeroplane Bib</li>
  //       <li>White & Blue Aeroplane Scratch Mittens</li>
  //       <li>Choice Of Crochet Booties</li>
  //         </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //         </>,
  //   categories: ["Male"],
  //   name: "Aeroplane Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: aeroplanehamper,
  //   productImages: [
  //     aeroplanehamper, teddybike1, teddybike2, teddybike3, teddybike4, teddybike5, whitecellular, bluecellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 months'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Cellular Colour',
  //       options: [
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Blue'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Wooden Shape Sorter',
  //           increment: 12.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },
  {
    id: "blue-digger",
    description:
      <>This hamper is packed full of essentials for the new arrival. Features a digger design throughout, what little one isn't obsessed with diggers at some stage, star them young! We've also added in lots of opportunities to add in additional gifts to customise this and make extra special. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
        <br />
        <li>White Cellular Blanket (100% Cotton, Size 75cm x 90cm)</li>
        <li>Blue Digger Onesie (100% Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
        <li>Blue Star Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
        <li>Blue Digger Hat</li>
        <li>Blue Digger Bib</li>
        <li>BlueDigger Scratch Mittens</li>
        <li>Choice Of Crochet Booties</li>
          </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["sale"],
    name: "Digger Hamper Gift Set",
    deliveryCharge: deliveryCharges,
    price: 19.99,
    was: 27.99,
    img: diggerhamper,
    productImages: [
      diggerhamper, fipctransportmain, fipctransport1, fipctransport2, fipctransport3, fipctransport4, whitecellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn'
          },
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 months'
          },
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          },
          {
            name: 'Bundle of Joy',
            increment: 3.50
          },          
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }          
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          {
            name: 'Unicorn Water Teether',
            increment: 2.99
          },
          {
            name: 'Mermaid Water Teether',
            increment: 2.99
          },
          {
            name: 'Car Water Teether',
            increment: 2.99
          },
          {
            name: 'Dinosaur Water Teether',
            increment: 2.99
          },
          {
            name: 'Pink Dumbell Rattle',
            increment: 2.99
          },
          {
            name: 'Yellow Dumbell Rattle',
            increment: 2.99
          },
          // {
          //   name: 'White Geo Organic Teether',
          //   increment: 5.99
          // },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          // {
          //   name: 'Pink Rainbow Teether',
          //   increment: 7.99
          // },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Blue Elephant Keepsake Box',
            increment: 11.99
          },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          // {
          //   name: 'Wooden Shape Sorter',
          //   increment: 12.99
          // },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
       ]
     },
    ]
  },
  {
    id: "beep-beep",
    description:
      <>This hamper is packed full of essentials for the new arrival. It features a fun car & giraffe design. We've also added in lots of opportunities to add in additional gifts to customise this and make extra special. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
        <br />
        <li>White Cellular Blanket (100% Cotton, Size 75cm x 90cm)</li>
        <li>Blue & Red Car Onesie (100% Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
        <li>Blue & Red Stripe Vest (100% Cotton, Sizes Newborn, 0-3 or 3-6 months)</li>
        <li>Blue & Red Car Hat</li>
        <li>Blue & Red Car Bib</li>
        <li>Blue & Red Stripe Scratch Mittens</li>
        <li>Choice Of Crochet Booties</li>
          </ul>
        <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
        <br /> Sizes 0-3 & 3-6 Months - Sold Out
          </>,
    categories: ["sale"],
    name: "Beep Beep Car Hamper Gift Set",
    deliveryCharge: deliveryCharges,
    price: 19.99,
    was:27.99,
    img: beepbeephamper,
    productImages: [
      beepbeephamper, fipcbeepmain, fipcbeep1, fipcbeep2, fipcbeep3, fipcbeep4, whitecellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          // {
          //   name: '0-3 Months'
          // },
          // {
          //   name: '3-6 months'
          // },
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          }
        ]
      },
      {
        title: 'Additional Items',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant Frame',
            increment: 4.99
          },
          {
            name: 'Grey Bunny Frame',
            increment: 4.99
          },
          {
            name: 'Grey Elephant Plaque',
            increment: 4.99
          },
          {
            name: 'White Bunny Plaque',
            increment: 4.99
          },
          {
            name: 'My First Cutlery Set',
            increment: 2.99
          },
          {
            name: 'Milestone Moment Cards',
            increment: 2.99
          },
          {
            name: 'Welcome To The World Heart',
            increment: 2.99
          },
          {
            name: 'Unicorn Water Teether',
            increment: 2.99
          },
          {
            name: 'Mermaid Water Teether',
            increment: 2.99
          },
          {
            name: 'Car Water Teether',
            increment: 2.99
          },
          {
            name: 'Dinosaur Water Teether',
            increment: 2.99
          },
          {
            name: 'Pink Dumbell Rattle',
            increment: 2.99
          },
          {
            name: 'Yellow Dumbell Rattle',
            increment: 2.99
          },
          // {
          //   name: 'White Geo Organic Teether',
          //   increment: 5.99
          // },
          {
            name: 'Orange Geo Organic Teether',
            increment: 5.99
          },
          {
            name: 'Dandelion Organic Teether',
            increment: 5.99
          },
          // {
          //   name: 'Pink Rainbow Teether',
          //   increment: 7.99
          // },
          {
            name: 'Brown Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 7.99
          },
          {
            name: 'Mummy Mug',
            increment: 5.99
          },
          {
            name: 'Daddy Mug',
            increment: 5.99
          },
          {
            name: 'Big Sister Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Big Brother Countdown Plaque',
            increment: 5.99
          },
          {
            name: 'Pink Elephant Keepsake Box',
            increment: 11.99
          },
          // {
          //   name: 'Blue Elephant Keepsake Box',
          //   increment: 11.99
          // },
          {
            name: 'Baby Boy Hanging Heart Plaque',
            increment: 5.99
          },
          {
            name: 'Everyday I Love You Moneybox',
            increment: 14.99
          },
          {
            name: 'Little Love Moneybox',
            increment: 14.99
          },
          {
            name: 'Twinkle Twinkle Moneybox',
            increment: 14.99
          },
          {
            name: 'Smallest Heart Moneybox',
            increment: 14.99
          },
          {
            name: 'Pink Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Blue Soft Rattle Cube',
            increment: 7.99
          },
          {
            name: 'Maze Learning Toy',
            increment: 5.99
          },
          // {
          //   name: 'Wooden Shape Sorter',
          //   increment: 12.99
          // },
          {
            name: 'Vehicles Puzzle',
            increment: 5.99
          }    
    ]
  },
    ]
  },
  // {
  //   id: "blue-safari",
  //   description:
  //     <>This hamper is packed full of essentials for the new arrival. It features a safari animal theme with blue colourings. We've also added in lots of opportunities to add in additional gifts to customise this and make extra special, and with plenty of safari animal toys & comforters for you to choose from. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Blue Safari Onesie (100% Cotton, newborn, 0-3 or 3-6 months)</li>
  //       <li>Blue Stripe Vest (100% Cotton, newborn, 0-3 or 3-6 months)</li>
  //       <li>Blue Safari Hat</li>
  //       <li>Blue Safari Bib</li>
  //       <li>Blue Safari Scratch Mittens</li>
  //       <li>Choice Of Crochet Booties</li>
  //       <li>Optional Cellular Blanket</li>
  //         </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes 0-3 & 3-6 Months - Sold Out
  //         </>,
  //   categories: ["sale"],
  //   name: "Blue Safari Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   was: 27.99,
  //   img: bluesafarihamper,
  //   productImages: [
  //     bluesafarihamper, fipcsafarimain, whitecellular, bluecellular, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards,  allstarmoneyboxes, dumbellrattlesmain, waterteethermain, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 months'
  //         // },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Blanket',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White',
  //           increment: 6.99
  //         },
  //         {
  //           name: 'Blue',
  //           increment: 6.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         // {
  //         //   name: 'White Geo Organic Teether',
  //         //   increment: 5.99
  //         // },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Pink Rainbow Teether',
  //         //   increment: 7.99
  //         // },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Maze Learning Toy',
  //           increment: 5.99
  //         },
  //         // {
  //         //   name: 'Wooden Shape Sorter',
  //         //   increment: 12.99
  //         // },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },
  // {
  //   id: "fleece-dinosaur",
  //   description:
  //     <>This hamper is packed full of essentials for the new arrival. It features a gorgeous super soft fleece blanket and cute dinosaur design throughout. We've also added in lots of opportunities to add in additional gifts to customise this and make extra special, and with plenty of safari animal toys & comforters for you to choose from. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Navy Fleece Dinosaur Blanket (100% Polyester, Size 75cm x 100cm</li>
  //       <li>Blue Dinosaur Onesie (100% Cotton, 0-3, 3-6 or 6-9 months)</li>
  //       <li>Blue Stripe Vest (100% Cotton, 0-3, 3-6 or 6-9 months)</li>
  //       <li>Blue Dinosaur Hat</li>
  //       <li>Blue Dinosaur Bib</li>
  //       <li>Blue Dinosaur Scratch Mittens</li>
  //       <li>Choice Of Crochet Booties</li>
  //         </ul>
  //       <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes 0-3 & 3-6 Months - Sold Out
  //         </>,
  //   categories: ["sale"],
  //   name: "Navy Dinosaur Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 19.99,
  //   was: 27.99,
  //   img: fleecedinohamper,
  //   productImages: [
  //     fleecedinohamper, fipcbluedinosaurmain, dinosaurblanket, whitedinosaur, bluedinosaur, allbooties, frames, plaques, wishstring, alltoowordy, welcomeplaque, rainbowteether, organicteethers, mugs, milestonecards, girlkeepsakebox, boykeepsakebox, cuttlery, boyheartplaque, countdownboards, allstarmoneyboxes, dumbellrattlesmain, waterteethermain, woodenblocks, vehiclejigsaw, softcube, mazecoasters
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: '0-3 Months <1 available>'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         {
  //           name: '6-9 months <1 available>'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Dinosaur',
  //           increment: 6.00
  //         },
  //         {
  //           name: 'Blue Dinosaur',
  //           increment: 6.00
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wishstring Bracelet',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'From Bump',
  //           increment: 3.99
  //         },
  //         {
  //           name: 'For Daddy',
  //           increment: 3.99
  //         },
  //         // {
  //         //   name: 'For New Mum',
  //         //   increment: 3.99
  //         // },
  //         {
  //           name: 'Mums Buttons',
  //           increment: 3.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'My First Cutlery Set',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Milestone Moment Cards',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Welcome To The World Heart',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Unicorn Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Mermaid Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Car Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Dinosaur Water Teether',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Pink Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Yellow Dumbell Rattle',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Orange Geo Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion Organic Teether',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Mummy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Daddy Mug',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Sister Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Big Brother Countdown Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Pink Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Blue Elephant Keepsake Box',
  //           increment: 11.99
  //         },
  //         {
  //           name: 'Baby Boy Hanging Heart Plaque',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Everyday I Love You Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Little Love Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Twinkle Twinkle Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Smallest Heart Moneybox',
  //           increment: 14.99
  //         },
  //         {
  //           name: 'Pink Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Blue Soft Rattle Cube',
  //           increment: 7.99
  //         },
  //         {
  //           name: 'Vehicles Puzzle',
  //           increment: 5.99
  //         }    
  //   ]
  // },
  //   ]
  // },        
  // {
  //   id: "organic-rattle",
  //   description:
  //     <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a choice of super soft organic muslin blankets, and a cute wooden & silicone rattle teether. All items suitable from birth.  Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //         <br />
  //       <li>Zoo or Panda Organic Muslin Blanket (100% Organic Cotton, Sizes 120cm x 85cm)</li>
  //       <li>Wood & Silicone Rattle Teething Ring (Made From European Std Beech Wood & BPS and BPA Free)</li>
  //       <li>Choice of Crochet Booties</li>
  //         </ul>
  //       <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Grey & Blue Wooden Rattle - Sold Out. Zoo Blanket - Sold Out
  //         </>,
  //   categories: ["eco-hampers", "unisex"],
  //   name: "Organic Rattle Hamper Gift",
  //   deliveryCharge: deliveryCharges,
  //   price: 29.99,
  //   img: rattleorganicmain,
  //   productImages: [
  //     rattleorganicmain, rattleorganic1, zoomuslin, pandamuslin, bearteether, allbooties, frames, plaques, welcomeplaque, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Blanket Design',
  //       options: [
  //         // {
  //         //   name: 'Zoo'
  //         // },
  //         {
  //           name: 'Panda'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Rattle Colour',
  //       options: [
  //         // {
  //         //   name: 'Grey',
  //         // },
  //         // {
  //         //   name: 'Blue',
  //         // },
  //         {
  //           name: 'Pink',
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'Navy'
  //         },
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //       ]
  //     },      
  //     {
  //       title: 'Optional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Welcome Little One Plaque',
  //           increment: 2.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },   
  // {
  //   id: "organic-mint",
  //   description:
  //     <>Treat that little person with this lovely mint geometric print gift hamper. A hand picked box of items with the added bonus of boasting Supersoft organic fabrics & long lasting wooden accessories.  Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //         <br />
  //       <li>Mint Animal Top (100% Organic Cotton, Sizes 0-3, 3-6, 6-12 or 12-18 months)</li>
  //       <li>Mint Aztec Jog Pants (100% Organic Cotton, Sizes 0-3, 3-6, 6-12 or 12-18 months)</li>
  //       <li>Reversible Mint Animal Bib</li>
  //       <li>White Geo Organic Muslin Blanket (100% Orgnic Cotton, Size 120cm x 120cm)</li>
  //       <li>Optional Bow Teething Ring</li>
  //         </ul>
  //       <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //         </>,
  //   categories: ["eco-hampers"],
  //   name: "3pc Organic Mint Hamper",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: thpcminthamper,
  //   productImages: [
  //     thpcminthamper, thpcminthamper1, fipcmintorganic4, fipcmintorganic2, fipcmintorganic3, organicwhitegeometric, allorganicbowteether, frames, plaques, welcomeplaque, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: '0-3 months'
  //         },
  //         {
  //           name: '3-6 months'
  //         },
  //         {
  //           name: '6-12 months'
  //         },
  //         {
  //           name: '12-18 months'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Organic Bow Teether',
  //       options: [
  //         {
  //           name: 'No Thanks',
  //         },
  //         {
  //           name: 'White Geo',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Orange Geo',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Dandelion',
  //           increment: 5.99
  //         },
  //         {
  //           name: 'Navy',
  //           increment: 5.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'Welcome Little One Plaque',
  //           increment: 2.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "organic-teether",
  //   description:
  //     <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a choice of super soft organic muslin blankets, and a cute bear wooden & silicone teether. All items suitable from birth.  Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //         <br />
  //       <li>Zoo or Panda Organic Muslin Blanket (100% Organic Cotton, Sizes 120cm x 85cm)</li>
  //       <li>Wood & Silicone Bear Teething Ring (Made From European Std Beech Wood & BPS and BPA Free)</li>
  //       <li>Choice of Crochet Booties</li>
  //         </ul>
  //       <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br /><br />Zoo Blanket - Sold Out
  //         </>,
  //   categories: ["eco-hampers", "best-sellers", "unisex"],
  //   showOnHomepage: true,
  //   name: "Organic Muslin Hamper Gift",
  //   deliveryCharge: deliveryCharges,
  //   price: 29.99,
  //   img: teetherorganicmain,
  //   productImages: [
  //     teetherorganicmain, teetherorganic1, zoomuslin, pandamuslin, bearteether, allbooties, frames, plaques, welcomeplaque, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Blanket Design',
  //       options: [
  //         // {
  //         //   name: 'Zoo'
  //         // },
  //         {
  //           name: 'Panda'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Teether Colour',
  //       options: [
  //         {
  //           name: 'Grey',
  //         },
  //         {
  //           name: 'Blue',
  //         },
  //         {
  //           name: 'Pink',
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'Navy'
  //         },
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //       ]
  //     },      
  //     {
  //       title: 'Optional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'Welcome Little One Plaque',
  //           increment: 2.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  {
    id: "organic-black-swirl",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a vibrant mono muslin blanket (great for baby sensory), and a choice of wooden accessory. All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Black Swirl Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Wooden Accessory (some items have an additional cost)</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Black Swirl Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: organicblackswirl,
    productImages: [
      organicblackswirl, swirlorganicmuslin, allbooties, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Navy'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Beige'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Sage'
          }
        ]
      },
      {
        title: 'Wooden Accessory',
        options: [
          {
            name: 'Elephant Frame',
          },
          {
            name: 'Bunny Frame',
          },
          {
            name: 'Elephant Plaque',
          },
          {
            name: 'Bunny Plaque',
          },
          {
            name: 'Wooden Heart Plaque',
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 5.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 5.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 3.00
          }
        ]
      },      
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },
  {
    id: "organic-sea-creatures",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a vibrant sea creature muslin blanket (great for baby sensory), and a choice of wooden accessory. All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Black Sea Creature Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Wooden Accessory (some items have an additional cost)</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Sealife Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: organicseacreatures,
    productImages: [
      organicseacreatures, seaanimalsorganicmuslin, allbooties, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Navy'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Beige'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Sage'
          }
        ]
      },
      {
        title: 'Wooden Accessory',
        options: [
          {
            name: 'Elephant Frame',
          },
          {
            name: 'Bunny Frame',
          },
          {
            name: 'Elephant Plaque',
          },
          {
            name: 'Bunny Plaque',
          },
          {
            name: 'Wooden Heart Plaque',
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 5.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 5.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 3.00
          }
        ]
      },      
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },  
  {
    id: "organic-pastel-elephant",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a lovely pastel elephant muslin blanket (great for baby sensory), and a choice of wooden accessory. All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Pastel Elephant Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Wooden Accessory (some items have an additional cost)</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Elephant Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: organicpastelelephant,
    productImages: [
      organicpastelelephant, elephantorganicmuslin, allbooties, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Navy'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Beige'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Sage'
          }
        ]
      },
      {
        title: 'Wooden Accessory',
        options: [
          {
            name: 'Elephant Frame',
          },
          {
            name: 'Bunny Frame',
          },
          {
            name: 'Elephant Plaque',
          },
          {
            name: 'Bunny Plaque',
          },
          {
            name: 'Wooden Heart Plaque',
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 5.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 5.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 3.00
          }
        ]
      },      
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },
  // {
  //   id: "organic-orange-leaf",
  //   description:
  //     <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a orange leaf muslin blanket (orange is super trendy right now!), and a choice of wooden accessory. All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //         <br />
  //       <li>Orange Leaf Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
  //       <li>Choice of Crochet Booties</li>
  //       <li>Choice of Wooden Accessory (some items have an additional cost)</li>
  //         </ul>
  //       <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //         </>,
  //   categories: ["eco-hampers", "unisex"],
  //   showOnHomepage: true,
  //   name: "Leaf Organic Hamper Gift",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: organicorgangeleaf,
  //   productImages: [
  //     organicorgangeleaf, orangeleaforganicmuslin, allbooties, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'White'
  //         },
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'Navy'
  //         },
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'Blue'
  //         },
  //         {
  //           name: 'Beige'
  //         },
  //         {
  //           name: 'Rose'
  //         },
  //         {
  //           name: 'Sage'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Wooden Accessory',
  //       options: [
  //         {
  //           name: 'Elephant Frame',
  //         },
  //         {
  //           name: 'Bunny Frame',
  //         },
  //         {
  //           name: 'Elephant Plaque',
  //         },
  //         {
  //           name: 'Bunny Plaque',
  //         },
  //         {
  //           name: 'Wooden Heart Plaque',
  //         },
  //         {
  //           name: 'Brown Rainbow Teether',
  //           increment: 2.00
  //         },
  //         {
  //           name: 'Burgundy Rainbow Teether',
  //           increment: 2.00
  //         },
  //         {
  //           name: 'Blue Bear Teether',
  //           increment: 5.00
  //         },
  //         {
  //           name: 'Pink Bear Teether',
  //           increment: 5.00
  //         },
  //         {
  //           name: 'Grey Bear Teether',
  //           increment: 5.00
  //         },
  //         {
  //           name: 'Pink Wooden Rattle',
  //           increment: 5.00
  //         },
  //         {
  //           name: 'Bear Stacking Toy',
  //           increment: 3.00
  //         },
  //         {
  //           name: 'Bunny Stacking Toy',
  //           increment: 3.00
  //         },
  //         {
  //           name: 'Elephant Stacking Toy',
  //           increment: 3.00
  //         }
  //       ]
  //     },      
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // }, 
  {
    id: "organic-orange-spot",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a orange spot muslin blanket (orange is super trendy right now!), and a choice of wooden accessory. All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Orange Spot Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Wooden Accessory (some items have an additional cost)</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Spot Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: organicorangespot,
    productImages: [
      organicorangespot, spotorganicmuslin, allbooties, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Navy'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Beige'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Sage'
          }
        ]
      },
      {
        title: 'Wooden Accessory',
        options: [
          {
            name: 'Elephant Frame',
          },
          {
            name: 'Bunny Frame',
          },
          {
            name: 'Elephant Plaque',
          },
          {
            name: 'Bunny Plaque',
          },
          {
            name: 'Wooden Heart Plaque',
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 5.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 5.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 3.00
          }
        ]
      },      
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  }, 
  {
    id: "organic-green-leaf",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a green leaf muslin blanket, and a choice of wooden accessory. All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Green Leaf Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Wooden Accessory (some items have an additional cost)</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Leaf Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: organicgreenleaf,
    productImages: [
      organicgreenleaf, leaforganicmuslin, allbooties, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Navy'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Beige'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Sage'
          }
        ]
      },
      {
        title: 'Wooden Accessory',
        options: [
          {
            name: 'Elephant Frame',
          },
          {
            name: 'Bunny Frame',
          },
          {
            name: 'Elephant Plaque',
          },
          {
            name: 'Bunny Plaque',
          },
          {
            name: 'Wooden Heart Plaque',
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 5.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 5.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 3.00
          }
        ]
      },      
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },
  {
    id: "organic-leopard",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a leopard print design muslin blanket, and a choice of wooden accessory. All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Leopard Design Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>Choice of Crochet Booties</li>
        <li>Choice of Wooden Accessory (some items have an additional cost)</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Leopard Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 24.99,
    img: organicleopard,
    productImages: [
      organicleopard, leopardorganicmuslin, allbooties, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Navy'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Beige'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Sage'
          }
        ]
      },
      {
        title: 'Wooden Accessory',
        options: [
          {
            name: 'Elephant Frame',
          },
          {
            name: 'Bunny Frame',
          },
          {
            name: 'Elephant Plaque',
          },
          {
            name: 'Bunny Plaque',
          },
          {
            name: 'Wooden Heart Plaque',
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 2.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 5.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 5.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 5.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 3.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 3.00
          }
        ]
      },      
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },
  {
    id: "organic-leopard-multi",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With a leopard print design muslin blanket, and 3pk matching muslin squares, because what new parent has too many muslins! All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Leopard Design Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>3pk Leopard Design Organic Muslin Squares (70% Bamboo, 30% Organic Cotton, Sizes 40cm x 40cm)</li>        
        <li>Choice of Giftcard</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Leopard Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 31.99,
    img: organicleopardmultipk,
    productImages: [
      organicleopardmultipk, leopardorganicmuslin, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Giftcard Choice',
        options: [
          {
            name: 'Pink Twinkle Toes'
          },
          {
            name: 'Blue Twinkle Toes'
          },
          // {
          //   name: 'Precious Daughter'
          // },
          {
            name: 'Baby Boy Banner'
          },
          {
            name: 'Little Lady'
          },
          {
            name: 'Little Dude'
          },
          {
            name: 'Lovely Happy News'
          },
          {
            name: 'Bundle Of Joy'
          },
          {
            name: 'Welcome Baby Boy'
          },
          {
            name: 'Welcome Baby Girl'
          },
          {
            name: 'New Chapter'
          },
          {
            name: 'Bun In The Oven'
          }
        ]
      },
      {
        title: 'Optional Wooden Accessory',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Elephant Frame',
            increment: 4.00
          },
          {
            name: 'Bunny Frame',
            increment: 4.00
          },
          {
            name: 'Elephant Plaque',
            increment: 4.00
          },
          {
            name: 'Bunny Plaque',
            increment: 4.00
          },
          {
            name: 'Wooden Heart Plaque',
            increment: 3.00
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 6.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 6.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 8.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 8.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 8.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 8.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 7.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 7.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 7.00
          }
        ]
      },      
    ]
  }, 
  {
    id: "organic-leaf-multi",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With an orange leaf muslin blanket, and 3pk matching muslin squares, because what new parent has too many muslins! All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Orange Leaf Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>3pk Leaf Design Organic Muslin Squares (70% Bamboo, 30% Organic Cotton, Sizes 40cm x 40cm)</li>        
        <li>Choice of Giftcard</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Leaf Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 31.99,
    img: organicleafmulti,
    productImages: [
      organicleafmulti, orangeleaforganicmuslin, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Giftcard Choice',
        options: [
          {
            name: 'Pink Twinkle Toes'
          },
          {
            name: 'Blue Twinkle Toes'
          },
          // {
          //   name: 'Precious Daughter'
          // },
          {
            name: 'Baby Boy Banner'
          },
          {
            name: 'Little Lady'
          },
          {
            name: 'Little Dude'
          },
          {
            name: 'Lovely Happy News'
          },
          {
            name: 'Bundle Of Joy'
          },
          {
            name: 'Welcome Baby Boy'
          },
          {
            name: 'Welcome Baby Girl'
          },
          {
            name: 'New Chapter'
          },
          {
            name: 'Bun In The Oven'
          }
        ]
      },
      {
        title: 'Optional Wooden Accessory',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Elephant Frame',
            increment: 4.00
          },
          {
            name: 'Bunny Frame',
            increment: 4.00
          },
          {
            name: 'Elephant Plaque',
            increment: 4.00
          },
          {
            name: 'Bunny Plaque',
            increment: 4.00
          },
          {
            name: 'Wooden Heart Plaque',
            increment: 3.00
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 6.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 6.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 8.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 8.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 8.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 8.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 7.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 7.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 7.00
          }
        ]
      },      
    ]
  },
  {
    id: "organic-spot-multi",
    description:
      <>Treat the new parents and baby with this goregous gift hamper packed with long lasting items. With an orange spot muslin blanket, and 3pk matching muslin squares, because what new parent has too many muslins! All items suitable from birth. Ideal for a baby shower, or for a new parent and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
          <br />
        <li>Orange Spot Organic Muslin Blanket (70% Bamboo, 30% Organic Cotton, Sizes 120cm x 85cm)</li>
        <li>3pk Spotty Design Organic Muslin Squares (70% Bamboo, 30% Organic Cotton, Sizes 40cm x 40cm)</li>        
        <li>Choice of Giftcard</li>
          </ul>
        <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
          </>,
    categories: ["eco-hampers", "unisex"],
    showOnHomepage: true,
    name: "Spot Organic Hamper Gift",
    deliveryCharge: deliveryCharges,
    price: 31.99,
    img: organicspotmulti,
    productImages: [
      organicspotmulti, spotorganicmuslin, bearteether, woodenrattle, woodenstacker, frames, plaques, rainbowteether, welcomeplaque, alltoowordy
    ],
    variants: [
      {
        title: 'Giftcard Choice',
        options: [
          {
            name: 'Pink Twinkle Toes'
          },
          {
            name: 'Blue Twinkle Toes'
          },
          // {
          //   name: 'Precious Daughter'
          // },
          {
            name: 'Baby Boy Banner'
          },
          {
            name: 'Little Lady'
          },
          {
            name: 'Little Dude'
          },
          {
            name: 'Lovely Happy News'
          },
          {
            name: 'Bundle Of Joy'
          },
          {
            name: 'Welcome Baby Boy'
          },
          {
            name: 'Welcome Baby Girl'
          },
          {
            name: 'New Chapter'
          },
          {
            name: 'Bun In The Oven'
          }
        ]
      },
      {
        title: 'Optional Wooden Accessory',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Elephant Frame',
            increment: 4.00
          },
          {
            name: 'Bunny Frame',
            increment: 4.00
          },
          {
            name: 'Elephant Plaque',
            increment: 4.00
          },
          {
            name: 'Bunny Plaque',
            increment: 4.00
          },
          {
            name: 'Wooden Heart Plaque',
            increment: 3.00
          },
          {
            name: 'Brown Rainbow Teether',
            increment: 6.00
          },
          {
            name: 'Burgundy Rainbow Teether',
            increment: 6.00
          },
          {
            name: 'Blue Bear Teether',
            increment: 8.00
          },
          {
            name: 'Pink Bear Teether',
            increment: 8.00
          },
          {
            name: 'Grey Bear Teether',
            increment: 8.00
          },
          {
            name: 'Pink Wooden Rattle',
            increment: 8.00
          },
          {
            name: 'Bear Stacking Toy',
            increment: 7.00
          },
          {
            name: 'Bunny Stacking Toy',
            increment: 7.00
          },
          {
            name: 'Elephant Stacking Toy',
            increment: 7.00
          }
        ]
      },      
    ]
  },                      
  // {
  //   id: "organic-mint-onesie",
  //   description:
  //     <>Treat that little person with this lovely mint geometric print gift hamper. The clothing boasts features such as: Extendable Cuffs for when baby grows, extendable waistbands, extendable neck on bibs & extendable gussets, allowing this set to last longer and grow with baby.  Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //         <br />
  //       <li>Mint Animal Onesie (100% Organic Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
  //       <li>Spotty Giraffe Vest (100% Organic Cotton, Sizes Newborn, 0-3, 3-6 months)</li>
  //       <li>Mint Animal Hat</li>
  //       <li>Mint Animal Bib</li>
  //       <li>Mint Animal Scratch Mitts</li>
  //       <li>Choice of Zebra Toy (Made from 100% Recycled Materials)</li>
  //         </ul>
  //       <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Size Newborn & 3-6 Months - Sold Out
  //         </>,
  //   categories: ["eco-hampers", "unisex", "sale"],
  //   name: "5pc Organic Mint Hamper",
  //   deliveryCharge: deliveryCharges,
  //   price: 17.99,
  //   was : 27.99,
  //   img: fipcmintorgmain,
  //   productImages: [
  //     fipcmintorgmain, fipcmintorg2, fipcmintorg3, fipcmintorg4, reczebracomforter, reczebrattle, reczebteething, reczebtoy, frames, plaques, welcomeplaque, alltoowordy 
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Choice Of Zebra',
  //       options: [
  //         {
  //           name: 'Zebra Toy'
  //         },
  //         {
  //           name: 'Zebra Comforter'
  //         },
  //         {
  //           name: 'Zebra Teething Ring'
  //         },
  //         {
  //           name: 'Zebra Stick Rattle'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Welcome Little One Plaque',
  //           increment: 2.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "organic-dandelion",
  //   description:
  //     <>Our Organic Cotton hampers have been built for those looking for something a little kinder to the environment, but with no compromise to quality or design. Our large muslin blankets are perfect multi use items for feeding, sleeping, play mats and many other uses. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Supersoft Large Organic Cotton Dandelion Seed Wish Swaddle Blanket (100% Organic Cotton, Size 120cm x 120cm)</li>
  //       <li>Organic Cotton Pom Pom Trim Bib , Choice Below (100% Organic Cotton)</li>
  //       <li>Organic Cotton Bow Teether, Choice Below (100% Organic Cotton)</li>
  //       </ul>
  //       <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //         </>,
  //   categories: ["eco-hampers"],
  //   name: "Organic Dandelion Hamper",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: organicdandelionmain,
  //   productImages: [
  //     organicdandelionmain, organicdandelion1, dandelionswaddle, organicbibs, organicteethers, rainbowteether, frames, plaques, welcomeplaque, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Bib Design',
  //       options: [
  //         // {
  //         //   name: 'Solid Navy'
  //         // },
  //         // {
  //         //   name: 'Dandelion Wish'
  //         // },
  //         {
  //           name: 'Orange Geometric'
  //         },
  //         {
  //           name: 'White Geometric'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Teether Design',
  //       options: [
  //         {
  //           name: 'Pink Rainbow'
  //         },
  //         {
  //           name: 'Burgundy Rainbow'
  //         },
  //         {
  //           name: 'Brown Rainbow'
  //         },
  //         {
  //           name: 'Solid Navy'
  //         },
  //         {
  //           name: 'Dandelion Wish'
  //         },
  //         {
  //           name: 'Orange Geometric'
  //         },
  //         {
  //           name: 'White Geometric'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'Welcome Little One Plaque',
  //           increment: 2.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "organic-rainbow",
  //   description:
  //     <>Treat that little person with this lovely pink rainbow gift hamper. A hand picked box of items with the added bonus of boasting Supersoft organic fabrics & long lasting wooden accessories.  Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //         <br />
  //       <li>Pink Rainbow Smock Top (100% Organic Cotton, Sizes 0-3, 3-6, 6-12 or 12-18 months)</li>
  //       <li>Pink Jog Pants (100% Organic Cotton, Sizes 0-3, 3-6, 6-12 or 12-18 months)</li>
  //       <li>Choice of Rainbow Teething Ring</li>
  //         </ul>
  //       <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes 0-3 & 3-6 Months - Sold Out
  //         </>,
  //   categories: ["eco-hampers", "Female"],
  //   name: "Organic Pink Rainbow Hamper",
  //   deliveryCharge: deliveryCharges,
  //   price: 24.99,
  //   img: organicrainbowmain,
  //   productImages: [
  //     organicrainbowmain, organicrainbow1, organicrainbow2, organicrainbow3, organicrainbow4, rainbowteether, frames, plaques, welcomeplaque, allorganicbowteether, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         // {
  //         //   name: '3-6 months'
  //         // },
  //         {
  //           name: '6-12 months'
  //         },
  //         {
  //           name: '12-18 months'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Rainbow Teether',
  //       options: [
  //         // {
  //         //   name: 'Pink Rainbow'
  //         // },
  //         {
  //           name: 'Burgundy Rainbow'
  //         },
  //         {
  //           name: 'Brown Rainbow'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'White Bunny Plaque',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Welcome Little One Plaque',
  //           increment: 2.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Baby Boy Banner',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },  
  // {
  //   id: "organic-geometric",
  //   description:
  //   <>Our Organic Cotton hampers have been built for those looking for something a little kinder to the environment, but with no compromise to quality or design. Our large muslin blankets are perfect multi use items for feeding, sleeping, play mats and many other uses. Ideal for a baby shower, or for a new parent and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :<ul>
  //       <br />
  //       <li>Supersoft Large Organic Cotton White Geometric Swaddle Blanket (100% Organic Cotton, Size 120cm x 120cm)</li>
  //       <li>Organic Cotton Pom Pom Trim Bib , Choice Below (100% Organic Cotton)</li>
  //       <li>Organic Teether, Choice Below (100% Organic Cotton)</li>
  //       <li>Optional Mint Organic 2 Piece Set (Size 0-3, 3-6 or 6-12 Months)</li>
  //         </ul>
  //       <br />We've also included an option if you wish to add on any additional gifts from our wooden collections.
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //         </>,
  //   categories: ["eco-hampers"],
  //   name: "Organic Geometric Hamper",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: organicgeometricmain,
  //   productImages: [
  //     organicgeometricmain, organicgeometric1, organicmint, organicbibs, organicteethers, rainbowteether, frames, plaques, welcomeplaque, alltoowordy
  //   ],
  //   variants: [
  //     {
  //       title: 'Bib Design',
  //       options: [
  //         // {
  //         //   name: 'Solid Navy'
  //         // },
  //         // {
  //         //   name: 'Dandelion Wish'
  //         // },
  //         {
  //           name: 'Orange Geometric'
  //         },
  //         {
  //           name: 'White Geometric'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Teether Design',
  //       options: [
  //         {
  //           name: 'Pink Rainbow'
  //         },
  //         {
  //           name: 'Burgundy Rainbow'
  //         },
  //         {
  //           name: 'Brown Rainbow'
  //         },
  //         {
  //           name: 'Solid Navy'
  //         },
  //         {
  //           name: 'Dandelion Wish'
  //         },
  //         {
  //           name: 'Orange Geometric'
  //         },
  //         {
  //           name: 'White Geometric'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Organic Mint 2 Piece',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: '0-3 Months',
  //           increment: 9.99
  //         },
  //         // {
  //         //   name: '3-6 Months',
  //         //   increment: 9.99
  //         // },
  //         {
  //           name: '6-12 Months',
  //           increment: 9.99
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Gift',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 4.99
  //         },
  //         {
  //           name: 'Grey Elephant Plaque',
  //           increment: 4.99
  //         },
  //         // {
  //         //   name: 'White Bunny Plaque',
  //         //   increment: 4.99
  //         // },
  //         {
  //           name: 'Welcome Little One Plaque',
  //           increment: 2.99
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Precious Daughter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },
  //   ]
  // },  
  // {
  //   id: "nautical",
  //   description:
  //     <>Treat that little person with this lovely unisex gift box. A hand picked box of items perfect for those special moments. Ideal for a baby shower, or for a new mum and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes:
  //       <br /><br />Navy Stripe Jacket & Trouser Set (Jacket 100% Polyester, Trousers 50% Cotton 50% Polyester 4% Elastane, Sizes 0-3, 3-6, 6-9 Months)
  //       <br /><br />White Supersoft Fleece Waffle Blanket
  //       <br />White Spotty Vest (100% Cotton, Sizes 0-3, 3-6 or 6-9 months)
  //       <br />Hat With Matching Mittens</>,
  //   categories: ["sale"],
  //   name: "Nautical Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   was : 26.99,
  //   img: nauticalmain,
  //   productImages: [
  //     nauticalmain, nautical1, nautical2, whitewaffle, hats1, hats2
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         {
  //           name: '3-6 months'
  //         },
  //         // {
  //         //   name: '6-9 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         {
  //           name: 'Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'White Hat & Mittens'
  //         },
  //         {
  //           name: 'White & Grey Hat & Mittens'
  //         },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         },
  //         // {
  //         //   name: 'Mustard Hat & Mittens'
  //         // },
  //         {
  //           name: 'Sage Hat & Mittens'
  //         },
  //         {
  //           name: 'Steel Hat & Mittens'
  //         },
  //         {
  //           name: 'Coffee Hat & Mittens'
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "lion-romper",
  //   description:
  //     <>Treat that little person with this lovely gift box. A hand picked box of items perfect for those special moments. Ideal for a baby shower, or for a new mum and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes:
  //       <br /><br />Lion Comforter
  //       <br />Lion Romper (Sizes 0-3, 3-6 or 6-9 Months)
  //       <br />White Cellular Blanket
  //       <br />White or Grey Dribble Bib
  //       <br />White or Grey Muslin Square
  //       <br />Choice of Crochet Booties
  //       <br />
  //       <br />Sizes 0-3 & 3-6 Months - Sold Out
  //       </>,
  //   categories: ["sale"],
  //   name: "Lion Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 13.99,
  //   was: 26.99,
  //   img: lionmain,
  //   productImages: [
  //     lionmain, lion1, lion2, lion, whitedribble, greydribble, greymuslin
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         // {
  //         //   name: '3-6 months'
  //         // },
  //         {
  //           name: '6-9 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Bib and Muslin Colour',
  //       options: [
  //         {
  //           name: 'Grey'
  //         },
  //         {
  //           name: 'White'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "unisex-teddy",
  //   description:
  //     <>Treat that little person with this lovely unisex gift box. A hand picked box of items perfect for those special moments. Ideal for a baby shower, or for a new mum and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :
  //       <br /><br />1 x White Star Velour Onesie (80% Cotton, 20% Polyester, Sizes 0-3, 3-6, 6-9 Months)
  //       <br />1 x Check Fleece Blanket
  //       <br />1 x Check Teddy Comforter
  //       <br />1 x White or Grey Dribble Bib
  //       <br />1 x Choice Crochet Booties</>,
  //   categories: ["sale"],
  //   name: "Teddy Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 25.00,
  //   img: teddymain,
  //   productImages: [
  //     teddymain, teddy1, teddy2, teddy3, teddy4, whitedribble, greydribble, littleoneplaque, frames, pinkbooties, whitebooties, greybooties, bluebooties, navybooties, giftwrap,
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         // {
  //         //   name: '3-6 months'
  //         // },
  //         {
  //           name: '6-9 months'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Little One Plaque',
  //           increment: 3.0
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 2.01
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 2.01
  //         },
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "Bear-velour",
  //   description:
  //     <>Treat that little person with this lovely unisex gift box. A hand picked box of items perfect for those special moments. Ideal for a baby shower, or for a new mum and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :
  //       <br /><br />Blue Velour Onesie (80% Cotton, 20% Polyester, Sizes 0-3, 3-6, 6-9 Months)
  //       <br />Choice Crochet Booties
  //       <br />Animal Baby Plaque or Photo Frame
  //       <br />
  //       <br /> Size 0-3 & 6-9 Months - Sold Out
  //       </>,
  //   categories: ["sale"],
  //   name: "Bear Hamper Gift Set",
  //   deliveryCharge: deliveryCharges,
  //   price: 11.99,
  //   was: 18.00,
  //   img: bearvelourmain,
  //   productImages: [
  //     bearvelourmain, bearvelour1, bearvelour2, plaques, frames, whitebooties, greybooties, bluebooties, navybooties
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: '0-3 months'
  //         // },
  //         {
  //           name: '3-6 months <1 Available>'
  //         },
  //         // {
  //         //   name: '6-9 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Additional Items',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Little One Plaque',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'White Elephant Frame',
  //           increment: 2.99
  //         },
  //         {
  //           name: 'Grey Bunny Frame',
  //           increment: 2.99
  //         },
  //       ]
  //     },
  //   ]
  // },
  
  {
    id: "Leopard-cat",
    description:
      <>Treat that little person with this lovely  gift box. A hand picked box of items perfect for those special moments. Ideal for a baby shower, or for a new mum and baby.
        <br /><br />Comes presented in a white gift box, ready to go and includes :
        <br /><br />1 x White Cellular Blanket
        <br />1 x Leopard Print Onesie (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)
        <br />1 x White Cat Vest (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)
        <br />1 x Leopard Print Hat
        <br />1 x White Cat Bib
        <br />1 Grey Polkadot Scratch Mittens
        <br />1 x Choice Crochet Booties
        <br /><br /> Optional Comforter</>,
    categories: ["Sale"],
    name: "Leopard Print Cat Hamper Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 26.99,
    img: leopardmain,
    productImages: [
      leopardmain, leopard1, leopard2, leopard3, leopard4, leopard5, whitecellular, sheep, bunnycloud, greyelephant, whiteelephant, pinkbunny, lion, recycledcomforters, greybooties, whitebooties, pinkbooties, navybooties, bluebooties, giftwrap
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          {
            name: 'Newborn'
          },
          {
            name: '0-3 months'
          },
          {
            name: '3-6 months'
          }
        ]
      },
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Grey Booties'
          },
          {
            name: 'White Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Navy Booties'
          }
        ]
      },
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant',
            increment: 6.0
          },
          {
            name: 'Grey Elephant',
            increment: 6.0
          },
          {
            name: 'Pink Bunny',
            increment: 6.0
          },
          {
            name: 'Grey Bunny',
            increment: 6.0
          },
          {
            name: 'Cream Lion',
            increment: 6.0
          },
          {
            name: 'Tan Giraffe',
            increment: 6.0
          },
          {
            name: 'Grey Zebra',
            increment: 6.0
          },
          {
            name: 'Cream Lamb',
            increment: 6.0
          },
        ]
      },
    ]
  },
  // {
  //   id: "mummy-me-girl",
  //   description:
  //     <>Treat that little person with this lovely unisex gift box. A hand picked box of items perfect for those special moments. Ideal for a baby shower, or for a new mum and baby.
  //       <br /><br />Comes presented in a white gift box, ready to go and includes :
  //       <br /><br />1 x White or Pink Cellular Blanket
  //       <br />1 x Pink Bunny Onesie (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)
  //       <br />1 x Pink Bow Vest (100% Cotton, Sizes Newborn, 0-3, or 3-6 months)
  //       <br />1 x Pink Bunny Hat
  //       <br />1 x Pink Bunny Bib
  //       <br />1 x Pink Bow Scratch Mittens
  //       <br />1 x Choice of Crochet Booties - White, Grey, Pink, Blue, Navy
  //       <br /><br /> Optional Comforter</>,
  //   categories: ["sale"],
  //   name: "Pink Mummy & Me Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 26.99,
  //   img: pinkmummymemain,
  //   productImages: [
  //     pinkmummymemain, pinkmummyme1, pinkmummyme2, pinkmummyme3, pinkmummyme4, pinkmummyme5, pinkmummyme6, pinkcellular, whitecellular, pinkbooties, whitebooties, greybooties, bluebooties, navybooties, giftwrap
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 months'
  //         },
  //         // {
  //         //   name: '3-6 months'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //   ]
  // },
  {
    id: "grey-elephant-comforter",
    description:
      <>Supersoft feel makes this comforter perfect for baby to snuggle up to! Suitable from 0+ months.
      <br /><br />Also available in White.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>36cm x 36cm</li></ul></>,
    categories: ["comforters"],
    name: "Grey Elephant Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: greyelephant,
    productImages: [
      greyelephant
    ],
  },
  {
    id: "brown-teddy-comforter",
    description:
      <>Supersoft feel makes this comforter perfect for baby to snuggle up to! Suitable from 0+ months. 
      <br /><br />Other Teddy Bear Options Available.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>36cm x 36cm</li></ul></>,
    categories: ["comforters"],
    name: "Brown Bear Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: newbrownbearcomf,
    productImages: [
      newbrownbearcomf
    ],
  },  
  {
    id: "white-elephant-comforter",
    description:
      <>Supersoft feel makes this comforter perfect for baby to snuggle up to! Suitable from 0+ months. 
      <br /><br />Also available in Grey.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>36cm x 36cm</li></ul></>,
    categories: ["comforters"],
    name: "White Elephant Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: whiteelephant,
    productImages: [
      whiteelephant
    ],
  },
  {
    id: "giraffe-comforter",
    description:
      <>Supersoft giraffe print makes this comforter perfect for baby to snuggle up to! Suitable from 0+ months. 
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>36cm x 36cm</li></ul></>,
    categories: ["comforters"],
    name: "Giraffe Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: giraffeprintcomforter,
    productImages: [ giraffeprintcomforter
    ],
  },
  {
    id: "blue-bunny-comforter",
    description:
      <>Bunnies are always super popular for us! These comforters come in 3 different colours and have a sweet floral design on them. Suitable from 0+ Months. Also available in grey and pink.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Blue Bunny Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: bluebunny,
    productImages: [
      bluebunny
    ],
  },
  // {
  //   id: "grey-bunny-comforter",
  //   description:
  //     <>Bunnies are always super popular for us! These comforters come in 3 different colours and have a sweet floral design on them. Suitable from 0+ Months. Also available in blue and pink.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>30cm x 30cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Grey Bunny Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: greyfloralbunny,
  //   productImages: [
  //     greyfloralbunny
  //   ],
  // },
  {
    id: "pink-bunny-comforter",
    description:
      <>Bunnies are always super popular for us! These comforters come in 3 different colours and have a sweet floral design on them. Suitable from 0+ Months. Also available in blue and grey.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Pink Bunny Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: pinkfloralbunny,
    productImages: [
      pinkfloralbunny
    ],
  },      
  // {
  //   id: "unicorn-comforter",
  //   description:
  //     <>With a rattle head & silver sparkles throughout the material, this makes a perfect gift! Suitable from 0+ Months.
  //     <br /><br />
  //     <ul>
  //       <li>Flannel Material</li>
  //       <li>30cm x 30cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Unicorn Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: unicorn,
  //   productImages: [
  //     unicorn
  //   ],
  // },
  {
    id: "lamb-comforter",
    description:
      <>One of our bestselling comforters, this little guy is super cute! Suitable from 0+ Months.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Lamb Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: lambcomf,
    productImages: [
      lambcomf
    ],
  },
  {
    id: "sheep-comforter",
    description:
      <>One of our bestselling comforters, this little guy is super cute! Suitable from 0+ Months.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Baby Sheep Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: sheep,
    productImages: [
      sheep
    ],
  },
  // {
  //   id: "grey-bunny-comforter",
  //   description:
  //     <>Supersoft feel with a lovely cloud print on the reverse. Great for a gender surprise baby! Suitable from 0+ Months
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>30cm x 30cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Rabbit Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: bunnycloud,
  //   productImages: [
  //     bunnycloud
  //   ],
  // },
  // {
  //   id: "pink-bunny-comforter",
  //   description:
  //     <>Gorgeous bow detail making this a perfect addition to any gift. Suitable from 0+ Months.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>30cm x 30cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Pink Rabbit Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: pinkbunny,
  //   productImages: [
  //     pinkbunny
  //   ],
  // },
  {
    id: "bluebunny-comforter",
    description:
      <>Super cute bunny comforter, perfect for baby to cuddle into for security. Suitable from 0+ Months.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters", "new-arrivals", "spring-summer"],
    name: "Blue Bunny Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: bluebunnycomf,
    productImages: [
      bluebunnycomf
    ],
  },  
  // {
  //   id: "pink-bear-comforter",
  //   description:
  //     <>Super cute bear comforter with a pink bow detail across one ear. Perfect for baby to cuddle into for security. Suitable from 0+ Months.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>30cm x 30cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Pink Bear Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: pinkbearcomf,
  //   productImages: [
  //     pinkbearcomf
  //   ],
  // },
  // {
  //   id: "brown-bear-comforter",
  //   description:
  //     <>Super cute bear comforter. Perfect for baby to cuddle into for security. Suitable from 0+ Months.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>30cm x 30cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Brown Bear Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: brownbearcomf,
  //   productImages: [
  //     brownbearcomf
  //   ],
  // },      
  // {
  //   id: "blue-dinosaur-comforter",
  //   description:
  //     <>Dinosaurs are always super popular for us! Multi textured with a bobble texture on the underside, great for sensory development. Suitable from 0+ Months. Also available in white.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>30cm x 30cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Blue Dinosaur Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: bluedinosaur,
  //   productImages: [
  //     bluedinosaur
  //   ],
  // },  
  {
    id: "white-dinosaur-comforter",
    description:
    <>Dinosaurs are always super popular for us! Multi textured with a bobble texture on the underside, great for sensory development. Suitable from 0+ Months. Also available in blue.
    <br /><br />
    <ul>
      <li>100% Polyester</li>
      <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "White Dinosaur Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: whitedinosaur,
    productImages: [
      whitedinosaur
    ],
  },
  {
    id: "lion-comforter",
    description:
      <>Lovely waffle texture on one side, smooth on the back to allow baby to experience different textures. Suitable from 0+ Months.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Lion Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: lion,
    productImages: [
      lion
    ],
  },
  {
    id: "brown-giraffe-comforter",
    description:
      <>This cute giraffe comforter is perfect for the new arrival to snuggle up to. Suitable from 0+ Months.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Giraffe Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: brightgiraffecomforter,
    productImages: [
      brightgiraffecomforter
    ],
  },  
  {
    id: "penguin-comforter",
    description:
      <>A lovely penguin designed comforter. Always a popular choice and its supersoft.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Penguin Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: penguin,
    productImages: [
      penguin
    ],
  },
  // {
  //   id: "blue-bunny-comforter",
  //   description:
  //     <>A sweet blue bunny comforter. Also available in Pink and White.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>Approx size: Bunny's Head 7cm, Bunny's Blanket 16.5x17.5cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Blue Bunny Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: bluebunny,
  //   productImages: [
  //     bluebunny
  //   ],
  // },
  // {
  //   id: "pink-bunny-comforter",
  //   description:
  //     <>A sweet blue bunny comforter. Also available in Blue and White.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>Approx size: Bunny's Head 7cm, Bunny's Blanket 16.5x17.5cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Pink Bunny Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: pinkbunnycomf,
  //   productImages: [
  //     pinkbunnycomf
  //   ],
  // },
  // {
  //   id: "white-bunny-comforter",
  //   description:
  //     <>A sweet blue bunny comforter. Also available in Blue and White.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>Approx size: Bunny's Head 7cm, Bunny's Blanket 16.5x17.5cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "White Bunny Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: whitebunny,
  //   productImages: [
  //     whitebunny
  //   ],
  // },
  // {
  //   id: "zebra-comforter",
  //   description:
  //     <>Features a grey & white zebra design blanket. Suitable from 0+ months.
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>30cm x 30cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Zebra Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 6.99,
  //   img: zebra,
  //   productImages: [
  //     zebra
  //   ],
  // },
  {
    id: "elephant-comforter-rattle",
    description:
      <>Can't choose between a rattle or comforter? This set gives you both! Suitable from 0+ Months. Also available in Giraffe Design.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>Comforter 30cm x 30cm</li>
        <li>Rattle 13cm</li></ul></>,
    categories: ["comforters"],
    name: "Elephant Comforter & Rattle Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: elephantcomforterrattle,
    productImages: [
      elephantcomforterrattle
    ],
  },
  {
    id: "giraffe-comforter-rattle",
    description:
      <>Can't choose between a rattle or comforter? This set gives you both! Suitable from 0+ Months. Also available in Elephant Design.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>Comforter 30cm x 30cm</li>
        <li>Rattle 13cm</li></ul></>,
    categories: ["comforters"],
    name: "Giraffe Comforter & Rattle Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: giraffecomforterrattle,
    productImages: [
      giraffecomforterrattle
    ],
  },
  {
    id: "rec-zebra-comforter",
    description:
      <>Designed with 100% recycled polyester made from recycled plastics, but with no compromise to quality or cuteness! Supersoft & super cuddly. Suitable from 0+ Months. Also available in Lamb, Unicorn & Giraffe Designs.
      <ul>
        <li>100% Polyester</li>
        <li>32cm x 32cm</li></ul></>,
    categories: ["comforters"],
    name: "Eco Zebra Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: reczebracomforter,
    productImages: [
      reczebracomforter
    ],
  },
  // {
  //   id: "rec-giraffe-comforter",
  //   description:
  //     <>Designed with 100% recycled polyester made from recycled plastics, but with no compromise to quality or cuteness! Supersoft & super cuddly. Suitable from 0+ Months. Also available in Lamb, Unicorn & Zebra Designs.
  //    <br /><br />
  //     <ul>
  //       <li>100% Polyester</li>
  //       <li>32cm x 32cm</li></ul></>,
  //   categories: ["comforters"],
  //   name: "Eco Giraffe Comforter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 8.99,
  //   img: recgiraffecomforter,
  //   productImages: [
  //     recgiraffecomforter
  //   ],
  // },
  {
    id: "rec-lamb-comforter",
    description:
      <>Designed with 100% recycled polyester made from recycled plastics, but with no compromise to quality or cuteness! Supersoft & super cuddly. Suitable from 0+ Months. Also available in Zebra, Unicorn & Giraffe Designs.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>32cm x 32cm</li></ul></>,
    categories: ["comforters"],
    name: "Eco Lamb Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: reclambcomforter,
    productImages: [
      reclambcomforter
    ],
  },
  {
    id: "rec-unicorn-comforter",
    description:
      <>Designed with 100% recycled polyester made from recycled plastics, but with no compromise to quality or cuteness! Supersoft & super cuddly. Suitable from 0+ Months. Also available in Zebra, Lamb & Giraffe Designs.
     <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>32cm x 32cm</li></ul></>,
    categories: ["comforters"],
    name: "Eco Unicorn Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: ecounicorncomforter,
    productImages: [
      ecounicorncomforter
    ],
  },
  {
    id: "knitted-rabbit-comforter",
    description:
      <>Super cute with a knitted material, a great gift for any new arrival. Suitable from 0+ Months. Also available in a Cat Design.
      <br /><br />
      <ul>
        <li>100% Cotton</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Knitted Rabbit Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: knitrabbit,
    productImages: [
      knitrabbit
    ],
  },
  {
    id: "knitted-cat-comforter",
    description:
      <>Super cute with a knitted material, a great gift for any new arrival. Suitable from 0+ Months. Also available in a Cat Design.
      <br /><br />
      <ul>
        <li>100% Cotton</li>
        <li>30cm x 30cm</li></ul></>,
    categories: ["comforters"],
    name: "Knitted Cat Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: knitcat,
    productImages: [
      knitcat
    ],
  },
  {
    id: "pink-star-taggie",
    description:
    <>Taggie comforters have many benefits. Different textures for sensory development, small tags to help develop grabbing motions & hand / eye co-ordination and smooth textures to cuddle into - what's not to love! 
    <br /><br />Suitable from 0+Months.
    <br /><br />
    <ul>
      <li>100% Polyester</li>
      <li>35cm x 35cm</li></ul></>,
    categories: ["comforters"],
    name: "Pink Star Taggie Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: pinkhearttaggie,
    productImages: [
      pinkhearttaggie
    ],
  },
  {
    id: "blue-star-taggie",
    description:
      <>Taggie comforters have many benefits. Different textures for sensory development, small tags to help develop grabbing motions & hand / eye co-ordination and smooth textures to cuddle into - what's not to love! 
      <br /><br />Suitable from 0+Months.
      <br /><br />
      <ul>
        <li>100% Polyester</li>
        <li>35cm x 35cm</li></ul></>,
    categories: ["comforters"],
    name: "Blue Star Taggie Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: bluestartaggie,
    productImages: [
      bluestartaggie
    ],
  },
  {
    id: "white-blue-taggie",
    description:
    <>Taggie comforters have many benefits. Different textures for sensory development, small tags to help develop grabbing motions & hand / eye co-ordination and smooth textures to cuddle into - what's not to love! 
    <br /><br />Suitable from 0+Months.
    <br /><br />
    <ul>
      <li>100% Polyester</li>
      <li>35cm x 35cm</li></ul></>,
    categories: ["comforters"],
    name: "White & Blue Cars Taggie Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: whitecartaggie,
    productImages: [
      whitecartaggie
    ],
  },
  {
    id: "white-pink-taggie",
    description:
    <>Taggie comforters have many benefits. Different textures for sensory development, small tags to help develop grabbing motions & hand / eye co-ordination and smooth textures to cuddle into - what's not to love! Suitable from 0+Months.
    <br /><br />
    <ul>
      <li>100% Polyester</li>
      <li>35cm x 35cm</li></ul></>,
    categories: ["comforters"],
    name: "White & Pink Star Taggie Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: whitestartaggie,
    productImages: [
      whitestartaggie
    ],
  },
  {
    id: "grey-star-taggie",
    description:
    <>Taggie comforters have many benefits. Different textures for sensory development, small tags to help develop grabbing motions & hand / eye co-ordination and smooth textures to cuddle into - what's not to love! 
    <br /><br />Suitable from 0+Months.
    <ul>
      <li>100% Polyester</li>
      <li>35cm x 35cm</li></ul></>,
    categories: ["comforters"],
    name: "Grey Star Taggie Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: greystartaggie,
    productImages: [
      greystartaggie
    ],
  },
  {
    id: "wooden-brush",
    description:
    <>The perfect addition to any bathtime or daily routine, this brush & comb set is gentle on baby's head & skin. Part of our wooden collection, built to last.
    <br /><br />
    <ul>
    <li>Material : Pear wood with Schimab superbawool bristles</li>
    <li>Approx Size: 15cm</li></ul></>,
    categories: ["baby-accessories", "spring-summer"],
    name: "Wooden Brush and Comb Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: woodenbrush,
    productImages: [
      woodenbrush
    ],
  },  
  {
    id: "3pk-leaf-organic-muslin",
    description:
      <>Part of our Organic Cotton range, these printed muslins are multi purpose. They can be used as a cloth nappy for newborn babies, shielding when feeding for those who prefer to, or just as a burping and mopping up cloth. 
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        <li>70x70cms</li></ul></>,
    categories: ["baby-accessories"],
    name: "3 Pack Leaf Organic Cotton Muslin",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: thpkleafmuslin,
    productImages: [
      thpkleafmuslin
    ],
  },   
  {
    id: "wooden-scan-frame",
    description:
    <>Help celebrate the wonderful news of a new baby on the way with this super cute frame, perfect size for a baby scan. It features the wording "We can't wait to meet you" and had a lovely hanging elephant to one side. 
    <br /><br />
    <ul>
      <li>Materials: 100% Wood</li>
      <li>Approx Size: 15cmx16cm. Fits Standard Scan Size</li></ul></>,
    categories: ["baby-accessories"],
    name: "Baby Scan Photo Frame",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: babyscan,
    productImages:  [
      babyscan
    ],
  },  
  {
    id: "bandana-bib",
    description:
      <>Simple but effective. These dribble bibs are perfect to help fend off teething dribbles & keep baby's clothes clean & dry. An essential for every new mum! 
      <br /><br />Suitable from 0+ Months.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 20cmx40cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Bandana Bib",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.50,
    img: allbibs,
    productImages: [
      allbibs, greybib, whitebib, pinkbib, bluebib, navybib
    ],
    variants: [
      {
        title: 'Bib Colour',
        options: [
          {
            name: 'Grey Bib'
          },
          {
            name: 'White Bib'
          },
          {
            name: 'Pink Bib'
          },
          {
            name: 'Blue Bib'
          },
          {
            name: 'Navy Bib'
          }
        ]
      }
    ]
  },
  // {
  //   id: "floral-bib",
  //   description:
  //   <>Two floral Bibs
  //   <ul>
  //     <li></li>
  //     <li></li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: "Two Floral Bibs",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: floralbib,
  //   productImages: [
  //   ],
  // },
  // {
  //   id: "bib-headband",
  //   description:
  //   <>Cute & practical, these floral bibs come with a pink pom pom trim & a matching headband. 
  //   <br /> <br />Suitable from 0+ Months.
  //   <br /><br />
  //   <ul>
  //     <li>Materials: Bibs - Front: 100% Cotton, Back: 76% Cotton, 24% Polyester</li>
  //     <li>Materials: Headband - 95% Cotton, 5% Spandex</li>
  //     <li>One Size: 0-6 Months</li></ul></>,
  //   categories: ["baby-accessories", "spring-summer"],
  //   name: "Floral Bibs and Headband Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: floralbib,
  //   productImages: [
  //     floralbib
  //   ],
  // },
  {
    id: "organic-bib",
    description:
    <>These lovely bibs boast a lovely organic cotton fabric making them supersoft and gentle. Featuring a pom pom trim. 
    <br /><br />Suitable from 0+ Months, adult supervision advised.
    <br /><br />White Geometric - Sold Out
    <br /><br />
    <ul>
      <li>Materials: 100% Organic Cotton</li>
      <li>Size: 25cmx25cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Organic Cotton Pom Pom Bib",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.99,
    img: organicbibs,
    productImages: [
      organicbibs
    ],
    variants: [
      {
        title: 'Organic Bib Colour',
        options: [
          {
            name: 'Solid Navy'
          },
          {
            name: 'Orange Geometric'
          },
          // {
          //   name: 'White Geometric'
          // }
        ]
      }
    ]
  },
  {
    id: "muslin",
    description:
      <>One of the most useful items for new baby, muslin squares are a must! This is generous in size and in our opinion you can never have too many. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton Muslin</li>
        <li>Size 71cmx71cm</li>
      </ul>
      </>,
    categories: ["baby-accessories"],
    name: "Muslin Square",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.50,
    img: allmuslins,
    productImages: [
      allmuslins, whitemuslin, greymuslin, pinkmuslin, bluemuslin
    ],
    variants: [
      {
        title: 'Muslin Colour',
        options: [
          {
            name: 'Grey Muslin'
          },
          {
            name: 'White Muslin'
          },
          {
            name: 'Pink Muslin'
          },
          {
            name: 'Blue Muslin'
          }
        ]
      }
    ]
  }, 
  {
    id: "3pk-leopard-organic-muslin",
    description:
      <>Part of our Organic Cotton range, these printed muslins are multi purpose. They can be used as a cloth nappy for newborn babies, shielding when feeding for those who prefer to, or just as a burping and mopping up cloth. 
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        <li>70x70cms</li></ul></>,
    categories: ["baby-accessories"],
    name: "3 Pack Leopard Organic Cotton Muslin",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: thpkleopardmuslin,
    productImages: [
      thpkleopardmuslin
    ],
  },  
  {
    id: "knotheadband",
    description:
    <>This cute headband adds a perfect finish to any outfit. The challenge is keeping them on! 
    <br />Adult supervision advised.
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size 0-6 Months</li></ul></>,
    categories: ["baby-accessories"],
    name: "Knot Headband",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.50,
    img: knotheadbands,
    productImages: [
      knotheadbands, knotheadbandwh, knotheadbandpk
    ],
    variants: [
      {
        title: 'Headband Colour',
        options: [
          {
            name: 'Rose'
          },
          {
            name: 'White'
          },
        ]
      },
    ]
  },
  {
    id: "floral-wrap-headband",
    description:
    <>This bright floral wrap is perfect to swaddle baby & keep them wrapped up and cosy, it comes with matching headband.
    <br /><br />
    <ul>
      <li>Materials: 95% Cotton, 5% Elastane Knit</li>
      <li>Size: 0-6 Months</li></ul></>,
    categories: ["baby-accessories"],
    name: "Floral Wrap & Headband Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: floralwrapandhead,
    productImages: [
      floralwrapandhead
    ],
  },
  {
    id: "floral-headband-bootie",
    description:
    <>This cute floral headband and bootie set adds a perfect finish to any outfit. The challenge is keeping them on! 
    <br /><br />
    <ul>
      <li>Materials: 95% Cotton, 5% Elastane Knit</li>
      <li>Size: 0-12 Months</li></ul></>,
    categories: ["baby-accessories"],
    name: "Floral Headband & Bootie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: floralbootieheadband,
    productImages: [
      floralbootieheadband
    ],
  },
  {
    id: "booties",
    description:
      <>Cute little addition to any newborn gift, these booties finish off any outfit & help keep baby's feet warm! 
      <br /><br />Suitable from 0+ Months.
      <br /><br />
      <ul>
        <li>Materials: 100% Acrylic</li>
        <li>One Size 0-6 Months</li></ul></>,
    categories: ["baby-accessories"],
    name: "Plain Knitted Booties",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.50,
    img: allbooties,
    productImages: [
      allbooties, greybooties, whitebooties, pinkbooties, bluebooties, navybooties, rosebooties, beigebooties, sagebooties
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'White Booties'
          },
          // {
          //   name: 'Grey Booties'
          // },
          {
            name: 'Pink Booties'
          },
          {
            name: 'Blue Booties'
          },
          {
            name: 'Navy Booties'
          },
          {
            name: 'Coffee Booties'
          },
          {
            name: 'Sage Booties'
          },
          {
            name: 'Rose Pink Booties'
          }
        ]
      },
    ]
  },
  // {
  //   id: "flower-booties",
  //   description:
  //   <>Grey booties with Flower
  //   <ul>
  //     <li></li>
  //     <li></li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: "Flower Booties",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 1.50,
  //   img: placeholder,
  //   productImages: [
  //     placeholder
  //   ],
  // },
  {
    id: "bow-booties",
    description:
    <>These booties feature a cable knit front & come with a cute little bow on front. 
    <br /><br />Suitable from 0+ Months.
    <br /><br />
    <ul>
      <li>Materials: 100% Acrylic</li>
      <li>One Size 0-3 Months</li></ul></>,
    categories: ["baby-accessories"],
    name: "Knitted Booties with Bow",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.50,
    img: bowbooties,
    productImages: [
      bowbooties, rosebowbooties, greybowbooties
    ],
    variants: [
      {
        title: 'Bootie Colour',
        options: [
          {
            name: 'Rose'
          },
          {
            name: 'Grey'
          }
        ]
      }
    ]
  },
  // {
  //   id: "milestone-cards",
  //   description:
  //   <>These cards are perfect to help record and remember all of baby's first milestones. This pack contains 30 cards marking both times and achievements from "6 months old today" to "My 1st Christmas!"
  //   <ul>
  //     <li>Materials: 100% Card</li>
  //     <li>Size: Approx 17cmx11cm</li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: "30pc Memorable Moment Cards",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 2.99,
  //   img: milestonecardsmain,
  //   productImages: [
  //     milestonecardsmain,
  //   ],
  // },
  {
    id: "colour-milestone-cards",
    description:
    <>These cards are perfect to help record and remember all of baby's first milestones. This pack contains 30 cards marking both times and achievements from "6 months old today" to "My 1st Christmas!"
    <ul>
    <br />
      <li>Materials: 100% Card</li>
      <li>Size: Approx 17cmx11cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Memorable Moment Cards",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.99,
    img: colourmomentsmain,
    productImages: [
      colourmomentsmain, colourmomentspink, colourmomentsblue
    ],
    variants: [
      {
        title: 'Colour',
        options: [
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      }
    ]    
  },  
  // {
  //   id: "milestone-mat",
  //   description:
  //   <>This neautral tones milestone mat is the perfect way to help record those moments with baby. This set contains 3pc to help you mark the date and milestone.  
  //   <br />There's space for baby to lie / sit on the mat. 
  //   <br /><br />The challenge is keeping baby still!
  //   <br /><br />
  //   <ul>
  //     <li>Materials:</li>
  //     <li>Size: </li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: "Memorable Moment Mat",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: milestone2,
  //   productImages: [
  //     milestone2
  //   ],
  // },
  // {
  //   id: "wooden-baby-sign",
  //   description:
  //   <>Wooden Baby Sign
  //   <ul>
  //     <li></li>
  //     <li></li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: "Wooden Hanging Baby Sign",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 5.00,
  //   img: hangingplaques,
  //   productImages: [
  //   ],
  //   variants: [
  //     {
  //       title: 'Wooden Sign Option',
  //       options: [
  //         {
  //           name: 'Dream Big Little One'
  //         },
  //         {
  //           name: 'I Love You'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "wooden-standing-baby-sign",
    description:
    <>These white & grey signs are a perfect addition to any nursery. 
    <br /><br />Bunny Sign Features the quote "Sometimes the littlest things take up the most room in your heart".
    <br />Elephant Sign Features the quote "No joys on earth bring greater pleasure than a baby to love and treasure".
    <br /><br />
    <ul>
      <li>Materials: 100% Wood</li>
      <li>Size 22cm x 9cm x 1.2cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Wooden Baby Sign",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 4.99,
    img: plaques,
    productImages: [
      plaques
    ],
    variants: [
      {
        title: 'Wooden Sign Option',
        options: [
          {
            name: 'Elephant Sign'
          },
          {
            name: 'Bunny Sign'
          }
        ]
      }
    ]
  },
  {
    id: "hat-mittens",
    description:
      <>Cute & Cosy, these pom pom hats are a must have for any baby to keep them nicely tucked up on colder days. They come with matching mittens for little hands too!
      <br /><br />
      <ul>
        <li>Materials: 100% Acrylic</li>
        <li>Size: 0-12 Months</li>
        <br />Mustard - Sold Out
        </ul></>,
    categories: ["baby-accessories", "winter-warmers"],
    name: "Pom Pom Hat & Mittens",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: hats2,
    productImages: [
      hats2, allhats, greyhat, whitegreyhat, whitehat, rosehat, steelhat, coffeehat, sagehat, mustardhat
    ],
    variants: [
      {
        title: 'Hat & Mittens Colour',
        options: [
          {
            name: 'Grey Hat & Mittens'
          },
          {
            name: 'White Hat & Mittens'
          },
          {
            name: 'White & Grey Stripe Hat & Mittens'
          },
          {
            name: 'Rose Hat & Mittens'
          },
          // {
          //   name: 'Mustard Hat & Mittens'
          // },
          {
            name: 'Sage Hat & Mittens'
          },
          {
            name: 'Steel Hat & Mittens'
          },
          {
            name: 'Coffee Hat & Mittens'
          }
        ]
      },
    ]
  },
  // {
  //   id: "double-hat-mittens",
  //   description:
  //     <>Cute & Cosy, these pom pom hats are a must have for any baby to keep them nicely tucked up on colder days. They come with matching mittens for little hands too!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Acrylic</li>
  //       <li>Size: 0-12 Months</li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: "Double Pom Pom Hat & Mittens",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 6.99,
  //   img: hats1,
  //   productImages: [
  //   hats1, bluehat
  //   ],
  //   variants: [
  //     {
  //       title: 'Hat & Mittens Colour',
  //       options: [
  //         // {
  //         //   name: 'Grey Hat & Mittens'
  //         // },
  //         // {
  //         //   name: 'White Hat & Mittens'
  //         // },
  //         {
  //           name: 'Blue Hat & Mittens'
  //         },
  //         {
  //           name: 'Pink Hat & Mittens'
  //         },
  //         {
  //           name: 'Navy Hat & Mittens'
  //         }
  //       ]
  //     },
  //   ]
  // },
  {
    id: "cable-mittens",
    description:
      <>Keep little hands warm with these cable knitted mittens.
      <br /><br />These come in lots of different colours so why not mix and match with our pom pom hats to choose your own colour combination!
      <br /><br />
      <ul>
        <li>Materials: 100% Acrylic</li>
        <li>Size: 0-12 Months</li>
        <br />Mustard - Sold Out
        </ul></>,
    categories: ["baby-accessories", "winter-warmers"],
    name: "Cable Mittens",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.50,
    img: cablemitts,
    productImages: [
      cablemitts
    ],
    variants: [
      {
        title: 'Mittens Colour',
        options: [
          {
            name: 'Grey Mittens'
          },
          {
            name: 'White Mittens'
          },
          {
            name: 'Rose Mittens'
          },
          // {
          //   name: 'Mustard Mittens'
          // },
          {
            name: 'Sage Mittens'
          },
          {
            name: 'Steel Mittens'
          },
          {
            name: 'Coffee Mittens'
          }
        ]
      },
    ]
  },
  {
    id: "single-hat",
    description:
      <>Cute & Cosy, these pom pom hats are a must have for any baby to keep them nicely tucked up on colder days. Mix and Match your colours with our matching cable mittens to keep little hands warm too!
      <br /><br />
      <ul>
        <li>Materials: 100% Acrylic</li>
        <li>Sizes: 0-12 & 12-24 Months</li>
      <br />Mustard - Sold Out  
        </ul></>,
    categories: ["baby-accessories", "winter-warmers"],
    name: "Pom Pom Hat",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 4.50,
    img: hats2,
    productImages: [
      hats2, allhats, greyhat, whitehat, rosehat, steelhat, coffeehat, sagehat, mustardhat
    ],
    variants: [
      {
        title: 'Hat Colour',
        options: [
          {
            name: 'Grey Hat 0-12 Months'
          },
          {
            name: 'Grey Hat 12-24 Months'
          },
          {
            name: 'White Hat 0-12 Months'
          },
          {
            name: 'White Hat 12-24 Months'
          },
          {
            name: 'Rose Hat 0-12 Months'
          },
          {
            name: 'Rose Hat 12-24 Months'
          },
          // {
          //   name: 'Mustard Hat 0-12 Months'
          // },
          {
            name: 'Sage Hat 0-12 Months'
          },
          {
            name: 'Sage Hat 12-24 Months'
          },
          {
            name: 'Steel Hat 0-12 Months'
          },
          {
            name: 'Coffee Hat 0-12 Months'
          },
          {
            name: 'Coffee Hat 12-24 Months'
          },
          {
            name: 'Pink Hat 0-12 Months'
          },
          {
            name: 'Pink Hat 12-24 Months'
          },
          {
            name: 'Blue Hat 0-12 Months'
          },
          {
            name: 'Blue Hat 12-24 Months'
          }
        ]
      },
    ]
  },  
  {
    id: "welcome-plaque",
    description:
    <>A lovely little keepsake for new parents or a new arrival, contains the wording "Welcome to the world little one". 
    <br /><br />Can be used as part of a gift tag or as a gift itself. 
    <br /><br />
    <ul>
      <li>Materials: 100% Wood</li>
      <li>Size: 14cmx13cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Welcome to the World Plaque",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.99,
    img: welcomeplaque,
    productImages: [
      welcomeplaque
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: 'One Size'
          }
        ]
      }
    ]
  },
  // {
  //   id: "twinkle-plaque",
  //   description:
  //   <>A lovely little keepsake for new parents or a new arrival, contains the wording 
  //   <br></br>"Twinkle Twinkle Little Star do you know how loved you are?". 
  //   <br /><br />
  //   <ul>
  //     <li>Materials: </li>
  //     <li>Size: </li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: "Twinkle Twinkle Plaque",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 6.00,
  //   img: twinkleplaque,
  //   productImages: [
  //     twinkleplaque
  //   ],
  // },
  // {
  //   id: "boy-heart-plaque",
  //   description:
  //   <>This gorgeous wooden hanging heart is a perfect keepsake marking a new arrival. Features a blue and elephant design.
  //   <br /><br /> Why not team up with an elephant hamper?
  //   <br /><br />
  //   <ul>
  //     <li>Materials: </li>
  //     <li>Size: </li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: " Baby Boy Heart Plaque",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 5.99,
  //   img: boyheartplaque,
  //   productImages: [
  //     boyheartplaque
  //   ],
  // },
  // {
  //   id: "boy-keepsake-box",
  //   description:
  //   <>Square keepsake box with elephant and heart design and features "My Little Keepsakes" wording. 
  //   <br></br> These boxes are great for storing those little memories as baby grows.
  //   <br /><br />
  //   <ul>
  //     <li>Materials: </li>
  //     <li>Size: </li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: " Baby Boy Keepsake Box",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 11.99,
  //   img: boykeepsakebox,
  //   productImages: [
  //     boykeepsakebox
  //   ],
  // },
  // {
  //   id: "girl-keepsake-box",
  //   description:
  //   <>Square keepsake box with elephant and heart design and features "My Little Keepsakes" wording. 
  //   <br /><br />These boxes are great for storing those little memories as baby grows.
  //   <br /><br />
  //   <ul>
  //     <li>Materials: </li>
  //     <li>Size: </li></ul></>,
  //   categories: ["baby-accessories"],
  //   name: " Baby Girl Keepsake Box",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 11.99,
  //   img: girlkeepsakebox,
  //   productImages: [
  //     girlkeepsakebox
  //   ],
  // },
  {
    id: "wooden-photo-frame",
    description:
    <>These white & grey photo frames are a perfect addition to any nursery. 
    <br /><br />Bunny Frame features the quote "No joys on earth bring greater pleasure than a baby to love and treasure".
    <br />Elephant Frame features the quote "Welcome to the world little one".
    <br /><br />
    <ul>
      <li>Materials: 100% Wood</li>
      <li>Approx Size: 20cmx18cm. Holds Photo 14cmx9cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Wooden Photo Frame",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 4.99,
    img: frames,
    productImages: [
      frames
    ],
    variants: [
      {
        title: 'Photo Frame Design',
        options: [
          {
            name: 'Elephant Frame'
          },
          {
            name: 'Rabbit Frame'
          }
        ]
      }
    ]
  },  
  {
    id: "record-book",
    description:
    <>This baby book is the perfect place to help you record all the little moments as baby grows. With space for memorable moments, memorable stats and photos if you wish to add them also! 
    <br /><br />It has 22 pages (44 sides) to complete & allow you to remember and treasure them forever. 
    <br /><br />
    <ul>
      <li>Approx Size: 22.5cmx22.5cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Baby Record Book",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: recordbook,
    productImages: [
      recordbook
    ],
  },
  {
    id: "peg-photo-",
    description:
    <>This photo frame is a great way to display special moments with baby, featuring three wooden pegs to hold photos, a grey frame and a cute baby design background. 
    <br /><br />Perfect as a keepsake or a christening/baby shower gift.
    <br /><br />
    <ul>
      <li>Materials: Made From Wood</li>
      <li>Size: 37cmx30cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Peg Photo Frame",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: pegframe,
    productImages: [
      pegframe
    ],
  },
  {
    id: "photo-album",
    description:
    <>This baby photo album holds 200 photos and allows you to record all of those moments! Each page holds 2 photos and has space for you to write a little memo either to remeber the occasion, or as a little message or note to baby when they grow up.
    <br /><br />Easy to slip the photos into the spaces, no need to stick them in!
    <br /><br />
    <ul>
      <li>Approx Size: 22cmx22cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Baby Photo Album",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: photoalbum,
    productImages: [
      photoalbum, photoalbuminside
    ],
  },
  {
    id: "countdown-board",
    description:
    <>A great way to get kids excited for a new arrival into the house, this board lets them update and countdown until the arrival. 
    <br /><br />Available in 'Big Sister' and 'Big Brother'.
    <br /><br />
    <ul>
      <li>Materials: 100% Wood</li>
      <li>Approx Size: 19cmx14cm.</li></ul></>,
    categories: ["baby-accessories"],
    name: "Brother/Sister Countdown Board",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.99,
    img: countdownboards,
    productImages: [
      countdownboards,
    ],
    variants: [
      {
        title: 'Countdown Board',
        options: [
          {
            name: 'Big Sister'
          },
          {
            name: 'Big Brother'
          }
        ]
      }
    ]
  },
  {
    id: "brush-comb",
    description:
    <>The perfect addition to any bathtime gift, this brush & comb set are gentle on baby's head & skin.
    <br /><br />
    <ul>
      <li>Approx Size: 8cm</li></ul></>,
    categories: ["baby-accessories"],
    name: "Brush and Comb Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.50,
    img: comb,
    productImages: [
      comb
    ],
  },
  {
    id: "mummy-daddy-mug",
    description:
    <>Every new parent needs one of these! Sit down and relax with a not so hot brew...
    <br/><br/>Mummy Mug features a pink heart design, Daddy mug features a blue star design
    <br/><br/>2 for £10 offer available on these also 
    <br /><br />
    <ul>
      <li>No Size</li></ul></>,
    categories: ["baby-accessories"],
    name: "Mummy & Daddy Mugs",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.99,
    img: mugs,
    productImages: [
      mugs, mummymug, daddymug
    ],
    variants: [
    {
      title: 'Mug Design',
      options: [
        {
          name: 'Mummy Mug',
        },
        {
          name: 'Daddy Mug',
        },
        {
          name: 'Mummy & Daddy Mugs',
          increment: 4.01
        },
        {
          name: 'Mummy & Mummy Mugs',
          increment: 4.01
        },
        {
          name: 'Daddy & Daddy Mugs',
          increment: 4.01
        }
      ]
    },
    ]
  },
  {
    id: "cuttlery-set",
    description:
    <>This lovely 3pc set is designed for little hands to help them learn and grow. Each item boasts an embossed design on the handle. The size and shape are designed to encourage independant eating. 
    <br /><br />The knife is blunt edged and all items are dishwasher safe.
    <br /><br />
    <ul>
      <li>Materials: Stainless Steel</li>
      <li>Approx Size: Length 17cm per item</li></ul></>,
    categories: ["baby-accessories"],
    name: "Baby's First 3pc Cutlery Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 2.99,
    img: cuttlery,
    productImages: [
      cuttlery
    ],
  },
  {
    id: "wishstrings",
    description:
    <>These Wishstrings bracelets are hand crafted in the UK. 
    <br />Each bracelet features a charm, and comes on a printed card with a message, choose from our mummy, daddy & baby options. 
    <br /><br />These make perfect gifts for new parents, baby showers.  They slip nicely in with a card, in our postal gift boxes or as an addition to any hamper. 
    <br /><br />Little Wish for Daddy - Sold Out
    <ul>
      <li>No Size</li></ul></>,
    categories: ["baby-accessories"],
    name: "Wishstring Bracelet",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 3.99,
    img: wishstring,
    productImages: [
      wishstring
    ],
    variants: [
    {
      title: 'Wishstring',
      options: [
        // {
        //   name: 'A Little Wish For a New Mum',
        // },
        {
          name: 'Mums are like Buttons,',
        },
        {
          name: 'With Love From The Bump',
        },
        // {
        //   name: 'A Little Wish For My Daddy',
        // },
        {
          name: 'Thanks For Coming To My Baby Shower'
        },
        {
          name: 'Congrats'
        },
        {
          name: 'Wonderful Mummy'
        }
      ]
    },
    ]
  },
  {
    id: "toowordycards",
    description:
    <>These lovely cards are the perfect addition to any gift. 
    <br />A great way to celebrate pregnancy announcements or the arrival of tiny fingers & toes. These can be bought alone or added to any Hamper. 
    <br /><br />If you are sending the gift straight to the recipient, we can hand write your gift message for you, just complete the gift message section! 
    <br /><br />Cards produced by @TooWordy 
    <br /><br />
    <ul>
      <li>Luxuriously textured FSC Certified Card</li>
      <li>A6 (105x148mm)</li></ul></>,
    categories: ["baby-accessories"],
    name: "TooWordy Gift Card",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 3.50,
    img: alltoowordy,
    productImages: [
      alltoowordy, babyboybanner, bluetiny, bluewelcomebanner, brandlittledude, brandnewlittlelady, bundleofjoy, buninoven, lovelyhappynews, newchapter, pinktiny, pinkwelcome, preciousdaughter 

    ],
    variants: [
    {
      title: 'TooWordy Card Choice',
      options: [
        {
          name: 'A New Chapter',
        },
        {
          name: 'Pink - Hello Tiny Toes',
        },
        {
          name: 'Blue - Hello Tiny Toes',
        },
        {
          name: 'Bun in the Oven',
        },
        {
          name: 'Lovely Happy News'
        },
        // {
        //   name: 'Baby Boy'
        // },
        {
          name: 'Brand New Little Dude'
        },
        // {
        //   name: 'A Precious Little Daughter'
        // },
        {
          name: 'Brand New Little Lady'
        },
        {
          name: 'Bundle of Joy'
        },
        {
          name: 'Welcome to the World - Blue'
        },
        {
          name: 'Welcome to the World - Pink'
        }
      ]
    },
    ]
  },
  // {
  //   id: "sheep-blanket",
  //   description:
  //     <>Our bestselling blanket, this adorable supersof t fleece blanket comes in a neutral grey colour and features a sheep design throughout. 
  //     <br /><br />Matching items available in our comforter and clothing ranges. 
  //     <br /><br />
  //     <ul>
  //     <li>Materials: 100% Polyester</li>
  //       <li>Size: 75cmx90cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Sheep Blanket",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: sheepblanket,
  //   productImages: [
  //     sheepblanket
  //   ],
  // },  
  {
    id: "cellular",
    description:
      <>Cellular blankets are a must have essential for any new baby. The subtle holes throughtout the fabric make it a breathable and safer option for baby to sleep in. 
      <br /><br />These blankets can also act as a cooler option in the warmer months!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 70cmx90cm</li>
      </ul></>,
      categories: ["blankets"],
    name: "Cellular Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: allcellular,
    productImages: [
      allcellular, whitecellular, greycellular, pinkcellular, bluecellular
    ],
    variants: [
      {
        title: 'Cellular Colour',
        options: [
          {
            name: 'White Cellular'
          },
          {
            name: 'Grey Cellular'
          },
          {
            name: 'Pink Cellular'
          },
          {
            name: 'Blue Cellular'
          }
        ]
      },
    ]
  },
  {
    id: "coffee-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Coffee Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: coffeewaffle,
    productImages: [
      coffeewaffle, whitewaffle, lemonwaffle, rosewaffle, mustardwaffle, pinkwaffle, bluewaffle, greywaffle, redwaffle
    ],
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },  
  {
    id: "zebra-blanket",
    description:
      <>This adorable supersoft fleece blanket comes in a neutral grey colour and features a Zebra print applique. 
      <br /><br />Matching items available in our comforter and clothing ranges. 
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Size: 75cmx90cm</li></ul></>,
    categories: ["blankets"],
    name: "Zebra Print Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: zebrablanket,
    productImages: [
      zebrablanket
    ],
  },  
  {
    id: "white-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets", "spring-summer"],
    name: "White Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: whitewaffle,
    productImages: [
       whitewaffle, lemonwaffle, rosewaffle, coffeewaffle, mustardwaffle, pinkwaffle, bluewaffle, greywaffle, redwaffle
    ],
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },
  {
    id: "dinosaur-blanket",
    description:
      <>Dinosaurs are always really popular for us and this blanket doesn't disappoint! 
      <br />The navy design features a green and turquoise design throughout and matches back to many of our other items.
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Size: 75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Dinosaur Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: dinosaurblanket,
    productImages: [
      dinosaurblanket
    ],
  },  
  // {
  //   id: "organic-design-blanket",
  //   description:
  //     <>Part of our Organic Cotton range, these swaddle blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
  //     <br /><br />The organic cotton is breathable making it perfect for the warmer months.
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Organic Cotton</li>
  //       <li>Size: 120cmx85cm</li>
  //       <br /> Zoo Design - Sold Out
  //       </ul></>,
  //   categories: ["blankets"],
  //   name: "Animal Organic Muslin Blanket",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: organicanimalsmain,
  //   productImages: [
  //     organicanimalsmain, organicpanda, organiczoo
  //   ],
  //   variants: [
  //     {
  //       title: 'Swaddle Design',
  //       options: [
  //         // {
  //         //   name: 'Zoo'
  //         // },
  //         {
  //           name: 'Panda'
  //         }
  //       ]
  //     },
  //   ]
  // },  
  {
    id: "leopard-organic-design-blanket",
    description:
      <>Part of our Organic Cotton range, these printed blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
      <br /><br />The organic cotton is breathable making it perfect for the warmer months.
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        <li>120x120cms</li>
        </ul></>,
    categories: ["blankets"],
    name: "Leopard Print Organic Cotton Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: leopardorganicmuslin,
    productImages: [
      leopardorganicmuslin
    ],
  },   
  // {
  //   id: "orange-leaf-organic-design-blanket",
  //   description:
  //     <>Part of our Organic Cotton range, these printed blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
  //     <br /><br />The organic cotton is breathable making it perfect for the warmer months.
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 70% Bamboo 30% Organic Cotton</li>
  //       <li>120x120cms</li>
  //       </ul></>,
  //   categories: ["blankets"],
  //   name: "Orange Leaf Organic Cotton Blanket",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: orangeleaforganicmuslin,
  //   productImages: [
  //     orangeleaforganicmuslin
  //   ],
  // },   
  {
    id: "floral-mink",
    description:
      <>This luxury blanket is a great show stopper. 
      <br /><br />Match with our cardigans or knitted hats & mittens to make a great set!
      <br /><br />
      <ul>
        <li>Materials: Floral Material: Mink, Backing Material: Sherpa Fleece</li>
        <li>Size: 75cmx100cm</li>
      </ul></>,
      categories: ["blankets"],
    name: "Floral Mink Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: floralminkblanket,
    productImages: [
      floralminkblanket
    ],
  },
  {
    id: "elephant-star-blanket",
    description:
      <>This adorable supersfot fleece blanket comes in a neutral grey colour and features an elephant and star design throughout. 
     <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Blanket Size: 75cmx90cm</li></ul></>,
    categories: ["blankets"],
    name: "Elephant & Star Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: elephantstarblanket,
    productImages: [
      elephantstarblanket
    ],
  },  
  {
    id: "giraffe-print-blanket",
    description:
      <>This adorable supersoft fleece blanket comes in a neutral grey colour and features a giraffe print design throughout. 
      <br /><br />Matching items available in our comforter and clothing ranges. 
      <br /><br />
      <ul>
        <li>Materials: Soft Flannel</li>
        <li>size 75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Giraffe Print Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: giraffeprintblanket,
    productImages: [
      giraffeprintblanket
    ],
  },  
  {
    id: "lemon-affle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets", "spring-summer"],
    name: "Lemon Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: lemonwaffle,
    productImages: [
      lemonwaffle, whitewaffle, rosewaffle, coffeewaffle, mustardwaffle, pinkwaffle, bluewaffle, greywaffle, redwaffle
    ],
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },
  {
    id: "rose-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Rose Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: rosewaffle,
    productImages: [
      rosewaffle, whitewaffle, lemonwaffle, coffeewaffle, mustardwaffle, pinkwaffle, bluewaffle, greywaffle, redwaffle
    ],
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },
  {
    id: "mustard-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Mustard Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: mustardwaffle,
    productImages: [
      mustardwaffle, whitewaffle, lemonwaffle, rosewaffle, coffeewaffle, pinkwaffle, bluewaffle, greywaffle, redwaffle
    ],
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },
  {
    id: "pink-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Pink Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: pinkwaffle,
    productImages: [
      pinkwaffle, whitewaffle, lemonwaffle, rosewaffle, coffeewaffle, mustardwaffle, bluewaffle, greywaffle, redwaffle
    ], 
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },
  {
    id: "blue-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Blue Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: bluewaffle,
    productImages: [
      bluewaffle, whitewaffle, lemonwaffle, rosewaffle, coffeewaffle, mustardwaffle, pinkwaffle, greywaffle, redwaffle
    ], 
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },
  {
    id: "grey-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Grey Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: greywaffle,
    productImages: [
      greywaffle, whitewaffle, lemonwaffle, rosewaffle, coffeewaffle, mustardwaffle, pinkwaffle, bluewaffle, redwaffle
    ], 
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },
  {
    id: "red-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby. Great for out in the pram, tucked up in the car or just for cuddles in your arms. 
      <br /><br /> Comes in a variety of colours to match back with our clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Red Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: redwaffle,
    productImages: [
      redwaffle, whitewaffle, lemonwaffle, rosewaffle, coffeewaffle, mustardwaffle, pinkwaffle, bluewaffle, greywaffle
    ], 
    variants: [
      {
        title: 'Waffle Blanket Colour',
        options: [
          {
            name: 'White'
          },
          {
            name: 'Grey'
          },
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          },
          {
            name: 'Lemon'
          },
          {
            name: 'Mustard'
          },
          {
            name: 'Rose'
          },
          {
            name: 'Red'
          }
        ]
      },
    ]
  },
  {
    id: "knitted-navy",
    description:
      <>This luxury blanket is a great show stopper. Its heavy cable knit makes it great for keeping baby warm, and the pom pom details are a lovely extra touch. 
      <br /><br />Match with our cardigans or knitted hats & mittens to make a great set!
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        {/* <li>Size: 75cmx90cm</li> */}
      </ul></>,
      categories: ["blankets"],
    name: "Knitted Cable Pom Pom Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: navyknittedblanket,
    productImages: [
      navyknittedblanket
    ],
  },
  // {
  //   id: "knitted-sage",
  //   description:
  //     <>This luxury blanket is a great show stopper. Its heavy cable knit makes it great for keeping baby warm, and the pom pom details are a lovely extra touch. 
  //     <br /><br />Match with our cardigans or knitted hats & mittens to make a great set!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Acrylic</li>
  //       <li>Size: 70cmx100cm</li>
  //     </ul></>,
  //     categories: ["blankets"],
  //   name: "Sage Knitted Cable Pom Pom Blanket",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: sageknittedblanket,
  //   productImages: [
  //     sageknittedblanket
  //   ],
  // },
  // {
  //   id: "elephant-blanket",
  //   description:
  //     <>This adorable supersfot fleece blanket comes in a neutral grey colour and features an elephant design throughout. 
  //     <br /><br />Matching items available in our comforter and clothing ranges. 
  //     <br /><br />
  //     <ul>
  //     <li>Materials: 100% Polyester</li>
  //       <li>Size: 75cmx100cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Elephant Blanket",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: elephantblanket,
  //   productImages: [
  //     elephantblanket
  //   ],
  // },
  // {
  //   id: "star-blanket",
  //   description:
  //     <>Twinkle Twinkle little star! 
  //     <br />This super cute blanket comes in grey with a white star print throughout. 
  //     <br /><br />Either individually or bought with matching items, this is a perfect gift. 
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Polyester</li>
  //       <li>Size: 75cmx100cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Star Blanket",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: starblanket,
  //   productImages: [
  //     starblanket
  //   ],
  // },
  {
    id: "navy-star-blanket",
    description:
      <>Treat that little person with this Blue Star blanket.
      <br /><br />
      <ul>
        <li></li>
        <li></li></ul></>,
    categories: ["blankets"],
    name: "Navy Star Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: bluestarblanket,
    productImages: [
      bluestarblanket
    ],
  },
  {
    id: "rainbow-blanket",
    description:
      <>Rainbows are always really popular for babies, and this white fleece blanket features pink rainbows throughout. 
      <br /><br />Matching items available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Size: 75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Rainbow Print Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: rainbowblanket,
    productImages: [
      rainbowblanket
    ],
  },
  {
    id: "organic-swaddle-blanket",
    description:
      <>Part of our Organic Cotton range, these swaddle blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
      <br /><br />The organic cotton is breathable making it perfect for the warmer months.
      <br /><br />
      <ul>
        <li>Materials: 100% Organic Cotton</li>
        <li>Size: 120cmx120cm</li>
        <br />Dandelion & White Geo - Sold Out
        </ul></>,
    categories: ["blankets"],
    name: "Organic Swaddle Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: organicorangegeometric,
    productImages: [
      organicorangegeometric, allorganicblankets, organicdandelion, organicwhitegeometric
    ],
    variants: [
      {
        title: 'Swaddle Design & Colour',
        options: [
          // {
          //   name: 'Cream Dandelion Wish'
          // },
          {
            name: 'Orange Geometric'
          },
          // {
          //   name: 'White Geometric'
          // }
        ]
      },
    ]
  },
  {
    id: "spot-organic-design-blanket",
    description:
      <>Part of our Organic Cotton range, these printed blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
      <br /><br />The organic cotton is breathable making it perfect for the warmer months.
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        </ul></>,
    categories: ["blankets"],
    name: "Spot Organic Cotton Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: spotorganicmuslin,
    productImages: [
      spotorganicmuslin
    ],
  },  
  {
    id: "swirl-organic-design-blanket",
    description:
      <>Part of our Organic Cotton range, these printed blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
      <br /><br />The organic cotton is breathable making it perfect for the warmer months.
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        <li>120x120cms</li>
        </ul></>,
    categories: ["blankets"],
    name: "Swirl Organic Cotton Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: swirlorganicmuslin,
    productImages: [
      swirlorganicmuslin
    ],
  },  
  {
    id: "leaf-organic-design-blanket",
    description:
      <>Part of our Organic Cotton range, these printed blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
      <br /><br />The organic cotton is breathable making it perfect for the warmer months.
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        <li>120x120cms</li>
        </ul></>,
    categories: ["blankets"],
    name: "Leaf Organic Cotton Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: leaforganicmuslin,
    productImages: [
      leaforganicmuslin
    ],
  },  
  {
    id: "flower-organic-design-blanket",
    description:
      <>Part of our Organic Cotton range, these printed blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
      <br /><br />The organic cotton is breathable making it perfect for the warmer months.
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        <li>120x120cms</li>
        </ul></>,
    categories: ["blankets"],
    name: "Flower Organic Cotton Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: flowerorganicmuslin,
    productImages: [
      flowerorganicmuslin
    ],
  },   
  {
    id: "elephant-organic-design-blanket",
    description:
      <>Part of our Organic Cotton range, these printed blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
      <br /><br />The organic cotton is breathable making it perfect for the warmer months.
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        <li>120x120cms</li>
        </ul></>,
    categories: ["blankets"],
    name: "Elephant Organic Cotton Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: elephantorganicmuslin,
    productImages: [
      elephantorganicmuslin
    ],
  },   
  {
    id: "sea-animals-organic-design-blanket",
    description:
      <>Part of our Organic Cotton range, these printed blankets are extra large allowing them to be multi purpose. They can be used to swaddle baby, cover up when feeding for those who prefer to, play mats when out and about or just to wrap up baby to keep them warm. 
      <br /><br />The organic cotton is breathable making it perfect for the warmer months.
      <br /><br />
      <ul>
        <li>Materials: 70% Bamboo 30% Organic Cotton</li>
        <li>120x120cms</li>
        </ul></>,
    categories: ["blankets"],
    name: "Sea Animals Organic Cotton Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: seaanimalsorganicmuslin,
    productImages: [
      seaanimalsorganicmuslin
    ],
  },  
  // {
  //   id: "unicorn-comforter-blanket",
  //   description:
  //     <>This white unicorn comforter features a silver star print and comes with a matching soft fleece blanket. 
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Polyester</li>
  //       <li>Blanket Size: 75cmx90cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Unicorn Comforter Blanket Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: unicorncomfblanket,
  //   productImages: [
  //     unicorncomfblanket,
  //   ],
  // },
  // {
  //   id: "elephant-comforter-blanket",
  //   description:
  //     <>This cute elephant comforter features a moon, star & cloud print and comes with a matching soft fleece blanket.
  //    <br /><br />
  //     <ul>
  //       <li>Materials: 100% Polyester</li>
  //       <li>Blanket Size: 75cmx90cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Elephant Comforter & Blanket Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: elephantcomfblanket,
  //   productImages: [
  //     elephantcomfblanket, 
  //   ],
  // },
  // {
  //   id: "giraffe-comforter-blanket",
  //   description:
  //     <>This gorgeous comforter features a pint heart print and comes with a matching soft fleece blanket.
  //    <br /><br />
  //     <ul>
  //       <li>Materials: 100% Polyester</li>
  //       <li>Blanket Size: 75cmx90cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Giraffe Comforter & Blanket Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: cosypgiraffe1,
  //   productImages: [
  //     cosypgiraffe1
  //   ],
  // },
  {
    id: "monkey-comforter-blanket",
    description:
      <>This cheeky comforter features a blue moon & star print and comes with a matching soft fleece blanket.
     <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Blanket Size: 75cmx90cm</li></ul></>,
    categories: ["blankets"],
    name: "Monkey Comforter & Blanket Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: cosybmonkey1,
    productImages: [
      cosybmonkey1
    ],
  }, 
  // {
  //   id: "sheep-comforter-blanket",
  //   description:
  //     <>This cute sheep comforter features a star print and comes with a matching soft fleece blanket.
  //    <br /><br />
  //     <ul>
  //       <li>Materials: 100% Polyester</li>
  //       <li>Blanket Size: 75cmx90cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Sheep Comforter & Blanket Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: cosygsheep1,
  //   productImages: [
  //     cosygsheep1
  //   ],
  // },
  // {
  //   id: "lamb-comforter-blanket",
  //   description:
  //     <>This lovely lamb comforter features a smudged spot print and comes with a matching soft fleece blanket.
  //    <br /><br />
  //     <ul>
  //       <li>Materials: 100% Polyester</li>
  //       <li>Blanket Size: 75cmx90cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Lamb Comforter & Blanket Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: cosyclamb1,
  //   productImages: [
  //     cosyclamb1
  //   ],
  // }, 
  // {
  //   id: "rabbit-comforter-blanket",
  //   description:
  //     <>This lovely rabbit comforter features a pink flower and grey spot design and comes with a matching soft fleece blanket.
  //    <br /><br />
  //     <ul>
  //       <li>Materials: 100% Polyester</li>
  //       <li>Blanket Size: 75cmx90cm</li></ul></>,
  //   categories: ["blankets"],
  //   name: "Rabbit Comforter & Blanket Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 14.99,
  //   img: rabbitblanketcomf,
  //   productImages: [
  //     rabbitblanketcomf
  //   ],
  // },      
  {
    id: "elephat-wrap-blanket",
    description:
      <>This blanket comes in grey and features a 3D elephant head design. Great for baby to play with if you need a distraction. 
      <br /><br />Elephants are super popular, lots of matching items available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Size: 76cmx76cm</li></ul></>,
    categories: ["blankets"],
    name: "3D Elephant Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: elephantwrap,
    productImages: [
      elephantwrap
    ],
  },
  {
    id: "owl-wrap-blanket",
    description:
      <>This blanket comes in white and has a cute hood with an owl design. Great for wrapping baby up head to toe. The supersoft material also has a waffle design for added texture.
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Size: 75cmx100cm</li></ul></>,
    categories: ["blankets"],
    name: "Hooded Owl Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: owlwrap,
    productImages: [
      owlwrap
    ],
  },
  {
    id: "blue-knitted-teddy-hamper",
    description:
    <>Part of our Winter Warmers Collection, this gift set is super sweet! This set has a blue teddy theme with the perfect items to keep baby wrapped up warm. Features a five piece knitted set with a blue teddy design. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
    <br /><br />Gift Hamper includes:
    <br /><br /><ul>
      <li>Supersoft Waffle Fleece Blanket(100% Polyester Fleece)</li>
      <li>Teddy Knitted Jumper & Pant Set (50% Cotton, 50% Acrylic Sizes: Newborn, 0-3 or 3-6 Months)</li>
      <li>Knitted Hat & Mittens (50% Cotton, 50% Acrylic)</li>
      <li>Optional Comforter (Various Materials)</li>
      <li>Optional Pom Pom Hat & Matching Mittens (100% Cotton)</li>
</ul>
    <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
        <br />
        <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
        <br />
        <br />Sizes Newborn & 3-6 Months - Sold Out
  </>,
    categories: ["Male", "winter-warmers"],
    name: "Blue Knitted Teddy Gift Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 22.99,
    img: knittedblueteddymain,
    productImages: [
      knittedblueteddymain, knittedblueteddy1, blueknittedbear, whitewaffle, greywaffle, bluewaffle, coffeewaffle, hats2, allbooties, allcomforters1, wishstring, alltoowordy
    ],
    variants: [
      {
        title: 'Clothing Size',
        options: [
          // {
          //   name: 'Newborn <1 available>'
          // },
          {
            name: '0-3 months <1 available>'
          },
          // {
          //   name: '3-6 months'
          // }
        ]
      },
      {
        title: 'Blanket Colour',
        options: [
          {
            name: 'Grey'
          },
          {
            name: 'White'
          },
          {
            name: 'Blue'
          },
          {
            name: 'Coffee'
          }
        ]
      },
      {
        title: 'Optional Hat & Mittens',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White',
            increment: 6.00
          },
          {
            name: 'Grey',
            increment: 6.00
          },
          {
            name: 'White & Grey Stripe',
            increment: 6.00
          },
          {
            name: 'Blue',
            increment: 6.00
          },          
          {
            name: 'Coffee',
            increment: 6.00
          },          
          {
            name: 'Sage',
            increment: 6.00
          },
          // {
          //   name: 'Mustard',
          //   increment: 6.00
          // }
        ]
      },
      {
        title: 'Optional Booties',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Booties',
            increment : 2.00
          },
          {
            name: 'Grey Booties',
            increment : 2.00
          },          
          {
            name: 'Blue Booties',
            increment : 2.00
          },
          {
            name: 'Navy Booties',
            increment : 2.00
          },
          {
            name: 'Coffee Booties',
            increment : 2.00
          }           
        ]
      },            
      {
        title: 'Optional Comforter',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'White Elephant',
            increment: 6.99
          },
          {
            name: 'Grey Elephant',
            increment: 6.99
          },
          {
            name: 'Grey Bunny',
            increment: 6.99
          },
          {
            name: 'Grey Penguin',
            increment: 6.99
          },          
          {
            name: 'White Dinosaur',
            increment: 6.99
          },          
          {
            name: 'Blue Dinosaur',
            increment: 6.99
          },          
          {
            name: 'Grey Giraffe',
            increment: 6.99
          },
          {
            name: 'Brown Bear',
            increment: 6.99
          },
          {
            name: 'Pink Bear',
            increment: 6.99
          }
        ]
      },
      {
        title: 'Wishstring Bracelet',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'From Bump',
            increment: 3.99
          },
          {
            name: 'For Daddy',
            increment: 3.99
          },
          {
            name: 'Congrats',
            increment: 3.99
          },
          {
            name: 'Coming Baby Shower',
            increment: 3.99
          },
          {
            name: 'Wonderful Mummy',
            increment: 3.99
          },
          // {
          //   name: 'For New Mum',
          //   increment: 3.99
          // },
          {
            name: 'Mums Buttons',
            increment: 3.99
          }
        ]
      },
      {
        title: 'Additional Giftcard',
        options: [
          {
            name: 'No Thanks'
          },
          {
            name: 'Pink Twinkle Toes',
            increment: 3.50
          },
          {
            name: 'Blue Twinkle Toes',
            increment: 3.50
          },
          // {
          //   name: 'Precious Daughter',
          //   increment: 3.50
          // },
          {
            name: 'Baby Boy Banner',
            increment: 3.50
          },
          {
            name: 'Little Lady',
            increment: 3.50
          },
          {
            name: 'Little Dude',
            increment: 3.50
          },
          {
            name: 'Lovely Happy News',
            increment: 3.50
          },
          {
            name: 'Bundle Of Joy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Boy',
            increment: 3.50
          },
          {
            name: 'Welcome Baby Girl',
            increment: 3.50
          },
          {
            name: 'New Chapter',
            increment: 3.50
          },
          {
            name: 'Bun In The Oven',
            increment: 3.50
          }
        ]
      },
    ]
  },    
  {
    id: "pink-cardigan",
    description:
      <>This lovely baby cardigan is perfect to keep baby warm out on their walks in the pram. With cute ears on the hood and bear shaped brown buttons on the front.
      <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6, 6-12 Months</li>
      <br /> Size 0-3 & 6-12 Months - Sold Out
        </ul></>,
    categories: ["winter-warmers", "clothing"],
    name: "Pink Double Knit Cardigan",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: pinkdoubleknit,
    productImages: [
      pinkdoubleknit
    ],
    variants: [
      {
        title: 'Cardigan Size',
        options: [
          // {
          //   name: '0-3 Months <1 available>'
          // },
          {
            name: '3-6 Months <1 available>'
          },
          // {
          //   name: '6-12 Months <1 available>'
          // }
        ]
      },
    ]
  }, 
  {
    id: "blue-velour-fox",
    description:
      <>Keep them cosy all year round with our cute & cosy velour onesies. This adorable fox velour onesie features three emboidered foxes across the front and has a cute peterpan collar.
      <br/><br/>Team up with our other items. Blankets, Booties & Comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3 or 3-6Months</li>
        <br />
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "new-arrivals"],
    name: "Fox Velour Onesie",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: bluevelourfox,
    productImages: [
      bluevelourfox, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },
  {
    id: "velour-ballet",
    description:
      <>Keep them cosy all year round with our cute & cosy velour onesies. This adorable velour onesie features three emboidered ballet shoes across the front and has a cute frill collar.
      <br/><br/>Team up with our other items. Blankets, Booties & Comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3 or 3-6 Months</li>
        <br />
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "new-arrivals"],
    name: "Ballet Velour Onesie",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: pinkvelourballet,
    productImages: [
      pinkvelourballet, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },    
  {
    id: "blue-velour-whale",
    description:
      <>Keep them cosy all year round with our cute & cosy velour onesies. This adorable velour onesie features three emboidered whales across the front and has a cute peterpan collar.
      <br/><br/>Team up with our other items. Blankets, Booties & Comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3 or 3-6 Months</li>
        <br />
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "new-arrivals"],
    name: "Whale Velour Onesie",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: bluevelourwhale,
    productImages: [
      bluevelourwhale, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },
  {
    id: "velour-frill",
    description:
      <>Keep them cosy all year round with our cute & cosy velour onesies. This adorable velour onesie features a white frill panel across the front and has a cute peterpan collar. Super cute frill sleeves too!
      <br/><br/>Team up with our other items. Blankets, Booties & Comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3, 3-6 or 6-9 Months</li>
        <br />
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "new-arrivals"],
    name: "Frill Velour Onesie",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: pinkvelourfrill,
    productImages: [
      pinkvelourfrill, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-9 Months <1 available>'
          }
        ]
      }
    ]
  },  
  {
    id: "knitted-cream-set",
    description:
      <>This knitted 2pc set with hat and gloves is perfect for keeping baby cosy.
      <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li></ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Cream Knitted Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: knittedwhite,
    productImages: [
      knittedwhite,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: 'Newborn'
          },
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          }
        ]
      },
    ]
  },       
  {
    id: "grey-cable-knit-cardigan",
    description:
      <>This lovely baby cardigan is perfect to keep baby warm out on their first walks in the pram. 
      <br /><br />Match perfectly with booties, hats & mittens or with any of our onesie sets.
      <br />
      <ul>
        <li>Materials: 100% Acrylic</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
        <br />Size 0-3 & 6-9 Months - Sold Out        
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Grey Cable Knit Cardigan",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: greyknitcardi,
    productImages: [
      greyknitcardi,
    ],
    variants: [
      {
        title: 'Cardigan Colour',
        options: [
          // {
          //   name: 'Navy'
          // },
          {
            name: 'Grey'
          },
        ]
      },
      {
        title: 'Cardigan Size',
        options: [
          // {
          //   name: '0-3 Months'
          // },
          {
            name: '3-6 Months <1 available>'
          },
          // {
          //   name: '6-9 Months <1 available>'
          // }
        ]
      },
    ]
  },
  {
    id: "navy-cable-knit-cardigan",
    description:
      <>This lovely baby cardigan is perfect to keep baby warm out on their first walks in the pram. 
      <br /><br />Match perfectly with booties, hats & mittens or with any of our onesie sets.
      <br />
      <ul>
        <li>Materials: 100% Acrylic</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
        <br />Size 3-6 Months - Sold Out        
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Navy Cable Knit Cardigan",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: navyknitcardi,
    productImages: [
      navyknitcardi
    ],
    variants: [
      {
        title: 'Cardigan Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          // {
          //   name: '3-6 Months'
          // },
          {
            name: '6-9 Months <2 available>'
          }
        ]
      },
    ]
  },
  // {
  //   id: "pink-cardigan-detailled-back",
  //   description:
  //     <>This lovely baby cardigan is perfect to keep baby warm out on their first walks in the pram. With cute back detail for that added extra.
  //     <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
  //     <br /> 
  //     <ul>
  //       <li>Materials: 100% Acrylic</li>
  //       <li>Size: Newborn, 0-3, 3-6 and 6-12 Months</li>
  //       <br /> Sizes Newborn, 0-3 & 3-6 Months - Sold Out        
  //       </ul></>,
  //   categories: ["clothing", "winter-warmers"],
  //   name: "Pink Cardigan with Detailed Back",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 8.99,
  //   img: pinkcardifancy1,
  //   productImages: [
  //     pinkcardifancy1, pinkcardifancy2
  //   ],
  //   variants: [
  //     {
  //       title: 'Cardigan Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         {
  //           name: '6-12 Months <1 available>'
  //         }
  //       ]
  //     },
  //   ]
  // },
  {
    id: "white-knit-cardigan",
    description:
      <>This lovely baby cardigan is perfect to keep baby warm out on their first walks in the pram. 
      <br/><br/>Match perfectly with booties, hats & mittens or with any of our onesie sets.
      <br />
      <ul>
        <li>Materials: 100% Acrylic</li>
        <li>Size:0-3, 3-6, 6-9 Months</li>
        <br /> Size 0-3, 3-6 Months - Sold Out        
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "White Knitted Cardigan",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: whiteknitcardi,
    productImages: [
      whiteknitcardi,
    ],
    variants: [
      {
        title: 'Cardigan Size',
        options: [
          // {
          //   name: '0-3 Months <2 available>'
          // },
          // {
          //   name: '3-6 Months'
          // },
          {
            name: '6-9 Months <2 available>'
          }
        ]
      },
    ]
  },
  {
    id: "chick-onesie",
    description:
      <>This adorable lemon clothing set with chick embroidery on multiple items, which we just adore. Part of our new sping collection. This set contains a onesie, vest, jacket, joggers, bib, hat & scratch mitts.
      <br/><br/>Team up with our Blankets, Booties & Accessories to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3, 3-6 Months</li>
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "spring-summer"],
    name: "Chick 7pc Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 18.99,
    img: lemonchickonesie,
    productImages: [
      lemonchickonesie, lemonchickonesie2, lemonchickonesie3, lemonchickonesie4 
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months <3 available>'
          },
          {
            name: '3-6 Months <3 available>'
          },
        ]
      }
    ]
  },
  {
    id: "star-duck-onesie",
    description:
      <>This adorable onesie set with embroidered duck detailing. Part of our new sping collection.
      <br/><br/>Team up with our Blankets, Booties & Accessories to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 80% Cotton, 20% Polyester</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
      </ul>
      </>,
    categories: ["onesie-sets", "clothing", "spring-summer"],
    name: "Star Duck Onesie",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: starduckonesie,
    productImages: [
      starduckonesie, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-9 Months <1 available>'
          }
        ]
      }
    ]
  },  
  // {
  //   id: "knitted-heart-set",
  //   description:
  //     <>This knitted 4pc set is perfect for keeping baby cosy. This set contains a knitted jumper with a heart design, and matching pants. 
  //     <br/><br/> Team with up with some booties and a blanket to make the perfect cosy pram outfit. 
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3 or 3-6 Months</li>
  //       <br />Sizes Newborn & 0-3 Months - Sold Out
  //       </ul></>,
  //   categories: ["clothing", "winter-warmers"],
  //   name: "Knitted Heart Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: knittedheart,
  //   productImages: [
  //     knittedheart,
  //   ],
  //   variants: [
  //     {
  //       title: 'Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         {
  //           name: '3-6 Months <1 available>'
  //         }
  //       ]
  //     },
  //   ]
  // },
  {
    id: "blue-tropical-romper",
    description:
      <>We just love these gorgeous outfits! Perfect for warmer weather, this outfit will look super cute on any baby. This set contains a blue tropical print romper and matching bow. 
      <br/><br/>Team up with our organic cotton blankets , teething rings or other accessories to make the perfect hamper.
      <br/><br/>Also Available in Peach
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:3-6, 6-9 & 9-12 Months</li>
      <br />
        </ul></>,
    categories: ["clothing", "spring-summer"],
    name: "Blue Tropical Romper",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: bluetropicalromper,
    productImages: [
      bluetropicalromper, peachtropicalromper
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-9 Months <1 available>'
          },
          {
            name: '9-12 Months <1 available>'
          }
        ]
      },
    ]
  },
  {
    id: "peach-tropical-romper",
    description:
      <>We just love these gorgeous outfits! Perfect for warmer weather, this outfit will look super cute on any baby. This set contains a peach tropical print romper and matching bow. 
      <br/><br/>Team up with our organic cotton blankets , teething rings or other accessories to make the perfect hamper.
      <br/><br/>Also Available in Blue 
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:3-6, 6-9 & 9-12 Months</li>
      <br />
        </ul></>,
    categories: ["clothing", "new-arrivals", "spring-summer"],
    name: "Peach Tropical Romper",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: peachtropicalromper,
    productImages: [
      peachtropicalromper, bluetropicalromper
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '3-6 Months <1 avaiable>'
          },
          {
            name: '6-9 Months <1 available>'
          },
          {
            name: '9-12 Months <1 available>'
          }
        ]
      },
    ]
  },
  {
    id: "floral-playsuit",
    description:
      <>We just love these playsuits, perfect for warmer weather. Cool jersey material with a cute elasticated waist, the essential for any summers day. 
      <br/><br/>If you love this, check our the rest of our Spring / Summer Collection!
      <br/><br/>Also Available in Sage.
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:3-6, 6-12, 12-18 & 18-24 Months</li>
      <br />
        </ul></>,
    categories: ["clothing", "new-arrivals","spring-summer"],
    name: "Floral Playsuit",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: floralplaysuit,
    productImages: [
      floralplaysuit, sageplaysuit
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-12 Months <1 available>'
          },
          {
            name: '12-18 Months <1 available>'
          },
          {
            name: '18-24 Months <1 available>'
          }
        ]
      },
    ]
  },  
  {
    id: "sage-playsuit",
    description:
      <>We just love these playsuits, perfect for warmer weather. Cool jersey material with a cute elasticated waist, the essential for any summers day. 
      <br/><br/>If you love this, check our the rest of our Spring / Summer Collection!
      <br/><br/>Also Available in Floral Print.
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:3-6, 6-12, 12-18 & 18-24 Months</li>
      <br />
        </ul></>,
    categories: ["clothing", "new-arrivals","spring-summer"],
    name: "Sage Playsuit",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: sageplaysuit,
    productImages: [
      sageplaysuit, floralplaysuit
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-12 Months <1 available>'
          },
          {
            name: '12-18 Months <1 available>'
          },
          {
            name: '18-24 Months <1 available>'
          }
        ]
      },
    ]
  },               
  {
    id: "pink-muslin-set",
    description:
      <>We just love these gorgeous outfits! Perfect for warmer weather, these outfits are made from muslin fabric with is naturally cooler for baby. This set contains a T-Shirt, shorts and matching headband. 
      <br/><br/>Team up with our organic cotton blankets , teething rings or other accessories to make the perfect hamper.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:0-3, 3-6, 6-12 Months</li></ul></>,
    categories: ["clothing", "spring-summer"],
    name: "Pink Muslin Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: pinkmuslinsetmain,
    productImages: [
      pinkmuslinsetmain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-12 Months'
          }
        ]
      },
    ]
  },
  {
    id: "pink-muslin-romper",
    description:
      <>We just love these gorgeous outfits! Perfect for warmer weather, these outfits are made from muslin fabric with is naturally cooler for baby. This set contains a romper and matching headband. 
      <br/><br/>Team up with our organic cotton blankets , teething rings or other accessories to make the perfect hamper.
      <br/><br/>
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:0-3, 3-6, 6-12 Months</li>
      <br /> Sizes 0-3 & 6-12 Months - Sold Out
        </ul></>,
    categories: ["clothing", "spring-summer"],
    name: "Pink Muslin Romper",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: pinkmuslinrompermain,
    productImages: [
      pinkmuslinrompermain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          // {
          //   name: '0-3 Months'
          // },
          {
            name: '3-6 Months'
          },
          // {
          //   name: '6-12 Months'
          // }
        ]
      },
    ]
  },
  {
    id: "blue-muslin-romper",
    description:
      <>We just love these gorgeous outfits! Perfect for warmer weather, these outfits are made from muslin fabric with is naturally cooler for baby. This set contains a romper and matching hat. 
      <br/><br/>Team up with our organic cotton blankets , teething rings or other accessories to make the perfect hamper.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:0-3, 3-6, 6-12 Months</li></ul></>,
    categories: ["clothing", "spring-summer"],
    name: "Blue Muslin Romper",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: bluemuslinrompermain,
    productImages: [
      bluemuslinrompermain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months'
          },
          {
            name: '3-6 Months'
          },
          {
            name: '6-12 Months'
          }
        ]
      },
    ]
  },
  {
    id: "blue-muslin-dungarees",
    description:
      <>We just love these gorgeous outfits! Perfect for warmer weather, these outfits are made from muslin fabric with is naturally cooler for baby. This set contains a dungarees and matching headband. 
      <br/><br/>Team up with our organic cotton blankets , teething rings or other accessories to make the perfect hamper.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:0-3, 3-6, 6-12 Months</li></ul>
        <br /> Size 3-6 Months - Sold Out
      <br />
        </>,
    categories: ["clothing", "spring-summer"],
    name: "Blue Muslin Dungarees",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 14.99,
    img: bluemuslindungareesmain,
    productImages: [
      bluemuslindungareesmain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months'
          },
          // {
          //   name: '3-6 Months'
          // },
          {
            name: '6-12 Months'
          }
        ]
      },
    ]
  },
  {
    id: "animals-4pc-set",
    description:
      <>These 4pc clothing sets make great gifts for a little person, containing fun outfits and accessories. This set contains a T-Shirt, jog pants, bib and matching socks, all with a safari animal theme. 
      <br/><br/> With plenty of other sarafi options available, why not make a nice themed hamper?
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:0-3 or 3-6 Months</li></ul></>,
    categories: ["clothing", "spring-summer"],
    name: "4pc Animal Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fourpcanimalmain,
    productImages: [
      fourpcanimalmain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <2 available>'
          }
        ]
      },
    ]
  },
  {
    id: "dinosaur-4pc-set",
    description:
      <>These 4pc clothing sets make great gifts for a little person, containing fun outfits and accessories. This set contains a T-Shirt, jog pants, bib and matching socks, all with a dinosaur theme. 
      <br/><br/> With plenty of other dinosaur options available, why not make a nice themed hamper?
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:0-3 or 3-6 Months</li></ul></>,
    categories: ["clothing", "spring-summer"],
    name: "4pc Dinosaur Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fourpcdinosaurmain,
    productImages: [
      fourpcdinosaurmain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months <2 available>'
          },
          {
            name: '3-6 Months <2 available>'
          }
        ]
      },
    ]
  }, 
  {
    id: "rainbow-4pc-set",
    description:
      <>These 4pc clothing sets make great gifts for a little person, containing fun outfits and accessories. This set contains a T-Shirt, jog pants, hairband and matching socks, all with a rainbow theme. 
      <br/><br/> With plenty of other sarafi options available, why not make a nice themed hamper?
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:0-3 or 3-6 Months</li></ul></>,
    categories: ["clothing", "spring-summer"],
    name: "4pc Rainbow Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fourpcrainbowmain,
    productImages: [
      fourpcrainbowmain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months <2 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      },
    ]
  }, 
  {
    id: "bunny-4pc-set",
    description:
      <>These 4pc clothing sets make great gifts for a little person, containing fun outfits and accessories. This set contains a T-Shirt, jog pants, bib and matching socks, all with a rabbit theme. 
      <br/><br/> With plenty of other rabbit options available, why not make a nice themed hamper?
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:0-3 or 3-6 Months</li></ul></>,
    categories: ["clothing", "spring-summer"],
    name: "4pc Bunny Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fourpcbunnymain,
    productImages: [
      fourpcbunnymain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-3 Months <1 available>'
          },
          {
            name: '3-6 Months <2 available>'
          }
        ]
      },
    ]
  },
  {
    id: "check-clothing-set",
    description:
      <>This beige and check print neutral clothing set makes a great gift. The set contains a beige quilted jacket, check pants with footsies, a beige vest with quote "tiny little love", a check bib , check mittens and a fleece lined pom pom hat. 
      <br/><br/> Great as a stand alone gift, or add in a blanket to make this a great little hamper. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size:Newborn, 0-3 or 3-6 Months</li>
        <br /> Sizes Newborn & 3-6 Months - Sold Out
        </ul></>,
    categories: ["clothing", "winter-warmers"],
    name: "Check Clothing Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: checksetmain,
    productImages: [
      checksetmain,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          // {
          //   name: 'Newborn'
          // },
          {
            name: '0-3 Months <3 available>'
          },
          // {
          //   name: '3-6 Months'
          // }
        ]
      },
    ]
  },
//   {  
//   id: "pink-rabbit-clothing-set",
//   description:
//     <>This bright pink floral clothing set is cute and fun! It contains a pink rabbit vest, floral pants with a matching floral hat and a pair of frilly socks. 
//     <br/><br/> Great as a stand alone gift, or teamed with with toys and a blanket for a great hamper.   
//     <br /><br />
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: 0-3, 3-6 or 6-12 Months</li></ul></>,
//   categories: ["clothing"],
//   name: "Pink Rabbit 4pc Clothing Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 12.99,
//   img: fourpcpinkfloralmain,
//   productImages: [
//     fourpcpinkfloralmain, fourpcpinkfloral1, fourpcpinkfloral2, fourpcpinkfloral3
//   ],
//   variants: [
//     {
//       title: 'Size',
//       options: [
//         {
//           name: '0-3 Months'
//         },
//         {
//           name: '3-6 Months'
//         },
//         {
//           name: '6-12 Months'
//         }
//       ]
//     },
//   ]
// },
// {  
//   id: "pink-floral-clothing-set",
//   description:
//     <>This bright pink floral clothing set is cute and fun! It contains 2 vests, one saying "love you a lot" and the other with a floral print and frill collar, pants with a flower on the bum, with a matching floral hat and headband. 
//     <br/><br/> Great as a stand alone gift, or teamed with with toys and a blanket for a great hamper.   
//     <br /><br />
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: Newborn, 0-3, 3-6 Months</li></ul></>,
//   categories: ["clothing"],
//   name: "Pink Floral 5pc Clothing Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 12.99,
//   img: pinkfloralbummain,
//   productImages: [
//     pinkfloralbummain, pinkfloralbum1, pinkfloralbum2, pinkfloralbum3
//   ],
//   variants: [
//     {
//       title: 'Size',
//       options: [
//         {
//           name: 'Newborn'
//         },
//         {
//           name: '0-3 Months'
//         },
//         {
//           name: '3-6 Months'
//         }
//       ]
//     },
//   ]
// },
// {  
//   id: "lemon-clothing-set",
//   description:
//     <>This sets contain a T-Shirt and jog pant, and make great day or night time sets. The T-Shirt is a gorgeous lemon colour and says "little day dreamer" and comes with and animal print pant. 
//     <br/><br/> Lots of matching items available to make this into a great neutral tone Hamper.   
//     <br /><br />
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: Newborn, 0-3, 3-6 Months</li>
//       <br /> Size 3-6 Months - Sold Out
//       </ul></>,
//   categories: ["clothing"],
//   name: "2pc Lemon Daydreamer Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 9.99,
//   img: lemondaydreamermain,
//   productImages: [
//     lemondaydreamermain,
//   ],
//   variants: [
//     {
//       title: 'Size',
//       options: [
//         {
//           name: 'Newborn'
//         },
//         {
//           name: '0-3 Months'
//         },
//         // {
//         //   name: '3-6 Months'
//         // }
//       ]
//     },
//   ]
// },
{  
  id: "organic-cotton-set-mint",
  description:
    <>This cute little 2pc set is part of our Eco Range, made from Organic Cotton. The set contains a T-Shirt and jog pant in a mint colour, and make a great day or night time set. 
    <br/><br/> Team up with our other organic cotton items for a great hamper selection.    
    <br /><br />Also available in Cream
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6 or 6-12 Months</li>
      <br /> Size 3-6 & 6-12 Months - Sold Out
      </ul></>,
  categories: ["clothing"],
  name: "2pc Mint Organic Cotton Set",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 9.99,
  img: organicmintmain,
  productImages: [
    organicmintmain, organicbeigemain
  ],
  variants: [
    {
      title: 'Colour',
      options: [
        {
          name: 'Mint'
        },
      ]
    },
    {
      title: 'Size',
      options: [
        {
          name: '0-3 Months'
        },
        // {
        //   name: '3-6 Months'
        // },
        // {
        //   name: '6-12 Months'
        // }
      ]
    }
  ]
},
{  
  id: "organic-cotton-set-cream",
  description:
    <>This cute little 2pc set is part of our Eco Range, made from Organic Cotton. The set contains a T-Shirt and jog pant in a Cream colour, and make a great day or night time set. 
    <br/><br/> Team up with our other organic cotton items for a great hamper selection.    
    <br /><br />Also available in Mint
    <br /><br />
    <ul>
      <li>Materials: 100% Cotton</li>
      <li>Size: 0-3, 3-6 or 6-12 Months</li>
      <br /> Size 3-6 Months - Sold Out
      </ul></>,
  categories: ["clothing"],
  name: "2pc Cream Organic Cotton Set",
  review: "productize virtual markets",
  deliveryCharge: deliveryCharges,
  price: 9.99,
  img: organicbeigemain,
  productImages: [
    organicbeigemain, organicmintmain
  ],
  variants: [
    {
      title: 'Colour',
      options: [
        {
          name: 'Cream'
        },
      ]
    },
    {
      title: 'Size',
      options: [
        {
          name: '0-3 Months'
        },
        // {
        //   name: '3-6 Months'
        // },
        {
          name: '6-12 Months'
        }
      ]
    }
  ]
},
// {  
//   id: "navy-stripe-set",
//   description:
//     <>This Navy & Stripe 2pc set is perfect for cosy walks. It contains a stripe jacket with button front and fleece pants with footies to keep baby's toes warm. 
//     <br/><br/> Team up with out blankets, hats and mittens for a super cosy hamper.    
//     <br /><br />
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: 0-3, 3-6 or 6-9 Months</li></ul></>,
//   categories: ["sale"],
//   name: "Navy Stripe Jacket & Trouser",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 12.99,
//   img: placeholder,
//   productImages: [
//     placeholder,
//   ],
//   variants: [
//     {
//       title: 'Size',
//       options: [
//         // {
//         //   name: '0-3 Months'
//         // },
//         {
//           name: '3-6 Months'
//         },
//         // {
//         //   name: '6-9 Months'
//         // }
//       ]
//     }
//   ]
// },
// {  
//   id: "camo-dinosaur-set",
//   description:
//     <>This Dinosaur set comes in a blue camoflauge print. Set contains a T-Shirt and jog pants and makes a perfect outfit for any little one. 
//     <br/><br/> Why not team up with our dinosaur blankets or toys to make a great themed hamper.    
//     <br /><br />
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: 3-6, 6-9 or 9-12 Months</li></ul></>,
//   categories: ["sale"],
//   name: "Dinosaur T-Shirt & Jog Pant Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 12.99,
//   img: placeholder,
//   productImages: [
//     placeholder,
//   ],
//   variants: [
//     {
//       title: 'Size',
//       options: [
//         // {
//         //   name: '3-6 Months'
//         // },
//         // {
//         //   name: '6-9 Months'
//         // },
//         {
//           name: '9-12 Months'
//         }
//       ]
//     }
//   ]
// },
// {  
//   id: "3pk-floral-sleepsuits",
//   description:
//     <>We love this three pack floral sleepsuits.  Each sleepsuit has a different colour and design, all as cute as each other. We find you can never have too many onesies making these a perfect gift.   
//     <br />Team these up with a cosy blanket or some accessories to make a lovely gift set!
//     <br /><br />** Please note these are ex-chain store and may contain chain store labels
//     <br /><br />
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: 3-6, 6-9 or 9-12 Months</li></ul></>,
//   categories: ["clothing"],
//   name: "Pack of 3 Floral Sleepsuits",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 12.99,
//   img: placeholder,
//   productImages: [
//     placeholder,
//   ],
//   variants: [
//     {
//       title: 'Size',
//       options: [
//         {
//           name: '3-6 Months'
//         },
//         {
//           name: '6-9 Months'
//         }, 
//         {
//           name: '9-12 Months'
//         }
//       ]
//     }
//   ]
// },
  {
    id: "eco-giraffe-toy",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These beanie toys come in 4 designs and make a great gift for baby. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Eco Giraffe Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: ecogiraffetoy,
    productImages: [
      ecogiraffetoy
    ],
  },
  {
    id: "eco-zebra-toy",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These beanie toys come in 4 designs and make a great gift for baby. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Eco Zebra Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: ecozebratoy,
    productImages: [
      ecozebratoy
    ],
  },
  {
    id: "eco-lamb-toy",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These beanie toys come in 4 designs and make a great gift for baby. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Eco Lamb Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: ecolambtoy,
    productImages: [
      ecolambtoy
    ],
  },
    {
    id: "eco-unicorn-toy",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These beanie toys come in 8 designs and make a great gift for baby. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys", "new-arrivals"],
    name: "Eco Unicorn Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: ecounicorntoy,
    productImages: [
      ecounicorntoy
    ],
  },
  {
    id: "eco-monkey-toy",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These beanie toys come in 8 designs and make a great gift for baby. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys", "new-arrivals"],
    name: "Eco Monkey Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: ecomonkeytoy,
    productImages: [
      ecomonkeytoy
    ],
  },
  {
    id: "eco-elephant-toy",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These beanie toys come in 8 designs and make a great gift for baby. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys", "new-arrivals"],
    name: "Eco Elephant Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: ecoelephanttoy,
    productImages: [
      ecoelephanttoy
    ],
  },
  {
    id: "eco-duck-toy",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These beanie toys come in 8 designs and make a great gift for baby. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys", "new-arrivals"],
    name: "Eco Duck Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: ecoducktoy,
    productImages: [
      ecoducktoy
    ],
  },
  {
    id: "eco-koala-toy",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These beanie toys come in 8 designs and make a great gift for baby. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys", "new-arrivals"],
    name: "Eco Koala Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: ecokoalatoy,
    productImages: [
      ecokoalatoy
    ],
  },
  {
    id: "organic-bow-teether",
    description:
      <>Part of our Eco Conscious Range, these teething rings are made from organic cotton fabrics and make a support to baby to chew on to smooth sore teeth and gums. 
      <br/><br/>These come in 4 designs, matching items available. 
      <br /><br />
      <ul>
        <li>Materials: Bow: 100% Organic Cotton, Fabric on Beechwood</li>
        <li>Size: One Size</li>
        <br />White Geo - Sold Out
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Organic Bow Teether",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.99,
    img: allorganicbowteether,
    productImages: [
      allorganicbowteether,
    ],
    variants: [
      {
        title: 'Bow Colour',
        options: [
          {
            name: 'Navy'
          },
          {
            name: 'Orange Grometric'
          },
          // {
          //   name: 'White Geometric'
          // },
          {
            name: 'Cream Dandelion'
          }
        ]
      }
    ]
  },
  {
    id: "organic-rainbow-teether",
    description:
      <>These teething rings come in a rainbow design. The wooden ring is perfect for baby to chew on to help soothe sore teeth & gums. 
      <br/><br/>Matching items available.
      <br /><br />
      <ul>
        <li>Materials: Beechwood Ring</li>
        <li>Approx Size: 10cm</li>
        <br />Pink - Sold Out
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Organic Rainbow Teether",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: rainbowteether,
    productImages: [
      rainbowteether,
    ],
    variants: [
      {
        title: 'Rainbow Colour',
        options: [
          {
            name: 'Rust'
          },
          {
            name: 'Brown'
          },
          // {
          //   name: 'Pink'
          // }
        ]
      }
    ]
  },
  {
    id: "wooden-stacker",
    description:
      <>These gorgeous wooden toys make a perfect gift for a new arrival to grow into. The wooden rings make up a lovley character deisn, topped with a fun character head. The rings are easy for baby to grab hold of and learn motor skills in stacking them back onto the holder. 
      <br /><be />Recommended from 10 Months+
      <br /><br />
      <ul>
        <li>Materials: Beechwood Ring</li>
        <li>Approx Size: 10cm</li>
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Wooden Ring Stacker",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: woodenstacker,
    productImages: [
      woodenstacker,
    ],
    variants: [
      {
        title: 'Toy Design',
        options: [
          {
            name: 'Elephant'
          },
          {
            name: 'Bear'
          },
          {
            name: 'Bunny'
          }
        ]
      }
    ]
  },  
  {
    id: "wooden-bear-teether",
    description:
      <>These super cute bear teething rings are perfect to help little gums and teeth when teething with a durable woodend and silicone ring. With durable and long lasting materials that are environmentally friendly and not harmful to baby, this will last until all of the teeth have popped through & are safe from birth.  
      <br/><br/>Safe for dishwasher & heat resistant.
      <br /><br />
      <ul>
        <li>Materials: FSC certified European Beech Wood & Silicone (No BPA or BPS chemicals)</li>
        <li>Approx Size: 5cm x 4cm</li>
        <br />Grey - Sold Out
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Bear Wood & Silicone Teether",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 10.99,
    img: bearteether,
    productImages: [
      bearteether,
    ],
    variants: [
      {
        title: 'Teether Colour',
        options: [
          // {
          //   name: 'Grey'
          // },
          {
            name: 'Blue'
          },
          {
            name: 'Pink'
          }
        ]
      }
    ]
  },
  {
    id: "wooden-rattle-teether",
    description:
      <>This super cute teething rattle if perfect to help little gums and teeth when teething with a durable silicone bead and wooden ring around the rattle stick. With durable and long lasting materials that are environmentally friendly and not harmful to baby, this will last until all of the teeth have popped through & are safe from birth.
      <br/><br/>Safe for dishwasher & heat resistant.
      <br /><br />
      <ul>
        <li>Materials: FSC certified European Beech Wood & Silicone (No BPA or BPS chemicals)</li>
        <li>Approx Size: 7cm x 3cm</li>
        <br />Grey & Blue - Sold Out
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Wood & Silicone Rattle Teether",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 10.99,
    img: woodenrattle,
    productImages: [
      woodenrattle,
    ],
    variants: [
      {
        title: 'Teether Colour',
        options: [
          // {
          //   name: 'Grey'
          // },
          // {
          //   name: 'Blue'
          // },
          {
            name: 'Pink'
          }
        ]
      }
    ]
  },    
  {
    id: "bunny-toy",
    description:
      <>This super cute rabbit makes a great gift for baby. The knitted material makes it durable with little hands and well, we love him!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Approx Size: 40cm</li>
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Knitted Rabbit Toy",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: bunnytoy,
    productImages: [
      bunnytoy,
    ],
  },
  {
    id: "soft-cube",
    description:
      <>These cubes are great for baby to play & explore. Lovely and soft with multiple textures to help sensory development. They have small tags on one side to help baby practice grabbing, and they also feature a mirror on one side to play peekaboo with! 
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Size: 10cmx10cm</li>
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Soft Cube Rattle",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: softcube,
    productImages: [
      softcube,
    ],
    variants: [
      {
        title: 'Cube Colour',
        options: [
          {
            name: 'Pink'
          },
          {
            name: 'Blue'
          }
        ]
      }
    ]
  },
  {
    id: "elephant-teether-toy",
    description:
      <>This comforter has dual benefits making it the perfect addition to any gift. The comforter itself is a great companion for baby to make them feel safe cuddling into something familiar as they grow. This comforter also features soft rubber feet to help soothe sore teeth & gums. Suitable from 0+ Months. 
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Size: 22cmx22cm</li>
      </ul>
      </>,
    categories: ["baby-toys", "comforters"],
    name: "Elephant Teething Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: greyelephteether,
    productImages: [
      greyelephteether
    ],
  },
  {
    id: "rabbit-teether-toy",
    description:
      <>This comforter has dual benefits making it the perfect addition to any gift. The comforter itself is a great companion for baby to make them feel safe cuddling into something familiar as they grow. This comforter also features soft rubber feet to help soothe sore teeth & gums. Suitable from 0+ Months. 
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Size: 22cmx22cm</li>
      </ul>
      </>,
    categories: ["baby-toys", "comforters"],
    name: "Bunny Teething Comforter",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: pinkbunnyteether,
    productImages: [
      pinkbunnyteether
    ],
  },    
  {
    id: "eco-stick-rattle",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These rattles are great way for baby to explore textures and sounds, with a lovely animal design. Supersoft feel and make a great sound when shaken. 
      <br/><br/>Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Eco Soft Rattle Stick",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.99,
    img: allrecrattle,
    productImages: [
      allrecrattle,
    ],
    variants: [
      {
        title: 'Rattle Type',
        options: [
          {
            name: 'Zebra'
          },
          {
            name: 'Giraffe'
          },
          {
            name: 'Lamb'
          }
        ]
      }
    ]
  },
  {
    id: "eco-ring-rattle",
    description:
      <>Part of our Eco Range, these toys are made from fully recycled materials but with no compromise on quality. These wooden teethers are great for sore teeth or for baby to practice grabbing, and feature a soft animal design too. 
      <br/><br />Matching items & clothing sets available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Recycled Plastic Fabrics</li>
        <li>Size: 14cm</li>
      </ul>
      </>,
    categories: ["baby-toys"],
    name: "Eco Ring Rattle",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: allrecrings,
    productImages: [
      allrecrings,
    ],
    variants: [
      {
        title: 'Rattle Type',
        options: [
          {
            name: 'Zebra'
          },
          {
            name: 'Giraffe'
          },
          {
            name: 'Lamb'
          }
        ]
      }
    ]
  },
  // {
  //   id: "maze-coaster",
  //   description:
  //     <>These wooden maze games are great to keep little fingers busy. Watch while they thread the beads through the maze from one side to the next. A great baby gift. 
  //     <br/><br/>Adult supervision essential. 
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Made from Wood</li>
  //       <li>Size: Approx 13cmx10cm</li>
  //     </ul>
  //     </>,
  //   categories: ["baby-toys", "sale"],
  //   name: "Maze Toy Coaster",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 2.99,
  //   was : 5.99,
  //   img: mazecoasters,
  //   productImages: [
  //     mazecoasters,
  //   ],
  //   variants: [
  //     {
  //       title: 'Coaster Colour',
  //       options: [
  //         // {
  //         //   name: 'Blue'
  //         // },
  //         {
  //           name: 'Green'
  //         },
  //         // {
  //         //   name: 'Purple'
  //         // },
  //         {
  //           name: 'Orange'
  //         },
  //         {
  //           name: 'Yellow'
  //         },
  //         // {
  //         //   name: 'Red'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "boardbook",
  //   description:
  //     <>These little books are a perfect size for little hands to explore. These come in a variety of different designs and make a great gift for baby. 
  //     <br/><br/>Either buy separately or add into any of our hampers.
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Solid Carboard</li>
  //       <li>Size: 4cmx4cm</li>
  //     </ul>
  //     </>,
  //   categories: ["baby-toys", "sale"],
  //   name: "Learning Board Books",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 1.50,
  //   was: 2.50,
  //   img: boardbooks,
  //   productImages: [
  //     boardbooks,
  //   ],
  //   variants: [
  //     {
  //       title: 'Board Book',
  //       options: [
  //         {
  //           name: 'Colours <2 available>'
  //         },
  //         {
  //           name: 'Opposites <3 available>'
  //         },
  //         {
  //           name: 'First Words <3 available>'
  //         },
  //         {
  //           name: 'Shapes <1 available>'
  //         },
  //         {
  //           name: 'Numbers <3 available>'
  //         },
  //         {
  //           name: 'Time <4 available>'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "vehicle-puzzle",
  //   description:
  //     <>This jigsaw puzzle features different vehicle shapes for baby to fit into the board. With 12pc to slot in, this will keep baby entertained and learning size and shapes. 
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Solid Carboard </li>
  //       <li>Approx Size: 28cmx17cm</li>
  //     </ul>
  //     </>,
  //   categories: ["baby-toys", "sale"],
  //   name: "Vehicle Board Puzzle",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price : 2.99,
  //   was: 5.99,
  //   img: vehiclejigsaw,
  //   productImages: [
  //     vehiclejigsaw,
  //   ],
  // },
  // {
  //   id: "shape-sorter",
  //   description:
  //     <>Perfect for problem solving, learning colours and shapes. Keeping little hands entertained. 
  //     <br/><br/>These are built to last, with thick wooden shapes to slot through the corresponding space. 
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Made from Wood</li>
  //       <li>Size: 15cmx15cm</li>
  //     </ul>
  //     </>,
  //   categories: ["baby-toys"],
  //   name: "Wooden Shape Sorter",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: woodenblocks,
  //   productImages: [
  //     woodenblocks,
  //   ],
  // },
  // {
  //   id: "water-teethers",
  //   description:
  //     <>Designed with little hands in mind, these teething aids are water filled to help soothe sore gums, just pop them in the fridge to keep them cool for extra relief. Bright fun colours encourage babies to grasp and reach. 
  //     <br /><br />Available in 4 designs. Suitable 3+ months.
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Made from durable materials, BPA Free</li>
  //       <li>Size: Approx 10cm x 10cm</li>
  //     </ul>
  //     </>,
  //   categories: ["baby-toys"],
  //   name: "Water Teething Rings",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 2.99,
  //   img: waterteethermain,
  //   productImages: [
  //     waterteethermain, waterteether1, waterteether2, waterteether3, waterteether4
  //   ],
  //   variants: [
  //     {
  //       title: 'Teether Design',
  //       options: [
  //         {
  //           name: 'Mermaid'
  //         },
  //         {
  //           name: 'Unicorn'
  //         },
  //         {
  //           name: 'Cars'
  //         },
  //         {
  //           name: 'Dinosaur'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "dumbell-rattle",
  //   description:
  //     <>What baby doesn't enjoy playing with a rattle! These are shaped like a mini dumbell to help baby grasp and grab them to make noise. 
  //     <br /><br />These make a great gift or addition to any hamper.
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Made from ABS and EVA, BPA free</li>
  //       <li>Size: Approx 16cm x 5cm</li>
  //     </ul>
  //     </>,
  //   categories: ["baby-toys"],
  //   name: "Dumbell Rattle",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 3.99,
  //   img: dumbellrattlesmain,
  //   productImages: [
  //     dumbellrattlesmain, dumbellrattles1, dumbellrattles2
  //   ],
  //   variants: [
  //     {
  //       title: 'Rattle Colour',
  //       options: [
  //         {
  //           name: 'Pink'
  //         },
  //         {
  //           name: 'Yellow'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "woodland-dressing-gown",
    description:
      <>This adorable dressing gown is one of our favourites, supersoft to keep your little one snuggled up nicely. It features an all over woodland animal print with pink detail.  
      <br /><br />Match with our hooded towels, comforters, onesies or bath accessories for a great gift!
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Sizes: 6-12, 12-18 or 18-24 Months</li>
      </ul>
      </>,
    categories: ["bathtime-accessories", "new-arrivals"],
    name: "Woodland Animal Dressing Gown",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: woodlandgown,
    productImages: [
      woodlandgown,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '6-12 Months <1 available>'
          },
          {
            name: '12-18 Months <1 available>'
          },
          {
            name: '18-24 Months <1 available>'
          }
        ]
      }
    ]    
  }, 
  {
    id: "zebra-towel",
    description:
      <>Wrap baby up warm after their bath in this white & grey hooded towel. Supersoft and features an embroidered zebra design. 
      <br /><br />Matching items available.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 75cm x 75cm</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Hooded Zebra Towel",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: zebratowel,
    productImages: [
      zebratowel
    ],
  },   
  {
    id: "grey-dressing-gown",
    description:
      <>This adorable dressing gown is supersoft to keep baby snuggled up nicely. It features little ears on the hood and an embroidered elephant design on the front. 
      <br /><br />Match with our hooded towels and bath accessories for a great bathtime gift!
      <br /><br />Also available in White, Blue & Pink
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester (Plush Fleece)</li>
        <li>Sizes 0-6, 6-12, 12-18 & 18-24 Months</li>
        <br /><br />
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Supersoft Grey Dressing Gown",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 11.99,
    img: greydressing,
    productImages: [
      greydressing, whitedressing, pinkdressing, bluedressing
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-6 Months <2 available>'
          },
          {
            name: '6-12 Months <2 available>'
          },
          {
            name: '12-18 Months <2 available>'
          },
          {
            name: '18-24 Months <1 available>'
          }
        ]
      }
    ]
  },
  {
    id: "pink-dressing-gown",
    description:
      <>This adorable dressing gown is supersoft to keep baby snuggled up nicely. It features little ears on the hood and an embroidered elephant design on the front. 
      <br /><br />Match with our hooded towels and bath accessories for a great bathtime gift!
      <br /><br />Also available in Grey, White & Blue
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester (Plush Fleece)</li>
        <li>Sizes 0-6, 6-12, 12-18 or 18-24 Months</li>
        <br />Size 6-12 Months - Sold Out
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Supersoft Pink Dressing Gown",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 11.99,
    img: pinkdressing,
    productImages: [
      pinkdressing, greydressing, whitedressing, bluedressing
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-6 Months <1 available>'
          },
          // {
          //   name: '6-12 Months'
          // },
          {
            name: '12-18 Months <1 available>'
          },
          {
            name: '18-24 Months <1 available>'
          }
        ]
      }
    ]
  },  
  {
    id: "rabbit-dressing-gown",
    description:
      <>This adorable dressing gown is supersoft to keep baby snuggled up nicely. It features little ears on the hood and an all over bunny print with pink detail.  
      <br /><br />Match with our hooded towels and bath accessories for a great bathtime gift! Matching Blanket Available.
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Sizes: 0-6 or 6-12 Months</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Bunny Dressing Gown",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: bunnygown,
    productImages: [
      bunnygown,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-6 Months <5 available>'
          },
          {
            name: '6-12 Months <4 available>'
          }
        ]
      }
    ]    
  },   
  {
    id: "white-dressing-gown",
    description:
      <>This adorable dressing gown is supersoft to keep baby snuggled up nicely. It features little ears on the hood and an embroidered elephant design on the front. 
      <br /><br />Match with our hooded towels and bath accessories for a great bathtime gift!
      <br /><br />Also available in Grey, Blue & Pink
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester (Plush Fleece)</li>
        <li>Sizes 0-6, 6-12, 12-18 & 18-24 Months</li>
        <br /><br />Size 12-18 Months - Sold Out
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Supersoft White Dressing Gown",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 11.99,
    img: whitedressing,
    productImages: [
      whitedressing, greydressing, pinkdressing, bluedressing
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-6 Months <3 available>'
          },
          {
            name: '6-12 Months <1 available>'
          },
          // {
          //   name: '12-18 Months <1 available>'
          // },
          {
            name: '18-24 Months <1 available>'
          }
        ]
      }
    ]
  },
  {
    id: "elephant-towel",
    description:
      <>Wrap baby up warm after their bath in this white & grey hooded towel. Supersoft and features an embroidered elephant design. 
      <br /><br />Matching items available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 75cm x 75cm</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Hooded Elephant Towel",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: elephanthoodedtowel,
    productImages: [
      elephanthoodedtowel
    ],
  },
  {
    id: "zebra-printed-towel",
    description:
      <>Wrap baby up warm after their bath in this white & grey hooded towel. Supersoft and features a zebra design. Sarafi animals are always really popular for us.
      <br /><br />Matching items available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 75cm x 75cm</li>
      </ul>
      </>,
    categories: ["bathtime-accessories",],
    name: "Zebra Towel",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: aopzebratowel,
    productImages: [
      aopzebratowel
    ],
  }, 
  {
    id: "safari-printed-towel",
    description:
      <>Wrap baby up warm after their bath in this white hooded towel. Supersoft and features a colourful safari animal design. Sarafi animals are always really popular for us.
      <br /><br />Matching items available. 
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 75cm x 75cm</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Safari Animal Towel",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: aopsafaritowel,
    productImages: [
      aopsafaritowel
    ],
  },   
  {
    id: "blue-dressing-gown",
    description:
      <>This adorable dressing gown is supersoft to keep baby snuggled up nicely. It features little ears on the hood and an embroidered elephant design on the front. 
      <br /><br />Match with our hooded towels and bath accessories for a great bathtime gift!
      <br /><br />Also available in Grey, White & Pink
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester (Plush Fleece)</li>
        <li>Sizes 0-6, 6-12, 12-18 & 18-24 Months</li>
        <br />Size 12-18 Months - Sold Out
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Supersoft Blue Dressing Gown",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 11.99,
    img: bluedressing,
    productImages: [
      bluedressing, greydressing, whitedressing, pinkdressing
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-6 Months <3 available>'
          },
          {
            name: '6-12 Months <1 available>'
          },
          // {
          //   name: '12-18 Months'
          // },
          {
            name: '18-24 Months <1 available>'
          }
        ]
      }
    ]
  },
  {
    id: "sheep-dressing-gown",
    description:
      <>This adorable dressing gown is supersoft to keep baby snuggled up nicely. It features little ears on the hood and an all over sheep print.  
      <br /><br />Match with our hooded towels and bath accessories for a great bathtime gift! Matching Blanket Available.
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Sizes: 0-6 or 6-12 Months</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Sheep Dressing Gown",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: sheepgown,
    productImages: [
      sheepgown,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-6 Months <2 available>'
          },
          {
            name: '6-12 Months <1 available>'
          }
        ]
      }
    ]    
  },   
  {
    id: "rainbow-dressing-gown",
    description:
      <>This adorable dressing gown is supersoft to keep baby snuggled up nicely. It features an all over elephant and rainbow print.  
      <br /><br />Match with our hooded towels and bath accessories for a great bathtime gift! Other Rainbow and Elephant gift items are available to match.
      <br /><br />
      <ul>
        <li>Materials: 100% Polyester</li>
        <li>Sizes: 0-6 or 6-12 Months</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Rainbow Elephant Dressing Gown",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: rainbowgown,
    productImages: [
      rainbowgown,
    ],
    variants: [
      {
        title: 'Size',
        options: [
          {
            name: '0-6 Months <1 available>'
          },
          {
            name: '6-12 Months <1 available>'
          }
        ]
      }
    ]    
  },    
  // {
  //   id: "sheep-towel",
  //   description:
  //     <>Wrap baby up warm after their bath in this white & grey hooded towel. Supersoft and features an embroidered sheep design. 
  //     <br /><br />Matching items available. 
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 75cm x 75cm</li>
  //     </ul>
  //     </>,
  //   categories: ["bathtime-accessories"],
  //   name: "Hooded Sheep Towel",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 8.99,
  //   img: sheephoodedtowel,
  //   productImages: [
  //     sheephoodedtowel
  //   ],
  // },
  // {
  //   id: "bear-towel",
  //   description:
  //     <>Wrap baby up warm after their bath in this pink snuggly hooded towel. 
  //     <br /><br />Features a bear hood with cute ear details
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 75cmx75cm</li>
  //     </ul>
  //     </>,
  //   categories: ["bathtime-accessories"],
  //   name: "Hooded Bear Towel",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 9.99,
  //   img: pinkbeartowel,
  //   productImages: [
  //     pinkbeartowel
  //   ],
  // },
  {
    id: "dino-towel",
    description:
      <>Wrap baby up warm after their bath in this white hooded towel. 
      <br /><br /> Supersoft and features a blue and red dinosaur design on the hood.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 75cm x 75cm</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Hooded Dinosaur Towel",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: dinotowel,
    productImages: [
      dinotowel
    ],
  },
  {
    id: "flower-towel",
    description:
      <>Wrap baby up warm after their bath in this white hooded towel. 
      <br /><br />Supersoft and features a pink floral design on the hood.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 75cm x 75cm</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Hooded Flower Towel",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: flowertowel,
    productImages: [
      flowertowel
    ],
  },
  {
    id: "bear-ballerina-towel",
    description:
      <>Wrap baby up warm after their bath in this pink hooded towel. Supersoft and features an embroidered ballerina bear design. 
      <br /><br />Matching items available.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 75cm x 75cm</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Hooded Ballerina Bear Towel",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: ballerinatowel,
    productImages: [
      ballerinatowel
    ],
  },
  {
    id: "bicycle-bear-towel",
    description:
      <>Wrap baby up warm after their bath in this blue hooded towel. Supersoft and features an embroidered bear on a bicycle design. 
      <br /><br />Matching items available.
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 75cm x 75cm</li>
      </ul>
      </>,
    categories: ["bathtime-accessories"],
    name: "Hooded Bicycle Bear Towel",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    img: bicyclebear,
    productImages: [
      bicyclebear
    ],
  },
  // {
  //   id: "bath-thermometer",
  //   description:
  //     <>Help make bathtime safe with this cute fish shaped thermometer that will float in bath and let you keep an eye on the temperature to keep baby comfortable. 
  //     <br /><br />Great as an add on into any of our bath hampers!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Made From Plastic</li>
  //       <li>Size: 14.5cm x 5.5cm x 1.5cm</li>
  //     </ul>
  //     </>,
  //   categories: ["bathtime-accessories"],
  //   name: "Bath Thermometer",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 2.50,
  //   img: baththermometer,
  //   productImages: [
  //     baththermometer
  //   ],
  // },
  // {
  //   id: "bath-foam-shapes",
  //   description:
  //     <>These letter and number shapes make playtime during a bath fun! Bright colours to help with visual development, these shapes float in the water or stick to any surface when wet. 
  //     <br /><br />Suitable 3+ months.
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Made From EVA</li>
  //       <li>Size: Each item approx 1.5cm x 2.5cm</li>
  //     </ul>
  //     </>,
  //   categories: ["bathtime-accessories"],
  //   name: "Bath Foam Shapes",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 6.99,
  //   img: foamshapes,
  //   productImages: [
  //     foamshapes
  //   ],
  // },
  // {
  //   id: "bath-books",
  //   description:
  //     <>Help make bathtime more engaging with these waterproof bath books. Great to establish books into a bedtime routine, these books are bright and fun. 
  //     <br /><br />Two designs with either numbers or letters theme. Great to add into any of our bathtime hampers!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: PVC with foam backing</li>
  //       <li>Size: Approx 13cm x 13cm</li>
  //     </ul>
  //     </>,
  //   categories: ["bathtime-accessories"],
  //   name: "Bath Books",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 2.50,
  //   img: bathbooks,
  //   productImages: [
  //     bathbooks
  //   ],
  //   variants: [
  //     {
  //       title: 'Book Design',
  //       options: [
  //         {
  //           name: 'Alphabet'
  //         },
  //         {
  //           name: 'Numbers'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "building-cups",
  //   description:
  //     <>This set of 9 building / stacking cups are great both bathtime and normal play. They have many benefits including helping develop coordination, developing problem-solving skills, encouraging counting development & teaching about colour. 
  //     <br /><br />They come with small holes in the bottom to aid water play, because what child doesnt love running water! Suitable 6+ months.
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Made From Plastic</li>
  //       <li>Size: Stack to 38cm</li>
  //     </ul>
  //     </>,
  //   categories: ["bathtime-accessories"],
  //   name: "Building Cups",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 6.99,
  //   img: buildingcups1,
  //   productImages: [
  //     buildingcups1, buildingcups2
  //   ],
  // },
  // {
  //   id: "bath-mirror",
  //   description:
  //     <>These little fish shaped foam mirrors are small size for helping to practice grabbing, floats in the water & sticks to surfaces when wet. Mirror play helps baby develop their visual senses, so these make great bathtime fun! 
  //     <br /><br />Great to add into any of our bathtime hampers.
  //     <br /><br />
  //     <ul>
  //       <li>Materials: Made From EVA</li>
  //       <li>Size: Approx 15cm x 12cm</li>
  //     </ul>
  //     </>,
  //   categories: ["bathtime-accessories"],
  //   name: "Bath Mirror",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 2.50,
  //   img: bathmirror,
  //   productImages: [
  //     bathmirror
  //   ],
  // }, 
  // {
  //   id: "6pc-white-sheep",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a sheep print onesie, vest, bib & hat, with plain white scratch mitts and a 2pk wash cloths.
  //     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3 or 3-6 Months</li>
  //       <br />Sizes Newborn & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets", "new-arrivals"],
  //   name: "Sheep 6pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcwhitesheep,
  //   productImages: [
  //     fipcwhitesheep, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months <3 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },  
  {
    id: "5pc-elephant-star",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains an elephant print onesie, stripey vest, elephant & star bib, elephant mitts and an elephant print hat.
      <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
        <br />Size 3-6 Months - Sold Out
        <br /><br />
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "Elephant Star 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcelephantstar,
    productImages: [
      fipcelephantstar, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <2 available>'
          },
          {
            name: '0-3 Months <4 available>'
          },
          // {
          //   name: '3-6 Months <1 available>'
          // }
        ]
      }
    ]
  },      
  {
    id: "5pc-blue-safari-animal",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a safari animal print onesie, a spotty vest & hat with the words ' I Love You' beside safari animals.
      <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
        <br /> Sizes Newborn & 3-6 Months- Sold Out
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "Blue Safari 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcbluesafari,
    productImages: [
      fipcbluesafari, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          // {
          //   name: 'Newborn <1 available>'
          // },
          {
            name: '0-3 Months <2 available>'
          },
          // {
          //   name: '3-6 Months <1 available>'
          // }
        ]
      }
    ]
  },   
//   {
//     id: "5pc-white-teddy",
//     description:
//       <>This onesie set makes a great gift containing all the essentials for new baby. 
//       <br /><br />The set contains an teddy & cloud print onesie, vest, mitts & hat with a cute teddy face bib.
//       <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
//       <br /><br />
//       <ul>
//         <li>Materials: 100% Cotton</li>
//         <li>Size: Newborn, 0-3, 3-6 Months</li>
//         <br />Size Newborn - Sold Out
//       </ul>
//       </>,
//     categories: ["onesie-sets"],
//     name: "White Teddy 5pc Onesie Set",
//     review: "productize virtual markets",
//     deliveryCharge: deliveryCharges,
//     price: 12.99,
//     img: fipcwhiteteddy,
//     productImages: [
//       fipcwhiteteddy, 
//     ],
//     variants: [
//       {
//         title: 'Onesie Size',
//         options: [
//           // {
//           //   name: 'Newborn <1 available>'
//           // },
//           {
//             name: '0-3 Months <1 available>'
//           },
//           {
//             name: '3-6 Months <1 available>'
//           }
//         ]
//       }
//     ]
// },     
  // {
  //   id: "velour-heart-stars",
  //   description:
  //     <>Keep them cosy in the cooler months with our cute & cosy velour onesies. This adorable pink velour onesie, features hearts and stars across the onesie and is set off with a cute collar. A beautiful, snuggly onesie.
  //     <br/><br/>Team up with our other items. Blankets, booties & comforters to make a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 80% Cotton, 20% Polyester</li>
  //       <li>Size: 0-3, 3-6, 6-9 Months</li>
  //       <br />Sizes 3-6 & 6-9 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Heart & Stars Velour Onesie",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 9.99,
  //   img: heartstarvelour,
  //   productImages: [
  //     heartstarvelour, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         // {
  //         //   name: '6-9 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "3pc-bear",
    description:
      <>This adorable bear themed onesie set contains essentials that every new mum needs. 
      <br/><br/>Each set contains a onesie, bib and hat and can be bought as a set, or teamed up with our other essential blankets, booties & comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
        <br /> Sizes 0-3, 3-6 Months - Sold Out
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "White Bear 3pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: thpcbearmain,
    productImages: [
      thpcbearmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          // {
          //   name: '0-3 Months'
          // },
          // {
          //   name: '3-6 Months'
          // },
          {
            name: '6-9 Months <4 Available>'
          }
        ]
      }
    ]
  },
  {
    id: "5pc-bunny-ballerina",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a bunny print onesie, pink striped vest with a flower print, bunny print bib with the words little bunny meadow, bunny print scratch mitts and hat. 
      <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 0-3 Months</li>
      </ul>
      <br />Size Newborn - Sold Out
      </>,
    categories: ["onesie-sets"],
    name: "Bunny Meadow 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcbunnymeadow,
    productImages: [
      fipcbunnymeadow, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          // {
          //   name: 'Newborn <1 available>'
          // },
          {
            name: '0-3 Months <2 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },  
  // {
  //   id: "3pc-dinosaur",
  //   description:
  //     <>This adorable dinosaur themed onesie set contains essentials that every new mum needs. 
  //     <br/><br/>Each set contains a onesie, bib and hat and can be bought as a set, or teamed up with our other essential blankets, booties & comforters to make a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3, 3-6, 6-9 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Blue Dinosaur 3pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 9.99,
  //   img: thpcdinosaurmain,
  //   productImages: [
  //     thpcdinosaurmain, thpcdinosaur1, thpcdinosaur2
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-9 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
//   {
//   id: "5pc-cartoon-giraffe",
//   description:
//     <>This onesie set makes a great gift containing all the essentials for new baby. 
//     <br /><br />The set contains a giraffe print onesie, stripey vest and giraffe bib, mitts and hat. Giraffes are always really popular for us!
//     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
//     <br /><br />
//     <ul>
//       <li>Materials: 100% Cotton</li>
//       <li>Size: Newborn, 0-3 & 3-6 Months</li>
//       <br />
//       <br /> Size 0-3 & 3-6 Months - Sold Out
//     </ul>
//     </>,
//   categories: ["onesie-sets", "new-arrivals"],
//   name: "Giraffe 5pc Onesie Set",
//   review: "productize virtual markets",
//   deliveryCharge: deliveryCharges,
//   price: 12.99,
//   img: fipccartoongiraffe,
//   productImages: [
//     fipccartoongiraffe, fipccartoongiraffeprint 
//   ],
//   variants: [
//     {
//       title: 'Onesie Size',
//       options: [
//         {
//           name: 'Newborn <1 available>'
//         },
//         // {
//         //   name: '0-3 Months <4 available>'
//         // },
//         // {
//         //   name: '3-6 Months <1 available>'
//         // }
//       ]
//     }
//   ]
// },  
  // {
  //   id: "3pc-farm",
  //   description:
  //     <>This adorable farm themed onesie set contains essentials that every new mum needs. 
  //     <br/><br/>Each set contains a onesie, bib and hat and can be bought as a set, or teamed up with our other essential blankets, booties & comforters to make a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3, 3-6, 6-9 Months</li>
  //       <br />Sizes 0-3 & 6-9 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "White Farm 3pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 9.99,
  //   img: thpcfarmmain,
  //   productImages: [
  //     thpcfarmmain,
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         {
  //           name: '3-6 Months <1 available>'
  //         },
  //         // {
  //         //   name: '6-9 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "3pc-sheep",
  //   description:
  //     <>This adorable sheep themed onesie set contains essentials that every new mum needs. 
  //     <br/><br/>Each set contains a onesie, vest and bib and can be bought as a set, or teamed up with our other essential blankets, booties & comforters to make a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br />Size 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "White Sheep 3pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: thpcsheepmain,
  //   productImages: [
  //     thpcsheepmain,
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <3 available>'
  //         },
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months <1 available>'
  //         // }
  //       ]
  //     }
  //   ]
  // },  
  {
    id: "3pc-blue-elephant",
    description:
      <>This adorable elephant themed onesie set contains essentials that every new mum needs. 
      <br/><br/>Each set contains a onesie, vest and bib and be bought as a set, or teamed up with our other essential blankets, booties & comforters to make a great hamper!      
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li>
      </ul>
      <br />Size 0-3 Months - Sold Out
      </>,
    categories: ["onesie-sets"],
    name: "Blue Elephant 3pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: thpcblueelephmain,
    productImages: [
      thpcblueelephmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          // {
          //   name: '0-3 Months'
          // },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },  
  // {
  //   id: "5pc-pink-floral",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a lovely floral design. 
  //     <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["sale", "onesie-sets"],
  //   name: "Pink Floral 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 3.99,
  //   was: 12.99,
  //   img: fipcpinkfloralmain,
  //   productImages: [
  //     fipcpinkfloralmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-pink-unicorn",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a cute unicorn design. 
  //     <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3 or 3-6 Months</li>
  //       <br />Sizes Newborn & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Pink Unicorn 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcunicornmain,
  //   productImages: [
  //     fipcunicornmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months <1 Available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },   
  {
    id: "3pc-white-elephant-mummy",
    description:
      <>This adorable "I love mummy" themed onesie set contains essentials that every new mum needs. 
      <br/><br/>Each set contains a onesie, bib and hat and can be bought as a set, or teamed up with our other essential blankets, booties & comforters to make a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
        <br />Size 0-3 Months - Sold Out
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "White Elephant Mummy 3pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 9.99,
    img: thpcwhiteelephantmummymain,
    productImages: [
      thpcwhiteelephantmummymain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          // {
          //   name: '0-3 Months'
          // },
          {
            name: '3-6 Months <1 available>'
          },
          {
            name: '6-9 Months <2 available>'
          }
        ]
      }
    ]
  },
  // {
  //   id: "5pc-lambs",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a lamb print onesie, stripe vest, lamb bib, stripey mitts and a lamb print hat. 
  //     <br /><br />Gender neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn 0-3, 3-6 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "White Lambs 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcwhitelambsmain,
  //   productImages: [
  //     fipcwhitelambsmain, fipcwhitelambs1, fipcwhitelambs2, fipcwhitelambs3, fipcwhitelambs4
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "5pc-grey-star",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a star onesie, spotty vest, "Wish Upon A Star" bib, spotty scratch mitts and a star hat. 
      <br /><br />Gender neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "Grey Star 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcgreystarmain,
    productImages: [
      fipcgreystarmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <3 Available>'
          },
          {
            name: '0-3 Months <1 Available>'
          },
          {
            name: '3-6 Months <2 Available>'
          }
        ]
      }
    ]
  },
  {
    id: "5pc-musical-bears",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a musical bears print onesie, blue and white stripe vest, musical bears bib, stripey mitts and a stripey hat.
      <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li>
      </ul>
      <br />Size 0-3 Months - Sold Out
      </>,
    categories: ["onesie-sets"],
    name: "Musical Bears 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcmusicalbearmain,
    productImages: [
      fipcmusicalbearmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 Available>'
          },
          // {
          //   name: '0-3 Months'
          // },
          {
            name: '3-6 Months <1 Available>'
          }
        ]
      }
    ]
  },
  // {
  //   id: "cartoon-giraffe-hamper",
  //   description:
  //   <>One of our most popular gift sets, this lovely hamper has a giraffe theme and features subtle neutral tones throughout. Why not add in an animal comforter for baby to snuggle up to! Ideal for a baby shower, or for a new parent and baby. 
  //   <br /><br />Gift Hamper includes:
  //   <br /><br /><ul>
  //     <li>Cellular Or Waffle Fleece Blanket(100% Cotton)</li>
  //     <li>White Giraffe Onesie (100% Cotton, Sizes: Newborn, 0-3, 3-6 Months)</li>
  //     <li>White Stripe Giraffe Vest (100% Cotton)</li>
  //     <li>White Giraffe Hat & Scratch Mittens</li>
  //     <li>White Giraffe Bib</li>
  //     <li>Crochet Booties (100% Acrylic)</li></ul>
  //   <br />There is an option to add in additional gifts for an added cost, we've lots of items that would make this hamper extra special, have a look at the options in the below dropdown!
  //       <br />
  //       <br />We also have some great giftcards available to help you get everything you need in one place. Just select from the below giftcard dropdown. We can also personalise this with a message for you, if you leave a message below!
  //       <br />
  //       <br /> Sizes 0-3 & 3-6 Months - Sold Out
  // </>,
  //   categories: ["Unisex", "new-arrivals", "best-sellers"],
  //   name: "Giraffe Hamper Gift Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 27.99,
  //   img: fipccartoongiraffehamper,
  //   productImages: [
  //      fipccartoongiraffehamper, fipccartoongiraffe, fipccartoongiraffeprint, whitecellular, whitewaffle, coffeewaffle, allbooties, greyelephant, whiteelephant, recgiraffecomforter, recycledtoys, allrecrings, allrecrattle, wishstring, alltoowordy, frames, plaques, welcomeplaque, mugs, milestonecards, cuttlery, boyheartplaque
  //   ],
  //   variants: [
  //     {
  //       title: 'Clothing Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 available>'
  //         },
  //         // {
  //         //   name: '0-3 months <4 available>'
  //         // },
  //         // {
  //         //   name: '3-6 months <1 available>'
  //         // }
  //       ]
  //     },
  //     {
  //       title: 'Bootie Colour',
  //       options: [
  //         {
  //           name: 'Grey Booties'
  //         },
  //         {
  //           name: 'White Booties'
  //         },
  //         {
  //           name: 'Blue Booties'
  //         },
  //         {
  //           name: 'Pink Booties'
  //         },
  //         {
  //           name: 'Navy Booties'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Blanket Colour',
  //       options: [
  //         {
  //           name: 'White Cellular'
  //         },
  //         {
  //           name: 'Coffee Waffle Fleece'
  //         },
  //         {
  //           name: 'White Waffle Fleece'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Optional Comforter',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'White Elephant',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Grey Elephant',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe Comforter',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe Toy',
  //           increment: 7.0
  //         },
  //         {
  //           name: 'Tan Giraffe Teething Rattle',
  //           increment: 6.0
  //         },
  //         {
  //           name: 'Tan Giraffe Stick Rattle',
  //           increment: 5.0
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Additional Giftcard',
  //       options: [
  //         {
  //           name: 'No Thanks'
  //         },
  //         {
  //           name: 'Pink Twinkle Toes',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Blue Twinkle Toes',
  //           increment: 3.50
  //         },
  //         // {
  //         //   name: 'Precious Daughter',
  //         //   increment: 3.50
  //         // },
  //         {
  //           name: 'Baby Boy Banner',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Lady',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Little Dude',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Lovely Happy News',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bundle Of Joy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Boy',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Welcome Baby Girl',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'New Chapter',
  //           increment: 3.50
  //         },
  //         {
  //           name: 'Bun In The Oven',
  //           increment: 3.50
  //         }
  //       ]
  //     },      
  // ]
  // },  
  {
    id: "5pc-little-loud-dinosaur",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a dinosaur print onesie, star vest, dinosaur bib with the words Little but Loud, dinosaur mitts and a dinosaur print hat.
      <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li>
      </ul>
      <br />
      </>,
    categories: ["onesie-sets"],
    name: "Little but Loud 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipclittledinosaurmain,
    productImages: [
      fipclittledinosaurmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <2 Available>'
          },
          {
            name: '0-3 Months <1 Available>'
          },
          {
            name: '0-3 Months <1 Available>'
          }
        ]
      }
    ]
  },
  // {
  //   id: "5pc-blue-dinosaur",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a dinosaur print onesie, striped vest, dinosaur bib, dinosaur mitts and a dinosaur print hat.
  //     <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3, 3-6, 6-9 Months</li>
  //       <br />Sizes 0-3 & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["sale", "onesie-sets"],
  //   name: "Blue Dinosaur 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 9.99,
  //   was: 12.99,
  //   img: fipcbluedinosaurmain,
  //   productImages: [
  //     fipcbluedinosaurmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: '0-3 Months <1 available>'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // },
  //         {
  //           name: '6-9 Months <1 available>'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "5pc-love-bear",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a bear print onesie, striped vest, bear print bib with the words love, striped scratch mitts and a bear print hat. 
      <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
        <br /> Sizes Newborn & 3-6 Months - Sold Out
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "Love Bear 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipclovebearmain,
    productImages: [
      fipclovebearmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          // {
          //   name: 'Newborn'
          // },
          {
            name: '0-3 Months <2 available>'
          },
          // {
          //   name: '3-6 Months'
          // }
        ]
      }
    ]
  },
  {
    id: "5pc-love-twirl-bear",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a bunny print onesie, pink vest with bunny print, bunny print bib with the words love to twirl, bunny print scratch mitts and hat. 
      <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
      </ul>
      <br />Size Newborn - Sold Out
      </>,
    categories: ["onesie-sets"],
    name: "Bunny Ballerina 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipclovetwirlbearmain,
    productImages: [
      fipclovetwirlbearmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          // {
          //   name: 'Newborn'
          // },
          {
            name: '0-3 Months <2 Available>'
          },
          {
            name: '3-6 Months <1 Available>'
          }
        ]
      }
    ]
  },
  {
    id: "5pc-ballerina",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a star print onesie, pink striped vest, 3 ballerinas with material tutu's on the bib, star print scratch mitts and hat. 
      <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li>
        <br />
        <br /> Size 0-3 Months - Sold Out
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "Ballerina 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcballerina,
    productImages: [
      fipcballerina, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 Available>'
          },
          // {
          //   name: '0-3 Months'
          // },
          {
            name: '3-6 Months <1 Available>'
          }
        ]
      }
    ]
  },
  // {
  //   id: "5pc-pink-ballerina",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a star print onesie, star vest, balloon bib, star mitts and a star print hat. 
  //     <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Pink Ballerina 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcballmousemain,
  //   productImages: [
  //     fipcballmousemain, fipcballmouse1, fipcballmouse2, fipcballmouse3, fipcballmouse4
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-white-rabbit",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a rabbit print onesie, star vest, rabbit bib, rabbit mitts and a rabbit print hat.
  //     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "White Rabbit 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcwhiterabbitmain,
  //   productImages: [
  //     fipcwhiterabbitmain, fipcwhiterabbit1, fipcwhiterabbit2, fipcwhiterabbit3
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "9pc-best-friends",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains an animal print onesie, star vest, 'Best Friends' bib, star mitts , 4pc washcloths and an animal print hat.
  //     <br /><br />Grey gender neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3, 3-6, 6-9 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "9pc Best Friends Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: nipcbestfriendsmain,
  //   productImages: [
  //     nipcbestfriendsmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-9 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-blue-whale",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a whale print onesie, stripe vest, whale bib, stripey mitts and a whale print hat.
  //     <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: 0-3, 3-6, 6-9 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Blue Whale 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcbluewhalemain,
  //   productImages: [
  //     fipcbluewhalemain, fipcbluewhale1, fipcbluewhale2, fipcbluewhale3, fipcbluewhale4
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-9 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "5pc-blue-transport",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a transport print onesie, stripe vest, digger bib, transport mitts and a transport print hat.
      <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
        <br /><br />Size 3-6 Months - Sold Out
      </ul>
      </>,
    categories: ["sale", "onesie-sets"],
    name: "Blue Transport 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 8.99,
    was: 12.99,
    img: fipctransportmain,
    productImages: [
      fipctransportmain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 Available>'
          },
          {
            name: '0-3 Months <1 Available>'
          },
          // {
          //   name: '3-6 Months'
          // }
        ]
      }
    ]
  },
  // {
  //   id: "5pc-brown-leopard",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a leopard print onesie, cat design vest, cat bib, leopard print  mitts and hat.
  //     <br /><br />Brown tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br />Size Newborn - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Brown Leopard 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcbrownleopardmain,
  //   productImages: [
  //     fipcbrownleopardmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         {
  //           name: '3-6 Months <1 available>'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-white-elephant",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a cute elephant design.
  //     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "White Elephant 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcwhiteelephantmain,
  //   productImages: [
  //     fipcwhiteelephantmain, fipcwhiteelephant1, fipcwhiteelephant2, fipcwhiteelephant3, fipcwhiteelephant4
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-lilac-rainbow",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a cute rainbow design.
  //     <br /><br />Purple tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br /><br />Sizes 0-3 & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["sale", "onesie-sets"],
  //   name: "Lilac Rainbow 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 9.99,
  //   was: 12.99,
  //   img: fipclilacrainmain,
  //   productImages: [
  //     fipclilacrainmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 available>'
  //         },
  //         // {
  //         //   name: '0-3 Months <2 available>'
  //         // },
  //         // {
  //         //   name: '3-6 Months <1 available>'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-white-spotty-giraffe",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a giraffe print onesie, spotty vest, giraffe bib, giraffe mitts and a giraffe print hat.
  //     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br />Size 0-3 & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "White Spotty Giraffe 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcspottygmain,
  //   productImages: [
  //     fipcspottygmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 Available>'
  //         },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-navy-teddy",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a teddy print onesie, stripey vest, teddy bib, teddy mitts and a teddy print hat.
  //     <br /><br />Navy & Red tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br />Sizes 0-3 & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["sale", "onesie-sets"],
  //   name: "Navy Teddy Bear 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 9.99,
  //   was: 12.99,
  //   img: fipcnavyteddymain,
  //   productImages: [
  //     fipcnavyteddymain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 Available>'
  //         },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-lemon-brave",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains animal print onesie, spotty vest, Curious & Brave print bib, spotty mitts and animal print hat.
  //     <br /><br />Lemon tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //     </ul>
  //     <br />Sizes 0-3 & 3-6 Months - Sold Out
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Lemon Brave 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipclemonbravemain,
  //   productImages: [
  //     fipclemonbravemain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <2 Available>'
  //         },
  //         // {
  //         //   name: '0-3 Months'
  //         // },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-white-alphabet",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a giraffe print onesie, spotty vest, "B is for Baby" bib, spotty mitts and a giraffe print hat.
  //     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "White Alphabet 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcwhiteabcmain,
  //   productImages: [
  //     fipcwhiteabcmain, fipcwhiteabc1, fipcwhiteabc2, fipcwhiteabc3, fipcwhiteabc4
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "5pc-safari-baby",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a cute safari animal design.
      <br /><br />Blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
      </ul>
      <br />Size 3-6 Months - Sold Out
      </>,
    categories: ["onesie-sets"],
    name: "Blue Safari Baby 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcsafaribaby,
    productImages: [
      fipcsafaribaby,
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <2 Available>'
          },
          {
            name: '0-3 Months <1 Available>'
          },
          // {
          //   name: '3-6 Months'
          // }
        ]
      }
    ]
  },
  // {
  //   id: "5pc-rose-rabbit",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a cute rabbit design.
  //     <br /><br />Rose pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Rose Rabbit 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcrosebunnymain,
  //   productImages: [
  //     fipcrosebunnymain, fipcrosebunny1, fipcrosebunny2, fipcrosebunny3, fipcrosebunny4
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-pastel-floral",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a lovely floral design.
  //     <br /><br />Pastel tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //     </ul>
  //     <br />Sizes 0-3 & 3-6 Months - Sold Out
  //     </>,
  //   categories: ["sale"],
  //   name: "Pastel Floral 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price : 8.99,
  //   was : 12.99,
  //   img: fipcpastelfloralmain,
  //   productImages: [
  //     fipcpastelfloralmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 available>'
  //         },
  //         // {
  //         //   name: '0-3 Months <2 available>'
  //         // },
  //         // {
  //         //   name: '3-6 Months <1 available>'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-sunshine-rainbows",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a lovely sunshine, rainbows and clouds design.
  //     <br /><br />Bright pink and blue tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br /><br />Sizes Newborn & 3-6 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Sun and Rainbows 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcsunshinerainbowsmain,
  //   productImages: [
  //     fipcsunshinerainbowsmain, 
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn <1 available>'
  //         // },
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-pink-blossom-floral",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a onesie, vest, hat, bib and scratch mitts, all with a lovely floral design.
  //     <br /><br />Pink tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets", "sale"],
  //   name: "Pink Blossom Floral 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcpinkblossommain,
  //   productImages: [
  //     fipcpinkblossommain, fipcpinkblossom1, fipcpinkblossom2, fipcpinkblossom3, fipcpinkblossom4
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "5pc-white-safari",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains animal print onesie, stripey vest, animal print bib, animal mitts and animal print hat.
  //     <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make into a great hamper!
      
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "White Safari 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcbrownsafarimain,
  //   productImages: [
  //     fipcbrownsafarimain, fipcbrownsafari1, fipcbrownsafari2, fipcbrownsafari3, fipcbrownsafari4
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "5pc-big-love",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a forest animal print onesie, star vest, forest animal print bib with the words big love embroidered at the bottom, forest animal scratch mitts and hat.
      <br /><br />Neutral tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make it into a great hamper!
      
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3, 3-6 Months</li>
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "White & Grey Big Love 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcbiglovemain,
    productImages: [
      fipcbiglovemain, 
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <2 Available>'
          },
          {
            name: '0-3 Months <1 Available>'
          },
          {
            name: '3-6 Months <1 Available>'
          }
        ]
      }
    ]
  },
  // {
  //   id: "5pc-navy-bear",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a navy coloured onesie with a bear print, navy striped vest, navy bear print bib, navy bear print scratch mitts and hat.
  //     <br /><br />Navy and brown tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make it into a great hamper!
  //     <br /><br /> 
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3, 3-6 Months</li>
  //       <br /> Size Newborn & 3-6 Months - Sold out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Navy Bear 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcnavybear1,
  //   productImages: [
  //     fipcnavybear1,
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         // {
  //         //   name: 'Newborn'
  //         // },
  //         {
  //           name: '0-3 Months <1 available>'
  //         },
  //         // {
  //         //   name: '3-6 Months'
  //         // }
  //       ]
  //     }
  //   ]
  // },
// {
//     id: "5pc-look-up",
//     description:
//       <>This onesie set makes a great gift containing all the essentials for new baby. 
//       <br /><br />The set contains a white coloured onesie with a lemon animal print, white zebra vest, giraffe & elephant bib with the words "look up to the stars", and animal print scratch mitts and hat.
//       <br /><br />White & lemon tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make it into a great hamper!
//       <br /><br />
//       <ul>
//         <li>Materials: 100% Cotton</li>
//         <li>Size: Newborn, 0-3, 3-6 Months</li>
//         <br /> Size Newborn, 0-3 Months - Sold Out
//       </ul>
//       </>,
//     categories: ["onesie-sets"],
//     name: "Look up to the Stars 5pc Onesie Set",
//     review: "productize virtual markets",
//     deliveryCharge: deliveryCharges,
//     price: 12.99,
//     img: fipclookup1,
//     productImages: [
//       fipclookup1,
//     ],
//     variants: [
//       {
//         title: 'Onesie Size',
//         options: [
//           // {
//           //   name: 'Newborn'
//           // },
//           // {
//           //   name: '0-3 Months'
//           // },
//           {
//             name: '3-6 Months'
//           }
//         ]
//       }
//     ]
//   },
  {
    id: "5pc-mint-zebra",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a mint coloured onesie with a zebra print, white scribble print vest, mint zebra print bib, mint zebra print scratch mitts and hat.
      <br /><br />Mint, White and grey tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make it into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: 0-3, 3-6, 6-9 Months</li>
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "Mint Zebra 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcmintzebra,
    productImages: [
      fipcmintzebra,
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: '0-3 Months <1 Available>'
          },
          {
            name: '3-6 Months <1 Available>'
          },
          {
            name: '6-9 Months <1 Available>'
          }
        ]
      }
    ]
  },
  // {
  //   id: "5pc-musical-animal",
  //   description:
  //     <>This onesie set makes a great gift containing all the essentials for new baby. 
  //     <br /><br />The set contains a white and blue coloured onesie with different animals playing musical instruments print, star print vest, musical animals print bib, scratch mitts and hat.
  //     <br /><br />Blue & Red tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make it into a great hamper!
  //     <br /><br />
  //     <ul>
  //       <li>Materials: 100% Cotton</li>
  //       <li>Size: Newborn, 0-3 or 3-6 Months</li>
  //       <br /><br />Size 0-3 Months - Sold Out
  //     </ul>
  //     </>,
  //   categories: ["onesie-sets"],
  //   name: "Musical Animals 5pc Onesie Set",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 12.99,
  //   img: fipcmusicalanimals,
  //   productImages: [
  //     fipcmusicalanimals,
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'Newborn <1 Available>'
  //         },
  //         // {
  //         //   name: '0-3 Months <1 available>'
  //         // },
  //         {
  //           name: '3-6 Months <1 Available'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "5pc-ballon-animal",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a white coloured onesie with different animals print, white print vest with a bear print, animals print bib, scratch mitts and hat.
      <br /><br />White and grey tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make it into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li>
      </ul>
      </>,
    categories: ["onesie-sets"],
    name: "Hot Air Balloon Animals 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcballoonanimal,
    productImages: [
      fipcballoonanimal,
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 Available>'
          },
          {
            name: '0-3 Months <1 Available>'
          },
          {
            name: '3-6 Months <1 Available>'
          }
        ]
      }
    ]
  },
  {
    id: "5pc-mono-animal",
    description:
      <>This onesie set makes a great gift containing all the essentials for new baby. 
      <br /><br />The set contains a white coloured onesie with different mono print animals, white mono animal print vest and mono animals print bib.
      <br /><br />White and black tones throughout. These sets make a great gift, why not team up with our blankets, booties, accessories & toys to make it into a great hamper!
      <br /><br />
      <ul>
        <li>Materials: 100% Cotton</li>
        <li>Size: Newborn, 0-3 or 3-6 Months</li>
      </ul>
      </>,
    categories: ["onesie-sets", "new-arrivals"],
    name: "Mono Animals 5pc Onesie Set",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 12.99,
    img: fipcmonoanimal,
    productImages: [
      fipcmonoanimal,
    ],
    variants: [
      {
        title: 'Onesie Size',
        options: [
          {
            name: 'Newborn <1 available>'
          },
          {
            name: '0-3 Months <2 available>'
          },
          {
            name: '3-6 Months <1 available>'
          }
        ]
      }
    ]
  },
  // {
  //   id: "bow-onesie",
  //   description:
  //     <>A beautiful onesie for the Chrismas period. A cute spotty design featuring a red bow front with a 'best present ever' tag. Also includes a matching red headband. A must have for any new baby this Christmas!
  //     <br /><br /> Why not match with other items from our Christmas range, blankets or hat & mitten sets. 
  //     <br /><br />
  //     <ul>
  //       <li>100% Cotton</li>
  //       <li>Sizes: First Size, 0-3, 3-6, 6-9, 9-12 Months</li></ul></>,
  //   categories: ["christmas"],
  //   name: "Red Christmas Bow Onesie",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 8.99,
  //   img: xmasonesie,
  //   productImages: [
  //     xmasonesie
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'First Size'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-9 Months'
  //         },
  //         {
  //           name: '9-12 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    id: "snowman-booties",
    description:
      <>Want to keep little ones feet warm during the Chrismas period? These applique and embroidered Snowman booties are the perfect solution. 
      <br /><br /> Why not match with other items from our Christmas range, clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester, Lining 100% Cotton, Sole Cotton Mix</li>
        <li>One Size, 0-6 Months</li></ul></>,
    categories: ["christmas"],
    name: "Snowman Booties",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.99,
    img: snowmanbooties,
    productImages: [
      snowmanbooties
    ],
  },  
  // {
  //   id: "reindeer-blanket",
  //   description:
  //     <>This supersoft blanket is the perfect essential for any new baby at Christmas time.  White in colour with a reindeer applique and embroidery. Great for out in the pram during those Christmas walks, tucked up in the car to visit friends and relatives. 
  //     <br /><br /> Why not match with other items from our Christmas range, clothing sets or hat & mitten sets. 
  //     <br /><br />
  //     <ul>
  //       <li>100% Polyester Waffle Fleece</li>
  //       <li>75cm x 100cm</li></ul></>,
  //   categories: ["christmas"],
  //   name: "Supersoft Reindeer Fleece Blanket",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: reindeerblanket,
  //   productImages: [
  //     reindeerblanket
  //   ],
  // },  
  // {
  //   id: "christmas-pyjamas",
  //   description:
  //     <>Baby's first Christmas Pyjama's.  
  //     <br/>Set includes red pants with a print including penguins, bears and presents. A long sleeved top with the words 'my 1st christmas' printed on the front, with a matching Christmas design. 
  //     <br/> Perfect to celebrate Baby's first Christmas and little one will look gorgeous in this set waiting for the big man to arrive on Christmas Eve.
  //     <br /><br /> Why not match with other items from our Christmas range, blankets or hat & mitten sets. 
  //     <br /><br />
  //     <ul>
  //       <li>100% Cotton</li>
  //       <li>Sizes: First Size, 0-3, 3-6, 6-9, 9-12 Months</li></ul></>,
  //   categories: ["christmas"],
  //   name: "First Christmas Pyjamas",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 8.99,
  //   img: xmaspyjamas,
  //   productImages: [
  //     xmaspyjamas
  //   ],
  //   variants: [
  //     {
  //       title: 'Onesie Size',
  //       options: [
  //         {
  //           name: 'First Size'
  //         },
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-9 Months'
  //         },
  //         {
  //           name: '9-12 Months'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "christmas-jumper",
  //   description:
  //     <>This jumper is the perfect essential for the Christmas period. A gorgeous red colour with green and white accents. Great for those wintry Christmas walks or for those first Christmas photo shoots by the tree! 
  //     <br /><br /> Why not match with other items from our Christmas range, clothing sets or hat & mitten sets. 
  //     <br /><br />
  //     <ul>
  //       <li>100% Acrylic</li>
  //       <li>Sizes: 0-3, 3-6, 6-9 Months</li></ul></>,
  //   categories: ["christmas"],
  //   name: "Christmas Jumper",
  //   review: "productize virtual markets",
  //   deliveryCharge: deliveryCharges,
  //   price: 7.99,
  //   img: xmasjumper,
  //   productImages: [
  //     xmasjumper
  //   ],
  //   variants: [
  //     {
  //       title: 'Size',
  //       options: [
  //         {
  //           name: '0-3 Months'
  //         },
  //         {
  //           name: '3-6 Months'
  //         },
  //         {
  //           name: '6-9 Months'
  //         },
  //       ]
  //     }
  //   ]
  // },
  {
    id: "elf-hat-booties",
    description:
      <>Look at this Elf Hat with the words 'Santa's Little Helper' and matching elf booties! How gorgeous will any little one look in this?  Perfect for those special Christmas pictures!
      <br /><br /> Why not match with other items from our Christmas range, clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Cotton</li>
        <li>One Size, 0-6 Months</li></ul></>,
    categories: ["christmas"],
    name: "Elf Hat and Booties",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 7.99,
    img: elfhatbooties,
    productImages: [
      elfhatbooties
    ],
  },  
  {
    id: "red-christmas-waffle-blanket",
    description:
      <>This supersoft blanket is the perfect essential for any new baby at Christmas time.  Gorgeous Red colour. Great for out in the pram during those Christmas walks, tucked up in the car to visit friends and relatives. 
      <br /><br /> Why not match with other items from our Christmas range, clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester Waffle Fleece</li>
        <li>75cm x 100cm</li></ul></>,
    categories: ["christmas"],
    name: "Red Waffle Fleece Blanket",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: redwaffle,
    productImages: [
      redwaffle
    ],
  },
  {
    id: "christmas-bibs",
    description:
      <>Two Pack Christmas bibs, one with a reindeer applique and embroidery, and the other with a gingerbread applique and embroidery.  Perfect for catching those christmas dinner dribbles. 
      <br /><br /> Why not match with other items from our Christmas range, clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>60% Cotton, 40% Polyester </li>
        <li>15cm x 15cm Approx</li></ul></>,
    categories: ["christmas"],
    name: "2 Pack Christmas Bibs",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 6.99,
    img: xmasbibs,
    productImages: [
      xmasbibs
    ],
  },
  {
    id: "gingerbread-booties",
    description:
      <>Want to keep little ones feet warm during the Chrismas period? These applique and embroidered Gingerbread Man booties are the perfect solution.  
      <br /><br /> Why not match with other items from our Christmas range, clothing sets or hat & mitten sets. 
      <br /><br />
      <ul>
        <li>100% Polyester, Lining 100% Cotton, Sole Cotton Mix</li>
        <li>One Size, 0-6 Months</li></ul></>,
    categories: ["christmas"],
    name: "Gingerbread Man Booties",
    review: "productize virtual markets",
    deliveryCharge: deliveryCharges,
    price: 5.99,
    img: gingerbreadbooties,
    productImages: [
      gingerbreadbooties
    ],
  },   
]
